import { SVGProps } from "react"

export const FilledStarIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox='0 0 20 20'>
    <path
      d='M10.0002 14.1666L5.10186 17.1583L6.43353 11.5749L2.0752 7.84159L7.79603 7.38325L10.0002 2.08325L12.2044 7.38325L17.926 7.84159L13.5669 11.5749L14.8985 17.1583L10.0002 14.1666Z'
      fill='#1F1F1F'
    />
  </svg>
)

export const HalfFilledStarIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox='0 0 20 20'>
    <path
      d='M10.0002 14.1666L5.10186 17.1583L6.43353 11.5749L2.0752 7.84159L7.79603 7.38325L10.0002 2.08325L12.2044 7.38325L17.926 7.84159L13.5669 11.5749L14.8985 17.1583L10.0002 14.1666Z'
      fill='#D9D9D9'
    />
    <path
      d='M10.0002 14.1666L5.10186 17.1583L6.43353 11.5749L2.0752 7.84159L7.79603 7.38325L10.0002 2.08325L12.2044Z'
      fill='#4B4C49'
    />
  </svg>
)

export const OutlineStarIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox='0 0 20 20'>
    <path
      d='M10.0002 14.1666L5.10186 17.1583L6.43353 11.5749L2.0752 7.84159L7.79603 7.38325L10.0002 2.08325L12.2044 7.38325L17.926 7.84159L13.5669 11.5749L14.8985 17.1583L10.0002 14.1666Z'
      fill='#D9D9D9'
    />
  </svg>
)

export const ChevronLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M18.8564 21.965V19.956C18.8564 19.8194 18.7894 19.6909 18.6796 19.6105L8.1903 12.0007L18.6796 4.39087C18.7894 4.31051 18.8564 4.18194 18.8564 4.04533V2.0364C18.8564 1.8623 18.6582 1.76051 18.5162 1.8623L5.49566 11.3069C5.02423 11.6498 5.02423 12.3516 5.49566 12.6918L18.5162 22.1364C18.6582 22.2409 18.8564 22.1391 18.8564 21.965Z'
      fill='#434343'
    />
  </svg>
)

export const ChevronRight = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M5.14209 2.03539V4.04432C5.14209 4.18092 5.20905 4.3095 5.31888 4.38985L15.8082 11.9997L5.31888 19.6095C5.20905 19.6899 5.14209 19.8184 5.14209 19.955V21.964C5.14209 22.1381 5.3403 22.2399 5.48227 22.1381L18.5028 12.6934C18.9742 12.3506 18.9742 11.6488 18.5028 11.3086L5.48227 1.86396C5.3403 1.75949 5.14209 1.86128 5.14209 2.03539Z'
      fill='#434343'
    />
  </svg>
)

export const SkyLogo = ({ width = 54, height = 32 }) => (
  <svg width={width} height={height} viewBox='0 0 54 32' fill='none' xmlns='https://www.w3.org/2000/svg'>
    <path
      d='M23.233 0.716046C23.233 0.207903 22.9014 0 22.4826 0H19.8421C18.7948 0 18.048 0.52501 18.048 1.80366V24.4174C18.048 24.9186 18.3814 25.1352 18.8036 25.1352H21.4388C22.4884 25.1352 23.2329 24.6101 23.2329 23.3291V0.716046H23.233ZM53.4122 8.34388C53.4122 7.91998 53.0991 7.71034 52.671 7.71034H49.4665C48.8248 7.71034 48.5401 7.93684 48.302 8.45655L43.7848 18.4819L37.4851 8.56161C37.1006 7.94494 36.6853 7.71034 35.7513 7.71034H31.9433C31.1546 7.71034 30.7283 7.91998 30.2589 8.42398L23.552 15.6278L29.5648 24.3948C29.914 24.8983 30.2044 25.1347 30.7283 25.1347H34.3138C34.8505 25.1347 35.1629 24.9187 35.1629 24.4681C35.1629 24.1951 35.0316 24.0162 34.8505 23.7613L29.5649 15.9373L33.5732 11.6197L41.4963 23.3293L37.9992 30.7264C37.9033 30.9465 37.7854 31.1561 37.7854 31.3658C37.7854 31.7943 38.0997 31.9999 38.5283 31.9999H41.7078C42.3537 31.9999 42.6336 31.7774 42.8706 31.2566L53.2025 8.98503C53.303 8.76489 53.4122 8.56161 53.4122 8.34388ZM6.4558 13.7378C5.40277 13.5009 5.07576 13.203 5.07576 12.6723C5.07576 12.2593 5.40277 11.9301 6.35303 11.9301H14.0409C15.3222 11.9301 15.8397 11.1821 15.8397 10.1373V8.46263C15.8397 8.04104 15.6289 7.70995 15.1247 7.70995H6.12012C2.10707 7.70995 0.00390625 10.0357 0.00390625 12.9933C0.00390625 15.628 1.62158 17.2314 4.85972 17.9515L10.0262 19.1071C11.077 19.3394 11.4028 19.6414 11.4028 20.1785C11.4028 20.5856 11.077 20.9149 10.1312 20.9149H2.11594C0.834627 20.9149 0.316451 21.6576 0.316451 22.7087V24.38C0.316451 24.7952 0.523239 25.135 1.02744 25.135H9.81888C14.5632 25.135 16.4764 22.8115 16.4764 20.0589C16.4764 17.2152 14.8373 15.6112 11.6218 14.894L6.4558 13.7378Z'
      fill='#595959'
    />
  </svg>
)

export const BcgLogo = ({ height = 28, width = 70 }) => (
  <svg width={width} height={height} viewBox='0 0 70 28' fill='none' xmlns='https://www.w3.org/2000/svg'>
    <path
      d='M70 14.0335C70 13.6319 69.9774 13.2303 69.9548 12.851C69.9323 12.4717 69.8645 12.0701 69.8194 11.6908H64.3323H58.8452L57.1742 14.2789L55.5032 16.8669H63.971C63.4742 18.5626 62.5032 20.0127 61.1935 21.039C59.8839 22.0653 58.2355 22.69 56.3161 22.69C53.9226 22.69 51.8 21.7084 50.2419 20.1243C48.6839 18.5402 47.7355 16.3761 47.7355 13.9888C47.7355 11.6462 48.6839 9.50438 50.2645 7.94263C51.8226 6.38088 53.9903 5.3992 56.3839 5.3992C57.4226 5.3992 58.3935 5.55538 59.2968 5.86773C60.2 6.15777 61.0129 6.60398 61.7355 7.13944L63.2032 4.81913L64.671 2.4988C63.5419 1.71792 62.2774 1.09323 60.8774 0.691635C59.5 0.26773 57.9871 0.0669295 56.4064 0.0669295C54.2839 0.0669295 52.3645 0.446217 50.671 1.13785C48.9774 1.82948 47.4645 2.83346 46.2 4.08287C43.1968 7.0502 42.3387 10.0622 41.7516 12.8064C41.1419 15.5729 40.8032 18.094 38.7484 20.102C37.8903 20.9498 36.9645 21.5968 35.9258 22.0207C34.8871 22.4446 33.7806 22.6677 32.5839 22.6677C30.1226 22.6677 27.9097 21.6637 26.2839 20.0797C24.6806 18.4956 23.6871 16.3315 23.6871 13.9888C23.6871 11.6908 24.6806 9.549 26.2839 7.96494C27.8871 6.38087 30.1 5.37689 32.5839 5.35458C33.6226 5.37689 34.571 5.53307 35.4516 5.8008C36.3323 6.06853 37.1452 6.49243 37.8677 7.02789L39.3581 4.70757L40.8484 2.38725C39.7194 1.60637 38.4548 1.00398 37.0774 0.602386C35.7 0.200793 34.1871 0 32.6064 0C30.1677 0 27.8871 0.580076 25.9 1.60637C23.9129 2.63267 22.2194 4.08287 20.9323 5.82311C20.4355 4.28367 19.3968 2.96733 17.9742 2.05259C16.5516 1.11553 14.7452 0.580081 12.7129 0.580081H6.34516H0V14.0335V27.4422H14C15.7613 27.4422 17.3419 27.0183 18.6516 26.3044C19.9613 25.5904 21 24.5641 21.7226 23.3594C23.0323 24.7872 24.6129 25.9474 26.4194 26.7506C28.2258 27.5538 30.2355 28 32.4032 28C34.9323 28 37.2581 27.4199 39.2677 26.3713C41.2774 25.3227 42.971 23.8279 44.2806 21.9761C45.5226 23.8056 47.2161 25.3004 49.2484 26.349C51.2581 27.3976 53.629 28 56.1581 28C60.0645 28 63.5194 26.4382 66.0032 23.8948C68.4871 21.396 70 17.8932 70 14.0335ZM5.89355 11.4677V5.6H12.6C13.4581 5.6 14.2032 5.91235 14.7452 6.4255C15.2871 6.93864 15.6258 7.6749 15.6258 8.52271C15.6258 9.37051 15.2871 10.1068 14.7452 10.6199C14.2032 11.1554 13.4355 11.4677 12.6 11.4677H9.25806H5.89355ZM5.89355 22.4669V16.3761H13.9323C14.8355 16.3761 15.6258 16.7108 16.2129 17.2462C16.8 17.7817 17.1613 18.5402 17.1613 19.4104C17.1613 20.2805 16.8 21.039 16.2129 21.5968C15.6258 22.1546 14.8355 22.4892 13.9323 22.4892H9.9129H5.89355V22.4669Z'
      fill='#595959'
    />
  </svg>
)

export const DentsuLogo = () => (
  <svg width='120' height='26' viewBox='0 0 300 64' fill='none' xmlns='https://www.w3.org/2000/svg'>
    <style>{'.st0{fill:#595959}'}</style>
    <g id='layer1' transform='translate(-517.063 -718.05)'>
      <g id='g24125' transform='matrix(6.10493 0 0 -6.10493 549.48 767.316)'>
        <path
          id='path24127'
          className='st0'
          d='M0 0c-.3-.2-.7-.3-1.2-.4-.5 0-.9.1-1.2.4-.5.4-.6 1.1-.6 1.9 0 .9.2 2.3 1.8 2.4.2 0 .8.1 1.2.1V0zm0 7.9V6.1h-1.1c-3.3 0-4-2.5-4-4.3 0-1.3.4-2.4 1.1-3.2.6-.6 1.4-1 2.4-1 .6.1 1.1.2 1.6.4v-.2h2.2V7.9H0'
        />
      </g>
      <g id='g24129' transform='matrix(6.10493 0 0 -6.10493 585.895 747.908)'>
        <path
          id='path24131'
          className='st0'
          d='M0 0c.2.8.8 1.3 1.7 1.3.8 0 1.3-.6 1.4-1.3H0zm5.3 0c-.1.9-.4 1.7-1 2.3-.7.6-1.5.9-2.6.9-1.3 0-2.3-.5-3-1.4-.6-.8-1-1.9-1-3.1 0-2 1.1-4.2 4.4-4.2 1.2 0 2.4.4 3.1.7v2c-.4-.1-1.6-.8-3.2-.8-1.2 0-1.8.7-2 1.8h5.3V0'
        />
      </g>
      <g id='g24133' transform='matrix(6.10493 0 0 -6.10493 653.336 728.568)'>
        <path
          id='path24135'
          className='st0'
          d='M0 0c-.7 0-1.5-.3-1.8-.4v.2H-4v-8.3h2.2v6.2c.5.3 1.2.4 1.8.3.6-.1.9-.5.9-1.6v-4.9h2.2v5.2C3.1-1.1 2.1 0 0 0'
        />
      </g>
      <g id='g24137' transform='matrix(6.10493 0 0 -6.10493 802.59 729.77)'>
        <path
          id='path24139'
          className='st0'
          d='M0 0v-6.2c-.5-.3-1.2-.4-1.8-.3-.6.1-.9.5-.9 1.6V0h-2.2v-5.2c0-2.2 1-3.3 3.1-3.3.7 0 1.5.3 1.8.4v-.2h2.2V0H0'
        />
      </g>
      <g id='g24141' transform='matrix(6.10493 0 0 -6.10493 697.084 719.05)'>
        <path
          id='path24143'
          className='st0'
          d='M0 0h-2.2v-7.2c0-1 .2-1.7.5-2.2.4-.6 1.1-.9 2.2-.9.8 0 1.6.2 2.1.3v2c-.3 0-1.2-.2-1.7-.2-.3 0-.6.1-.7.2-.2.2-.2.6-.2.9v3.5c.9 0 1.9-.1 2.6-.1v1.9H0V0'
        />
      </g>
      <g id='g24145' transform='matrix(6.10493 0 0 -6.10493 746.785 748.775)'>
        <path
          id='path24147'
          className='st0'
          d='M0 0c-.5.1-1.1.2-1.5.4-.2.1-.3.2-.3.4 0 .1.1.3.3.4.3.2.9.3 1.8.1.9-.2 1.8-.5 2.1-.6v2c-1 .5-1.9.7-2.9.7-.9 0-1.8-.3-2.4-.7-.6-.5-1-1.2-1-2C-4-.8-3.2-1.6-1.2-2c.4-.1 1-.2 1.3-.3.3-.1.4-.3.4-.5s-.1-.4-.3-.4c-.4-.2-1-.1-1.4-.1-1.1.1-2.2.5-2.6.7v-2.1c.7-.3 1.7-.7 3-.7 1.4 0 3.2.5 3.6 2.4.1.7 0 1.3-.4 1.8C1.9-.5 1.2-.2 0 0'
        />
      </g>
    </g>
  </svg>
)

export const SkyscannerLogo = () => (
  <svg width='199' height='32' viewBox='0 0 199 32' fill='none' xmlns='https://www.w3.org/2000/svg'>
    <path
      d='M21.9593 27.4144C22.4234 27.4144 22.8544 27.3155 23.2854 27.0515L28.0596 24.3134C29.021 23.7856 30.1483 23.5217 31.2423 23.6536C37.0442 24.3134 41.1221 25.4021 42.3157 25.765C42.5477 25.8309 42.8461 25.732 42.9787 25.534C43.1777 25.3031 43.4097 24.9072 43.6087 24.3464C43.7744 23.8186 43.8076 23.3567 43.7744 23.0268C43.7413 22.7629 43.5755 22.532 43.3103 22.466C41.4205 21.9381 33.0989 19.6949 21.893 19.6949C10.687 19.6949 2.36547 21.9381 0.475705 22.466C0.210476 22.532 0.0447067 22.7629 0.011553 23.0268C-0.0216006 23.3237 0.011553 23.7856 0.177321 24.3464C0.34309 24.9072 0.60832 25.3031 0.807242 25.534C0.973011 25.732 1.23824 25.8309 1.47032 25.765C2.66385 25.4021 6.77491 24.3134 12.5436 23.6536C13.6709 23.5217 14.7649 23.7526 15.7264 24.3134L20.6331 27.0515C21.031 27.3155 21.4951 27.4144 21.9593 27.4144ZM13.9693 11.9753C14.2345 12.4371 14.6323 12.734 15.1296 12.866C15.6269 12.9979 16.1242 12.932 16.5884 12.668C17.0525 12.4041 17.3509 12.0082 17.4835 11.5134C17.6162 11.0186 17.5499 10.5237 17.2846 10.0619L12.9746 2.63918C12.842 2.40825 12.5436 2.30928 12.3116 2.34227C11.9469 2.37526 11.4827 2.54021 10.9191 2.87011C10.3555 3.2 9.95766 3.5299 9.75874 3.79381C9.59297 4.02474 9.55982 4.28866 9.69243 4.51959C9.65928 4.58557 13.9693 11.9753 13.9693 11.9753ZM10.024 17.2866C10.4881 17.5505 11.0186 17.5835 11.4827 17.4845C11.98 17.3526 12.3779 17.0557 12.6431 16.5938C12.9083 16.132 12.9415 15.6041 12.842 15.1423C12.7426 14.6804 12.411 14.2515 11.9469 13.9876L4.4873 9.69897C4.25523 9.56701 3.95684 9.6 3.75792 9.76495C3.45954 9.96289 3.16115 10.3588 2.82962 10.9196C2.49808 11.4804 2.33231 11.9753 2.29916 12.3052C2.266 12.6021 2.39862 12.833 2.59754 12.9649L10.024 17.2866ZM23.8491 9.36907C23.8491 9.89691 23.617 10.3588 23.3186 10.7217C22.9539 11.0845 22.5229 11.2495 21.9593 11.2495C21.4288 11.2495 20.9647 11.0186 20.6 10.7217C20.2353 10.3588 20.0695 9.9299 20.0695 9.36907V0.824742C20.0695 0.527835 20.2353 0.329901 20.5005 0.230932C20.7989 0.0659834 21.2962 0 21.9593 0C22.6224 0 23.1197 0.0989731 23.4181 0.230932C23.6501 0.362891 23.8491 0.560825 23.8491 0.824742V9.36907ZM29.9162 11.9753C29.651 12.4371 29.2531 12.734 28.7558 12.866C28.2585 12.9979 27.7612 12.932 27.297 12.668C26.8329 12.4041 26.5345 12.0082 26.4019 11.5134C26.2693 11.0186 26.3356 10.5237 26.6008 10.0619L30.9108 2.63918C31.0434 2.40825 31.3418 2.30928 31.5739 2.34227C31.9386 2.37526 32.4027 2.54021 32.9663 2.87011C33.5299 3.2 33.9278 3.5299 34.1267 3.79381C34.2925 4.02474 34.3256 4.28866 34.193 4.51959L29.9162 11.9753ZM33.8615 17.2866C33.3973 17.5505 32.8669 17.5835 32.4027 17.4845C31.9054 17.3526 31.5076 17.0557 31.2423 16.5938C30.9771 16.132 30.9439 15.6041 31.0434 15.1423C31.176 14.6474 31.4744 14.2515 31.9386 13.9876L39.3981 9.69897C39.6302 9.56701 39.9286 9.6 40.1275 9.76495C40.4259 9.96289 40.7243 10.3588 41.0558 10.9196C41.3874 11.4804 41.5531 11.9753 41.5863 12.3052C41.6194 12.6021 41.4868 12.833 41.2879 12.9649L33.8615 17.2866ZM81.4039 11.4144H84.9845C85.1171 11.4144 85.2165 11.5134 85.2828 11.6124L88.8303 20.7175L92.2783 11.6124C92.3114 11.4804 92.444 11.4144 92.5766 11.4144H96.0909C96.323 11.4144 96.4888 11.6454 96.3893 11.8433L87.6367 31.8021C87.6036 31.901 87.471 32 87.3384 32H84.2882C84.0562 32 83.8904 31.7691 83.9899 31.5711L86.9737 24.5773L81.1055 11.8433C81.006 11.6454 81.1718 11.4144 81.4039 11.4144ZM134.35 13.4268V11.7443C134.35 11.5794 134.516 11.4144 134.682 11.4144H137.865C138.03 11.4144 138.196 11.5794 138.196 11.7443V25.3031C138.196 25.468 138.03 25.633 137.865 25.633H134.682C134.516 25.633 134.35 25.468 134.35 25.3031V23.5216C133.687 24.5773 132.195 25.9299 129.775 25.9299C125.134 25.9299 122.747 22.4 122.747 18.4742C122.747 13.3278 126.327 11.1505 129.676 11.1505C131.864 11.0845 133.389 12.1402 134.35 13.4268ZM126.526 18.4742C126.526 20.9155 128.051 22.7959 130.471 22.7959C132.892 22.7959 134.45 21.1794 134.45 18.6722C134.45 16.165 132.925 14.2516 130.372 14.2516C127.952 14.2186 126.526 16.099 126.526 18.4742ZM141.047 25.2701V11.7113C141.047 11.5464 141.213 11.3814 141.379 11.3814H144.562C144.727 11.3814 144.893 11.5464 144.893 11.7113V13.5588C145.623 12.2722 147.048 11.0845 149.435 11.0845C151.889 11.0845 154.607 12.2722 154.607 17.7814V25.2371C154.607 25.4021 154.441 25.567 154.276 25.567H151.093C150.927 25.567 150.761 25.4021 150.761 25.2371V17.8474C150.761 16.5278 150.43 14.2516 148.076 14.2516C145.722 14.2516 144.893 16.3299 144.893 18.2433V25.2701C144.893 25.4351 144.727 25.6 144.562 25.6H141.379C141.18 25.6 141.047 25.468 141.047 25.2701ZM157.293 25.2701V11.7113C157.293 11.5464 157.458 11.3814 157.624 11.3814H160.807C160.973 11.3814 161.138 11.5464 161.138 11.7113V13.5588C161.868 12.2722 163.293 11.0845 165.681 11.0845C168.134 11.0845 170.853 12.2722 170.853 17.7814V25.2371C170.853 25.4021 170.687 25.567 170.521 25.567H167.338C167.172 25.567 167.007 25.4021 167.007 25.2371V17.8474C167.007 16.5278 166.675 14.2516 164.321 14.2516C161.967 14.2516 161.138 16.3299 161.138 18.2433V25.2701C161.138 25.4351 160.973 25.6 160.807 25.6H157.624C157.425 25.6 157.293 25.468 157.293 25.2701ZM190.579 11.4144H193.662C193.828 11.4144 193.994 11.5794 193.994 11.7443V14.5485C194.591 11.7773 197.011 10.8206 198.768 11.2165C198.934 11.2495 199 11.3814 199 11.5134V14.6144C199 14.8124 198.834 14.9773 198.602 14.9113C195.353 14.2845 194.06 16.033 194.06 18.4412V25.2701C194.06 25.4351 193.894 25.6 193.729 25.6H190.546C190.38 25.6 190.214 25.4351 190.214 25.2701V11.7113C190.247 11.5464 190.413 11.4144 190.579 11.4144ZM60.4176 14.4825C59.423 14.1526 58.8925 13.9546 58.13 13.6907C57.3343 13.3938 55.9418 12.6351 55.9418 11.3485C55.9418 10.0948 56.8038 9.27011 58.5941 9.27011C60.2187 9.27011 61.1138 10.0619 61.7106 11.3155C61.81 11.4804 62.009 11.5464 62.1747 11.4804L64.7607 9.96289C64.8933 9.86392 64.9596 9.69897 64.8933 9.53402C64.0976 7.81856 62.2742 5.7402 58.6273 5.7402C54.5825 5.7402 52.0628 8.14846 52.0628 11.2825C52.0628 14.4165 54.1515 16.033 56.9696 16.9897C57.9974 17.3526 58.4284 17.4845 59.2904 17.7814C60.948 18.3423 61.7106 19.101 61.7106 20.1237C61.7106 21.1464 61.0475 22.367 58.4615 22.367C56.1076 22.367 55.2788 21.1134 54.7814 19.9588C54.7151 19.7938 54.4831 19.6948 54.3173 19.7938L51.5987 21.3443C51.4661 21.4433 51.3998 21.5753 51.4661 21.7402C52.527 24.3134 55.3782 25.8309 58.5941 25.8309C62.3736 25.8309 65.5564 23.9175 65.5564 20.0577C65.5564 16.1979 61.379 14.8124 60.4176 14.4825ZM81.2712 21.9052C81.1718 21.7402 80.9729 21.6742 80.8071 21.8062C79.5804 22.6969 78.1548 22.7299 77.0607 21.0474C76.1324 19.6289 75.0384 17.8804 75.0384 17.8804L79.8456 11.9423C80.0114 11.7113 79.8788 11.4144 79.6136 11.4144H75.8672C75.7677 11.4144 75.6683 11.4474 75.602 11.5464L71.4578 17.2206V5.80619C71.4578 5.64124 71.292 5.47629 71.1262 5.47629H67.9435C67.7777 5.47629 67.6119 5.64124 67.6119 5.80619V25.3031C67.6119 25.468 67.7777 25.633 67.9435 25.633H71.1262C71.292 25.633 71.4578 25.468 71.4578 25.3031V18.9691C71.4578 18.9691 73.5796 22.301 74.3753 23.5216C75.4694 25.2041 76.9944 25.9299 78.6521 25.9299C80.2103 25.9299 81.2381 25.501 82.4316 24.3464C82.5311 24.2474 82.5642 24.0825 82.4979 23.9505L81.2712 21.9052ZM104.048 17.4186C103.053 17.0557 102.689 16.9237 101.926 16.6268C101.163 16.3299 100.467 15.934 100.467 15.3072C100.467 14.6804 101.031 14.0206 102.191 14.0206C103.186 14.0206 103.816 14.4165 104.147 15.1093C104.247 15.2742 104.446 15.3402 104.578 15.2412L106.8 13.9546C106.965 13.8557 106.999 13.6577 106.899 13.5258C106.302 12.4701 105.076 11.1175 102.191 11.1175C98.6438 11.1175 96.7872 13.1629 96.7872 15.4392C96.7872 17.7155 98.6438 18.7711 100.335 19.4309C102.258 20.2227 102.39 20.2557 102.622 20.3546C103.219 20.5856 103.948 20.9485 103.948 21.6412C103.948 22.334 103.153 22.9278 101.959 22.9278C100.832 22.9278 99.5721 22.466 99.0416 21.1794C98.9753 21.0144 98.7432 20.9155 98.5775 21.0144L96.323 22.301C96.1904 22.4 96.1241 22.532 96.1904 22.6969C96.8535 24.3794 98.7764 25.8969 101.926 25.8969C105.341 25.8969 107.595 24.0825 107.595 21.5423C107.695 19.0021 105.938 18.1113 104.048 17.4186ZM116.845 14.4825C118.271 14.4825 119.332 14.9113 120.293 15.6041C120.459 15.7031 120.658 15.6701 120.757 15.5052L122.083 13.2289C122.183 13.0639 122.117 12.899 121.984 12.8C120.625 11.8763 118.934 11.0515 116.679 11.0515C114.425 11.0515 112.336 11.6454 110.877 13.1629C109.386 14.6474 108.722 16.3959 108.722 18.5072C108.722 21.0144 109.783 22.6309 110.911 23.7856C112.038 24.9072 114.093 25.8639 116.713 25.8639C119.066 25.8639 120.824 24.8742 122.017 24.1155C122.15 24.0165 122.183 23.8186 122.117 23.6866L120.824 21.4433C120.724 21.2784 120.525 21.2124 120.359 21.3443C119.497 21.9382 118.271 22.466 116.911 22.466C115.353 22.466 112.535 21.6082 112.535 18.4742C112.502 15.3732 115.287 14.4825 116.845 14.4825ZM181.163 22.7629C179.903 22.7629 178.677 22.466 177.815 21.7732C176.953 21.0804 176.522 20.3546 176.522 19.4969H187.86C188.026 19.4969 188.192 19.332 188.192 19.167C188.126 15.8021 187.032 14.2515 185.971 13.1959C184.877 12.1072 183.02 11.1175 180.567 11.1175C178.113 11.1175 176.223 12.0083 174.964 13.2619C173.704 14.5155 172.742 16.132 172.742 18.5732C172.742 21.0144 173.737 22.6309 174.93 23.8186C176.124 25.0062 178.113 25.8969 180.931 25.8969C183.584 25.8969 185.838 24.9732 187.463 23.1258C187.595 22.9608 187.562 22.7299 187.363 22.6309L185.109 21.3113C185.009 21.2454 184.843 21.2454 184.744 21.3443C183.617 22.4 182.191 22.7629 181.163 22.7629ZM180.567 14.1526C182.39 14.1526 184.048 15.2412 184.313 17.1876H176.688C177.185 15.0763 178.743 14.1526 180.567 14.1526Z'
      fill='#595959'
    />
  </svg>
)

export const LorealLogo = () => (
  <svg width='160' height='30' viewBox='0 0 800 145' fill='none' xmlns='https://www.w3.org/2000/svg'>
    <style>{'.st0{fill:#595959}'}</style>
    <path
      id='polyline3'
      className='st0'
      d='M435.2 135L538.5 135 538.5 122.4 452.9 122.4 452.9 82 517.2 82 517.2 69.3 452.9 69.3 452.9 32.1 538.5 32.1 538.5 19.6 435.2 19.6 435.2 135'
    />
    <path id='polyline5' className='st0' d='M488.9 0.9L474.9 16.6 518.8 0.9 488.9 0.9' />
    <path
      id='polyline7'
      className='st0'
      d='M711.8 122.4L711.8 19.6 695.6 19.6 695.6 135 800 135 800 122.4 711.8 122.4'
    />
    <path
      id='path9'
      className='st0'
      d='M605.4 19.6L546.7 135h19.8l15-29.9h70.4L667 135h19.6L628 19.6h-22.6m-16.5 71.1l27.7-55.1 28 55.1h-55.7z'
    />
    <path
      id='path11'
      className='st0'
      d='M379.2 86.7c26.5-7.1 29-26.7 28.9-33.8-1.6-20.6-15.5-33.4-40.4-33.4h-72.8V135h16.6V86.6h47.4l34.9 48.4h20.9c-.1 0-25.2-32.6-35.5-48.3m-13.8-13.8h-53.9V33.2h55.8c12.8 0 20.1 6 22.7 13.6 1.7 5.2.6 12.1-2.2 16.7-4.8 7.8-13.6 9.4-22.4 9.4z'
    />
    <path
      id='path13'
      className='st0'
      d='M195.2 0c-46.8 0-78.7 33-78.7 73 0 42.1 35.3 71.8 78.7 71.8 43.5 0 78.7-29.3 78.7-71.8 0-40-32.3-73-78.7-73m-.6 130.4c-32.4 0-59.1-26-59.1-57.4 0-31.3 25.4-58.6 60.3-58.6 34 0 59.1 27.3 59.1 58.6.1 31.4-27.9 57.4-60.3 57.4z'
    />
    <path id='polyline15' className='st0' d='M74.7 60.4L86.6 60.4 108.4 19.6 90.9 19.6 74.7 60.4' />
    <path
      id='polyline17'
      className='st0'
      d='M16.1 122.4L16.1 19.6 0 19.6 0 135 104.4 135 104.4 122.4 16.1 122.4'
    />
  </svg>
)

export const EdfLogo = () => (
  <section style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
    <svg width='36' height='32' viewBox='0 0 36 32' fill='none' xmlns='https://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M19.449 4.90663C19.5735 3.90218 19.449 2.44441 20.2135 1.75996C20.4446 0.693294 22.1246 0.942183 21.8579 0.257739C21.6979 -0.160039 20.9068 -3.91919e-05 20.5868 0.115516C19.4622 0.470829 18.32 0.767524 17.1646 1.00441L16.0446 0.684405C14.5957 0.879961 13.7602 2.02663 12.9602 2.94218C12.2846 3.70663 11.3779 5.60885 12.0713 6.70218C12.0713 6.95107 11.9913 7.19107 11.9557 7.43996L13.5913 9.83996C14.1602 10.24 14.2313 10.5422 14.8446 10.9422L15.2179 11.5111C15.921 11.8142 16.7094 11.8552 17.4402 11.6266C19.7957 11.8489 19.5468 7.05774 20.2935 6.05329C20.1638 5.57967 19.8628 5.17105 19.449 4.90663ZM9.26238 19.28C9.86484 19.1866 10.4592 19.047 11.0402 18.8622C11.7513 18.5066 14.2046 16.7822 13.4224 15.3866C13.1824 12.4444 9.63571 14.9333 8.08905 13.9022C6.61349 13.7066 4.89793 10.8089 4.4446 9.5733C4.37932 9.31318 4.25797 9.07048 4.08905 8.86218C4.08905 8.81774 3.93793 8.99552 3.93793 8.95107C3.49349 9.47552 3.5646 9.92885 3.50238 11.2H2.89793C2.91088 11.5398 2.8039 11.8733 2.59571 12.1422L2.46238 12.3733C2.08016 12.2489 2.27571 12.4266 2.11571 12.1155C0.702379 12.1511 0.800156 13.5644 0.160156 14.3733C0.186823 17.0133 5.42238 20.2755 9.26238 19.28ZM26.6402 11.28C25.0157 11.472 23.4595 12.0446 22.0979 12.9511C21.7494 13.1901 21.4481 13.4915 21.209 13.84C21.0441 14.1408 20.9906 14.4902 21.0579 14.8266C21.0772 15.0377 21.1391 15.2427 21.2399 15.4291C21.3408 15.6155 21.4785 15.7795 21.6446 15.9111C24.4535 15.7066 29.3157 15.5289 30.2668 17.8844C30.3011 18.088 30.3456 18.2897 30.4002 18.4889C31.289 18.2577 30.649 18.3377 32.009 18.5511C32.5512 18.5412 33.0895 18.4575 33.609 18.3022C33.7582 18.2591 33.8873 18.1646 33.9735 18.0355C33.9589 17.9204 33.9589 17.8039 33.9735 17.6889C34.205 17.7116 34.4383 17.6717 34.649 17.5733C35.9468 17.3689 35.2624 16.7555 35.8757 16.0711C35.4579 11.6177 30.9424 10.5955 26.6668 11.2533L26.6402 11.28ZM21.6357 20.8266C20.9868 21.3244 20.7468 21.2 20.329 21.9733C20.329 21.9733 20.3913 22.0889 20.329 22.0889C20.7202 22.8622 21.609 23.1733 22.2668 23.7155C22.4713 23.8933 23.0224 24.8444 23.2802 24.9155C23.5735 25.2622 23.769 26.24 23.9557 26.24C24.1602 26.5066 23.9557 27.1289 24.1424 27.4044C24.1424 28.5511 23.9913 28.64 23.7957 28.8533C23.7957 28.9333 23.9024 29.1466 23.9024 29.2266C23.9024 29.3066 24.4179 29.6088 24.6224 29.5644C25.2446 29.5644 27.8135 31.5911 28.0179 31.9822C29.8579 32.1155 29.7246 31.5555 30.9957 31.0133C31.3424 30.8711 31.6179 31.0133 31.8846 30.7733C32.1513 30.5333 32.1424 30.0533 32.3646 29.8133C32.3735 25.28 26.2046 20.9866 21.6357 20.8266ZM14.3824 21.8666C14.1246 22.1333 13.4135 22.24 13.2179 22.5511C12.7762 23.2886 12.261 23.9795 11.6802 24.6133C9.90238 26.2666 6.2046 27.1022 4.3646 25.5022C4.24016 25.5022 4.31127 25.5822 4.45349 26.0355C4.58682 26.9244 5.28016 28.9066 5.02238 29.4222C5.19127 29.9911 5.36016 29.7866 5.68016 30.0977C6.00016 30.4089 5.98238 30.8711 6.22238 30.9866L7.11127 30.9333C7.1646 31.0844 7.21793 31.2444 7.26238 31.4044L8.34682 31.3244C8.55127 31.3689 9.1646 31.6889 9.34238 31.7333L10.5424 31.6533C10.9801 31.7337 11.4301 31.7164 11.8604 31.6027C12.2906 31.489 12.6904 31.2816 13.0313 30.9955C13.4668 30.7022 13.9202 30.7466 14.3202 30.4177C14.9504 29.8401 15.4951 29.1756 15.9379 28.4444C16.8268 26.8622 16.5157 23.1111 15.7246 22.1511C15.4224 21.7955 15.0579 21.7866 14.3824 21.8666Z'
        fill='#595959'
      />
    </svg>
    <svg width='38' height='15' viewBox='0 0 38 15' fill='none' xmlns='https://www.w3.org/2000/svg'>
      <path
        d='M20.6143 0.55544C24.4098 0.55544 26.9698 2.95544 26.9698 7.23989C26.9698 12.6354 23.4143 14.2266 19.7521 14.2266H14.8098V2.66211V0.564329L20.6143 0.55544ZM19.5032 11.6399C21.6009 11.6399 23.2987 10.9466 23.2987 7.24877C23.2987 4.10211 21.6009 3.05322 19.5032 3.05322H18.4009V11.6399H19.5032ZM32.3476 12.111C32.3476 13.1066 32.4009 14.1999 32.4009 14.1999H28.7298V2.66211V0.564329H37.3965V3.231C37.3965 3.231 35.4587 3.18655 34.8009 3.18655H32.3476V5.88877H36.8454V8.40433H32.3476V12.111ZM7.49428 11.471C7.09379 11.496 6.69249 11.437 6.31613 11.2978C5.93976 11.1587 5.59663 10.9424 5.30874 10.6629C5.02084 10.3833 4.79454 10.0467 4.64433 9.67464C4.49413 9.30254 4.42334 8.90316 4.4365 8.50211V8.351C4.4365 8.351 7.64539 8.271 8.72983 8.271C10.5787 8.271 11.3432 8.271 12.7921 8.22655V7.19544C12.7921 2.53766 10.8187 0.270996 6.74761 0.270996C4.87206 0.270996 0.525391 0.973218 0.525391 7.50655C0.525391 11.8532 2.72983 14.4577 6.56983 14.4577C8.78393 14.5738 10.9735 13.9482 12.7921 12.6799C12.6498 12.4577 11.5209 10.4399 11.3787 10.2177C10.2548 11.047 8.89098 11.4871 7.49428 11.471ZM4.4365 5.72877C4.48984 4.93766 4.77428 3.06211 6.77428 3.06211C8.77428 3.06211 8.93428 4.79544 8.93428 5.72877V5.88877H4.42761L4.4365 5.72877Z'
        fill='#595959'
      />
    </svg>
  </section>
)

export const SnapIncLogo = () => (
  <svg width='136' height='32' viewBox='0 0 136 32' fill='none' xmlns='https://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M14.7414 0.000230622C14.4802 0.00710011 14.2399 0.144232 14.1005 0.365177L13.8364 0.78353C13.6268 1.11166 13.2068 1.23981 12.8514 1.07727C11.2441 0.338972 9.64075 0.178253 8.51355 0.178253C3.86958 0.178253 0.226599 2.85344 0.226599 7.39411C0.226599 11.4714 3.36704 12.9409 4.70387 13.5774C5.67307 14.0119 6.67653 14.378 7.64421 14.7791C10.9179 16.0156 12.5873 16.852 12.5873 18.9211C12.5873 21.1603 10.7501 22.9296 8.24355 22.9296C4.80425 22.9296 3.16604 20.3922 2.69815 19.6569C2.18079 18.8284 1.79991 17.9212 1.57067 16.9717C1.46806 16.5821 1.08763 16.3346 0.689458 16.3961L0.659787 16.3992C0.24931 16.4617 -0.0379118 16.8347 0.00407045 17.2477C0.190923 19.133 0.374453 21.6008 0.39572 23.7337C0.397947 23.9505 0.487729 24.1544 0.647919 24.3004C0.808111 24.4465 1.0223 24.5199 1.23836 24.5022L1.29473 24.4991C1.54647 24.4797 1.77412 24.3405 1.90595 24.1253L2.20265 23.6357C2.31083 23.456 2.48521 23.3253 2.68925 23.2767C2.89326 23.2281 3.10808 23.2659 3.28562 23.3776C4.32167 24.0354 6.10688 24.8997 8.84586 24.8997C14.3573 24.8997 17.833 21.26 17.833 16.9183C17.833 12.5083 14.5263 11.0714 12.1215 10.1357C10.6175 9.53409 9.11394 9.06617 7.67685 8.36434C6.97501 8.03013 5.37145 7.25984 5.37145 5.45663C5.37145 3.88585 6.77563 1.94958 9.1485 1.94958C10.9851 1.94958 12.4562 2.98696 13.5575 4.48938C14.0178 5.17906 14.2539 5.69623 14.6731 6.80367C14.7079 7.10882 14.9156 7.36622 15.2072 7.46235C15.4989 7.5585 15.8197 7.47638 16.0291 7.25169C16.2386 7.02701 16.2997 6.69917 16.1834 6.41499C15.9078 4.52731 15.6961 2.6321 15.5484 0.730124C15.517 0.311463 15.1611 -0.00984575 14.7414 0.000230622ZM81.8648 0.736058C81.4364 0.723905 81.0845 1.0663 81.0845 1.53419C81.0846 1.90548 81.3532 2.22397 81.7194 2.28485C82.7403 2.455 83.1377 2.59438 83.3899 3.18684C83.6254 3.65473 83.6561 4.42246 83.6896 6.96092V17.5829C83.6896 21.8167 83.6103 22.4947 81.7372 22.7575C81.3404 22.8264 81.064 23.1909 81.1082 23.5912C81.1524 23.9915 81.5011 24.2899 81.9034 24.2707C83.0412 24.1901 83.8161 24.1668 85.7606 24.1668C89.3138 24.1668 90.2016 24.1674 91.5582 24.2677C91.7724 24.2823 91.9843 24.2053 92.1397 24.057C92.2951 23.9089 92.3815 23.702 92.3771 23.4874C92.3772 23.11 92.1007 22.7911 91.7273 22.7367C91.0406 22.644 90.5917 22.4657 90.3061 22.1285C89.905 21.5952 89.8715 21.3948 89.8046 17.8856L89.772 7.5306C89.772 3.10082 89.7716 2.49984 91.751 2.25222C92.1692 2.21783 92.4796 1.85155 92.4453 1.43332C92.411 1.01508 92.0446 0.701665 91.6264 0.736064C90.5904 0.771004 89.383 0.813207 87.4993 0.813207C85.6231 0.813207 83.7425 0.786195 81.8648 0.736064L81.8648 0.736058ZM61.6741 8.52158C61.5888 8.50948 61.5007 8.51595 61.416 8.53939C60.2417 8.8584 57.8535 9.47279 55.5976 9.71433C55.2745 9.75149 55.0325 10.0241 55.0338 10.3493V10.5184C55.0308 10.8067 55.2173 11.0624 55.4937 11.1445C56.6331 11.4589 56.9995 12.0578 56.9387 14.61L56.9713 25.4337C56.9713 26.169 56.9721 28.1396 56.9387 28.7746C56.9387 29.7271 56.8313 30.4104 55.5887 30.6231C55.2818 30.6748 55.0665 30.9541 55.0665 31.264V31.3471C55.0671 31.5219 55.1386 31.6895 55.2653 31.8099C55.3921 31.9304 55.5623 31.9933 55.737 31.985C56.8065 31.9394 57.6198 31.9167 58.8762 31.9167C60.5282 31.9268 62.1797 31.9541 63.8311 31.9998C64.0037 32.0039 64.1705 31.9394 64.294 31.8188C64.4175 31.6982 64.4868 31.5317 64.4868 31.3589C64.4912 31.0539 64.2786 30.7893 63.9795 30.7299C62.5971 30.496 62.5167 29.5007 62.5167 28.2079V24.3508C62.5178 24.1247 62.6394 23.9166 62.8342 23.8019C63.029 23.6872 63.2681 23.6842 63.4662 23.7929C64.1118 24.1408 65.0458 24.4664 66.3264 24.4664C70.501 24.4664 74.0763 20.9589 74.0763 15.9154C74.0763 12.2406 71.5705 8.76483 67.5281 8.76483C65.8874 8.76483 64.5932 9.20355 63.2822 10.0436C63.1011 10.1552 62.8766 10.1699 62.6829 10.0822C62.4892 9.99447 62.3535 9.81714 62.3179 9.60747C62.2754 9.36897 62.2401 9.17791 62.2052 9.02296C62.1706 8.85047 62.0642 8.69977 61.9144 8.60758C61.8395 8.56147 61.7594 8.53363 61.6741 8.52153V8.52158ZM30.7931 8.99928C29.0324 8.99928 27.8378 9.54289 26.5769 10.2751C26.396 10.3839 26.174 10.4029 25.9776 10.3255C25.781 10.2481 25.6322 10.0835 25.5741 9.88049C25.5513 9.7939 25.5243 9.71047 25.4969 9.62236C25.4406 9.44952 25.3186 9.3056 25.1557 9.22477C24.9929 9.14391 24.8053 9.13262 24.6335 9.19214C23.3134 9.64787 20.7961 10.3602 19.1326 10.6519C18.806 10.7081 18.5659 10.9868 18.5659 11.3195V11.3996C18.5645 11.7009 18.7633 11.9648 19.0525 12.0494C19.8424 12.2727 20.4055 12.7341 20.4055 14.4112C20.4055 15.5809 20.4381 17.4843 20.4381 18.654C20.4381 19.1554 20.4375 21.1595 20.3372 21.9297C20.2446 22.5707 19.634 22.7867 19.1296 22.8702C18.8045 22.9249 18.5659 23.2081 18.5659 23.5408V23.5764C18.565 23.7676 18.6442 23.9487 18.7855 24.0778C18.9267 24.2069 19.1172 24.2709 19.3077 24.2529C19.8773 24.1982 20.4876 24.1639 21.5389 24.1639C24.2718 24.1639 25.7299 24.2111 26.8647 24.2825C27.052 24.2942 27.2354 24.2273 27.3721 24.0986C27.5088 23.9699 27.586 23.7909 27.5857 23.6031V23.5141C27.5857 23.2118 27.3908 22.9403 27.0991 22.8643C26.2833 22.6486 26.0161 22.2252 26.0161 20.6924C26.0161 19.2067 26.0159 14.4534 25.9627 12.7793C25.9576 12.5557 26.0613 12.345 26.2416 12.2126C26.9161 11.7037 27.6164 11.37 28.5203 11.37C30.6927 11.37 30.7597 13.2091 30.7931 14.8117L30.8613 20.0248C30.8902 22.0589 30.767 22.5258 29.7902 22.7901C29.494 22.8676 29.2888 23.1375 29.2888 23.4429V23.5853C29.2889 23.7759 29.3705 23.9581 29.5113 24.0867C29.652 24.2152 29.8407 24.2788 30.0305 24.2618C30.7096 24.2025 31.4385 24.1639 32.7632 24.1639C35.1118 24.1639 36.5433 24.2069 37.4897 24.2707C37.6768 24.2828 37.8603 24.2151 37.9971 24.0867C38.1338 23.9584 38.2111 23.7788 38.2107 23.5912C38.2151 23.269 37.9893 22.9915 37.6736 22.9266C36.5692 22.7215 36.3414 22.2046 36.3414 21.36C36.3414 20.7903 36.4067 18.1852 36.4067 17.6838V14.7524C36.27 12.9249 35.9983 11.1977 34.3713 10.0674C33.3353 9.3337 32.0631 8.9993 30.7931 8.9993L30.7931 8.99928ZM104.848 8.99928C103.085 8.99928 101.889 9.54289 100.628 10.2751C100.447 10.3833 100.225 10.4029 100.029 10.3255C99.8331 10.2482 99.6839 10.083 99.6256 9.88049C99.6028 9.7939 99.5787 9.71047 99.5514 9.62236C99.495 9.44952 99.37 9.30562 99.2072 9.22477C99.0443 9.14392 98.8568 9.13262 98.685 9.19214C97.3634 9.64787 94.8505 10.3602 93.1871 10.6519C92.8589 10.7081 92.6204 10.9868 92.6204 11.3195V11.3996C92.619 11.7009 92.8147 11.9648 93.104 12.0494C93.8939 12.2727 94.457 12.7341 94.457 14.4112C94.457 15.5809 94.4896 17.4843 94.4896 18.654C94.4896 19.1554 94.4919 21.1595 94.3917 21.9297C94.299 22.5707 93.6884 22.7867 93.1841 22.8702C92.859 22.9249 92.6204 23.2081 92.6204 23.5408V23.5764C92.6194 23.7676 92.6986 23.9487 92.8399 24.0778C92.9812 24.2069 93.1686 24.2709 93.3591 24.2529C93.9288 24.1982 94.5421 24.1639 95.5933 24.1639C98.3262 24.1639 99.7844 24.2111 100.919 24.2825C101.106 24.2942 101.29 24.2273 101.427 24.0986C101.563 23.9699 101.64 23.7909 101.64 23.6031V23.5141C101.64 23.2118 101.442 22.9403 101.151 22.8643C100.333 22.6486 100.068 22.2252 100.068 20.6924C100.068 19.2067 100.07 14.4534 100.017 12.7793C100.012 12.5559 100.113 12.3453 100.293 12.2126C100.968 11.7037 101.671 11.37 102.575 11.37C104.747 11.37 104.813 13.2091 104.848 14.8117L104.913 20.0248C104.942 22.0589 104.821 22.5258 103.845 22.7901C103.548 22.8676 103.343 23.1375 103.343 23.4429V23.5853C103.343 23.7759 103.422 23.9581 103.563 24.0867C103.703 24.2152 103.892 24.2788 104.082 24.2618C104.761 24.2025 105.491 24.1639 106.818 24.1639C109.165 24.1639 110.596 24.2069 111.541 24.2707C111.729 24.2833 111.912 24.2181 112.049 24.0897C112.186 23.9612 112.263 23.7791 112.262 23.5912C112.267 23.269 112.044 22.9915 111.728 22.9266C110.622 22.7215 110.393 22.2046 110.393 21.36C110.393 20.7903 110.461 18.1852 110.461 17.6838V14.8058C110.461 14.7876 110.461 14.7706 110.458 14.7524C110.324 12.9249 110.048 11.1977 108.42 10.0674C107.384 9.3337 106.116 8.9993 104.847 8.9993L104.848 8.99928ZM48.2363 9.06455C44.0937 9.06455 39.5162 11.0717 39.5162 13.5448C39.5162 14.7798 40.4829 15.4467 41.519 15.4467C42.353 15.4467 43.29 15.0119 43.5573 13.8771C43.6576 13.4426 43.6588 12.9764 43.7591 12.5419C43.9596 11.8067 44.561 11.1385 45.6639 11.1385C45.831 11.1385 47.1647 11.1378 47.5658 12.3075C47.7056 12.7268 47.7053 13.9419 47.7023 14.9749C47.7018 15.3001 47.4674 15.5779 47.1474 15.6366C44.4874 16.1136 38.6142 17.7115 38.6142 21.5291C38.6142 22.7642 39.3492 24.8344 42.4239 24.8344C44.5324 24.8344 46.4301 23.7699 47.3492 23.1728C47.6438 22.9781 48.0385 23.0452 48.2512 23.3271C48.4307 23.5644 48.6393 23.7787 48.8713 23.965C49.5989 24.4977 50.4739 24.791 51.3755 24.8018C52.252 24.8018 53.8435 24.4719 55.4492 22.8465C55.5825 22.7093 55.651 22.5212 55.6391 22.3302C55.6273 22.1394 55.5361 21.9633 55.3869 21.8436C55.1457 21.6498 54.8022 21.6443 54.5561 21.8318C54.3647 21.9806 54.1636 22.0929 53.9479 22.0929C53.079 22.0929 53.1134 20.7918 53.1468 20.2236L53.2121 12.7734C53.2121 9.99945 51.109 9.06457 48.2363 9.06457L48.2363 9.06455ZM121.327 9.10016C116.348 9.10016 112.274 12.1719 112.274 16.948C112.274 21.4917 115.78 24.8018 120.558 24.8018C123.154 24.7806 125.641 23.744 127.483 21.9148C127.851 21.5502 127.793 20.9369 127.373 20.6331C127.051 20.4018 126.61 20.4234 126.314 20.6865C125.401 21.4886 124.373 22.0602 123.13 22.0602C120.793 22.0602 118.653 19.5214 118.653 15.7463C118.653 14.1087 119.189 10.8032 121.128 10.8032C122.162 10.8032 122.83 11.9396 123.13 12.5746C123.765 14.0101 123.833 14.1764 124.133 14.4438C124.501 14.8114 125.104 15.0461 125.605 15.0461C126.741 15.0461 127.709 14.0773 127.709 12.9425C127.709 10.5362 124.6 9.10016 121.327 9.10016V9.10016ZM64.6886 11.2038C67.1587 11.2038 68.16 14.4111 68.16 16.8174C68.16 19.0885 67.2611 22.529 64.7895 22.529C62.485 22.529 62.4841 20.6255 62.4841 19.556C62.4841 18.7205 62.4485 14.9781 62.4485 14.2094C62.4485 13.5091 62.4494 11.2038 64.6886 11.2038H64.6886ZM47.1237 17.3159C47.2239 17.3362 47.3195 17.3797 47.4026 17.4435C47.569 17.5713 47.6655 17.7679 47.6667 17.9776V20.9031C47.6676 21.1284 47.5568 21.3379 47.37 21.4638C46.9644 21.7312 46.5781 21.9267 45.931 21.9267C44.661 21.9267 44.1923 20.9272 44.1923 20.0248C44.1923 18.2687 45.6879 17.6104 46.8151 17.3248C46.9166 17.2983 47.0236 17.2956 47.1237 17.3158V17.3159ZM131.987 18.7876C130.617 18.7876 129.011 19.8235 129.011 21.8941C129.031 23.5361 130.378 24.8513 132.02 24.8344C133.624 24.8344 135.025 23.5303 135.025 21.8258C135.025 20.0894 133.625 18.7876 131.987 18.7876Z'
      fill='#595959'
    />
  </svg>
)

export const EyLogo = () => (
  <svg width='32' height='32' viewBox='0 0 356.3 374.6' xmlns='https://www.w3.org/2000/svg'>
    <style>
      {'.st0,.st1{fill:#595959}.st1{opacity:0;stroke:#fff;stroke-width:4.998900e-02;stroke-miterlimit:10}'}
    </style>
    <path className='st0' d='M0.3 134.8L356.2 4.9 356.3 4.9 356.3 72 0.3 134.8z' />
    <path className='st1' d='M0 134.9L510.8 -51.5 510.8 44.7z' />
    <path
      className='st0'
      d='M3.2 374.6L3.2 190.3 107.9 190.3 132.3 232.6 58.3 232.6 58.3 263 125.3 263 125.3 301.9 58.3 301.9 58.3 332.3 150.8 332.3 150.8 374.6z'
    />
    <path
      className='st1'
      d='M58.3 301.9L125.3 301.9 125.3 263 58.3 263 58.3 232.6 132.3 232.6 107.9 190.3 3.2 190.3 3.2 374.6 150.8 374.6 150.8 332.3 58.3 332.3z'
    />
    <path
      className='st0'
      d='M189.7 374.6L189.7 301.9 125.3 190.3 186.5 190.3 217.5 250.6 248.9 190.3 309.5 190.3 244.8 301.9 244.8 374.6z'
    />
    <path
      className='st1'
      d='M248.9 190.3L217.5 250.6 186.5 190.3 125.3 190.3 189.7 301.9 189.7 374.6 244.8 374.6 244.8 301.9 309.5 190.3z'
    />
  </svg>
)

export const GdprLogo = () => (
  <svg width={76} height={79} viewBox='0 0 76 79' fill='none'>
    <path d='M76 0H0v39.5h76V0z' fill='#BFBFBF' />
    <path d='M76 39.5H0V79h76V39.5z' fill='#595A5A' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M40.864 18.324l-3.745 3.84c-.11.11-.33.22-.44.22h-.331c-.11 0-.33-.11-.44-.22l-1.763-1.756a.333.333 0 010-.439l.661-.658c.11-.11.33-.11.44 0l1.102 1.097c.11.11.33.11.44 0l3.085-3.182c.11-.11.33-.11.44 0l.661.659c0 .11 0 .329-.11.439zM37.449 7.68l.44 1.317h1.212l-.991.768.33 1.207-.991-.768-.991.768.33-1.207-.991-.768h1.212l.44-1.316zM37.449 28.528l.44 1.207h1.212l-.991.768.33 1.317-.991-.769-.991.769.33-1.317-.991-.768h1.212l.44-1.207zM42.627 9.546l.44 1.317h1.322l-1.101.768.44 1.207-1.101-.768-.992.768.441-1.207-1.101-.768h1.321l.33-1.317zM46.922 23.151l.33 1.317h1.322l-.991.768.33 1.317-.991-.878-1.102.878.44-1.317-.99-.768h1.211l.44-1.317zM47.914 18.104l.33 1.207h1.322l-.991.878.33 1.207-.991-.768-.991.768.33-1.207-.991-.878h1.211l.44-1.207zM26.986 18.104l.44 1.207h1.212l-.991.878.33 1.207-.99-.768-.992.768.33-1.207-.991-.878h1.322l.33-1.207zM27.867 23.151l.44 1.317h1.212l-.991.768.33 1.317-.991-.878-.991.878.33-1.317-.991-.768h1.211l.441-1.317zM46.922 12.837l.33 1.317h1.322l-.991.768.33 1.207-.991-.768-1.102.768.44-1.207-.99-.768h1.211l.44-1.317zM28.306 12.837l.33 1.317h1.323l-.992.768.33 1.207-.99-.768-.992.768.33-1.207-.99-.768h1.21l.442-1.317zM43.617 27.54l.44 1.317h1.212l-.991.768.33 1.207-.991-.768-.991.768.33-1.207-.991-.768h1.322l.33-1.316zM32.272 9.546l.33 1.317h1.322l-1.101.768.44 1.207-.99-.768-1.102.768.44-1.207-1.101-.768h1.321l.441-1.317zM31.281 27.54l.33 1.317h1.322l-.991.768.33 1.207-.99-.768-.992.768.33-1.207-.991-.768h1.211l.441-1.316zM25.113 60.347c-.661.11-1.322.22-2.093.22-.77 0-1.542-.11-2.203-.33-.66-.219-1.211-.548-1.652-.987-.44-.439-.881-.988-1.101-1.646-.22-.658-.441-1.317-.441-2.085s.11-1.426.44-2.084c.22-.659.662-1.207 1.102-1.646.44-.44.991-.768 1.652-.988.661-.22 1.322-.329 2.093-.329.771 0 1.432.11 2.093.33.66.219 1.211.548 1.652.877l-1.432 1.646c-.22-.22-.55-.439-.881-.658-.33-.22-.771-.22-1.322-.22-.44 0-.77.11-1.101.22-.33.11-.661.329-.881.658-.22.22-.441.549-.551.987-.11.33-.22.769-.22 1.207 0 .44.11.878.22 1.207.11.33.33.659.55.988.22.22.551.439.882.658.33.11.77.22 1.321.22.22 0 .551 0 .772-.11.22 0 .44-.11.66-.22v-1.755H22.8v-1.865h3.965v5.047c-.44.329-.991.548-1.652.658zM36.017 55.52c0-.549-.11-.988-.22-1.317-.22-.33-.441-.658-.661-.878-.33-.22-.661-.329-.992-.439-.33-.11-.77-.11-1.211-.11H31.72v5.596h1.102c.44 0 .88 0 1.211-.11.44-.109.771-.219.992-.438.33-.22.55-.549.66-.878.33-.439.33-.878.33-1.426zm2.533 0c0 .877-.11 1.536-.44 2.194-.33.658-.771 1.097-1.212 1.536-.55.44-1.101.659-1.762.878-.771.11-1.432.22-2.093.22h-3.635v-9.656h3.525c.66 0 1.322.11 1.983.22.66.11 1.211.438 1.762.767.55.33.991.878 1.211 1.427.44.768.661 1.536.661 2.414zM45.82 53.654c0-.22 0-.439-.11-.548l-.33-.33c-.22 0-.44-.11-.66-.11h-1.653v2.195H44.719c.22 0 .33-.11.55-.22.111-.109.331-.219.331-.328.11-.22.22-.44.22-.659zm2.314 0c0 .549-.11.988-.33 1.427-.221.439-.441.658-.882.878-.44.219-.771.438-1.212.548-.44.11-.99.11-1.431.11h-1.212v3.73h-2.313v-9.655h3.525c.55 0 .99 0 1.542.11.44.11.88.22 1.211.548.33.22.661.549.771.878.22.439.33.878.33 1.426zM55.403 53.654c0-.22 0-.439-.11-.548l-.33-.33c-.11-.11-.33-.11-.55-.11H52.65v2.195H54.3c.221 0 .441-.11.552-.22.11-.109.33-.219.44-.328 0-.22.11-.44.11-.659zm0 6.693l-2.092-3.84h-.771v3.84h-2.313v-9.655h3.745c.44 0 .88 0 1.321.11.44.11.881.22 1.212.438.33.22.66.55.881.878.22.33.33.878.33 1.427 0 .658-.22 1.207-.55 1.645-.33.44-.881.769-1.432.988l2.533 4.06h-2.864v.11zM17.072 68.357h2.974v.439h-3.524v-5.377h3.414v.44h-2.864v1.865h2.644v.548h-2.644v2.085zM23.792 64.297c-.11-.11-.22-.33-.44-.439-.22-.11-.44-.11-.661-.11-.11 0-.22 0-.44.11-.11 0-.221.11-.331.22-.11.11-.22.22-.22.329-.11.11-.11.329-.11.439 0 .11 0 .329.11.439.11.11.11.219.22.329.11.11.22.11.33.22.11 0 .33.109.44.109.221.11.331.11.551.22.22.11.331.11.551.329.11.11.33.219.33.438.11 0 .11.22.11.44 0 .219 0 .548-.11.658-.11.22-.22.329-.44.438-.22.11-.33.22-.55.33-.22.11-.441.11-.662.11h-.44c-.11 0-.33-.11-.44-.11-.11-.11-.331-.11-.441-.22l-.33-.329.44-.33c.11.22.33.33.55.44.221.11.441.22.772.22.11 0 .33 0 .44-.11.11 0 .22-.11.44-.22l.331-.33c.11-.109.11-.328.11-.438 0-.22 0-.33-.11-.439l-.33-.329c-.11-.11-.22-.11-.44-.22-.11-.11-.331-.11-.551-.219-.22-.11-.33-.11-.551-.22-.22-.11-.33-.11-.44-.329-.11-.11-.221-.219-.331-.438-.22-.11-.22-.33-.22-.549 0-.22 0-.439.11-.658.11-.22.22-.33.44-.44.22-.109.33-.219.551-.219.22-.11.44-.11.66-.11.331 0 .662.11.992.22.22.11.44.33.55.439l-.44.33zM28.087 64.297c-.11-.11-.22-.329-.44-.439-.22-.11-.441-.11-.661-.11-.11 0-.22 0-.44.11-.111 0-.221.11-.331.22-.11.11-.22.22-.22.329-.11.11-.11.33-.11.439 0 .11 0 .329.11.439.11.11.11.22.22.329.11.11.22.11.33.22.11 0 .33.109.44.109.221.11.331.11.552.22.22.11.33.11.55.329.11.11.33.22.33.438.11.22.11.44.11.659 0 .22 0 .549-.11.658-.11.22-.22.33-.44.44-.22.109-.33.219-.55.328-.221.11-.441.11-.662.11h-.44c-.11 0-.33-.11-.44-.11-.11-.11-.331-.11-.441-.22l-.33-.328.44-.33c.11.22.33.33.55.44.22.11.441.219.772.219.11 0 .33 0 .44-.11.11 0 .22-.11.44-.22l.331-.328c.11-.11.11-.33.11-.44 0-.219 0-.329-.11-.438l-.33-.33c-.11-.11-.22-.11-.44-.219-.111-.11-.331-.11-.552-.22-.22-.11-.33-.11-.55-.219-.22-.11-.33-.11-.44-.329-.111-.11-.221-.22-.331-.439-.11-.22-.11-.329-.11-.658 0-.22 0-.44.11-.659.11-.219.22-.329.44-.438.22-.11.33-.22.551-.22.22-.11.44-.11.66-.11.331 0 .662.11.992.22.22.11.44.329.55.439l-.55.22zM30.4 68.357h2.864v.439H29.85v-5.377h3.414v.44H30.4v1.865h2.644v.548H30.4v2.085zM38.33 68.028v-4.609h.551v5.377h-.77l-3.195-4.609v4.609h-.55v-5.377h.77l3.194 4.609zM42.075 68.796h-.55v-4.938h-1.873v-.439h4.296v.44h-1.873v4.937zM44.719 68.796h.55v-5.377h-.55v5.377zM47.473 66.93h2.423l-1.212-2.852-1.211 2.852zm-.771 1.866h-.661l2.313-5.377h.55l2.314 5.377h-.55l-.552-1.427h-2.863l-.551 1.427zM52.648 68.357h2.644v.439h-3.194v-5.377h.55v4.938zM58.706 64.297c-.11-.11-.22-.329-.44-.439-.22-.11-.44-.11-.661-.11-.11 0-.22 0-.44.11-.11 0-.221.11-.331.22-.11.11-.22.22-.22.329-.11.11-.11.33-.11.439 0 .11 0 .329.11.439.11.11.11.22.22.329.11.11.22.11.33.22.11 0 .33.109.44.109.221.11.331.11.552.22.22.11.33.11.55.329.11.11.33.22.33.438.11.22.11.44.11.659 0 .22 0 .549-.11.658-.11.22-.22.33-.44.44-.22.109-.33.219-.55.328-.22.11-.441.11-.661.11h-.441c-.11 0-.33-.11-.44-.11-.11-.11-.331-.11-.441-.22l-.33-.328.44-.33c.11.22.33.33.55.44.221.11.441.219.772.219.11 0 .33 0 .44-.11.11 0 .22-.11.44-.22l.331-.328c.11-.11.11-.33.11-.44 0-.219 0-.329-.11-.438l-.33-.33c-.11-.11-.22-.11-.44-.219-.11-.11-.331-.11-.551-.22-.22-.11-.33-.11-.551-.219-.22-.11-.33-.11-.44-.329-.11-.11-.221-.22-.331-.439-.11-.22-.11-.329-.11-.658 0-.22 0-.44.11-.659.11-.219.22-.329.44-.438.22-.11.33-.22.551-.22.22-.11.44-.11.661-.11.33 0 .66.11.991.22.22.11.44.329.551.439l-.55.22z'
      fill='#fff'
    />
  </svg>
)
export const IsoLogo = () => (
  <svg
    id='Layer_1'
    xmlns='http://www.w3.org/2000/svg'
    x='0px'
    y='0px'
    width='79px'
    height='79px'
    viewBox='0 0 1890 1890'>
    <path
      fill='#FFFFFF'
      opacity='1.000000'
      stroke='none'
      d='
M1.000000,463.000000 
C1.000000,308.666656 1.000000,154.833328 1.000000,1.000000 
C631.000000,1.000000 1261.000000,1.000000 1891.000000,1.000000 
C1891.000000,631.000000 1891.000000,1261.000000 1891.000000,1891.000000 
C1261.000000,1891.000000 631.000000,1891.000000 1.000000,1891.000000 
C1.000000,1415.166626 1.000000,939.333313 1.000000,463.000000 
M583.500061,22.154867 
C399.169586,22.154865 214.839127,22.154854 30.508654,22.154903 
C22.155579,22.154905 22.154959,22.155172 22.154957,30.265064 
C22.154839,640.757141 22.154839,1251.249268 22.154957,1861.741333 
C22.154959,1869.843872 22.155586,1869.845093 30.015030,1869.845093 
C640.673767,1869.845337 1251.332520,1869.845215 1861.991333,1869.845215 
C1862.657959,1869.845215 1863.332031,1869.781006 1863.990112,1869.855469 
C1868.214844,1870.333862 1870.362305,1868.720825 1869.867554,1864.231079 
C1869.722412,1862.913818 1869.845215,1861.566895 1869.845215,1860.233643 
C1869.845093,1250.574829 1869.845093,640.916016 1869.845093,31.257240 
C1869.845093,22.154961 1869.845703,22.154877 1860.983643,22.154877 
C1435.489136,22.154863 1009.994629,22.154867 583.500061,22.154867 
z'
    />
    <path
      fill='#131313'
      opacity='1.000000'
      stroke='none'
      d='
M584.000122,22.154869 
C1009.994629,22.154867 1435.489136,22.154863 1860.983643,22.154877 
C1869.845703,22.154877 1869.845093,22.154961 1869.845093,31.257240 
C1869.845093,640.916016 1869.845093,1250.574829 1869.845215,1860.233643 
C1869.845215,1861.566895 1869.722412,1862.913818 1869.867554,1864.231079 
C1870.362305,1868.720825 1868.214844,1870.333862 1863.990112,1869.855469 
C1863.332031,1869.781006 1862.657959,1869.845215 1861.991333,1869.845215 
C1251.332520,1869.845215 640.673767,1869.845337 30.015030,1869.845093 
C22.155586,1869.845093 22.154959,1869.843872 22.154957,1861.741333 
C22.154839,1251.249268 22.154839,640.757141 22.154957,30.265064 
C22.154959,22.155172 22.155579,22.154905 30.508654,22.154903 
C214.839127,22.154854 399.169586,22.154865 584.000122,22.154869 
M238.500000,1865.004395 
C780.589844,1865.004395 1322.679688,1865.004395 1864.716797,1865.004395 
C1864.716797,1252.028687 1864.716797,639.629333 1864.716797,27.283981 
C1252.029053,27.283981 639.629639,27.283981 27.283836,27.283981 
C27.283836,639.971985 27.283836,1252.371460 27.283836,1865.004395 
C97.547989,1865.004395 167.524002,1865.004395 238.500000,1865.004395 
z'
    />
    <path
      fill='#FFFFFF'
      opacity='1.000000'
      stroke='none'
      d='
M238.000000,1865.004395 
C167.524002,1865.004395 97.547989,1865.004395 27.283836,1865.004395 
C27.283836,1252.371460 27.283836,639.971985 27.283836,27.283981 
C639.629639,27.283981 1252.029053,27.283981 1864.716797,27.283981 
C1864.716797,639.629333 1864.716797,1252.028687 1864.716797,1865.004395 
C1322.679688,1865.004395 780.589844,1865.004395 238.000000,1865.004395 
M1224.667358,1765.188843 
C1235.487061,1785.598633 1246.283447,1806.020752 1257.162231,1826.399048 
C1258.246338,1828.430054 1259.459717,1831.214233 1261.260132,1831.868774 
C1264.953857,1833.211548 1269.163574,1834.027222 1272.994995,1833.593506 
C1274.260986,1833.450073 1275.851685,1828.810059 1275.876099,1826.212891 
C1276.098022,1802.555542 1275.896729,1778.894165 1276.105591,1755.236572 
C1276.144043,1750.895752 1274.542725,1749.812012 1270.611816,1749.780640 
C1266.571167,1749.748535 1264.237793,1750.618164 1264.774780,1755.338501 
C1265.130371,1758.463745 1264.842041,1761.662231 1264.842041,1764.828003 
C1264.842041,1782.243774 1264.842041,1799.659424 1264.842041,1818.432983 
C1263.773926,1816.496826 1263.324585,1815.712646 1262.903198,1814.913818 
C1253.210449,1796.539185 1243.529419,1778.158447 1233.818237,1759.793579 
C1232.731689,1757.739014 1231.618530,1755.671387 1230.267456,1753.789551 
C1227.739258,1750.268066 1220.431885,1748.479126 1215.625244,1750.232178 
C1211.166748,1751.858154 1212.230713,1755.860962 1212.222290,1759.209839 
C1212.164307,1782.535767 1212.311401,1805.863281 1212.087280,1829.187378 
C1212.044678,1833.624390 1213.989624,1834.640503 1217.674927,1834.690063 
C1221.526611,1834.741821 1223.717407,1833.856689 1223.639404,1829.085449 
C1223.313110,1809.096436 1223.378906,1789.100830 1223.358276,1769.107544 
C1223.356812,1767.709351 1223.819580,1766.310669 1224.023315,1764.971436 
C1224.023315,1764.971436 1223.975830,1765.027466 1224.667358,1765.188843 
M95.099556,1177.934570 
C95.156487,1190.962158 95.213425,1203.989868 95.108849,1217.940063 
C95.135468,1242.274536 95.162086,1266.609131 95.037491,1291.807007 
C96.815163,1292.204468 98.592796,1292.949341 100.370529,1292.949463 
C185.698578,1292.958740 271.026642,1292.885986 356.354675,1292.922119 
C359.682220,1292.923584 361.716217,1292.017944 363.662689,1289.161255 
C550.007141,1015.664001 736.438477,742.225952 922.754578,468.709351 
C924.479858,466.176575 925.553223,462.642609 925.556763,459.574493 
C925.695679,339.079590 925.675354,218.584488 925.665344,98.089417 
C925.665222,96.506859 925.529480,94.924316 925.394043,91.966209 
C923.614624,94.471893 922.588989,95.882812 921.597229,97.317169 
C745.098572,352.567078 568.606995,607.821899 392.098541,863.065063 
C374.868011,887.981567 357.533905,912.826477 340.175354,936.807861 
C340.088531,926.873779 340.001678,916.939758 340.115021,906.086365 
C340.049927,892.725891 339.984863,879.365356 340.115173,865.084839 
C340.048279,849.390991 339.981384,833.697205 340.104614,817.082458 
C340.039795,806.722778 339.974976,796.363098 340.097626,785.082092 
C340.032043,765.390320 339.966461,745.698608 340.093933,725.086060 
C340.031677,701.058716 339.969421,677.031372 340.091248,652.081970 
C340.091248,621.183044 340.091248,590.284058 340.091248,559.445801 
C258.040619,559.445801 176.792068,559.445801 95.079498,559.445801 
C95.079498,561.513916 95.079559,563.305298 95.079491,565.096680 
C95.075020,695.072876 95.069771,825.049133 95.074394,955.025330 
C95.074455,956.686096 95.200218,958.346802 95.108017,960.931763 
C95.163338,985.958740 95.218658,1010.985718 95.116096,1036.936523 
C95.165451,1056.293091 95.214813,1075.649658 95.101028,1095.930054 
C95.154869,1106.623413 95.208710,1117.316772 95.099159,1128.933228 
C95.152504,1144.959106 95.205841,1160.984985 95.099556,1177.934570 
M1409.500000,98.115440 
C1273.562622,98.115440 1137.625122,98.115440 1001.482422,98.115440 
C1001.482422,456.646606 1001.482422,814.669128 1001.482422,1172.605225 
C1281.800781,1172.605225 1561.821533,1172.605225 1841.645630,1172.605225 
C1841.645630,814.304260 1841.645630,456.401031 1841.645630,98.115440 
C1697.737061,98.115440 1554.118530,98.115440 1409.500000,98.115440 
M925.669922,951.500000 
C925.669922,920.070801 925.669922,888.641541 925.669922,857.212341 
C925.209534,857.145447 924.749146,857.078552 924.288818,857.011719 
C825.410889,1001.993591 726.533020,1146.975464 627.252686,1292.547363 
C727.290710,1292.547363 826.162537,1292.547363 925.669617,1292.547363 
C925.669617,1179.000366 925.669617,1065.750244 925.669922,951.500000 
M650.123413,1565.382690 
C652.968750,1567.672485 655.617615,1570.276123 658.691589,1572.200562 
C677.315674,1583.860229 697.713806,1584.905884 718.447205,1580.719849 
C741.688660,1576.027344 757.131592,1561.680176 765.064087,1539.418823 
C772.517273,1518.502808 772.790283,1497.011475 769.318115,1475.355591 
C767.175781,1461.994263 762.496887,1449.656616 753.186584,1439.495483 
C739.830566,1424.918945 722.428894,1420.470703 703.544617,1420.129028 
C668.324829,1419.491699 643.203857,1437.419556 634.389771,1469.533813 
C629.517090,1487.287109 629.080383,1505.323853 631.680298,1523.498901 
C633.889771,1538.944214 638.568237,1553.280273 650.123413,1565.382690 
M1203.020264,1479.486572 
C1200.870117,1499.808838 1201.108643,1520.088135 1205.088867,1540.161011 
C1207.944458,1554.561890 1213.640137,1567.577881 1226.764526,1575.785522 
C1255.762329,1593.919434 1294.824951,1579.467651 1304.749512,1546.041870 
C1313.752319,1515.720459 1313.329712,1484.791870 1305.047607,1454.313721 
C1299.638916,1434.408936 1286.235962,1422.978516 1265.247803,1420.461304 
C1238.405762,1417.242310 1217.381958,1429.416870 1208.477417,1454.813477 
C1205.806641,1462.431396 1204.847656,1470.649536 1203.020264,1479.486572 
M1085.957642,1458.489136 
C1085.621216,1459.600830 1085.224487,1460.698364 1084.957397,1461.826416 
C1079.438110,1485.133789 1079.543945,1508.638672 1082.499268,1532.243774 
C1083.854858,1543.072388 1086.573242,1553.489868 1092.545898,1562.752930 
C1105.653198,1583.081421 1139.207031,1589.446533 1161.370728,1575.924927 
C1175.595703,1567.246460 1182.521362,1553.662964 1185.872314,1538.101929 
C1190.757080,1515.418335 1190.532104,1492.519409 1187.400513,1469.600098 
C1185.710571,1457.231689 1182.191284,1445.590698 1174.272827,1435.635376 
C1159.556030,1417.133057 1130.043457,1417.500244 1113.960083,1424.337646 
C1099.054810,1430.674316 1091.056152,1442.954590 1085.957642,1458.489136 
M517.382019,1561.226807 
C517.052124,1568.991333 521.753906,1573.005981 528.254211,1575.480957 
C533.361206,1577.425415 538.464722,1579.630615 543.774292,1580.746216 
C562.482544,1584.677002 580.467957,1583.316528 596.814758,1572.155029 
C618.622681,1557.264404 621.150818,1522.395996 600.595337,1505.957642 
C591.277283,1498.505859 579.696289,1493.907104 569.235229,1487.852661 
C562.791809,1484.123413 556.091064,1480.637695 550.289978,1476.051025 
C543.303040,1470.526489 541.425903,1462.529663 543.452576,1453.952271 
C545.451477,1445.492798 551.264709,1440.322632 559.631653,1438.983398 
C565.430908,1438.055176 571.761658,1437.466553 577.334839,1438.838623 
C584.788330,1440.673828 591.760803,1444.501831 598.892334,1447.584106 
C601.338318,1448.641235 603.563782,1449.794556 604.941040,1446.263794 
C608.210754,1437.881226 604.871033,1429.814209 596.569031,1426.208740 
C582.386475,1420.049316 567.758972,1418.520752 552.702148,1422.259521 
C522.302124,1429.808105 514.830322,1460.060791 526.515869,1481.847900 
C530.906860,1490.034546 537.817688,1495.757935 545.886230,1500.034790 
C557.031921,1505.942749 568.463013,1511.326782 579.472717,1517.471191 
C585.842896,1521.026489 590.834961,1526.340088 591.973511,1534.018433 
C594.321350,1549.852051 585.575378,1561.408691 569.369324,1564.053223 
C554.317688,1566.509399 540.793579,1562.174194 527.949829,1554.670410 
C519.372864,1549.659546 518.236938,1550.345581 517.382019,1561.226807 
M932.230957,1580.428467 
C940.468933,1580.411621 941.902832,1579.121826 941.971680,1571.666504 
C942.039917,1564.276978 940.352905,1562.695068 932.383911,1562.694336 
C913.057007,1562.692383 893.730042,1562.693726 874.403137,1562.693726 
C872.855652,1562.693726 871.308105,1562.693726 868.462708,1562.693726 
C871.400574,1559.594849 873.353577,1557.583008 875.253784,1555.522461 
C888.010803,1541.689209 901.165283,1528.195312 913.391418,1513.907104 
C925.713562,1499.506714 934.383911,1483.269409 934.831116,1463.513428 
C935.256348,1444.724854 925.553589,1428.795898 908.850159,1423.351074 
C889.319519,1416.984741 870.839539,1420.517212 853.142151,1430.295898 
C846.672974,1433.870361 845.313904,1439.232422 846.110657,1445.865356 
C846.842896,1451.960815 848.792786,1452.972534 854.179199,1449.888550 
C856.199097,1448.731934 858.139893,1447.430176 860.195740,1446.344238 
C869.589050,1441.381958 879.314514,1437.953247 890.244202,1438.971924 
C900.921814,1439.967041 909.678894,1446.631104 911.975586,1457.176025 
C913.080444,1462.248779 913.113770,1467.788574 912.453064,1472.966553 
C910.752808,1486.291382 904.010681,1497.591553 895.388611,1507.357422 
C880.957825,1523.702637 865.685974,1539.304932 850.787537,1555.238159 
C848.970581,1557.181274 847.002563,1559.061890 845.575989,1561.275391 
C842.388245,1566.221558 841.969055,1571.790283 844.212585,1577.053223 
C846.331604,1582.023926 851.384155,1580.346558 855.315735,1580.365601 
C880.640015,1580.488525 905.965271,1580.428345 932.230957,1580.428467 
M1342.367188,1443.905029 
C1336.162231,1446.588989 1334.596069,1451.567993 1335.409546,1457.794556 
C1336.137695,1463.366333 1337.620605,1464.405884 1342.499146,1461.685669 
C1350.630493,1457.151733 1358.547119,1452.233398 1366.557983,1447.483154 
C1368.586182,1446.280640 1370.628418,1445.101685 1372.879150,1443.786133 
C1372.879150,1484.186401 1372.879150,1523.792114 1372.879150,1563.650879 
C1363.093018,1563.650879 1353.604004,1563.640015 1344.115112,1563.654785 
C1337.605713,1563.664795 1336.045776,1565.266357 1335.977173,1571.922485 
C1335.907715,1578.662109 1337.512451,1580.420288 1343.866699,1580.423340 
C1369.027588,1580.435303 1394.188599,1580.436768 1419.349487,1580.422729 
C1425.815186,1580.419067 1427.153687,1578.913574 1427.119019,1571.877808 
C1427.085938,1565.149048 1425.749634,1563.673950 1419.544678,1563.656250 
C1411.254517,1563.632568 1402.964233,1563.650269 1394.191162,1563.650269 
C1394.191162,1561.302979 1394.191162,1559.505493 1394.191162,1557.708008 
C1394.191162,1533.880127 1394.191162,1510.052246 1394.191162,1486.224365 
C1394.191162,1466.728760 1394.263184,1447.232544 1394.076782,1427.738770 
C1394.058594,1425.844849 1392.747681,1422.583984 1391.517456,1422.312500 
C1385.167969,1420.911865 1378.762939,1420.327026 1372.765747,1424.318726 
C1362.934082,1430.862183 1352.911377,1437.118530 1342.367188,1443.905029 
M1062.916626,1423.385132 
C1060.631348,1423.060913 1058.346558,1422.459595 1056.060547,1422.454468 
C1027.565918,1422.390137 999.071228,1422.402710 970.576477,1422.419800 
C964.186096,1422.423706 962.564148,1424.278687 962.490540,1431.445557 
C962.414368,1438.867310 964.172852,1440.951294 970.604187,1440.954346 
C992.766785,1440.964844 1014.929321,1440.958496 1037.091919,1440.958496 
C1038.797119,1440.958496 1040.502441,1440.958496 1042.680298,1440.958496 
C1041.792847,1443.201538 1041.302246,1444.592773 1040.702637,1445.935181 
C1027.625854,1475.211060 1014.533020,1504.479736 1001.452026,1533.753784 
C995.419312,1547.254028 989.355896,1560.741089 983.410339,1574.279785 
C981.445496,1578.754028 982.350220,1580.290039 987.209778,1580.857910 
C990.008911,1581.185059 992.871277,1580.926514 995.697327,1581.077637 
C1001.377258,1581.381348 1004.977173,1579.121338 1007.153259,1573.597168 
C1010.987061,1563.864746 1015.404846,1554.362549 1019.568970,1544.760132 
C1033.845947,1511.838379 1048.147095,1478.927002 1062.370850,1445.982300 
C1065.462280,1438.821899 1067.247437,1431.486206 1062.916626,1423.385132 
M1092.389038,1825.972900 
C1101.014160,1804.645142 1109.639160,1783.317505 1118.264282,1761.989746 
C1118.635254,1762.107666 1119.006348,1762.225464 1119.377319,1762.343384 
C1119.377319,1764.166260 1119.377319,1765.989258 1119.377441,1767.812256 
C1119.377930,1787.966309 1119.502319,1808.121826 1119.281128,1828.273438 
C1119.233032,1832.639160 1120.273682,1834.679199 1124.925293,1834.757568 
C1129.896851,1834.841309 1130.979004,1832.577271 1130.854004,1828.036621 
C1130.560791,1817.384644 1130.760254,1806.719116 1130.760010,1796.059082 
C1130.759766,1783.067261 1130.934937,1770.070801 1130.596924,1757.087769 
C1130.536133,1754.750854 1128.889526,1751.098877 1127.071167,1750.397583 
C1118.961304,1747.270142 1112.564331,1750.521240 1109.179077,1758.713867 
C1101.759888,1776.668701 1094.394165,1794.645752 1086.991455,1812.607544 
C1086.359741,1814.140137 1085.614624,1815.626099 1084.587036,1817.863525 
C1076.768311,1798.036377 1069.336914,1779.195923 1061.909546,1760.353882 
C1058.011841,1750.466064 1057.214111,1749.925659 1046.494629,1749.979614 
C1040.083740,1750.011963 1039.016479,1751.053223 1039.011475,1757.568604 
C1038.993408,1781.387085 1039.139771,1805.207031 1038.887695,1829.022827 
C1038.838135,1833.700317 1040.785889,1834.911011 1044.708374,1834.648560 
C1046.454224,1834.531616 1048.176636,1834.065308 1050.270142,1833.693726 
C1050.270142,1809.445801 1050.270142,1785.624146 1050.270142,1761.802490 
C1051.684937,1763.119873 1052.365723,1764.571045 1052.941772,1766.062622 
C1061.196655,1787.437744 1069.520386,1808.787231 1077.593140,1830.231079 
C1078.818359,1833.485596 1080.717896,1834.430176 1083.822021,1834.731445 
C1089.911133,1835.322510 1090.545532,1830.592773 1092.389038,1825.972900 
M686.074036,1691.439331 
C685.304871,1690.287842 684.303589,1689.229126 683.801331,1687.971069 
C676.844910,1670.547119 669.953430,1653.097168 663.053772,1635.650635 
C658.864624,1625.057983 658.206909,1624.604248 647.037354,1624.760620 
C641.006836,1624.845093 640.001953,1625.774658 639.995483,1631.717041 
C639.969177,1655.866455 640.124146,1680.017212 639.864868,1704.163818 
C639.814026,1708.908203 642.038147,1709.263794 645.600464,1709.297363 
C649.288879,1709.332031 651.302185,1708.657227 651.246033,1704.062744 
C650.987549,1682.914307 651.131592,1661.760986 651.131348,1640.609497 
C651.131348,1639.254517 651.131409,1637.899536 651.131409,1636.544556 
C652.620972,1637.832031 653.276978,1639.124878 653.795715,1640.470703 
C661.857361,1661.384644 669.943298,1682.289551 677.907532,1703.240601 
C679.214172,1706.677856 680.277893,1709.411743 684.954041,1709.417480 
C689.449707,1709.422852 690.840881,1707.145996 692.251221,1703.579834 
C700.433105,1682.891602 708.809570,1662.280029 717.133301,1641.648071 
C717.843750,1639.886963 718.650574,1638.164795 719.412659,1636.424438 
C719.709717,1636.477051 720.006714,1636.529663 720.303772,1636.582275 
C720.303772,1638.166138 720.303711,1639.750000 720.303772,1641.333862 
C720.304626,1661.985718 720.451477,1682.639526 720.195679,1703.288208 
C720.137390,1707.989868 721.687683,1709.368042 726.152710,1709.355835 
C730.486389,1709.344116 731.851501,1707.848022 731.793762,1703.479370 
C731.564941,1686.161499 731.700195,1668.838623 731.699463,1651.517700 
C731.699158,1644.689209 731.996765,1637.839600 731.516663,1631.044922 
C731.366699,1628.923340 729.494568,1625.630981 727.759033,1625.129150 
C718.390076,1622.420776 713.652832,1625.078857 709.888184,1634.194702 
C702.092957,1653.070312 694.300781,1671.947021 686.074036,1691.439331 
M616.924194,1776.325928 
C611.284973,1789.943359 605.645752,1803.560669 599.713501,1817.885742 
C598.863342,1815.878540 598.335999,1814.702515 597.862610,1813.505371 
C590.839355,1795.743164 583.821594,1777.979004 576.806091,1760.213867 
C573.012512,1750.607300 572.060913,1749.956055 561.776367,1749.980835 
C554.895813,1749.997437 553.987549,1750.870850 553.983643,1757.725098 
C553.969849,1781.549561 553.973938,1805.374023 553.986877,1829.198486 
C553.987671,1830.666626 554.122437,1832.134766 554.220215,1834.116943 
C557.879700,1834.116943 561.248535,1834.116943 565.194092,1834.116943 
C565.194092,1809.615967 565.194092,1785.670044 565.194092,1761.723999 
C566.735535,1763.269043 567.411743,1764.922119 568.053101,1766.588623 
C576.106445,1787.514526 584.238159,1808.411011 592.125549,1829.399292 
C593.499451,1833.055054 595.428650,1834.737671 599.335632,1834.751099 
C603.196960,1834.764404 604.741577,1832.739624 606.052551,1829.433350 
C614.561279,1807.973145 623.255432,1786.586304 631.908997,1765.183594 
C632.354187,1764.082397 632.984619,1763.056152 633.528809,1761.994873 
C633.783997,1762.069946 634.039185,1762.144897 634.294373,1762.219849 
C634.294373,1764.009766 634.294312,1765.799805 634.294373,1767.589722 
C634.294983,1788.248657 634.429260,1808.909180 634.196228,1829.565552 
C634.142334,1834.345337 636.774170,1834.668457 640.145447,1834.657349 
C643.367493,1834.646606 646.129578,1834.206299 645.743713,1829.736206 
C645.429626,1826.098022 645.681519,1822.411133 645.681519,1818.745850 
C645.681580,1798.420044 645.764221,1778.093628 645.570068,1757.769653 
C645.547363,1755.384644 644.707825,1752.047363 643.027771,1750.818604 
C638.022034,1747.157227 627.736877,1750.546265 625.215576,1756.279297 
C622.407410,1762.664551 619.825500,1769.149292 616.924194,1776.325928 
M487.067688,1580.955444 
C491.906219,1580.776611 493.258545,1578.289062 493.241180,1573.521606 
C493.071960,1527.062500 493.139374,1480.602661 493.139191,1434.142944 
C493.139130,1421.782104 492.572235,1421.263550 479.821472,1421.949463 
C472.999847,1422.316284 472.129578,1423.216919 472.129211,1429.981323 
C472.126740,1475.774902 472.127625,1521.568604 472.127502,1567.362183 
C472.127472,1581.404419 472.127563,1581.404419 487.067688,1580.955444 
M146.694016,361.699188 
C145.031296,360.958893 143.412643,359.706787 141.698898,359.559235 
C127.880424,358.369690 114.044060,357.387970 99.855667,356.315735 
C99.855667,383.813965 99.855667,409.828186 99.855667,435.834320 
C100.669113,435.975281 101.155296,436.134399 101.640907,436.132629 
C111.959999,436.095398 122.293098,436.336823 132.591400,435.848022 
C136.952652,435.641052 141.536636,434.535980 145.501541,432.712860 
C154.196045,428.714966 158.359787,421.466278 157.939606,411.843658 
C157.567596,403.323700 152.450012,398.707367 144.721817,396.392395 
C144.146820,396.220154 143.609482,395.922150 142.938644,395.632538 
C158.639481,384.984283 160.321457,371.619507 146.694016,361.699188 
M153.088242,122.277069 
C155.726944,109.984657 149.651459,100.020348 136.868317,98.417313 
C124.413498,96.855453 111.729370,97.122177 98.979141,96.578949 
C98.979141,123.088493 98.979141,148.659668 98.979141,174.552948 
C108.781227,174.552948 118.260017,174.719559 127.729721,174.497971 
C134.762604,174.333405 141.686661,173.295380 147.541290,168.831787 
C154.248398,163.718246 156.908020,156.779236 155.783417,148.608963 
C154.784698,141.353134 149.853241,137.388718 143.094040,135.408691 
C142.464813,135.224350 141.878693,134.892883 142.516434,135.169754 
C146.024124,131.096298 149.482971,127.079559 153.088242,122.277069 
M1494.480713,1709.243530 
C1498.705811,1709.688477 1500.203613,1708.083984 1500.152588,1703.584229 
C1499.910278,1682.258423 1500.044434,1660.928467 1500.044434,1639.599976 
C1500.044434,1637.849854 1500.044434,1636.099609 1500.044434,1634.135620 
C1506.597046,1634.135620 1512.418335,1634.000610 1518.229980,1634.180176 
C1522.567261,1634.314209 1526.811401,1634.731934 1526.228882,1627.165771 
C1530.842529,1636.320312 1534.256958,1644.514160 1538.873901,1651.962646 
C1548.668823,1667.764771 1553.217529,1684.574463 1550.922363,1703.115845 
C1550.841187,1703.772339 1550.976440,1704.454956 1550.902222,1705.113037 
C1550.379761,1709.743652 1553.776733,1709.181763 1556.498291,1709.199463 
C1559.264526,1709.217529 1562.255737,1709.647339 1562.110596,1705.054077 
C1561.847900,1696.730957 1561.914429,1688.390625 1562.114624,1680.063965 
C1562.171875,1677.679932 1562.747192,1675.115234 1563.792114,1672.979370 
C1570.583984,1659.096313 1577.580811,1645.313599 1584.482544,1631.484131 
C1585.406860,1629.631958 1586.173828,1627.701416 1587.015747,1625.802368 
C1579.185913,1622.640869 1576.158569,1623.722412 1572.968262,1630.438599 
C1568.619629,1639.593018 1564.309204,1648.765625 1560.002686,1657.939819 
C1558.926270,1660.233276 1557.926270,1662.562622 1556.798828,1665.081421 
C1551.065430,1652.998047 1545.282837,1641.572021 1540.239258,1629.828613 
C1538.037720,1624.702393 1534.589844,1623.950317 1529.976929,1624.280640 
C1526.934326,1624.498535 1523.885010,1624.752563 1520.838135,1624.760376 
C1503.342163,1624.805664 1485.845215,1624.871338 1468.350708,1624.711060 
C1464.583740,1624.676514 1462.875610,1625.644409 1462.913940,1629.692261 
C1462.951782,1633.694092 1464.953491,1634.275269 1468.296753,1634.188232 
C1475.062256,1634.011963 1481.835571,1634.135620 1488.924316,1634.135620 
C1488.924316,1636.567871 1488.924316,1638.374146 1488.924316,1640.180420 
C1488.924316,1661.508911 1489.002808,1682.838013 1488.848389,1704.165283 
C1488.822144,1707.786743 1489.805420,1709.553345 1494.480713,1709.243530 
M391.536591,1681.895996 
C382.796875,1665.468018 373.908600,1649.116455 365.398346,1632.570435 
C362.438812,1626.816284 358.522064,1624.155518 351.959900,1624.669556 
C345.798004,1625.152466 344.912567,1625.595093 344.906464,1631.619873 
C344.881927,1655.769287 345.018677,1679.920044 344.786621,1704.067139 
C344.742920,1708.615234 346.693176,1709.357056 350.413879,1709.307007 
C353.990265,1709.258789 356.218048,1708.852173 356.151611,1704.150757 
C355.862213,1683.669189 355.983643,1663.181763 355.977753,1642.696533 
C355.977448,1641.568115 356.174774,1640.439819 356.330994,1638.766357 
C367.184326,1659.096313 377.642334,1678.747681 388.180817,1698.355591 
C389.668610,1701.123901 391.309113,1703.879639 393.302490,1706.291016 
C396.548126,1710.217651 401.243225,1709.670288 405.356476,1708.674072 
C409.302307,1707.718262 408.561859,1703.730957 408.566345,1700.643433 
C408.600769,1676.993652 408.466217,1653.342651 408.686249,1629.694946 
C408.729553,1625.040527 406.406830,1624.514771 402.879181,1624.506714 
C399.291229,1624.498413 397.048767,1625.159058 397.117401,1629.771851 
C397.397339,1648.587769 397.286316,1667.409668 397.318665,1686.229370 
C397.321320,1687.781616 397.319031,1689.333740 397.319031,1690.885986 
C396.983459,1690.969360 396.647919,1691.052612 396.312347,1691.135986 
C394.840637,1688.271729 393.368927,1685.407349 391.536591,1681.895996 
M1015.272888,1659.272461 
C1022.437500,1672.590088 1029.564331,1685.928345 1036.799072,1699.207764 
C1038.220825,1701.817261 1039.522095,1705.289307 1041.833252,1706.430054 
C1045.278198,1708.130371 1049.694580,1709.055298 1053.469727,1708.562988 
C1057.347534,1708.057373 1056.711060,1703.750610 1056.714355,1700.638062 
C1056.739136,1677.148926 1056.606812,1653.658691 1056.832642,1630.171753 
C1056.877197,1625.546631 1054.959229,1624.496826 1050.973389,1624.464844 
C1046.833374,1624.431396 1045.171021,1625.804810 1045.239014,1630.293091 
C1045.526489,1649.280151 1045.449463,1668.272827 1045.486938,1687.263428 
C1045.489258,1688.481812 1045.333496,1689.700439 1045.149658,1692.422852 
C1043.925049,1690.202515 1043.396484,1689.276733 1042.897827,1688.335205 
C1033.332153,1670.271973 1023.774292,1652.204468 1014.199951,1634.145752 
C1013.266479,1632.385132 1012.345215,1630.601318 1011.226746,1628.958740 
C1008.619202,1625.129272 1001.720093,1623.280762 996.300964,1625.011963 
C991.554504,1626.528320 993.019653,1630.655762 993.006714,1633.906250 
C992.913818,1657.228394 993.069519,1680.552124 992.855591,1703.872681 
C992.815857,1708.196045 994.394104,1709.326660 998.313477,1709.320679 
C1002.246704,1709.314575 1004.284912,1708.573608 1004.214600,1703.809937 
C1003.919617,1683.823364 1004.046875,1663.830322 1004.020020,1643.839722 
C1004.017944,1642.325195 1004.019653,1640.810791 1004.019653,1639.296265 
C1004.284302,1639.297852 1004.549011,1639.299438 1004.813660,1639.301025 
C1008.196777,1645.733398 1011.579834,1652.165894 1015.272888,1659.272461 
M791.826172,1782.500000 
C791.826172,1794.032471 791.826172,1805.564941 791.826172,1818.299927 
C790.794312,1816.557739 790.370789,1815.907837 790.010315,1815.224609 
C780.324036,1796.863892 770.650757,1778.496338 760.954102,1760.141113 
C759.868835,1758.086792 758.790100,1756.007568 757.475769,1754.100220 
C754.868774,1750.316772 747.386230,1748.362793 742.508423,1750.256592 
C738.127563,1751.957520 739.214172,1755.956543 739.205627,1759.303955 
C739.146790,1782.281006 739.284790,1805.259277 739.077209,1828.234741 
C739.037903,1832.584961 740.042114,1834.645996 744.698975,1834.755737 
C749.723389,1834.874268 750.656067,1832.534424 750.582336,1828.041260 
C750.336487,1813.060059 750.488037,1798.072388 750.487427,1783.087280 
C750.487183,1776.909790 750.487366,1770.732178 750.487366,1763.730713 
C751.313843,1764.914673 751.719177,1765.384033 752.003052,1765.918213 
C762.291443,1785.276855 772.539185,1804.657227 782.880371,1823.987549 
C784.359009,1826.751587 785.957703,1829.581787 788.075012,1831.843750 
C791.450134,1835.449585 796.271362,1835.282715 800.127197,1833.587158 
C801.863159,1832.823853 802.847473,1828.617920 802.870300,1825.962891 
C803.075012,1802.154785 802.888123,1778.343506 803.078003,1754.535278 
C803.114502,1749.959595 800.640625,1749.856567 797.398376,1749.842041 
C794.137512,1749.827515 791.584351,1749.950317 791.737976,1754.529663 
C792.039307,1763.510620 791.826294,1772.508911 791.826172,1782.500000 
M496.463257,305.866791 
C498.416779,305.866791 500.370300,305.866791 502.861877,305.866791 
C502.861877,299.576752 502.975586,293.789062 502.834747,288.007568 
C502.632294,279.698120 502.864532,271.310150 501.766144,263.109070 
C500.606262,254.448593 493.709045,249.380829 484.925476,249.011124 
C476.657043,248.663086 470.103088,251.663101 465.621277,258.931641 
C458.839264,246.877289 450.695648,245.913361 437.270325,255.210999 
C434.359985,249.334610 432.850739,248.780334 424.521149,250.497910 
C424.521149,268.888580 424.521149,287.265076 424.521149,305.477173 
C429.181549,305.477173 433.422272,305.477173 437.910553,305.477173 
C437.910553,292.937653 437.897797,280.785339 437.916534,268.633087 
C437.924469,263.476959 441.479523,260.083954 447.094543,259.792969 
C452.669586,259.504059 455.827393,261.713684 456.099823,267.339935 
C456.614777,277.976562 456.545410,288.641632 456.705963,299.295105 
C456.737335,301.378235 456.710480,303.462189 456.710480,305.606140 
C461.577850,305.606140 465.669098,305.606140 470.289520,305.606140 
C470.289520,302.066772 470.245209,298.778656 470.298004,295.492065 
C470.444977,286.341248 470.332123,277.171875 470.914612,268.047668 
C471.272430,262.443451 474.864288,259.754181 480.212128,259.792450 
C485.331085,259.829071 488.304199,262.583862 488.902130,268.103882 
C489.152283,270.413361 489.058472,272.763763 489.061676,275.095673 
C489.075623,285.205597 489.067688,295.315552 489.067688,305.866913 
C491.599854,305.866913 493.560547,305.866913 496.463257,305.866791 
M552.954041,1685.330566 
C553.712280,1676.279907 555.465576,1667.180542 555.026306,1658.188354 
C554.043091,1638.061157 543.029602,1624.468140 520.473511,1623.513550 
C501.491547,1622.710083 486.334229,1633.412354 482.248810,1651.520752 
C479.794769,1662.398193 479.817200,1673.339355 482.301392,1684.158081 
C484.249451,1692.641968 488.290619,1700.095825 496.036285,1704.744629 
C517.269165,1717.488647 543.408997,1708.819214 552.954041,1685.330566 
M904.040771,1654.645996 
C903.758728,1661.606201 902.861206,1668.609619 903.346191,1675.515991 
C903.991943,1684.711304 906.272278,1693.746460 913.253845,1700.432617 
C924.706299,1711.400635 938.534973,1711.957397 952.858765,1708.090698 
C966.089172,1704.519165 973.113342,1694.881348 976.139954,1682.052246 
C979.426819,1668.119873 979.388306,1654.208618 973.193604,1641.071167 
C965.692017,1625.162354 948.708496,1621.192993 931.178162,1624.701782 
C915.461182,1627.847778 907.386230,1638.727173 904.040771,1654.645996 
M156.793533,274.675751 
C150.522018,258.804932 144.250504,242.934128 137.951401,226.993500 
C134.340164,226.993500 130.986755,227.278549 127.703964,226.918991 
C123.878822,226.500046 122.273712,228.112930 120.944870,231.562943 
C111.943222,254.933517 102.708702,278.214386 93.567123,301.531158 
C93.056862,302.832672 92.703529,304.195709 92.170143,305.864960 
C95.191048,305.864960 97.698837,305.668854 100.164848,305.906433 
C105.071106,306.379089 108.041779,304.441742 109.404396,299.635895 
C110.306221,296.455231 111.965233,293.479309 112.761055,290.281281 
C113.581657,286.983673 115.432198,286.295013 118.516373,286.381805 
C125.498642,286.578247 132.529953,286.901703 139.465652,286.300568 
C145.168671,285.806274 147.484970,287.869781 149.225021,293.179413 
C153.650482,306.683228 153.947845,306.586212 167.764114,305.736877 
C167.924866,305.727020 168.080811,305.639008 168.769226,305.414764 
C164.841949,295.400299 160.923492,285.408386 156.793533,274.675751 
M919.686218,1833.928833 
C931.600342,1836.565918 943.106262,1835.302856 954.330383,1830.558594 
C957.583740,1829.183350 958.858032,1826.891724 958.859436,1823.598877 
C958.863525,1813.605469 958.867737,1803.612183 958.850342,1793.618774 
C958.844177,1790.045044 957.306824,1788.007202 953.438782,1788.042236 
C945.611206,1788.113403 937.780640,1788.166748 929.955383,1788.015381 
C926.381897,1787.946289 925.852966,1789.890991 925.883972,1792.761353 
C925.915771,1795.702759 926.699341,1797.435059 930.178833,1797.298950 
C935.797485,1797.079224 941.431030,1797.239624 947.569397,1797.239624 
C947.569397,1805.212891 947.678223,1812.673950 947.442688,1820.124146 
C947.410339,1821.146240 945.846802,1822.585815 944.684814,1823.032349 
C935.944275,1826.391113 927.084106,1826.674072 918.571594,1822.509277 
C906.453186,1816.580078 902.869263,1805.576782 902.229309,1793.187988 
C900.897400,1767.404419 921.811401,1752.058105 945.953308,1761.088257 
C949.902649,1762.565552 953.656006,1764.566772 957.503418,1766.327271 
C959.995605,1760.438354 959.298950,1757.377930 955.174622,1754.666138 
C941.998474,1746.002075 918.404907,1747.378784 906.103394,1757.293823 
C895.137146,1766.132690 890.859863,1777.974976 890.531128,1791.485962 
C890.058105,1810.925659 898.375854,1828.195679 919.686218,1833.928833 
M587.371765,1671.347656 
C596.453247,1670.867798 602.070435,1675.486694 605.318909,1683.565430 
C607.982300,1690.188965 610.912170,1696.724854 613.173889,1703.483521 
C614.717041,1708.095093 617.318176,1709.734863 622.014343,1709.285400 
C627.010132,1708.807129 627.539856,1708.359375 625.634460,1703.469604 
C622.982117,1696.663330 620.482849,1689.758911 617.241943,1683.232300 
C614.518982,1677.748779 610.828979,1672.745483 607.404175,1667.268921 
C607.156494,1667.412354 607.958191,1666.895142 608.804504,1666.465942 
C618.549500,1661.523926 622.734070,1654.300903 621.542419,1644.447266 
C620.319763,1634.337158 614.951294,1627.663696 604.160828,1626.081909 
C594.364563,1624.645752 584.279724,1625.083496 574.318420,1624.920532 
C570.918335,1624.864746 570.527527,1627.719604 570.523376,1630.301880 
C570.483398,1655.289185 570.472534,1680.276733 570.574280,1705.263550 
C570.579285,1706.483154 571.399597,1708.353638 572.363708,1708.806641 
C577.679382,1711.303345 581.811157,1708.627563 581.814636,1702.941162 
C581.821167,1692.490479 581.816589,1682.039917 581.816589,1671.347046 
C583.740601,1671.347046 585.065186,1671.347046 587.371765,1671.347656 
M1373.014893,1700.400146 
C1373.014893,1701.233154 1373.098999,1702.076294 1373.000610,1702.897461 
C1372.508911,1706.999390 1373.365845,1709.372070 1378.424072,1709.390259 
C1383.554443,1709.408691 1384.387695,1707.230469 1384.263184,1702.764771 
C1383.976562,1692.475464 1384.172241,1682.172607 1384.172241,1671.968750 
C1396.685181,1669.719360 1403.127930,1672.874756 1407.897583,1683.660522 
C1410.716675,1690.035156 1413.638916,1696.437500 1415.597778,1703.097046 
C1417.263428,1708.759888 1420.635498,1709.690796 1425.662109,1709.229004 
C1428.960571,1708.925903 1429.740234,1707.547241 1428.606567,1704.687012 
C1426.771118,1700.055420 1424.974487,1695.406250 1423.028442,1690.820923 
C1419.508911,1682.528564 1417.134399,1673.516724 1408.438843,1668.011597 
C1409.641846,1667.377441 1410.336670,1666.994995 1411.045044,1666.639893 
C1421.361572,1661.467773 1425.303711,1654.349731 1423.971924,1643.289185 
C1422.883667,1634.250366 1416.830444,1627.567993 1406.057861,1625.901245 
C1397.579224,1624.589478 1388.822876,1624.981323 1380.186035,1624.814453 
C1373.629150,1624.687622 1373.025269,1625.393921 1373.020630,1631.953491 
C1373.004883,1654.444458 1373.014771,1676.935303 1373.014893,1700.400146 
M1290.183350,1671.480225 
C1291.149170,1678.849976 1290.884033,1686.663452 1293.346558,1693.493530 
C1297.948975,1706.257812 1311.896240,1712.206177 1327.893066,1709.794556 
C1341.888550,1707.684692 1352.144531,1698.454102 1352.945312,1684.719482 
C1354.048828,1665.791992 1353.673584,1646.776123 1353.837891,1627.797363 
C1353.874023,1623.637329 1350.390259,1624.368774 1347.959229,1624.322144 
C1345.403076,1624.272705 1342.510498,1624.115845 1342.635986,1628.327393 
C1342.849243,1635.484375 1342.758789,1642.653076 1342.676270,1649.815552 
C1342.547852,1660.968628 1342.669922,1672.141235 1342.010010,1683.265625 
C1341.568237,1690.716553 1337.764160,1696.495728 1330.337280,1699.186890 
C1315.765991,1704.466797 1302.584229,1696.442261 1301.918335,1681.042603 
C1301.177734,1663.916016 1301.357544,1646.740356 1301.531982,1629.590088 
C1301.578247,1625.036499 1299.524170,1624.184204 1295.884888,1624.230103 
C1292.378784,1624.274414 1289.970581,1624.826294 1290.075439,1629.507812 
C1290.381348,1643.161255 1290.183594,1656.826050 1290.183350,1671.480225 
M657.531006,1827.932617 
C657.010620,1829.635132 656.490234,1831.337769 655.993652,1832.962280 
C663.087830,1836.411011 666.708191,1835.060303 668.938782,1828.520996 
C670.798828,1823.067505 672.669128,1817.617676 674.569153,1812.066284 
C685.587097,1812.066284 696.232544,1811.967651 706.870911,1812.197998 
C708.122192,1812.225098 709.938904,1813.815918 710.458557,1815.100464 
C712.572205,1820.326538 714.218079,1825.739380 716.165405,1831.035889 
C717.399475,1834.392578 722.885803,1836.082764 726.811035,1834.261475 
C730.547180,1832.527954 727.904053,1829.922852 727.204041,1827.951782 
C718.482361,1803.395752 709.502625,1778.930664 700.913696,1754.328857 
C699.245789,1749.551392 695.971924,1749.663818 692.286438,1749.652466 
C688.764221,1749.641602 685.630188,1749.543823 684.037903,1754.089478 
C675.477783,1778.526245 666.601379,1802.852295 657.531006,1827.932617 
M842.843628,1751.230591 
C833.294678,1777.410522 823.734131,1803.586182 814.234863,1829.784058 
C813.813110,1830.947266 813.948547,1832.312622 813.832153,1833.504272 
C821.832275,1836.037598 824.021179,1835.027832 826.446899,1827.967407 
C827.956848,1823.572632 829.320190,1819.117676 831.081360,1814.825806 
C831.562683,1813.652954 833.229309,1812.206177 834.376099,1812.184937 
C845.163269,1811.984253 855.955688,1812.065674 866.819824,1812.065674 
C868.809814,1817.652954 870.698792,1822.965088 872.593933,1828.274902 
C875.054260,1835.167847 878.938965,1836.600586 885.946838,1833.104614 
C885.902405,1832.500122 885.998718,1831.795044 885.785645,1831.200928 
C876.430115,1805.118408 867.085205,1779.031738 857.558960,1753.011597 
C857.064941,1751.662109 855.045837,1750.096802 853.648010,1750.006348 
C850.248047,1749.786865 846.795837,1750.376831 842.843628,1751.230591 
M787.445679,1631.011719 
C786.594604,1625.822021 783.503418,1624.066772 778.342712,1624.098633 
C773.428162,1624.129150 770.863220,1625.869141 769.405945,1630.654541 
C767.089050,1638.262817 764.086975,1645.662354 761.379089,1653.151733 
C755.343079,1669.846191 749.262085,1686.524658 743.350769,1703.263184 
C742.774048,1704.896240 742.475769,1707.663574 743.385254,1708.586182 
C745.836853,1711.072876 752.927063,1708.782227 754.123291,1705.427002 
C756.285645,1699.362793 758.345276,1693.261963 760.470703,1687.109863 
C772.289795,1687.109863 783.894104,1687.109863 795.613647,1687.109863 
C797.803101,1693.345337 799.895874,1699.451294 802.097290,1705.517944 
C803.356384,1708.987549 808.063599,1710.699951 812.590698,1709.015869 
C816.825562,1707.440552 813.860657,1704.506470 813.138245,1702.465088 
C804.780701,1678.848267 796.261292,1655.288940 787.445679,1631.011719 
M295.314453,173.690048 
C295.314453,155.925415 295.314453,138.160797 295.314453,119.855484 
C282.281982,119.855484 269.555420,119.855484 256.345093,119.855484 
C256.345093,113.914482 256.345093,108.517723 256.345093,103.185417 
C247.165161,102.408699 247.152267,102.406059 245.448639,110.729721 
C244.822998,113.786476 244.274307,116.858986 243.718018,119.779884 
C242.072037,120.143082 240.779709,120.442665 239.480911,120.710953 
C238.065247,121.003380 236.643585,121.266762 234.834518,121.618675 
C235.097275,123.983353 234.570541,126.924118 235.746078,127.993294 
C237.441940,129.535721 240.373322,129.719681 243.076904,130.578415 
C243.076904,139.900162 243.078308,149.375397 243.076401,158.850632 
C243.075073,165.383301 244.595108,171.133286 251.242020,174.054062 
C257.624573,176.858704 267.007446,175.009872 271.965759,170.080704 
C268.726227,163.597244 268.726471,163.599792 262.155426,164.215607 
C259.270172,164.485992 256.939301,163.549637 256.890869,160.379059 
C256.736786,150.297043 256.833832,140.211182 256.833832,129.978882 
C265.397949,129.978882 273.479279,129.978882 282.180237,129.978882 
C282.180237,144.878891 282.180237,159.567627 282.180237,174.314285 
C286.764618,174.314285 290.729523,174.314285 295.314453,173.690048 
M359.659088,95.017784 
C355.840240,94.617271 356.911285,97.476974 356.907501,99.366653 
C356.860016,123.189278 356.872284,147.012024 356.888947,170.834732 
C356.889709,171.947906 357.074890,173.060959 357.185913,174.305664 
C361.546631,174.305664 365.632233,174.305664 369.618317,174.305664 
C369.829193,173.715118 370.034729,173.407150 370.035553,173.098679 
C370.065308,161.770828 370.044922,150.442749 370.124908,139.115326 
C370.136139,137.522079 370.178253,135.647507 370.976440,134.393478 
C373.490204,130.444061 380.722046,128.300415 385.344574,129.822800 
C390.449036,131.503891 391.156281,135.679367 391.168335,140.222717 
C391.180237,144.720688 391.178467,149.218689 391.179535,153.716675 
C391.181122,160.489777 391.179962,167.262894 391.179962,174.237671 
C395.988495,174.237671 400.218536,174.237671 404.100159,174.237671 
C404.100159,160.605133 404.848541,147.271896 403.860931,134.068527 
C403.085297,123.698822 395.537872,118.072594 385.172455,119.059959 
C380.028046,119.550003 375.073578,122.034248 369.847626,123.674545 
C369.847626,114.556549 369.847626,104.956223 369.847626,95.016571 
C366.554169,95.016571 363.587433,95.016571 359.659088,95.017784 
M1192.493652,1708.989746 
C1195.826294,1708.989868 1199.170166,1708.817383 1202.488403,1709.036377 
C1206.163086,1709.279053 1208.604004,1708.688354 1208.571655,1704.148560 
C1208.540039,1699.723022 1205.959961,1699.618408 1202.656006,1699.656250 
C1192.876465,1699.768555 1183.094727,1699.696411 1173.157959,1699.696411 
C1173.157959,1689.464966 1173.157959,1679.699951 1173.157959,1669.532104 
C1181.681274,1669.532104 1189.973145,1669.450562 1198.261841,1669.573730 
C1201.410522,1669.620361 1203.287598,1669.000244 1203.284424,1665.252441 
C1203.281372,1661.595459 1201.956421,1660.233398 1198.268799,1660.317261 
C1189.983032,1660.505981 1181.690063,1660.376587 1173.197266,1660.376587 
C1173.197266,1651.422241 1173.197266,1642.869873 1173.197266,1634.012451 
C1183.440063,1634.012451 1193.411255,1633.879883 1203.375610,1634.082397 
C1207.008789,1634.156128 1208.019287,1632.584961 1208.037354,1629.344727 
C1208.055908,1625.994995 1206.789917,1624.659790 1203.276978,1624.709595 
C1191.282104,1624.880005 1179.282349,1624.857544 1167.286377,1624.729614 
C1163.160889,1624.685669 1161.658447,1626.520630 1161.667847,1630.455688 
C1161.726074,1654.783447 1161.723633,1679.111572 1161.678711,1703.439575 
C1161.671265,1707.490234 1163.540771,1709.084351 1167.502075,1709.024780 
C1175.498657,1708.904297 1183.498047,1708.989380 1192.493652,1708.989746 
M1125.062500,1709.906982 
C1126.526245,1709.599487 1127.996948,1709.321899 1129.452637,1708.979736 
C1139.455322,1706.628662 1146.797119,1699.068115 1148.083496,1689.813232 
C1149.624390,1678.728760 1145.774658,1670.837036 1135.903198,1665.316040 
C1132.137695,1663.210083 1128.119141,1661.559448 1124.324951,1659.500610 
C1120.976196,1657.683594 1117.531494,1655.897705 1114.574097,1653.539795 
C1110.377686,1650.194092 1109.371460,1645.550781 1111.034180,1640.471069 
C1112.643433,1635.554932 1116.695557,1633.376221 1121.342407,1633.155396 
C1125.216919,1632.971191 1129.250244,1633.752197 1133.034790,1634.769165 
C1136.289917,1635.644165 1139.292847,1637.456665 1142.406128,1638.854126 
C1145.272827,1632.058472 1144.318237,1628.630005 1138.302124,1626.558472 
C1133.660156,1624.960205 1128.646240,1623.734131 1123.775146,1623.650879 
C1111.972168,1623.448975 1103.223755,1629.029175 1100.128418,1637.763794 
C1096.233398,1648.755005 1100.449951,1659.572754 1111.338623,1665.746338 
C1117.258301,1669.102539 1123.522339,1671.850952 1129.445190,1675.202026 
C1135.392578,1678.566772 1137.709351,1683.583862 1136.545532,1689.302368 
C1135.320068,1695.323486 1131.150635,1699.023560 1124.420288,1700.161133 
C1116.998657,1701.415405 1110.273682,1699.370361 1103.784180,1696.001343 
C1101.958130,1695.053345 1100.020874,1694.319702 1098.096191,1693.470581 
C1095.578491,1700.642578 1096.589600,1703.363159 1102.287354,1706.190186 
C1109.207031,1709.623535 1116.563110,1710.453735 1125.062500,1709.906982 
M1156.780762,1834.158325 
C1168.610596,1834.158081 1180.442017,1834.053955 1192.269531,1834.221436 
C1195.764648,1834.270996 1197.002686,1832.967651 1197.050415,1829.599731 
C1197.103760,1825.834595 1195.418335,1824.819580 1191.859863,1824.886597 
C1181.768311,1825.076782 1171.671021,1824.953369 1161.576416,1824.953369 
C1161.576416,1814.578491 1161.576416,1804.847778 1161.576416,1794.861450 
C1169.069092,1794.861450 1176.231689,1795.055542 1183.375732,1794.775024 
C1186.656372,1794.646118 1191.756836,1797.082642 1191.840210,1790.436157 
C1191.928711,1783.377441 1186.531738,1786.336426 1183.160645,1785.861572 
C1180.873413,1785.539429 1178.504028,1785.800171 1176.171387,1785.800171 
C1171.256592,1785.800171 1166.341675,1785.800049 1161.538818,1785.800049 
C1161.538818,1776.521362 1161.538818,1768.092651 1161.538818,1759.113525 
C1173.078003,1759.113525 1184.326538,1759.113525 1195.416626,1759.113525 
C1197.531982,1750.884155 1196.882324,1749.988037 1189.338501,1749.987427 
C1178.341675,1749.986572 1167.343140,1750.103027 1156.348999,1749.932861 
C1151.868286,1749.863403 1150.007324,1751.618652 1150.022583,1756.105713 
C1150.104248,1780.098511 1150.091675,1804.091675 1150.029907,1828.084473 
C1150.019409,1832.165771 1151.441284,1834.500366 1156.780762,1834.158325 
M1020.038513,1824.955933 
C1009.445251,1824.955933 998.852051,1824.955933 988.354126,1824.955933 
C988.354126,1814.552246 988.354126,1804.805420 988.354126,1794.859253 
C996.823730,1794.859253 1004.979858,1794.736084 1013.129089,1794.918335 
C1016.513977,1794.994019 1018.581543,1794.307373 1018.565369,1790.410034 
C1018.550171,1786.754395 1016.984802,1785.612183 1013.357483,1785.722534 
C1005.078674,1785.974731 996.786865,1785.802368 988.306458,1785.802368 
C988.306458,1776.756714 988.306458,1768.195557 988.306458,1759.205933 
C998.530945,1759.205933 1008.493103,1759.086914 1018.449646,1759.270264 
C1021.944336,1759.334595 1023.225037,1758.090576 1023.174133,1754.659180 
C1023.125916,1751.409546 1022.213196,1749.858398 1018.558228,1749.918945 
C1006.896057,1750.112183 995.228638,1749.971191 983.563354,1749.997681 
C977.661133,1750.011108 976.933228,1750.725464 976.927551,1756.650269 
C976.904846,1780.314331 976.990356,1803.978638 976.855042,1827.641968 
C976.828613,1832.265503 978.305664,1834.312866 983.181641,1834.225586 
C995.009888,1834.013794 1006.846497,1834.262329 1018.674072,1834.034180 
C1020.338806,1834.002075 1022.924561,1832.682373 1023.407166,1831.350830 
C1024.227783,1829.087158 1024.676514,1825.940430 1020.038513,1824.955933 
M1267.719116,1707.307373 
C1269.682495,1706.422119 1271.723267,1705.674927 1273.594360,1704.625122 
C1278.912231,1701.641479 1279.872314,1698.081299 1276.989136,1692.099976 
C1273.012939,1694.093262 1269.142944,1696.345825 1265.040894,1698.034180 
C1249.720215,1704.339111 1234.436035,1696.985962 1231.168945,1680.818604 
C1229.559204,1672.852539 1229.192749,1664.123169 1230.609619,1656.156372 
C1234.463501,1634.485352 1252.864868,1627.111938 1271.529541,1638.918823 
C1273.134399,1639.933838 1274.905762,1640.685669 1277.320190,1641.931396 
C1278.152344,1636.911743 1279.413208,1632.985229 1274.858154,1629.660889 
C1260.473267,1619.163086 1236.316406,1622.962402 1226.116699,1637.561401 
C1217.043579,1650.548096 1216.227173,1665.075806 1218.591797,1680.075195 
C1219.833130,1687.949829 1222.800781,1695.186279 1228.743896,1700.721680 
C1239.957275,1711.166260 1253.106323,1711.628296 1267.719116,1707.307373 
M280.199371,252.601929 
C269.076416,259.644714 266.136505,270.129913 267.847839,282.434814 
C269.361145,293.315796 274.565857,301.657715 285.533936,304.943115 
C297.512146,308.531036 308.445526,306.477783 317.705963,297.592438 
C313.061005,290.147308 313.062256,290.150055 305.510437,293.619629 
C304.605530,294.035339 303.700684,294.470917 302.757416,294.780334 
C290.567505,298.779114 281.255402,292.373871 281.432892,279.686829 
C290.051025,279.686829 298.681610,279.686859 307.312225,279.686829 
C319.081421,279.686829 320.471741,277.853119 317.373840,266.332123 
C316.987640,264.895813 316.561310,263.447388 315.946442,262.099060 
C310.222290,249.547348 295.356995,245.370651 280.199371,252.601929 
M531.619751,249.902924 
C519.745239,253.454269 512.629517,262.464508 512.089661,274.632721 
C511.449188,289.067871 517.802917,300.600220 528.864929,304.671539 
C540.455566,308.937439 556.751709,305.570770 562.138733,297.215668 
C557.710266,290.201996 557.711792,290.205322 550.147705,293.662445 
C549.244629,294.075134 548.336609,294.497925 547.393372,294.798187 
C533.498474,299.221344 525.061707,289.948975 526.422852,279.686584 
C536.639893,279.686584 546.922241,279.570343 557.199707,279.743225 
C561.371033,279.813385 563.147400,278.536774 563.106018,274.041168 
C562.944031,256.410675 550.705566,246.557312 531.619751,249.902924 
M573.963196,276.500000 
C573.963196,286.238007 573.963196,295.976044 573.963196,305.590179 
C578.893677,305.590179 582.994507,305.590179 587.621277,305.590179 
C587.621277,303.693268 587.621216,302.067780 587.621277,300.442261 
C587.621521,289.948792 587.555115,279.454468 587.690308,268.962738 
C587.711853,267.295654 588.154785,265.160980 589.236450,264.065582 
C593.139160,260.113373 598.195557,258.536621 603.434021,260.336426 
C608.476440,262.068909 609.012451,266.877441 609.033142,271.546814 
C609.051575,275.710785 609.037781,279.874939 609.037842,284.039001 
C609.038025,291.153198 609.037842,298.267395 609.037842,305.424622 
C613.909424,305.424622 618.260376,305.424622 622.740173,305.424622 
C622.740173,292.998962 622.985291,281.007263 622.652893,269.031616 
C622.435669,261.207916 619.942749,254.044266 612.036316,250.667770 
C604.034668,247.250595 596.428894,248.731186 589.513367,253.944565 
C588.664124,254.584778 587.724243,255.104904 586.742432,255.734558 
C584.657715,249.419037 582.521362,248.598450 573.963196,250.624268 
C573.963196,258.877991 573.963196,267.188995 573.963196,276.500000 
M423.200165,410.456726 
C423.066345,413.924011 423.608704,417.599487 422.621979,420.804169 
C421.471558,424.540497 413.331482,427.153778 408.459564,425.949005 
C403.624512,424.753296 402.005280,421.058197 401.963562,416.542816 
C401.868317,406.225616 401.903809,395.907196 401.887207,385.589294 
C401.884399,383.848633 401.886841,382.108002 401.886841,380.527710 
C396.803375,380.527710 392.568512,380.527710 388.082153,380.527710 
C388.082153,391.715332 388.077423,402.519775 388.087128,413.324219 
C388.088623,414.987732 388.063538,416.659302 388.208160,418.313385 
C389.370758,431.613068 398.760803,439.334503 411.276917,436.588806 
C415.760773,435.605164 419.846527,432.806671 424.108490,430.839050 
C426.557343,436.743225 426.971100,436.918732 436.709442,435.724945 
C436.709442,417.382812 436.709442,399.009277 436.709442,380.405029 
C432.224792,380.405029 427.994659,380.405029 423.200195,380.405029 
C423.200195,390.261597 423.200195,399.865021 423.200165,410.456726 
M171.467850,428.871429 
C175.169891,431.481964 178.533539,435.268829 182.646225,436.451874 
C190.579468,438.733978 197.801819,435.554596 203.939560,429.953278 
C206.359329,436.643982 207.656754,437.165833 216.626801,435.575562 
C216.626801,417.198486 216.626801,398.821411 216.626801,380.508667 
C212.041565,380.508667 207.813553,380.508667 203.216461,380.508667 
C203.216461,392.504089 203.218704,404.136414 203.215546,415.768768 
C203.213837,422.065277 199.114441,425.903778 192.121887,426.167877 
C185.453751,426.419739 182.117432,423.314758 181.974442,416.191864 
C181.794006,407.201752 181.909668,398.205688 181.899536,389.212189 
C181.896240,386.286713 181.899017,383.361237 181.899017,380.489136 
C176.919708,380.489136 172.682480,380.489136 168.246658,380.489136 
C168.246658,393.464874 168.061371,406.100586 168.375870,418.723846 
C168.455307,421.912384 170.131027,425.061157 171.467850,428.871429 
M348.603516,379.997101 
C342.531189,381.330475 337.023315,383.686188 332.793579,388.340973 
C336.744354,395.903839 337.753021,396.234863 344.796936,392.674561 
C346.124115,392.003693 347.487488,391.327301 348.911926,390.938385 
C359.178223,388.135132 364.512024,393.187653 362.558197,403.859589 
C358.459137,404.315002 354.259949,404.405487 350.253418,405.330444 
C346.086578,406.292389 341.889099,407.635010 338.091339,409.569580 
C331.317596,413.020111 328.630463,419.455658 330.437714,426.257904 
C332.195251,432.873077 337.422668,436.581696 344.886719,437.034882 
C352.483521,437.496185 358.749878,434.532715 364.443085,429.756592 
C367.053894,436.672241 368.453033,437.296387 376.557190,435.414185 
C376.557190,423.329468 376.615753,411.204956 376.501923,399.082092 
C376.481995,396.959564 375.950226,394.775452 375.292816,392.736511 
C371.919708,382.274078 363.006561,377.878662 348.603516,379.997101 
M287.049225,419.152863 
C286.228271,416.258667 285.407318,413.364441 284.450958,409.992889 
C295.964966,409.992889 306.450317,409.849579 316.928253,410.066803 
C320.854218,410.148254 322.204926,408.777405 322.228943,404.903656 
C322.380920,380.381104 299.575745,374.876434 284.874573,382.662842 
C272.825897,389.044373 267.921631,404.285919 273.107666,419.312012 
C276.498169,429.135742 283.568085,435.185699 293.788452,436.620636 
C304.215424,438.084534 313.911072,436.061371 321.589111,428.059021 
C316.731232,420.717010 316.731201,420.716949 309.220917,424.141510 
C300.079193,428.309937 292.943970,426.905701 287.049225,419.152863 
M1321.476685,1245.434448 
C1321.698608,1253.906982 1327.263062,1258.658325 1334.068970,1262.729858 
C1330.934204,1264.995361 1328.076904,1266.903564 1325.394287,1269.032227 
C1320.085449,1273.244995 1318.125244,1278.812500 1319.453247,1285.414429 
C1320.823242,1292.225342 1325.494751,1296.577515 1331.908447,1297.424805 
C1338.656738,1298.316406 1345.758667,1298.091919 1352.500244,1297.038452 
C1359.262939,1295.981689 1363.456665,1290.985596 1364.829956,1284.201172 
C1366.211060,1277.377930 1363.875000,1271.761597 1358.336548,1267.565918 
C1355.743286,1265.601318 1353.004272,1263.829346 1350.304321,1261.951294 
C1353.008545,1259.692383 1355.733154,1257.807251 1357.975586,1255.460938 
C1362.438721,1250.790894 1363.932495,1245.142090 1361.885742,1238.938354 
C1359.977051,1233.153320 1355.374878,1230.077515 1349.678589,1229.186768 
C1345.477539,1228.529907 1341.044556,1228.482544 1336.822510,1229.015747 
C1327.645996,1230.174683 1322.768921,1235.455566 1321.476685,1245.434448 
M1461.470093,1265.928589 
C1459.411377,1264.648315 1457.352539,1263.368042 1455.276123,1262.076660 
C1458.224121,1259.573120 1461.114624,1257.589111 1463.424438,1255.072388 
C1471.613403,1246.149536 1468.118896,1233.210571 1456.585205,1229.625732 
C1450.210938,1227.644531 1443.720703,1227.794189 1437.462891,1230.111938 
C1425.677002,1234.476685 1422.774048,1248.414307 1431.793091,1257.213623 
C1433.952637,1259.320679 1436.523560,1261.005981 1438.920654,1262.897461 
C1435.892456,1265.083984 1432.992798,1266.992432 1430.302002,1269.160034 
C1425.187866,1273.280029 1423.247681,1278.708862 1424.473877,1285.138794 
C1425.727539,1291.712158 1429.926147,1295.987305 1436.276367,1297.192749 
C1441.724487,1298.226807 1447.462769,1298.557129 1452.992798,1298.139526 
C1461.012817,1297.534180 1467.290527,1293.699341 1469.574829,1285.374390 
C1471.801147,1277.260376 1468.535156,1271.136353 1461.470093,1265.928589 
M427.999451,1664.500000 
C427.999481,1677.656616 428.155365,1690.816040 427.905151,1703.967896 
C427.829468,1707.946777 429.118927,1709.166504 432.965057,1709.310669 
C437.590240,1709.484009 439.438477,1708.215942 439.239136,1703.173584 
C438.834229,1692.931396 439.118103,1682.661987 439.118103,1672.100830 
C448.573456,1672.100830 457.378357,1671.989258 466.177673,1672.161987 
C469.221558,1672.221802 470.398254,1670.989014 470.560333,1668.167847 
C470.765472,1664.597412 469.802216,1662.680542 465.573914,1662.825073 
C456.835449,1663.123901 448.079651,1662.915161 439.118134,1662.915161 
C439.118134,1657.528809 439.118134,1652.879639 439.118134,1648.230591 
C439.118134,1643.634521 439.118134,1639.038452 439.118134,1634.128174 
C449.078186,1634.128174 458.382446,1633.984619 467.678497,1634.198975 
C471.386536,1634.284424 472.193207,1632.611206 472.212280,1629.404785 
C472.232147,1626.066040 471.112457,1624.665161 467.543427,1624.723511 
C456.388306,1624.905884 445.226532,1624.905273 434.071045,1624.734863 
C429.491974,1624.664917 427.880890,1626.597290 427.947052,1631.025635 
C428.108734,1641.848389 427.999603,1652.674927 427.999451,1664.500000 
M1504.780151,1287.425049 
C1496.695557,1293.824097 1487.870605,1290.869141 1479.244385,1288.898560 
C1478.227295,1293.211548 1478.423218,1296.093750 1483.039673,1297.537964 
C1499.436279,1302.668091 1515.024170,1294.625488 1519.451538,1278.265747 
C1522.459839,1267.149536 1522.549683,1255.873291 1519.934937,1244.670166 
C1517.443970,1233.997681 1510.052612,1228.187622 1499.646973,1228.292847 
C1487.786011,1228.412842 1479.260986,1234.409668 1477.382324,1245.026123 
C1474.706421,1260.148315 1479.842896,1272.606934 1499.419556,1271.052368 
C1503.704590,1270.712158 1507.895996,1269.192871 1512.164185,1268.208740 
C1512.096680,1276.690796 1510.444946,1281.184570 1504.780151,1287.425049 
M861.301392,1624.780029 
C844.142151,1624.780151 826.982056,1624.868042 809.824280,1624.708740 
C806.222595,1624.675293 804.683044,1625.694946 804.682922,1629.436768 
C804.682739,1633.130005 806.099976,1634.346924 809.766785,1634.209717 
C816.550598,1633.955688 823.350586,1634.137207 830.591736,1634.137207 
C830.591736,1636.462769 830.591675,1638.265259 830.591736,1640.067627 
C830.592102,1661.225098 830.717773,1682.384033 830.491211,1703.539062 
C830.443726,1707.972290 831.847656,1709.386841 836.140198,1709.331909 
C840.233643,1709.279419 842.014038,1708.253174 841.963257,1703.650513 
C841.728333,1682.328979 841.859375,1661.003418 841.859375,1639.679321 
C841.859375,1637.924683 841.859375,1636.170044 841.859375,1634.137207 
C849.025940,1634.137207 855.503235,1633.997803 861.970398,1634.193604 
C865.420898,1634.297974 867.787781,1633.863770 867.789978,1629.605347 
C867.791992,1625.622192 865.979187,1624.222046 861.301392,1624.780029 
M1341.205078,1759.494629 
C1344.610474,1759.456177 1348.294189,1760.458740 1348.265869,1754.666382 
C1348.237061,1748.785034 1344.420166,1750.007812 1341.108887,1750.001709 
C1324.280029,1749.970215 1307.449707,1750.108276 1290.623413,1749.896606 
C1286.731567,1749.847534 1285.149292,1751.083130 1285.135864,1754.890869 
C1285.122559,1758.651855 1286.971680,1759.661621 1290.473145,1759.554077 
C1297.223511,1759.346680 1303.984863,1759.493530 1311.067993,1759.493530 
C1311.067993,1761.733032 1311.067993,1763.374512 1311.067993,1765.015869 
C1311.068237,1786.343506 1311.215454,1807.673096 1310.953979,1828.997437 
C1310.896484,1833.697876 1312.941040,1834.854004 1316.822388,1834.630371 
C1318.561646,1834.530273 1320.279053,1834.049561 1322.379761,1833.674927 
C1322.379761,1808.794800 1322.379761,1784.368530 1322.379761,1759.494507 
C1328.654053,1759.494507 1334.461426,1759.494507 1341.205078,1759.494629 
M379.526520,278.017700 
C382.037750,279.281952 384.488708,280.689880 387.075226,281.774689 
C390.429688,283.181671 394.073212,284.000336 397.232422,285.729706 
C398.841278,286.610382 400.840240,289.165161 400.563904,290.541962 
C400.152588,292.591187 398.061157,295.606964 396.367889,295.832428 
C392.454956,296.353485 388.027161,296.308319 384.391876,294.940948 
C376.316711,291.903625 375.683258,291.811432 372.153564,299.986877 
C380.831360,306.466095 390.399841,308.304718 400.769745,305.120605 
C408.965332,302.604126 413.663513,296.163300 413.717529,288.120453 
C413.761536,281.564728 410.062439,277.155426 401.755768,273.953339 
C397.890381,272.463287 393.804688,271.403809 390.196167,269.451691 
C388.545105,268.558533 386.739319,265.847626 386.944031,264.202545 
C387.161194,262.457306 389.535889,259.865906 391.223724,259.651215 
C394.701752,259.208710 398.547180,259.491302 401.887085,260.571381 
C409.115601,262.908966 409.042053,263.183746 412.769684,255.668625 
C404.448059,248.650848 394.988586,247.115372 384.897736,250.617462 
C372.483002,254.926086 369.489349,269.117584 379.526520,278.017700 
M254.727783,301.271210 
C264.584900,290.524048 261.958893,279.146301 248.409409,273.879700 
C244.404266,272.322906 240.271255,271.011139 236.470535,269.055176 
C235.019150,268.308228 233.330872,265.907013 233.551712,264.553558 
C233.836044,262.811157 235.766281,260.235413 237.278641,260.014923 
C240.901199,259.486786 244.918427,259.390167 248.372482,260.443573 
C256.169769,262.821594 256.201904,263.094147 259.510468,255.618256 
C252.191177,249.287003 243.738907,247.628479 234.467422,249.845261 
C225.638657,251.956177 220.591873,257.661896 220.202560,265.546875 
C219.844437,272.800293 223.722427,277.750916 232.427017,281.136810 
C236.436096,282.696289 240.616577,283.931549 244.381317,285.945648 
C245.891647,286.753662 247.393661,289.331818 247.262054,290.972992 
C247.123657,292.698700 245.128937,295.557159 243.766052,295.665497 
C239.481415,296.006165 234.767227,296.223297 230.849991,294.778503 
C223.303497,291.995148 222.516708,291.896484 219.136292,299.644592 
C228.517288,308.107147 243.271042,308.992004 254.727783,301.271210 
M336.876526,305.854279 
C343.570923,307.111816 350.181122,307.046326 356.373871,303.878174 
C363.101440,300.436432 366.238007,294.781921 366.006073,287.208557 
C365.794830,280.309662 361.281036,276.963593 355.675629,274.510071 
C354.006287,273.779388 352.248993,273.252075 350.545166,272.597260 
C347.761871,271.527588 344.754913,270.793610 342.298279,269.210449 
C340.767609,268.224030 339.103424,265.830536 339.274109,264.261597 
C339.453430,262.613556 341.615997,260.085510 343.149353,259.899536 
C346.795746,259.457245 350.799744,259.475861 354.267334,260.560852 
C361.639923,262.867645 361.612915,263.163452 365.146973,255.716217 
C358.457550,249.431259 350.310181,247.999161 341.637665,249.395309 
C332.481659,250.869324 326.619110,256.878876 326.043549,264.478485 
C325.398163,272.999908 329.027008,277.834564 338.937683,281.546143 
C342.201782,282.768524 345.778076,283.426697 348.704437,285.186340 
C350.639954,286.350159 353.084198,289.297699 352.756958,290.939667 
C352.332855,293.067505 349.555054,295.957794 347.472717,296.249298 
C343.907135,296.748352 339.814606,296.180389 336.443542,294.820526 
C328.992706,291.815002 327.976379,291.967407 324.454498,300.578461 
C328.310089,302.257965 332.194031,303.949829 336.876526,305.854279 
M201.736786,260.708191 
C208.084717,263.271667 208.692825,262.983307 211.991608,255.656235 
C205.078232,249.381256 196.817291,247.851730 187.957260,249.532913 
C178.891663,251.253113 173.491806,256.975006 172.975815,264.508759 
C172.387192,273.103027 175.674255,277.603638 185.359253,281.324036 
C188.916550,282.690582 192.751724,283.527191 196.016785,285.384827 
C197.828354,286.415527 200.004944,289.285736 199.711197,290.909729 
C199.341431,292.954041 196.776474,295.862366 194.871613,296.100403 
C191.124588,296.568512 186.880219,296.211548 183.377731,294.833405 
C175.778992,291.843414 175.233444,291.757568 171.356277,299.930573 
C179.841995,306.321716 189.239258,308.191620 199.462143,305.334015 
C207.824203,302.996582 212.665787,296.803955 212.931290,288.815430 
C213.174484,281.498077 209.764954,277.282257 200.812210,273.856323 
C196.945831,272.376740 192.907257,271.228638 189.276688,269.306946 
C187.720200,268.483063 185.924713,265.882172 186.179474,264.429077 
C186.497925,262.612579 188.647797,260.012482 190.306931,259.765503 
C193.768631,259.250214 197.427322,260.058228 201.736786,260.708191 
M650.055847,239.536087 
C650.055847,237.412720 650.055847,235.289337 650.055847,233.230560 
C640.501465,232.078583 640.479309,232.100571 638.953247,240.816147 
C638.724121,242.124573 638.166748,243.415451 638.161926,244.715912 
C638.146179,248.977356 636.274109,251.222717 631.871887,251.060089 
C628.846252,250.948303 627.836304,252.428329 628.051575,255.385681 
C628.265015,258.317810 629.124695,260.187897 632.473389,260.020447 
C633.727722,259.957733 634.998596,260.223236 636.410767,260.352753 
C636.410767,263.218170 636.376770,265.710327 636.416870,268.201294 
C636.558716,277.015930 636.529785,285.839783 636.961792,294.640686 
C637.197449,299.441223 639.885803,303.037476 644.334778,305.118134 
C651.050476,308.258942 660.574463,306.540985 665.958252,301.245178 
C663.854736,296.989197 662.385620,292.129028 655.633667,295.196167 
C653.043884,296.372620 650.466309,294.305847 650.404114,291.393951 
C650.182068,280.993622 650.317261,270.585663 650.317261,259.805084 
C655.347473,259.805084 659.946411,259.805084 664.653870,259.805084 
C664.653870,256.502869 664.653870,253.590042 664.653870,250.060455 
C659.712891,250.060455 655.000427,250.060455 650.055847,250.060455 
C650.055847,246.466141 650.055847,243.490097 650.055847,239.536087 
M341.299622,122.153023 
C335.561462,118.846664 329.315033,118.363724 322.936951,119.079140 
C314.549713,120.019920 308.027252,125.999695 307.103668,133.336929 
C306.085266,141.427292 309.677246,146.699249 318.645020,150.231583 
C322.648529,151.808548 326.800262,153.086823 330.611542,155.035049 
C332.091156,155.791397 333.883240,158.224289 333.635376,159.534500 
C333.266022,161.487244 331.358246,164.472565 329.852081,164.632248 
C325.749115,165.067230 321.180389,165.146729 317.400818,163.741226 
C309.860291,160.937180 308.544678,161.113861 305.993683,168.714890 
C312.696594,174.338333 322.508789,176.644501 331.270172,174.655670 
C340.344940,172.595718 345.627411,166.847839 346.239960,158.366867 
C346.793610,150.701630 343.327057,146.442978 333.610596,142.832123 
C330.193237,141.562134 326.566803,140.644928 323.457886,138.839752 
C321.812561,137.884399 319.839325,135.023804 320.225739,133.641663 
C320.752014,131.759186 323.232544,129.453857 325.160095,129.152542 
C328.290161,128.663223 331.828339,129.116776 334.879547,130.124893 
C342.056122,132.496048 342.376709,132.550690 345.445282,125.238846 
C344.313934,124.372261 343.135590,123.469673 341.299622,122.153023 
M1412.102783,1297.907837 
C1415.716309,1298.273926 1416.204834,1296.087280 1416.084229,1293.208130 
C1415.953247,1290.078735 1413.913818,1290.003296 1411.576294,1290.015381 
C1402.841187,1290.060303 1394.105713,1290.033325 1384.675781,1290.033325 
C1390.628052,1283.521118 1396.124634,1277.782349 1401.285278,1271.755859 
C1404.299316,1268.236206 1407.089844,1264.441406 1409.440186,1260.451904 
C1418.510620,1245.055786 1411.344238,1229.234741 1394.726807,1228.617188 
C1389.648926,1228.428589 1384.277588,1230.197510 1379.404297,1232.034302 
C1374.054199,1234.050903 1373.700073,1235.982178 1375.757568,1242.119263 
C1378.903809,1240.662476 1381.931274,1238.945923 1385.166748,1237.834595 
C1390.350708,1236.053955 1395.765015,1235.282959 1400.178955,1239.508301 
C1404.579712,1243.721191 1404.194214,1249.081665 1402.481934,1254.378418 
C1401.774292,1256.567871 1400.939209,1258.870361 1399.562866,1260.660889 
C1395.313721,1266.188843 1390.900513,1271.603882 1386.308960,1276.851074 
C1382.912231,1280.732910 1378.797363,1284.023682 1375.678711,1288.095703 
C1374.183228,1290.048584 1373.685791,1293.254272 1373.923828,1295.780640 
C1374.006958,1296.662598 1377.642578,1297.773804 1379.674561,1297.813354 
C1390.169556,1298.017578 1400.670532,1297.908203 1412.102783,1297.907837 
M183.422104,136.110809 
C186.698380,131.990005 191.086105,131.391510 195.991379,131.804184 
C197.533615,131.933960 200.333618,131.228104 200.560501,130.374039 
C201.428391,127.107178 201.482910,123.624237 201.841080,120.221970 
C198.150528,119.946869 194.251236,118.819130 190.832901,119.655968 
C187.892502,120.375809 185.463623,123.290367 182.886459,125.332787 
C181.961273,126.066017 181.263550,127.086296 180.235825,128.226517 
C178.455048,118.874062 176.554703,117.750580 167.523712,120.274437 
C167.523712,138.156967 167.523712,156.058701 167.523712,174.274139 
C171.989532,174.274139 176.213211,174.274139 180.336197,174.274139 
C180.574326,173.725159 180.810776,173.433273 180.812073,173.140335 
C180.855118,163.495193 180.738251,153.846329 180.993240,144.207214 
C181.059387,141.706726 182.278412,139.236740 183.422104,136.110809 
M252.396194,393.177704 
C255.209763,393.096436 258.025970,393.063141 260.835602,392.909943 
C261.939484,392.849762 263.865204,392.747009 263.991272,392.279358 
C264.928680,388.802368 266.206329,385.143707 265.791748,381.734924 
C265.659943,380.651215 260.232544,378.839996 258.086456,379.646149 
C252.938416,381.579865 248.299316,384.868561 243.639908,387.505707 
C241.132935,379.302216 241.132935,379.302216 231.172668,380.627167 
C231.172668,398.979980 231.172668,417.368744 231.172668,435.852448 
C235.660217,435.852448 239.885513,435.852448 244.520004,435.852448 
C244.520004,425.746887 244.720413,415.935547 244.444916,406.137634 
C244.279480,400.254242 246.666000,396.278107 252.396194,393.177704 
M1442.495850,1681.499756 
C1442.495972,1689.152954 1442.746460,1696.817627 1442.401367,1704.455200 
C1442.196899,1708.978027 1444.674683,1709.263550 1447.962402,1709.269165 
C1451.368164,1709.275024 1453.968384,1709.180176 1453.925903,1704.322388 
C1453.708008,1679.368042 1453.717285,1654.409912 1453.920776,1629.455322 
C1453.958496,1624.825073 1451.574341,1624.242310 1448.087402,1624.237183 
C1444.513428,1624.231812 1442.315308,1625.024658 1442.388428,1629.590820 
C1442.660156,1646.556763 1442.496216,1663.529541 1442.495850,1681.499756 
M321.281372,1709.186157 
C325.160339,1709.496338 325.386627,1707.093994 325.378357,1704.085938 
C325.310211,1679.288940 325.223114,1654.490601 325.447784,1629.695435 
C325.487671,1625.294312 323.668610,1624.200684 319.942139,1624.229492 
C316.160126,1624.258789 313.934326,1625.092041 313.982605,1629.867798 
C314.228149,1654.163330 314.240234,1678.464233 313.978241,1702.759399 
C313.923767,1707.811157 315.390015,1709.903931 321.281372,1709.186157 
M876.958740,1660.500000 
C876.958862,1675.297119 877.102112,1690.096313 876.871765,1704.889893 
C876.802734,1709.324951 879.398010,1709.236328 882.307495,1709.210327 
C885.277100,1709.183838 888.193909,1709.640137 888.157654,1704.807739 
C887.968079,1679.537720 887.965149,1654.264648 888.164062,1628.994873 
C888.200195,1624.402222 885.554077,1624.280762 882.496887,1624.284302 
C879.404236,1624.287842 876.724121,1624.520386 876.863281,1629.077515 
C877.172729,1639.209961 876.959106,1649.358154 876.958740,1660.500000 
M225.180832,159.495621 
C225.180832,146.264450 225.180832,133.033279 225.180832,119.766281 
C220.378433,119.766281 216.303253,119.766281 212.297058,119.766281 
C212.297058,138.138916 212.297058,156.186752 212.297058,174.256454 
C216.713135,174.256454 220.783035,174.256454 225.180862,174.256454 
C225.180862,169.449036 225.180862,164.971222 225.180832,159.495621 
M224.849640,109.281517 
C227.569061,105.915787 228.420105,101.941284 225.277679,98.929131 
C223.212433,96.949532 219.255981,95.259789 216.757675,95.884521 
C214.216171,96.520050 211.195663,99.907272 210.669525,102.545235 
C210.198685,104.905922 212.223785,108.545204 214.250916,110.439987 
C217.278519,113.269928 221.062912,112.265907 224.849640,109.281517 
M284.214569,110.516312 
C289.483063,114.445297 296.233246,109.948524 296.991333,105.744598 
C297.760345,101.480232 296.477325,98.157043 292.552734,96.184006 
C288.583923,94.188713 285.049683,95.177124 282.303192,98.503761 
C279.386993,102.036003 279.894104,105.673279 284.214569,110.516312 
z'
    />
    <path
      fill='#454545'
      opacity='1.000000'
      stroke='none'
      d='
M340.247925,937.704651 
C357.533905,912.826477 374.868011,887.981567 392.098541,863.065063 
C568.606995,607.821899 745.098572,352.567078 921.597229,97.317169 
C922.588989,95.882812 923.614624,94.471893 925.394043,91.966209 
C925.529480,94.924316 925.665222,96.506859 925.665344,98.089417 
C925.675354,218.584488 925.695679,339.079590 925.556763,459.574493 
C925.553223,462.642609 924.479858,466.176575 922.754578,468.709351 
C736.438477,742.225952 550.007141,1015.664001 363.662689,1289.161255 
C361.716217,1292.017944 359.682220,1292.923584 356.354675,1292.922119 
C271.026642,1292.885986 185.698578,1292.958740 100.370529,1292.949463 
C98.592796,1292.949341 96.815163,1292.204468 95.437210,1291.313477 
C96.966873,1289.423340 98.193146,1288.093140 99.212318,1286.619751 
C115.675163,1262.819702 132.087616,1238.984497 148.558975,1215.190308 
C186.705414,1160.084717 224.875748,1104.995605 263.040009,1049.902344 
C277.813232,1028.576172 292.643677,1007.289368 307.359680,985.923828 
C318.395660,969.901184 329.290344,953.781250 340.247925,937.704651 
z'
    />
    <path
      fill='#272727'
      opacity='1.000000'
      stroke='none'
      d='
M1410.000000,98.115440 
C1554.118530,98.115440 1697.737061,98.115440 1841.645630,98.115440 
C1841.645630,456.401031 1841.645630,814.304260 1841.645630,1172.605225 
C1561.821533,1172.605225 1281.800781,1172.605225 1001.482422,1172.605225 
C1001.482422,814.669128 1001.482422,456.646606 1001.482422,98.115440 
C1137.625122,98.115440 1273.562622,98.115440 1410.000000,98.115440 
M1819.978149,474.376190 
C1819.978149,474.376190 1819.979858,473.939392 1820.131226,473.019653 
C1820.093384,464.993927 1820.055542,456.968170 1819.993164,448.565277 
C1819.993164,448.565277 1819.974365,448.187775 1820.578369,447.608154 
C1820.377075,444.675140 1820.175781,441.742096 1819.975464,438.365112 
C1819.975464,438.365112 1819.973633,437.921173 1820.125488,437.003754 
C1820.068970,429.007599 1820.012451,421.011414 1820.610352,412.506683 
C1820.516235,408.698029 1820.421997,404.889404 1820.248657,400.136749 
C1820.248657,306.748413 1820.248657,213.360092 1820.248657,120.017715 
C1554.105347,120.017715 1288.726196,120.017715 1022.903992,120.017715 
C1022.903992,122.187943 1022.904297,124.144173 1022.903931,126.100395 
C1022.885742,217.745819 1022.867432,309.391266 1022.311646,401.642456 
C1022.570129,405.457520 1022.828613,409.272552 1022.934509,414.002930 
C1022.979065,421.939240 1023.023560,429.875549 1023.034729,438.383972 
C1023.026611,438.574860 1023.018555,438.765717 1022.409912,439.548706 
C1022.529968,445.369324 1022.650085,451.189972 1022.889587,457.936584 
C1022.973083,463.213928 1023.056519,468.491241 1022.508484,474.370911 
C1022.595703,479.584137 1022.682922,484.797363 1022.889587,490.938965 
C1022.944092,497.243347 1022.998535,503.547729 1023.028259,510.405334 
C1023.022156,510.589813 1023.016052,510.774323 1022.427917,511.510559 
C1022.622009,514.354187 1022.816040,517.197754 1023.016357,520.556213 
C1023.019043,520.727783 1023.021729,520.899414 1022.944824,521.996582 
C1022.979126,529.953064 1023.013428,537.909485 1023.026245,546.411133 
C1023.020996,546.592896 1023.015747,546.774658 1022.428101,547.508606 
C1022.622131,550.352844 1022.816162,553.197083 1023.018066,556.562134 
C1023.021667,556.735779 1023.025208,556.909363 1022.949951,558.007080 
C1022.980835,565.964722 1023.011719,573.922363 1023.023987,582.418640 
C1023.019409,582.598206 1023.014893,582.777771 1022.417297,583.533813 
C1022.535400,587.359375 1022.653503,591.184937 1022.890381,595.939514 
C1022.965393,603.240051 1023.040344,610.540527 1022.491699,618.412231 
C1022.701172,621.997009 1022.910706,625.581787 1022.966187,630.071838 
C1022.997925,638.024963 1023.029663,645.978149 1023.026855,653.989502 
C1023.026855,653.989502 1022.982727,654.040894 1022.392883,654.580444 
C1022.598694,657.734802 1022.804565,660.889160 1023.025146,664.586121 
C1023.031860,664.766907 1023.038574,664.947693 1022.967407,666.047119 
C1022.995422,674.012146 1023.023376,681.977234 1023.021606,689.995789 
C1023.021606,689.995789 1022.981995,690.042480 1022.392212,690.581665 
C1022.598206,693.734924 1022.804199,696.888123 1023.027771,700.593994 
C1023.035767,700.778076 1023.043823,700.962158 1022.972595,702.062561 
C1023.014221,710.003418 1023.055908,717.944214 1022.474792,726.447876 
C1022.695740,730.038391 1022.916687,733.628845 1022.978638,738.117249 
C1022.991638,746.060913 1023.004700,754.004639 1023.013184,762.454895 
C1023.011902,762.623779 1023.010559,762.792603 1022.409790,763.551941 
C1022.529907,769.038147 1022.650085,774.524414 1022.889587,780.939575 
C1022.889587,904.521423 1022.889587,1028.103271 1022.889587,1151.727295 
C1288.952637,1151.727295 1554.478027,1151.727295 1820.237305,1151.727295 
C1820.237305,1149.952759 1820.237427,1148.471558 1820.237427,1146.990234 
C1820.237305,1024.011963 1820.238159,901.033752 1820.226074,778.055481 
C1820.225830,776.394958 1820.062378,774.734375 1819.976196,772.630493 
C1819.976196,772.630493 1819.974487,772.187073 1820.587646,771.586670 
C1820.525391,767.727234 1820.463257,763.867859 1820.256958,759.080872 
C1820.166016,751.736389 1820.075073,744.391968 1819.979736,736.617432 
C1819.979736,736.617432 1819.974365,736.187378 1820.578491,735.607971 
C1820.377197,732.676208 1820.175781,729.744385 1819.991821,726.428833 
C1819.991821,726.428833 1820.013916,726.045227 1820.182373,725.115051 
C1820.241333,717.401917 1820.300293,709.688721 1820.830566,701.329712 
C1820.545166,697.824097 1820.259766,694.318420 1819.990479,690.423035 
C1819.990479,690.423035 1820.010376,690.033325 1820.175781,689.104065 
C1820.115234,681.075317 1820.054688,673.046631 1819.983643,664.602661 
C1819.983643,664.602661 1819.974365,664.187378 1820.582275,663.599121 
C1820.396484,660.418030 1820.210571,657.237000 1820.008667,654.039490 
C1820.008667,654.039490 1820.012573,654.017090 1820.168213,653.088440 
C1820.111694,645.060303 1820.055176,637.032104 1819.985718,628.595459 
C1819.985718,628.595459 1819.974365,628.187012 1820.578979,627.608093 
C1820.377441,624.676270 1820.175903,621.744446 1819.987183,618.409607 
C1819.987183,618.409607 1820.002075,618.006653 1820.161133,617.079773 
C1820.108643,609.049194 1820.056152,601.018616 1819.987671,592.587769 
C1819.987671,592.587769 1819.974365,592.187378 1820.582275,591.599243 
C1820.395996,588.417114 1820.209595,585.234924 1820.002563,582.025574 
C1820.002563,582.025574 1819.994141,581.992371 1820.151733,581.067078 
C1820.103760,573.036072 1820.055908,565.005005 1819.989624,556.580261 
C1819.989624,556.580261 1819.974609,556.186340 1820.593628,555.573303 
C1820.530151,550.718445 1820.466797,545.863525 1820.257935,540.081604 
C1820.175781,533.708862 1820.093506,527.336121 1819.990967,520.575500 
C1819.990967,520.575500 1819.974365,520.187378 1820.582153,519.598938 
C1820.395264,516.415771 1820.208374,513.232666 1819.990601,510.010162 
C1819.990601,510.010162 1819.971191,509.964081 1820.135498,509.043213 
C1820.223389,501.688080 1820.311279,494.332947 1820.862549,486.316559 
C1820.566528,482.482025 1820.270508,478.647522 1819.978149,474.376190 
z'
    />
    <path
      fill='#6F6F6F'
      opacity='1.000000'
      stroke='none'
      d='
M925.669800,952.000000 
C925.669617,1065.750244 925.669617,1179.000366 925.669617,1292.547363 
C826.162537,1292.547363 727.290710,1292.547363 627.252686,1292.547363 
C726.533020,1146.975464 825.410889,1001.993591 924.288818,857.011719 
C924.749146,857.078552 925.209534,857.145447 925.669922,857.212341 
C925.669922,888.641541 925.669922,920.070801 925.669800,952.000000 
z'
    />
    <path
      fill='#424242'
      opacity='1.000000'
      stroke='none'
      d='
M95.267303,960.007568 
C95.200218,958.346802 95.074455,956.686096 95.074394,955.025330 
C95.069771,825.049133 95.075020,695.072876 95.079491,565.096680 
C95.079559,563.305298 95.079498,561.513916 95.079498,559.445801 
C176.792068,559.445801 258.040619,559.445801 340.091248,559.445801 
C340.091248,590.284058 340.091248,621.183044 339.608826,652.542480 
C337.501282,653.642944 335.326050,653.820984 334.339081,654.996582 
C327.212372,663.485413 321.845276,673.221313 314.653900,681.803040 
C309.278625,688.217590 302.289337,693.703064 299.075806,702.073730 
C297.981598,704.923889 293.779938,706.558655 292.616730,709.409241 
C289.824860,716.250854 283.995270,720.075928 279.175415,724.944275 
C277.694977,726.439697 276.211700,728.024536 275.140015,729.814148 
C272.465485,734.279968 270.519012,739.263672 267.387451,743.356384 
C261.417450,751.158630 254.857895,758.512756 248.474136,765.994019 
C246.137421,768.732544 243.290863,771.082886 241.235168,774.003296 
C238.097763,778.460449 235.740936,783.475952 232.520050,787.863403 
C227.244080,795.049988 221.527695,801.912659 216.022797,808.932129 
C213.665390,811.938110 211.367905,814.991211 209.051666,818.029358 
C204.209839,824.380432 199.346161,830.715210 194.556046,837.105042 
C193.468994,838.555176 192.810822,840.337341 191.672379,841.736511 
C185.332443,849.528870 178.779221,857.150513 172.548279,865.027710 
C167.604218,871.277954 163.086517,877.863464 158.254135,884.204529 
C153.497345,890.446350 148.158142,896.288818 143.862427,902.824402 
C139.936188,908.797913 132.994247,912.405212 131.082001,920.033630 
C130.626953,921.848877 127.034286,922.667725 125.487808,924.463989 
C122.481895,927.955566 119.890167,931.805359 117.150642,935.524353 
C113.040428,941.104126 109.243759,946.950928 104.740166,952.191223 
C102.118736,955.241455 101.600616,961.330627 95.267303,960.007568 
z'
    />
    <path
      fill='#3C3C3C'
      opacity='1.000000'
      stroke='none'
      d='
M95.187660,960.469666 
C101.600616,961.330627 102.118736,955.241455 104.740166,952.191223 
C109.243759,946.950928 113.040428,941.104126 117.150642,935.524353 
C119.890167,931.805359 122.481895,927.955566 125.487808,924.463989 
C127.034286,922.667725 130.626953,921.848877 131.082001,920.033630 
C132.994247,912.405212 139.936188,908.797913 143.862427,902.824402 
C148.158142,896.288818 153.497345,890.446350 158.254135,884.204529 
C163.086517,877.863464 167.604218,871.277954 172.548279,865.027710 
C178.779221,857.150513 185.332443,849.528870 191.672379,841.736511 
C192.810822,840.337341 193.468994,838.555176 194.556046,837.105042 
C199.346161,830.715210 204.209839,824.380432 209.051666,818.029358 
C211.367905,814.991211 213.665390,811.938110 216.022797,808.932129 
C221.527695,801.912659 227.244080,795.049988 232.520050,787.863403 
C235.740936,783.475952 238.097763,778.460449 241.235168,774.003296 
C243.290863,771.082886 246.137421,768.732544 248.474136,765.994019 
C254.857895,758.512756 261.417450,751.158630 267.387451,743.356384 
C270.519012,739.263672 272.465485,734.279968 275.140015,729.814148 
C276.211700,728.024536 277.694977,726.439697 279.175415,724.944275 
C283.995270,720.075928 289.824860,716.250854 292.616730,709.409241 
C293.779938,706.558655 297.981598,704.923889 299.075806,702.073730 
C302.289337,693.703064 309.278625,688.217590 314.653900,681.803040 
C321.845276,673.221313 327.212372,663.485413 334.339081,654.996582 
C335.326050,653.820984 337.501282,653.642944 339.516785,653.003540 
C339.969421,677.031372 340.031677,701.058716 339.659119,725.584045 
C335.958984,729.744812 332.570923,733.306641 329.454803,737.092346 
C323.673157,744.116516 317.888672,751.149048 312.398956,758.400330 
C304.111145,769.347534 296.232025,780.605286 287.891266,791.510803 
C278.160980,804.233154 268.109985,816.710022 258.217957,829.308899 
C245.456207,845.562683 232.639709,861.774292 219.985718,878.111633 
C208.647858,892.749634 197.538712,907.564575 186.254562,922.244446 
C175.055954,936.813171 163.745346,951.295715 152.521500,965.845093 
C145.856079,974.485474 139.328171,983.232483 132.619095,991.838501 
C126.329994,999.905701 119.817207,1007.798584 113.531662,1015.868469 
C109.771736,1020.695801 106.479691,1025.901855 102.540359,1030.568970 
C100.638222,1032.822510 97.727837,1034.224854 95.273979,1036.012695 
C95.218658,1010.985718 95.163338,985.958740 95.187660,960.469666 
z'
    />
    <path
      fill='#313131'
      opacity='1.000000'
      stroke='none'
      d='
M95.195038,1036.474609 
C97.727837,1034.224854 100.638222,1032.822510 102.540359,1030.568970 
C106.479691,1025.901855 109.771736,1020.695801 113.531662,1015.868469 
C119.817207,1007.798584 126.329994,999.905701 132.619095,991.838501 
C139.328171,983.232483 145.856079,974.485474 152.521500,965.845093 
C163.745346,951.295715 175.055954,936.813171 186.254562,922.244446 
C197.538712,907.564575 208.647858,892.749634 219.985718,878.111633 
C232.639709,861.774292 245.456207,845.562683 258.217957,829.308899 
C268.109985,816.710022 278.160980,804.233154 287.891266,791.510803 
C296.232025,780.605286 304.111145,769.347534 312.398956,758.400330 
C317.888672,751.149048 323.673157,744.116516 329.454803,737.092346 
C332.570923,733.306641 335.958984,729.744812 339.562622,726.044434 
C339.966461,745.698608 340.032043,765.390320 339.641663,785.546631 
C337.512512,787.230713 335.468079,788.156067 334.228668,789.719604 
C327.971924,797.612305 321.991882,805.723694 315.789856,813.660767 
C303.765747,829.048462 291.600220,844.325745 279.606049,859.736633 
C271.911743,869.622864 264.529083,879.752197 256.806274,889.615540 
C248.445297,900.293884 239.627792,910.619507 231.409225,921.403625 
C217.795578,939.267029 204.635941,957.476440 191.026184,975.342896 
C182.101837,987.058533 172.706467,998.415039 163.550446,1009.954895 
C155.849808,1019.660522 148.109833,1029.336548 140.530716,1039.136719 
C128.590256,1054.576172 116.861374,1070.180176 104.829895,1085.547729 
C102.087837,1089.050171 98.475792,1091.871460 95.264168,1095.006226 
C95.214813,1075.649658 95.165451,1056.293091 95.195038,1036.474609 
z'
    />
    <path
      fill='#0F0F0F'
      opacity='1.000000'
      stroke='none'
      d='
M340.211670,937.256226 
C329.290344,953.781250 318.395660,969.901184 307.359680,985.923828 
C292.643677,1007.289368 277.813232,1028.576172 263.040009,1049.902344 
C224.875748,1104.995605 186.705414,1160.084717 148.558975,1215.190308 
C132.087616,1238.984497 115.675163,1262.819702 99.212318,1286.619751 
C98.193146,1288.093140 96.966873,1289.423340 95.512817,1290.881836 
C95.162086,1266.609131 95.135468,1242.274536 95.559357,1217.480469 
C97.361153,1216.288940 99.065109,1215.855957 99.991394,1214.763550 
C102.013885,1212.378418 103.512154,1209.556763 105.451256,1207.091675 
C115.572372,1194.225342 125.834793,1181.469727 135.905914,1168.564575 
C142.116714,1160.605957 147.939133,1152.343750 154.171951,1144.403076 
C167.251144,1127.739990 180.589081,1111.279785 193.625122,1094.583496 
C204.317764,1080.888428 214.701843,1066.952637 225.268524,1053.158691 
C239.450287,1034.645508 253.611588,1016.115967 267.906677,997.690491 
C276.935120,986.053284 286.318817,974.691040 295.315338,963.029724 
C307.850494,946.781738 320.116180,930.325928 332.642059,914.070679 
C334.683838,911.420959 337.471802,909.346191 339.914856,907.005676 
C340.001678,916.939758 340.088531,926.873779 340.211670,937.256226 
z'
    />
    <path
      fill='#252525'
      opacity='1.000000'
      stroke='none'
      d='
M339.914490,818.003296 
C339.981384,833.697205 340.048279,849.390991 339.674011,865.581848 
C338.154602,867.051025 336.894653,867.884155 336.026947,869.017456 
C329.284088,877.825989 322.732422,886.782898 315.901184,895.521484 
C303.155731,911.825806 290.149353,927.926758 277.462006,944.275635 
C265.911163,959.160217 254.715027,974.319763 243.212372,989.242310 
C237.561859,996.572754 231.411850,1003.518616 225.773300,1010.857849 
C217.917465,1021.083252 210.482071,1031.632446 202.590378,1041.829224 
C190.836411,1057.016479 178.769623,1071.961304 166.971680,1087.114868 
C157.816177,1098.874512 148.893280,1110.814819 139.821701,1122.640137 
C127.742622,1138.385864 115.702728,1154.163330 103.438919,1169.764282 
C101.223946,1172.581909 98.011238,1174.615356 95.259186,1177.010864 
C95.205841,1160.984985 95.152504,1144.959106 95.548843,1128.471313 
C97.443001,1127.361206 99.395660,1127.107788 100.253273,1126.003662 
C108.771088,1115.038574 117.098289,1103.925659 125.498787,1092.869263 
C132.803162,1083.255615 140.016327,1073.569580 147.475876,1064.077393 
C161.796478,1045.854370 176.416458,1027.865112 190.622192,1009.553833 
C202.800491,993.856079 214.412125,977.718933 226.575623,962.009399 
C237.217041,948.265503 248.456329,934.984558 259.100922,921.243103 
C268.924347,908.561768 278.198853,895.456665 287.919220,882.693665 
C296.337708,871.639954 305.070801,860.826416 313.609955,849.863953 
C318.994446,842.951477 324.145599,835.853088 329.657532,829.045471 
C332.811432,825.150085 336.478455,821.670227 339.914490,818.003296 
z'
    />
    <path
      fill='#1B1B1B'
      opacity='1.000000'
      stroke='none'
      d='
M95.179367,1177.472656 
C98.011238,1174.615356 101.223946,1172.581909 103.438919,1169.764282 
C115.702728,1154.163330 127.742622,1138.385864 139.821701,1122.640137 
C148.893280,1110.814819 157.816177,1098.874512 166.971680,1087.114868 
C178.769623,1071.961304 190.836411,1057.016479 202.590378,1041.829224 
C210.482071,1031.632446 217.917465,1021.083252 225.773300,1010.857849 
C231.411850,1003.518616 237.561859,996.572754 243.212372,989.242310 
C254.715027,974.319763 265.911163,959.160217 277.462006,944.275635 
C290.149353,927.926758 303.155731,911.825806 315.901184,895.521484 
C322.732422,886.782898 329.284088,877.825989 336.026947,869.017456 
C336.894653,867.884155 338.154602,867.051025 339.576294,866.041870 
C339.984863,879.365356 340.049927,892.725891 340.014954,906.546021 
C337.471802,909.346191 334.683838,911.420959 332.642059,914.070679 
C320.116180,930.325928 307.850494,946.781738 295.315338,963.029724 
C286.318817,974.691040 276.935120,986.053284 267.906677,997.690491 
C253.611588,1016.115967 239.450287,1034.645508 225.268524,1053.158691 
C214.701843,1066.952637 204.317764,1080.888428 193.625122,1094.583496 
C180.589081,1111.279785 167.251144,1127.739990 154.171951,1144.403076 
C147.939133,1152.343750 142.116714,1160.605957 135.905914,1168.564575 
C125.834793,1181.469727 115.572372,1194.225342 105.451256,1207.091675 
C103.512154,1209.556763 102.013885,1212.378418 99.991394,1214.763550 
C99.065109,1215.855957 97.361153,1216.288940 95.640106,1217.019287 
C95.213425,1203.989868 95.156487,1190.962158 95.179367,1177.472656 
z'
    />
    <path
      fill='#282828'
      opacity='1.000000'
      stroke='none'
      d='
M649.880127,1565.122192 
C638.568237,1553.280273 633.889771,1538.944214 631.680298,1523.498901 
C629.080383,1505.323853 629.517090,1487.287109 634.389771,1469.533813 
C643.203857,1437.419556 668.324829,1419.491699 703.544617,1420.129028 
C722.428894,1420.470703 739.830566,1424.918945 753.186584,1439.495483 
C762.496887,1449.656616 767.175781,1461.994263 769.318115,1475.355591 
C772.790283,1497.011475 772.517273,1518.502808 765.064087,1539.418823 
C757.131592,1561.680176 741.688660,1576.027344 718.447205,1580.719849 
C697.713806,1584.905884 677.315674,1583.860229 658.691589,1572.200562 
C655.617615,1570.276123 652.968750,1567.672485 649.880127,1565.122192 
M655.365356,1528.893066 
C661.993774,1556.752441 679.784790,1563.939697 698.716431,1564.562134 
C721.308411,1565.304932 738.326599,1553.509644 744.854736,1531.846191 
C750.413635,1513.399048 750.428284,1494.659424 746.707825,1476.013306 
C742.140442,1453.122803 729.593445,1441.397583 707.967468,1438.429810 
C683.648315,1435.092407 664.073486,1447.496460 656.836609,1470.797363 
C650.953247,1489.740479 651.708496,1508.872437 655.365356,1528.893066 
z'
    />
    <path
      fill='#2B2B2B'
      opacity='1.000000'
      stroke='none'
      d='
M340.009521,817.542847 
C336.478455,821.670227 332.811432,825.150085 329.657532,829.045471 
C324.145599,835.853088 318.994446,842.951477 313.609955,849.863953 
C305.070801,860.826416 296.337708,871.639954 287.919220,882.693665 
C278.198853,895.456665 268.924347,908.561768 259.100922,921.243103 
C248.456329,934.984558 237.217041,948.265503 226.575623,962.009399 
C214.412125,977.718933 202.800491,993.856079 190.622192,1009.553833 
C176.416458,1027.865112 161.796478,1045.854370 147.475876,1064.077393 
C140.016327,1073.569580 132.803162,1083.255615 125.498787,1092.869263 
C117.098289,1103.925659 108.771088,1115.038574 100.253273,1126.003662 
C99.395660,1127.107788 97.443001,1127.361206 95.630531,1128.009766 
C95.208710,1117.316772 95.154869,1106.623413 95.182594,1095.468140 
C98.475792,1091.871460 102.087837,1089.050171 104.829895,1085.547729 
C116.861374,1070.180176 128.590256,1054.576172 140.530716,1039.136719 
C148.109833,1029.336548 155.849808,1019.660522 163.550446,1009.954895 
C172.706467,998.415039 182.101837,987.058533 191.026184,975.342896 
C204.635941,957.476440 217.795578,939.267029 231.409225,921.403625 
C239.627792,910.619507 248.445297,900.293884 256.806274,889.615540 
C264.529083,879.752197 271.911743,869.622864 279.606049,859.736633 
C291.600220,844.325745 303.765747,829.048462 315.789856,813.660767 
C321.991882,805.723694 327.971924,797.612305 334.228668,789.719604 
C335.468079,788.156067 337.512512,787.230713 339.547913,786.007263 
C339.974976,796.363098 340.039795,806.722778 340.009521,817.542847 
z'
    />
    <path
      fill='#282828'
      opacity='1.000000'
      stroke='none'
      d='
M1203.062256,1479.039551 
C1204.847656,1470.649536 1205.806641,1462.431396 1208.477417,1454.813477 
C1217.381958,1429.416870 1238.405762,1417.242310 1265.247803,1420.461304 
C1286.235962,1422.978516 1299.638916,1434.408936 1305.047607,1454.313721 
C1313.329712,1484.791870 1313.752319,1515.720459 1304.749512,1546.041870 
C1294.824951,1579.467651 1255.762329,1593.919434 1226.764526,1575.785522 
C1213.640137,1567.577881 1207.944458,1554.561890 1205.088867,1540.161011 
C1201.108643,1520.088135 1200.870117,1499.808838 1203.062256,1479.039551 
M1229.683105,1547.740479 
C1236.269409,1567.328369 1257.409790,1568.141479 1269.221558,1562.521973 
C1279.292603,1557.730591 1283.477539,1548.371826 1285.826538,1538.296875 
C1290.919800,1516.452515 1289.894409,1494.354248 1287.299683,1472.317993 
C1286.647095,1466.774658 1285.120728,1461.205811 1283.140991,1455.972290 
C1278.221924,1442.968994 1269.367432,1437.114380 1256.104980,1437.349609 
C1243.130005,1437.579834 1232.990112,1444.372070 1229.232178,1457.179810 
C1226.406860,1466.809814 1224.419312,1476.901001 1223.743042,1486.900879 
C1222.372559,1507.165039 1222.453735,1527.476807 1229.683105,1547.740479 
z'
    />
    <path
      fill='#272727'
      opacity='1.000000'
      stroke='none'
      d='
M1086.046631,1458.100220 
C1091.056152,1442.954590 1099.054810,1430.674316 1113.960083,1424.337646 
C1130.043457,1417.500244 1159.556030,1417.133057 1174.272827,1435.635376 
C1182.191284,1445.590698 1185.710571,1457.231689 1187.400513,1469.600098 
C1190.532104,1492.519409 1190.757080,1515.418335 1185.872314,1538.101929 
C1182.521362,1553.662964 1175.595703,1567.246460 1161.370728,1575.924927 
C1139.207031,1589.446533 1105.653198,1583.081421 1092.545898,1562.752930 
C1086.573242,1553.489868 1083.854858,1543.072388 1082.499268,1532.243774 
C1079.543945,1508.638672 1079.438110,1485.133789 1084.957397,1461.826416 
C1085.224487,1460.698364 1085.621216,1459.600830 1086.046631,1458.100220 
M1164.993164,1465.698242 
C1164.299072,1463.132446 1163.745605,1460.518433 1162.887573,1458.008667 
C1158.107300,1444.026611 1148.982300,1437.278687 1135.100220,1437.351074 
C1121.808228,1437.420410 1111.826904,1444.381104 1107.736084,1457.967529 
C1105.123901,1466.643555 1103.346558,1475.750488 1102.624634,1484.778564 
C1101.134521,1503.409546 1101.328003,1522.094238 1105.914307,1540.402710 
C1111.102051,1561.112061 1123.709717,1569.196289 1144.517334,1563.818237 
C1156.111084,1560.821655 1161.255615,1551.103882 1163.969482,1540.419189 
C1170.189209,1515.932861 1168.935913,1491.231567 1164.993164,1465.698242 
z'
    />
    <path
      fill='#282828'
      opacity='1.000000'
      stroke='none'
      d='
M517.357422,1560.806885 
C518.236938,1550.345581 519.372864,1549.659546 527.949829,1554.670410 
C540.793579,1562.174194 554.317688,1566.509399 569.369324,1564.053223 
C585.575378,1561.408691 594.321350,1549.852051 591.973511,1534.018433 
C590.834961,1526.340088 585.842896,1521.026489 579.472717,1517.471191 
C568.463013,1511.326782 557.031921,1505.942749 545.886230,1500.034790 
C537.817688,1495.757935 530.906860,1490.034546 526.515869,1481.847900 
C514.830322,1460.060791 522.302124,1429.808105 552.702148,1422.259521 
C567.758972,1418.520752 582.386475,1420.049316 596.569031,1426.208740 
C604.871033,1429.814209 608.210754,1437.881226 604.941040,1446.263794 
C603.563782,1449.794556 601.338318,1448.641235 598.892334,1447.584106 
C591.760803,1444.501831 584.788330,1440.673828 577.334839,1438.838623 
C571.761658,1437.466553 565.430908,1438.055176 559.631653,1438.983398 
C551.264709,1440.322632 545.451477,1445.492798 543.452576,1453.952271 
C541.425903,1462.529663 543.303040,1470.526489 550.289978,1476.051025 
C556.091064,1480.637695 562.791809,1484.123413 569.235229,1487.852661 
C579.696289,1493.907104 591.277283,1498.505859 600.595337,1505.957642 
C621.150818,1522.395996 618.622681,1557.264404 596.814758,1572.155029 
C580.467957,1583.316528 562.482544,1584.677002 543.774292,1580.746216 
C538.464722,1579.630615 533.361206,1577.425415 528.254211,1575.480957 
C521.753906,1573.005981 517.052124,1568.991333 517.357422,1560.806885 
z'
    />
    <path
      fill='#272727'
      opacity='1.000000'
      stroke='none'
      d='
M931.760559,1580.428467 
C905.965271,1580.428345 880.640015,1580.488525 855.315735,1580.365601 
C851.384155,1580.346558 846.331604,1582.023926 844.212585,1577.053223 
C841.969055,1571.790283 842.388245,1566.221558 845.575989,1561.275391 
C847.002563,1559.061890 848.970581,1557.181274 850.787537,1555.238159 
C865.685974,1539.304932 880.957825,1523.702637 895.388611,1507.357422 
C904.010681,1497.591553 910.752808,1486.291382 912.453064,1472.966553 
C913.113770,1467.788574 913.080444,1462.248779 911.975586,1457.176025 
C909.678894,1446.631104 900.921814,1439.967041 890.244202,1438.971924 
C879.314514,1437.953247 869.589050,1441.381958 860.195740,1446.344238 
C858.139893,1447.430176 856.199097,1448.731934 854.179199,1449.888550 
C848.792786,1452.972534 846.842896,1451.960815 846.110657,1445.865356 
C845.313904,1439.232422 846.672974,1433.870361 853.142151,1430.295898 
C870.839539,1420.517212 889.319519,1416.984741 908.850159,1423.351074 
C925.553589,1428.795898 935.256348,1444.724854 934.831116,1463.513428 
C934.383911,1483.269409 925.713562,1499.506714 913.391418,1513.907104 
C901.165283,1528.195312 888.010803,1541.689209 875.253784,1555.522461 
C873.353577,1557.583008 871.400574,1559.594849 868.462708,1562.693726 
C871.308105,1562.693726 872.855652,1562.693726 874.403137,1562.693726 
C893.730042,1562.693726 913.057007,1562.692383 932.383911,1562.694336 
C940.352905,1562.695068 942.039917,1564.276978 941.971680,1571.666504 
C941.902832,1579.121826 940.468933,1580.411621 931.760559,1580.428467 
z'
    />
    <path
      fill='#272727'
      opacity='1.000000'
      stroke='none'
      d='
M1342.668213,1443.700439 
C1352.911377,1437.118530 1362.934082,1430.862183 1372.765747,1424.318726 
C1378.762939,1420.327026 1385.167969,1420.911865 1391.517456,1422.312500 
C1392.747681,1422.583984 1394.058594,1425.844849 1394.076782,1427.738770 
C1394.263184,1447.232544 1394.191162,1466.728760 1394.191162,1486.224365 
C1394.191162,1510.052246 1394.191162,1533.880127 1394.191162,1557.708008 
C1394.191162,1559.505493 1394.191162,1561.302979 1394.191162,1563.650269 
C1402.964233,1563.650269 1411.254517,1563.632568 1419.544678,1563.656250 
C1425.749634,1563.673950 1427.085938,1565.149048 1427.119019,1571.877808 
C1427.153687,1578.913574 1425.815186,1580.419067 1419.349487,1580.422729 
C1394.188599,1580.436768 1369.027588,1580.435303 1343.866699,1580.423340 
C1337.512451,1580.420288 1335.907715,1578.662109 1335.977173,1571.922485 
C1336.045776,1565.266357 1337.605713,1563.664795 1344.115112,1563.654785 
C1353.604004,1563.640015 1363.093018,1563.650879 1372.879150,1563.650879 
C1372.879150,1523.792114 1372.879150,1484.186401 1372.879150,1443.786133 
C1370.628418,1445.101685 1368.586182,1446.280640 1366.557983,1447.483154 
C1358.547119,1452.233398 1350.630493,1457.151733 1342.499146,1461.685669 
C1337.620605,1464.405884 1336.137695,1463.366333 1335.409546,1457.794556 
C1334.596069,1451.567993 1336.162231,1446.588989 1342.668213,1443.700439 
z'
    />
    <path
      fill='#2A2A2A'
      opacity='1.000000'
      stroke='none'
      d='
M1063.226562,1423.650391 
C1067.247437,1431.486206 1065.462280,1438.821899 1062.370850,1445.982300 
C1048.147095,1478.927002 1033.845947,1511.838379 1019.568970,1544.760132 
C1015.404846,1554.362549 1010.987061,1563.864746 1007.153259,1573.597168 
C1004.977173,1579.121338 1001.377258,1581.381348 995.697327,1581.077637 
C992.871277,1580.926514 990.008911,1581.185059 987.209778,1580.857910 
C982.350220,1580.290039 981.445496,1578.754028 983.410339,1574.279785 
C989.355896,1560.741089 995.419312,1547.254028 1001.452026,1533.753784 
C1014.533020,1504.479736 1027.625854,1475.211060 1040.702637,1445.935181 
C1041.302246,1444.592773 1041.792847,1443.201538 1042.680298,1440.958496 
C1040.502441,1440.958496 1038.797119,1440.958496 1037.091919,1440.958496 
C1014.929321,1440.958496 992.766785,1440.964844 970.604187,1440.954346 
C964.172852,1440.951294 962.414368,1438.867310 962.490540,1431.445557 
C962.564148,1424.278687 964.186096,1422.423706 970.576477,1422.419800 
C999.071228,1422.402710 1027.565918,1422.390137 1056.060547,1422.454468 
C1058.346558,1422.459595 1060.631348,1423.060913 1063.226562,1423.650391 
z'
    />
    <path
      fill='#2B2B2B'
      opacity='1.000000'
      stroke='none'
      d='
M1092.247314,1826.329346 
C1090.545532,1830.592773 1089.911133,1835.322510 1083.822021,1834.731445 
C1080.717896,1834.430176 1078.818359,1833.485596 1077.593140,1830.231079 
C1069.520386,1808.787231 1061.196655,1787.437744 1052.941772,1766.062622 
C1052.365723,1764.571045 1051.684937,1763.119873 1050.270142,1761.802490 
C1050.270142,1785.624146 1050.270142,1809.445801 1050.270142,1833.693726 
C1048.176636,1834.065308 1046.454224,1834.531616 1044.708374,1834.648560 
C1040.785889,1834.911011 1038.838135,1833.700317 1038.887695,1829.022827 
C1039.139771,1805.207031 1038.993408,1781.387085 1039.011475,1757.568604 
C1039.016479,1751.053223 1040.083740,1750.011963 1046.494629,1749.979614 
C1057.214111,1749.925659 1058.011841,1750.466064 1061.909546,1760.353882 
C1069.336914,1779.195923 1076.768311,1798.036377 1084.587036,1817.863525 
C1085.614624,1815.626099 1086.359741,1814.140137 1086.991455,1812.607544 
C1094.394165,1794.645752 1101.759888,1776.668701 1109.179077,1758.713867 
C1112.564331,1750.521240 1118.961304,1747.270142 1127.071167,1750.397583 
C1128.889526,1751.098877 1130.536133,1754.750854 1130.596924,1757.087769 
C1130.934937,1770.070801 1130.759766,1783.067261 1130.760010,1796.059082 
C1130.760254,1806.719116 1130.560791,1817.384644 1130.854004,1828.036621 
C1130.979004,1832.577271 1129.896851,1834.841309 1124.925293,1834.757568 
C1120.273682,1834.679199 1119.233032,1832.639160 1119.281128,1828.273438 
C1119.502319,1808.121826 1119.377930,1787.966309 1119.377441,1767.812256 
C1119.377319,1765.989258 1119.377319,1764.166260 1119.377319,1762.343384 
C1119.006348,1762.225464 1118.635254,1762.107666 1118.264282,1761.989746 
C1109.639160,1783.317505 1101.014160,1804.645142 1092.247314,1826.329346 
z'
    />
    <path
      fill='#2B2B2B'
      opacity='1.000000'
      stroke='none'
      d='
M686.290649,1691.131348 
C694.300781,1671.947021 702.092957,1653.070312 709.888184,1634.194702 
C713.652832,1625.078857 718.390076,1622.420776 727.759033,1625.129150 
C729.494568,1625.630981 731.366699,1628.923340 731.516663,1631.044922 
C731.996765,1637.839600 731.699158,1644.689209 731.699463,1651.517700 
C731.700195,1668.838623 731.564941,1686.161499 731.793762,1703.479370 
C731.851501,1707.848022 730.486389,1709.344116 726.152710,1709.355835 
C721.687683,1709.368042 720.137390,1707.989868 720.195679,1703.288208 
C720.451477,1682.639526 720.304626,1661.985718 720.303772,1641.333862 
C720.303711,1639.750000 720.303772,1638.166138 720.303772,1636.582275 
C720.006714,1636.529663 719.709717,1636.477051 719.412659,1636.424438 
C718.650574,1638.164795 717.843750,1639.886963 717.133301,1641.648071 
C708.809570,1662.280029 700.433105,1682.891602 692.251221,1703.579834 
C690.840881,1707.145996 689.449707,1709.422852 684.954041,1709.417480 
C680.277893,1709.411743 679.214172,1706.677856 677.907532,1703.240601 
C669.943298,1682.289551 661.857361,1661.384644 653.795715,1640.470703 
C653.276978,1639.124878 652.620972,1637.832031 651.131409,1636.544556 
C651.131409,1637.899536 651.131348,1639.254517 651.131348,1640.609497 
C651.131592,1661.760986 650.987549,1682.914307 651.246033,1704.062744 
C651.302185,1708.657227 649.288879,1709.332031 645.600464,1709.297363 
C642.038147,1709.263794 639.814026,1708.908203 639.864868,1704.163818 
C640.124146,1680.017212 639.969177,1655.866455 639.995483,1631.717041 
C640.001953,1625.774658 641.006836,1624.845093 647.037354,1624.760620 
C658.206909,1624.604248 658.864624,1625.057983 663.053772,1635.650635 
C669.953430,1653.097168 676.844910,1670.547119 683.801331,1687.971069 
C684.303589,1689.229126 685.304871,1690.287842 686.290649,1691.131348 
z'
    />
    <path
      fill='#2B2B2B'
      opacity='1.000000'
      stroke='none'
      d='
M617.034668,1775.958252 
C619.825500,1769.149292 622.407410,1762.664551 625.215576,1756.279297 
C627.736877,1750.546265 638.022034,1747.157227 643.027771,1750.818604 
C644.707825,1752.047363 645.547363,1755.384644 645.570068,1757.769653 
C645.764221,1778.093628 645.681580,1798.420044 645.681519,1818.745850 
C645.681519,1822.411133 645.429626,1826.098022 645.743713,1829.736206 
C646.129578,1834.206299 643.367493,1834.646606 640.145447,1834.657349 
C636.774170,1834.668457 634.142334,1834.345337 634.196228,1829.565552 
C634.429260,1808.909180 634.294983,1788.248657 634.294373,1767.589722 
C634.294312,1765.799805 634.294373,1764.009766 634.294373,1762.219849 
C634.039185,1762.144897 633.783997,1762.069946 633.528809,1761.994873 
C632.984619,1763.056152 632.354187,1764.082397 631.908997,1765.183594 
C623.255432,1786.586304 614.561279,1807.973145 606.052551,1829.433350 
C604.741577,1832.739624 603.196960,1834.764404 599.335632,1834.751099 
C595.428650,1834.737671 593.499451,1833.055054 592.125549,1829.399292 
C584.238159,1808.411011 576.106445,1787.514526 568.053101,1766.588623 
C567.411743,1764.922119 566.735535,1763.269043 565.194092,1761.723999 
C565.194092,1785.670044 565.194092,1809.615967 565.194092,1834.116943 
C561.248535,1834.116943 557.879700,1834.116943 554.220215,1834.116943 
C554.122437,1832.134766 553.987671,1830.666626 553.986877,1829.198486 
C553.973938,1805.374023 553.969849,1781.549561 553.983643,1757.725098 
C553.987549,1750.870850 554.895813,1749.997437 561.776367,1749.980835 
C572.060913,1749.956055 573.012512,1750.607300 576.806091,1760.213867 
C583.821594,1777.979004 590.839355,1795.743164 597.862610,1813.505371 
C598.335999,1814.702515 598.863342,1815.878540 599.713501,1817.885742 
C605.645752,1803.560669 611.284973,1789.943359 617.034668,1775.958252 
z'
    />
    <path
      fill='#272727'
      opacity='1.000000'
      stroke='none'
      d='
M486.617706,1580.972046 
C472.127563,1581.404419 472.127472,1581.404419 472.127502,1567.362183 
C472.127625,1521.568604 472.126740,1475.774902 472.129211,1429.981323 
C472.129578,1423.216919 472.999847,1422.316284 479.821472,1421.949463 
C492.572235,1421.263550 493.139130,1421.782104 493.139191,1434.142944 
C493.139374,1480.602661 493.071960,1527.062500 493.241180,1573.521606 
C493.258545,1578.289062 491.906219,1580.776611 486.617706,1580.972046 
z'
    />
    <path
      fill='#494949'
      opacity='1.000000'
      stroke='none'
      d='
M147.018433,361.875183 
C160.321457,371.619507 158.639481,384.984283 142.938644,395.632538 
C143.609482,395.922150 144.146820,396.220154 144.721817,396.392395 
C152.450012,398.707367 157.567596,403.323700 157.939606,411.843658 
C158.359787,421.466278 154.196045,428.714966 145.501541,432.712860 
C141.536636,434.535980 136.952652,435.641052 132.591400,435.848022 
C122.293098,436.336823 111.959999,436.095398 101.640907,436.132629 
C101.155296,436.134399 100.669113,435.975281 99.855667,435.834320 
C99.855667,409.828186 99.855667,383.813965 99.855667,356.315735 
C114.044060,357.387970 127.880424,358.369690 141.698898,359.559235 
C143.412643,359.706787 145.031296,360.958893 147.018433,361.875183 
M132.061920,402.047516 
C126.303055,402.047516 120.544182,402.047516 114.667313,402.047516 
C114.667313,409.698792 114.667313,416.924744 114.667313,424.350983 
C120.574760,424.350983 126.202980,424.691620 131.773056,424.267975 
C139.362579,423.690735 142.845871,420.137299 143.136398,413.638885 
C143.449402,406.637604 140.931885,403.795349 132.061920,402.047516 
M130.043579,391.041718 
C138.168701,389.627869 141.226456,386.436981 141.026489,379.580658 
C140.835953,373.047791 137.490097,369.797119 129.565582,369.199921 
C124.666313,368.830627 119.716537,369.131439 114.358749,369.131439 
C114.358749,375.292877 114.343910,381.079529 114.370140,386.865967 
C114.376030,388.165710 114.525467,389.464783 114.629311,391.083435 
C119.606209,391.083435 124.371529,391.083435 130.043579,391.041718 
z'
    />
    <path
      fill='#494949'
      opacity='1.000000'
      stroke='none'
      d='
M153.015045,122.669952 
C149.482971,127.079559 146.024124,131.096298 142.516434,135.169754 
C141.878693,134.892883 142.464813,135.224350 143.094040,135.408691 
C149.853241,137.388718 154.784698,141.353134 155.783417,148.608963 
C156.908020,156.779236 154.248398,163.718246 147.541290,168.831787 
C141.686661,173.295380 134.762604,174.333405 127.729721,174.497971 
C118.260017,174.719559 108.781227,174.552948 98.979141,174.552948 
C98.979141,148.659668 98.979141,123.088493 98.979141,96.578949 
C111.729370,97.122177 124.413498,96.855453 136.868317,98.417313 
C149.651459,100.020348 155.726944,109.984657 153.015045,122.669952 
M113.117165,143.716888 
C113.117165,150.109512 113.117165,156.502151 113.117165,163.433594 
C120.339417,163.025345 126.861649,163.207901 133.173523,162.143295 
C139.362000,161.099518 141.863464,156.794922 141.373947,150.494965 
C140.936295,144.862228 137.862228,141.598267 131.767395,141.121063 
C126.482704,140.707321 121.150566,140.782700 115.843773,140.880127 
C114.927635,140.896942 114.033318,142.102554 113.117165,143.716888 
M113.115570,112.804184 
C113.115570,118.553345 113.115570,124.302505 113.115570,129.929550 
C119.314407,129.929550 124.984146,130.452957 130.512115,129.791519 
C136.827576,129.035843 139.495331,124.962311 139.113754,118.529099 
C138.744354,112.301498 135.959625,109.456367 129.340485,108.933609 
C125.043930,108.594292 120.716858,108.657333 116.413269,108.385048 
C113.749733,108.216530 112.766487,109.340805 113.115570,112.804184 
z'
    />
    <path
      fill='#272727'
      opacity='1.000000'
      stroke='none'
      d='
M1494.018188,1709.224609 
C1489.805420,1709.553345 1488.822144,1707.786743 1488.848389,1704.165283 
C1489.002808,1682.838013 1488.924316,1661.508911 1488.924316,1640.180420 
C1488.924316,1638.374146 1488.924316,1636.567871 1488.924316,1634.135620 
C1481.835571,1634.135620 1475.062256,1634.011963 1468.296753,1634.188232 
C1464.953491,1634.275269 1462.951782,1633.694092 1462.913940,1629.692261 
C1462.875610,1625.644409 1464.583740,1624.676514 1468.350708,1624.711060 
C1485.845215,1624.871338 1503.342163,1624.805664 1520.838135,1624.760376 
C1523.885010,1624.752563 1526.934326,1624.498535 1529.976929,1624.280640 
C1534.589844,1623.950317 1538.037720,1624.702393 1540.239258,1629.828613 
C1545.282837,1641.572021 1551.065430,1652.998047 1556.798828,1665.081421 
C1557.926270,1662.562622 1558.926270,1660.233276 1560.002686,1657.939819 
C1564.309204,1648.765625 1568.619629,1639.593018 1572.968262,1630.438599 
C1576.158569,1623.722412 1579.185913,1622.640869 1587.015747,1625.802368 
C1586.173828,1627.701416 1585.406860,1629.631958 1584.482544,1631.484131 
C1577.580811,1645.313599 1570.583984,1659.096313 1563.792114,1672.979370 
C1562.747192,1675.115234 1562.171875,1677.679932 1562.114624,1680.063965 
C1561.914429,1688.390625 1561.847900,1696.730957 1562.110596,1705.054077 
C1562.255737,1709.647339 1559.264526,1709.217529 1556.498291,1709.199463 
C1553.776733,1709.181763 1550.379761,1709.743652 1550.902222,1705.113037 
C1550.976440,1704.454956 1550.841187,1703.772339 1550.922363,1703.115845 
C1553.217529,1684.574463 1548.668823,1667.764771 1538.873901,1651.962646 
C1534.256958,1644.514160 1530.842529,1636.320312 1526.228882,1627.165771 
C1526.811401,1634.731934 1522.567261,1634.314209 1518.229980,1634.180176 
C1512.418335,1634.000610 1506.597046,1634.135620 1500.044434,1634.135620 
C1500.044434,1636.099609 1500.044434,1637.849854 1500.044434,1639.599976 
C1500.044434,1660.928467 1499.910278,1682.258423 1500.152588,1703.584229 
C1500.203613,1708.083984 1498.705811,1709.688477 1494.018188,1709.224609 
z'
    />
    <path
      fill='#2B2B2B'
      opacity='1.000000'
      stroke='none'
      d='
M391.716919,1682.219482 
C393.368927,1685.407349 394.840637,1688.271729 396.312347,1691.135986 
C396.647919,1691.052612 396.983459,1690.969360 397.319031,1690.885986 
C397.319031,1689.333740 397.321320,1687.781616 397.318665,1686.229370 
C397.286316,1667.409668 397.397339,1648.587769 397.117401,1629.771851 
C397.048767,1625.159058 399.291229,1624.498413 402.879181,1624.506714 
C406.406830,1624.514771 408.729553,1625.040527 408.686249,1629.694946 
C408.466217,1653.342651 408.600769,1676.993652 408.566345,1700.643433 
C408.561859,1703.730957 409.302307,1707.718262 405.356476,1708.674072 
C401.243225,1709.670288 396.548126,1710.217651 393.302490,1706.291016 
C391.309113,1703.879639 389.668610,1701.123901 388.180817,1698.355591 
C377.642334,1678.747681 367.184326,1659.096313 356.330994,1638.766357 
C356.174774,1640.439819 355.977448,1641.568115 355.977753,1642.696533 
C355.983643,1663.181763 355.862213,1683.669189 356.151611,1704.150757 
C356.218048,1708.852173 353.990265,1709.258789 350.413879,1709.307007 
C346.693176,1709.357056 344.742920,1708.615234 344.786621,1704.067139 
C345.018677,1679.920044 344.881927,1655.769287 344.906464,1631.619873 
C344.912567,1625.595093 345.798004,1625.152466 351.959900,1624.669556 
C358.522064,1624.155518 362.438812,1626.816284 365.398346,1632.570435 
C373.908600,1649.116455 382.796875,1665.468018 391.716919,1682.219482 
z'
    />
    <path
      fill='#2B2B2B'
      opacity='1.000000'
      stroke='none'
      d='
M1015.117920,1658.935425 
C1011.579834,1652.165894 1008.196777,1645.733398 1004.813660,1639.301025 
C1004.549011,1639.299438 1004.284302,1639.297852 1004.019653,1639.296265 
C1004.019653,1640.810791 1004.017944,1642.325195 1004.020020,1643.839722 
C1004.046875,1663.830322 1003.919617,1683.823364 1004.214600,1703.809937 
C1004.284912,1708.573608 1002.246704,1709.314575 998.313477,1709.320679 
C994.394104,1709.326660 992.815857,1708.196045 992.855591,1703.872681 
C993.069519,1680.552124 992.913818,1657.228394 993.006714,1633.906250 
C993.019653,1630.655762 991.554504,1626.528320 996.300964,1625.011963 
C1001.720093,1623.280762 1008.619202,1625.129272 1011.226746,1628.958740 
C1012.345215,1630.601318 1013.266479,1632.385132 1014.199951,1634.145752 
C1023.774292,1652.204468 1033.332153,1670.271973 1042.897827,1688.335205 
C1043.396484,1689.276733 1043.925049,1690.202515 1045.149658,1692.422852 
C1045.333496,1689.700439 1045.489258,1688.481812 1045.486938,1687.263428 
C1045.449463,1668.272827 1045.526489,1649.280151 1045.239014,1630.293091 
C1045.171021,1625.804810 1046.833374,1624.431396 1050.973389,1624.464844 
C1054.959229,1624.496826 1056.877197,1625.546631 1056.832642,1630.171753 
C1056.606812,1653.658691 1056.739136,1677.148926 1056.714355,1700.638062 
C1056.711060,1703.750610 1057.347534,1708.057373 1053.469727,1708.562988 
C1049.694580,1709.055298 1045.278198,1708.130371 1041.833252,1706.430054 
C1039.522095,1705.289307 1038.220825,1701.817261 1036.799072,1699.207764 
C1029.564331,1685.928345 1022.437500,1672.590088 1015.117920,1658.935425 
z'
    />
    <path
      fill='#2A2A2A'
      opacity='1.000000'
      stroke='none'
      d='
M1224.066528,1764.912231 
C1223.819580,1766.310669 1223.356812,1767.709351 1223.358276,1769.107544 
C1223.378906,1789.100830 1223.313110,1809.096436 1223.639404,1829.085449 
C1223.717407,1833.856689 1221.526611,1834.741821 1217.674927,1834.690063 
C1213.989624,1834.640503 1212.044678,1833.624390 1212.087280,1829.187378 
C1212.311401,1805.863281 1212.164307,1782.535767 1212.222290,1759.209839 
C1212.230713,1755.860962 1211.166748,1751.858154 1215.625244,1750.232178 
C1220.431885,1748.479126 1227.739258,1750.268066 1230.267456,1753.789551 
C1231.618530,1755.671387 1232.731689,1757.739014 1233.818237,1759.793579 
C1243.529419,1778.158447 1253.210449,1796.539185 1262.903198,1814.913818 
C1263.324585,1815.712646 1263.773926,1816.496826 1264.842041,1818.432983 
C1264.842041,1799.659424 1264.842041,1782.243774 1264.842041,1764.828003 
C1264.842041,1761.662231 1265.130371,1758.463745 1264.774780,1755.338501 
C1264.237793,1750.618164 1266.571167,1749.748535 1270.611816,1749.780640 
C1274.542725,1749.812012 1276.144043,1750.895752 1276.105591,1755.236572 
C1275.896729,1778.894165 1276.098022,1802.555542 1275.876099,1826.212891 
C1275.851685,1828.810059 1274.260986,1833.450073 1272.994995,1833.593506 
C1269.163574,1834.027222 1264.953857,1833.211548 1261.260132,1831.868774 
C1259.459717,1831.214233 1258.246338,1828.430054 1257.162231,1826.399048 
C1246.283447,1806.020752 1235.487061,1785.598633 1224.299072,1764.838501 
C1223.743774,1764.489502 1223.556885,1764.490845 1223.369873,1764.492188 
C1223.383789,1764.623657 1223.374390,1764.859741 1223.415649,1764.868896 
C1223.625488,1764.915649 1223.848267,1764.903687 1224.066528,1764.912231 
z'
    />
    <path
      fill='#2A2A2A'
      opacity='1.000000'
      stroke='none'
      d='
M791.826172,1782.000000 
C791.826294,1772.508911 792.039307,1763.510620 791.737976,1754.529663 
C791.584351,1749.950317 794.137512,1749.827515 797.398376,1749.842041 
C800.640625,1749.856567 803.114502,1749.959595 803.078003,1754.535278 
C802.888123,1778.343506 803.075012,1802.154785 802.870300,1825.962891 
C802.847473,1828.617920 801.863159,1832.823853 800.127197,1833.587158 
C796.271362,1835.282715 791.450134,1835.449585 788.075012,1831.843750 
C785.957703,1829.581787 784.359009,1826.751587 782.880371,1823.987549 
C772.539185,1804.657227 762.291443,1785.276855 752.003052,1765.918213 
C751.719177,1765.384033 751.313843,1764.914673 750.487366,1763.730713 
C750.487366,1770.732178 750.487183,1776.909790 750.487427,1783.087280 
C750.488037,1798.072388 750.336487,1813.060059 750.582336,1828.041260 
C750.656067,1832.534424 749.723389,1834.874268 744.698975,1834.755737 
C740.042114,1834.645996 739.037903,1832.584961 739.077209,1828.234741 
C739.284790,1805.259277 739.146790,1782.281006 739.205627,1759.303955 
C739.214172,1755.956543 738.127563,1751.957520 742.508423,1750.256592 
C747.386230,1748.362793 754.868774,1750.316772 757.475769,1754.100220 
C758.790100,1756.007568 759.868835,1758.086792 760.954102,1760.141113 
C770.650757,1778.496338 780.324036,1796.863892 790.010315,1815.224609 
C790.370789,1815.907837 790.794312,1816.557739 791.826172,1818.299927 
C791.826172,1805.564941 791.826172,1794.032471 791.826172,1782.000000 
z'
    />
    <path
      fill='#494949'
      opacity='1.000000'
      stroke='none'
      d='
M495.992249,305.866852 
C493.560547,305.866913 491.599854,305.866913 489.067688,305.866913 
C489.067688,295.315552 489.075623,285.205597 489.061676,275.095673 
C489.058472,272.763763 489.152283,270.413361 488.902130,268.103882 
C488.304199,262.583862 485.331085,259.829071 480.212128,259.792450 
C474.864288,259.754181 471.272430,262.443451 470.914612,268.047668 
C470.332123,277.171875 470.444977,286.341248 470.298004,295.492065 
C470.245209,298.778656 470.289520,302.066772 470.289520,305.606140 
C465.669098,305.606140 461.577850,305.606140 456.710480,305.606140 
C456.710480,303.462189 456.737335,301.378235 456.705963,299.295105 
C456.545410,288.641632 456.614777,277.976562 456.099823,267.339935 
C455.827393,261.713684 452.669586,259.504059 447.094543,259.792969 
C441.479523,260.083954 437.924469,263.476959 437.916534,268.633087 
C437.897797,280.785339 437.910553,292.937653 437.910553,305.477173 
C433.422272,305.477173 429.181549,305.477173 424.521149,305.477173 
C424.521149,287.265076 424.521149,268.888580 424.521149,250.497910 
C432.850739,248.780334 434.359985,249.334610 437.270325,255.210999 
C450.695648,245.913361 458.839264,246.877289 465.621277,258.931641 
C470.103088,251.663101 476.657043,248.663086 484.925476,249.011124 
C493.709045,249.380829 500.606262,254.448593 501.766144,263.109070 
C502.864532,271.310150 502.632294,279.698120 502.834747,288.007568 
C502.975586,293.789062 502.861877,299.576752 502.861877,305.866791 
C500.370300,305.866791 498.416779,305.866791 495.992249,305.866852 
z'
    />
    <path
      fill='#2A2A2A'
      opacity='1.000000'
      stroke='none'
      d='
M552.821777,1685.703491 
C543.408997,1708.819214 517.269165,1717.488647 496.036285,1704.744629 
C488.290619,1700.095825 484.249451,1692.641968 482.301392,1684.158081 
C479.817200,1673.339355 479.794769,1662.398193 482.248810,1651.520752 
C486.334229,1633.412354 501.491547,1622.710083 520.473511,1623.513550 
C543.029602,1624.468140 554.043091,1638.061157 555.026306,1658.188354 
C555.465576,1667.180542 553.712280,1676.279907 552.821777,1685.703491 
M502.724579,1638.119873 
C499.971771,1642.369873 496.354370,1646.301514 494.647675,1650.936768 
C491.185547,1660.339844 491.571167,1670.281128 493.566528,1679.988647 
C496.399658,1693.771851 503.937042,1700.040527 517.201172,1700.346313 
C530.004272,1700.641479 538.532104,1694.150635 542.046082,1681.134399 
C544.650940,1671.485718 544.669800,1661.709961 542.146423,1652.057983 
C537.455872,1634.117310 518.705566,1627.262207 502.724579,1638.119873 
z'
    />
    <path
      fill='#2A2A2A'
      opacity='1.000000'
      stroke='none'
      d='
M904.108765,1654.225830 
C907.386230,1638.727173 915.461182,1627.847778 931.178162,1624.701782 
C948.708496,1621.192993 965.692017,1625.162354 973.193604,1641.071167 
C979.388306,1654.208618 979.426819,1668.119873 976.139954,1682.052246 
C973.113342,1694.881348 966.089172,1704.519165 952.858765,1708.090698 
C938.534973,1711.957397 924.706299,1711.400635 913.253845,1700.432617 
C906.272278,1693.746460 903.991943,1684.711304 903.346191,1675.515991 
C902.861206,1668.609619 903.758728,1661.606201 904.108765,1654.225830 
M966.011169,1660.794800 
C965.609436,1657.998901 965.421082,1655.152222 964.769470,1652.415771 
C961.809509,1639.986572 953.947815,1633.501709 941.559753,1633.083130 
C929.346619,1632.670654 920.405151,1639.149902 916.859924,1651.351562 
C913.821899,1661.807861 913.974243,1672.398926 916.798035,1682.867798 
C919.976013,1694.649902 927.245483,1700.056152 939.677246,1700.334839 
C951.539734,1700.600952 960.841064,1694.610229 963.677307,1683.398315 
C965.441650,1676.423828 965.316040,1668.971069 966.011169,1660.794800 
z'
    />
    <path
      fill='#494949'
      opacity='1.000000'
      stroke='none'
      d='
M156.899292,275.046082 
C160.923492,285.408386 164.841949,295.400299 168.769226,305.414764 
C168.080811,305.639008 167.924866,305.727020 167.764114,305.736877 
C153.947845,306.586212 153.650482,306.683228 149.225021,293.179413 
C147.484970,287.869781 145.168671,285.806274 139.465652,286.300568 
C132.529953,286.901703 125.498642,286.578247 118.516373,286.381805 
C115.432198,286.295013 113.581657,286.983673 112.761055,290.281281 
C111.965233,293.479309 110.306221,296.455231 109.404396,299.635895 
C108.041779,304.441742 105.071106,306.379089 100.164848,305.906433 
C97.698837,305.668854 95.191048,305.864960 92.170143,305.864960 
C92.703529,304.195709 93.056862,302.832672 93.567123,301.531158 
C102.708702,278.214386 111.943222,254.933517 120.944870,231.562943 
C122.273712,228.112930 123.878822,226.500046 127.703964,226.918991 
C130.986755,227.278549 134.340164,226.993500 137.951401,226.993500 
C144.250504,242.934128 150.522018,258.804932 156.899292,275.046082 
M140.961075,270.783813 
C137.499619,261.318817 134.038162,251.853821 130.415405,241.947769 
C126.437965,252.888153 122.650909,263.295105 118.878265,273.707275 
C118.661240,274.306244 118.561646,274.947784 118.382225,275.671021 
C126.406120,275.671021 134.231339,275.671021 142.441711,275.671021 
C141.940369,274.057281 141.557007,272.823273 140.961075,270.783813 
z'
    />
    <path
      fill='#2A2A2A'
      opacity='1.000000'
      stroke='none'
      d='
M919.284973,1833.827637 
C898.375854,1828.195679 890.058105,1810.925659 890.531128,1791.485962 
C890.859863,1777.974976 895.137146,1766.132690 906.103394,1757.293823 
C918.404907,1747.378784 941.998474,1746.002075 955.174622,1754.666138 
C959.298950,1757.377930 959.995605,1760.438354 957.503418,1766.327271 
C953.656006,1764.566772 949.902649,1762.565552 945.953308,1761.088257 
C921.811401,1752.058105 900.897400,1767.404419 902.229309,1793.187988 
C902.869263,1805.576782 906.453186,1816.580078 918.571594,1822.509277 
C927.084106,1826.674072 935.944275,1826.391113 944.684814,1823.032349 
C945.846802,1822.585815 947.410339,1821.146240 947.442688,1820.124146 
C947.678223,1812.673950 947.569397,1805.212891 947.569397,1797.239624 
C941.431030,1797.239624 935.797485,1797.079224 930.178833,1797.298950 
C926.699341,1797.435059 925.915771,1795.702759 925.883972,1792.761353 
C925.852966,1789.890991 926.381897,1787.946289 929.955383,1788.015381 
C937.780640,1788.166748 945.611206,1788.113403 953.438782,1788.042236 
C957.306824,1788.007202 958.844177,1790.045044 958.850342,1793.618774 
C958.867737,1803.612183 958.863525,1813.605469 958.859436,1823.598877 
C958.858032,1826.891724 957.583740,1829.183350 954.330383,1830.558594 
C943.106262,1835.302856 931.600342,1836.565918 919.284973,1833.827637 
z'
    />
    <path
      fill='#2A2A2A'
      opacity='1.000000'
      stroke='none'
      d='
M586.880737,1671.347412 
C585.065186,1671.347046 583.740601,1671.347046 581.816589,1671.347046 
C581.816589,1682.039917 581.821167,1692.490479 581.814636,1702.941162 
C581.811157,1708.627563 577.679382,1711.303345 572.363708,1708.806641 
C571.399597,1708.353638 570.579285,1706.483154 570.574280,1705.263550 
C570.472534,1680.276733 570.483398,1655.289185 570.523376,1630.301880 
C570.527527,1627.719604 570.918335,1624.864746 574.318420,1624.920532 
C584.279724,1625.083496 594.364563,1624.645752 604.160828,1626.081909 
C614.951294,1627.663696 620.319763,1634.337158 621.542419,1644.447266 
C622.734070,1654.300903 618.549500,1661.523926 608.804504,1666.465942 
C607.958191,1666.895142 607.156494,1667.412354 607.404175,1667.268921 
C610.828979,1672.745483 614.518982,1677.748779 617.241943,1683.232300 
C620.482849,1689.758911 622.982117,1696.663330 625.634460,1703.469604 
C627.539856,1708.359375 627.010132,1708.807129 622.014343,1709.285400 
C617.318176,1709.734863 614.717041,1708.095093 613.173889,1703.483521 
C610.912170,1696.724854 607.982300,1690.188965 605.318909,1683.565430 
C602.070435,1675.486694 596.453247,1670.867798 586.880737,1671.347412 
M609.173584,1643.680786 
C607.821655,1638.356079 604.077759,1635.414185 598.960327,1634.734375 
C593.431702,1634.000000 587.798767,1634.050049 582.188660,1633.756836 
C582.188660,1643.677368 582.188660,1652.883545 582.188660,1662.069946 
C586.886536,1662.069946 591.224304,1662.288940 595.532593,1662.026367 
C605.824402,1661.399292 611.001831,1654.695557 609.173584,1643.680786 
z'
    />
    <path
      fill='#282828'
      opacity='1.000000'
      stroke='none'
      d='
M1373.014893,1699.913208 
C1373.014771,1676.935303 1373.004883,1654.444458 1373.020630,1631.953491 
C1373.025269,1625.393921 1373.629150,1624.687622 1380.186035,1624.814453 
C1388.822876,1624.981323 1397.579224,1624.589478 1406.057861,1625.901245 
C1416.830444,1627.567993 1422.883667,1634.250366 1423.971924,1643.289185 
C1425.303711,1654.349731 1421.361572,1661.467773 1411.045044,1666.639893 
C1410.336670,1666.994995 1409.641846,1667.377441 1408.438843,1668.011597 
C1417.134399,1673.516724 1419.508911,1682.528564 1423.028442,1690.820923 
C1424.974487,1695.406250 1426.771118,1700.055420 1428.606567,1704.687012 
C1429.740234,1707.547241 1428.960571,1708.925903 1425.662109,1709.229004 
C1420.635498,1709.690796 1417.263428,1708.759888 1415.597778,1703.097046 
C1413.638916,1696.437500 1410.716675,1690.035156 1407.897583,1683.660522 
C1403.127930,1672.874756 1396.685181,1669.719360 1384.172241,1671.968750 
C1384.172241,1682.172607 1383.976562,1692.475464 1384.263184,1702.764771 
C1384.387695,1707.230469 1383.554443,1709.408691 1378.424072,1709.390259 
C1373.365845,1709.372070 1372.508911,1706.999390 1373.000610,1702.897461 
C1373.098999,1702.076294 1373.014893,1701.233154 1373.014893,1699.913208 
M1403.871948,1635.248901 
C1397.385620,1634.675537 1390.899292,1634.102173 1384.164307,1633.506714 
C1384.164307,1639.226562 1384.164307,1643.701904 1384.164307,1648.177246 
C1384.164307,1652.776733 1384.164307,1657.376343 1384.164307,1661.966309 
C1389.774658,1661.966309 1394.780151,1662.334595 1399.708984,1661.877319 
C1406.545532,1661.243042 1411.195190,1656.743408 1412.056152,1650.789429 
C1413.115479,1643.462158 1410.775146,1638.735474 1403.871948,1635.248901 
z'
    />
    <path
      fill='#2B2B2B'
      opacity='1.000000'
      stroke='none'
      d='
M1290.183350,1670.983276 
C1290.183594,1656.826050 1290.381348,1643.161255 1290.075439,1629.507812 
C1289.970581,1624.826294 1292.378784,1624.274414 1295.884888,1624.230103 
C1299.524170,1624.184204 1301.578247,1625.036499 1301.531982,1629.590088 
C1301.357544,1646.740356 1301.177734,1663.916016 1301.918335,1681.042603 
C1302.584229,1696.442261 1315.765991,1704.466797 1330.337280,1699.186890 
C1337.764160,1696.495728 1341.568237,1690.716553 1342.010010,1683.265625 
C1342.669922,1672.141235 1342.547852,1660.968628 1342.676270,1649.815552 
C1342.758789,1642.653076 1342.849243,1635.484375 1342.635986,1628.327393 
C1342.510498,1624.115845 1345.403076,1624.272705 1347.959229,1624.322144 
C1350.390259,1624.368774 1353.874023,1623.637329 1353.837891,1627.797363 
C1353.673584,1646.776123 1354.048828,1665.791992 1352.945312,1684.719482 
C1352.144531,1698.454102 1341.888550,1707.684692 1327.893066,1709.794556 
C1311.896240,1712.206177 1297.948975,1706.257812 1293.346558,1693.493530 
C1290.884033,1686.663452 1291.149170,1678.849976 1290.183350,1670.983276 
z'
    />
    <path
      fill='#2A2A2A'
      opacity='1.000000'
      stroke='none'
      d='
M657.682617,1827.574585 
C666.601379,1802.852295 675.477783,1778.526245 684.037903,1754.089478 
C685.630188,1749.543823 688.764221,1749.641602 692.286438,1749.652466 
C695.971924,1749.663818 699.245789,1749.551392 700.913696,1754.328857 
C709.502625,1778.930664 718.482361,1803.395752 727.204041,1827.951782 
C727.904053,1829.922852 730.547180,1832.527954 726.811035,1834.261475 
C722.885803,1836.082764 717.399475,1834.392578 716.165405,1831.035889 
C714.218079,1825.739380 712.572205,1820.326538 710.458557,1815.100464 
C709.938904,1813.815918 708.122192,1812.225098 706.870911,1812.197998 
C696.232544,1811.967651 685.587097,1812.066284 674.569153,1812.066284 
C672.669128,1817.617676 670.798828,1823.067505 668.938782,1828.520996 
C666.708191,1835.060303 663.087830,1836.411011 655.993652,1832.962280 
C656.490234,1831.337769 657.010620,1829.635132 657.682617,1827.574585 
M703.953003,1795.605225 
C700.027527,1784.490967 696.102112,1773.376831 691.791199,1761.171265 
C686.741943,1775.877808 682.151917,1789.246948 677.494873,1802.811279 
C687.489441,1802.811279 696.701965,1802.811279 706.422546,1802.811279 
C705.567688,1800.394165 704.859131,1798.390381 703.953003,1795.605225 
z'
    />
    <path
      fill='#2A2A2A'
      opacity='1.000000'
      stroke='none'
      d='
M843.104126,1750.935669 
C846.795837,1750.376831 850.248047,1749.786865 853.648010,1750.006348 
C855.045837,1750.096802 857.064941,1751.662109 857.558960,1753.011597 
C867.085205,1779.031738 876.430115,1805.118408 885.785645,1831.200928 
C885.998718,1831.795044 885.902405,1832.500122 885.946838,1833.104614 
C878.938965,1836.600586 875.054260,1835.167847 872.593933,1828.274902 
C870.698792,1822.965088 868.809814,1817.652954 866.819824,1812.065674 
C855.955688,1812.065674 845.163269,1811.984253 834.376099,1812.184937 
C833.229309,1812.206177 831.562683,1813.652954 831.081360,1814.825806 
C829.320190,1819.117676 827.956848,1823.572632 826.446899,1827.967407 
C824.021179,1835.027832 821.832275,1836.037598 813.832153,1833.504272 
C813.948547,1832.312622 813.813110,1830.947266 814.234863,1829.784058 
C823.734131,1803.586182 833.294678,1777.410522 843.104126,1750.935669 
M862.025696,1797.734497 
C857.902588,1785.959106 853.779541,1774.183838 849.217346,1761.154541 
C844.150269,1775.805908 839.511902,1789.217896 834.767578,1802.936035 
C844.573059,1802.936035 853.863037,1802.936035 863.616577,1802.936035 
C863.123596,1801.325806 862.699158,1799.939331 862.025696,1797.734497 
z'
    />
    <path
      fill='#2A2A2A'
      opacity='1.000000'
      stroke='none'
      d='
M787.615234,1631.363037 
C796.261292,1655.288940 804.780701,1678.848267 813.138245,1702.465088 
C813.860657,1704.506470 816.825562,1707.440552 812.590698,1709.015869 
C808.063599,1710.699951 803.356384,1708.987549 802.097290,1705.517944 
C799.895874,1699.451294 797.803101,1693.345337 795.613647,1687.109863 
C783.894104,1687.109863 772.289795,1687.109863 760.470703,1687.109863 
C758.345276,1693.261963 756.285645,1699.362793 754.123291,1705.427002 
C752.927063,1708.782227 745.836853,1711.072876 743.385254,1708.586182 
C742.475769,1707.663574 742.774048,1704.896240 743.350769,1703.263184 
C749.262085,1686.524658 755.343079,1669.846191 761.379089,1653.151733 
C764.086975,1645.662354 767.089050,1638.262817 769.405945,1630.654541 
C770.863220,1625.869141 773.428162,1624.129150 778.342712,1624.098633 
C783.503418,1624.066772 786.594604,1625.822021 787.615234,1631.363037 
M764.996094,1677.917358 
C773.949402,1677.917358 782.902710,1677.917358 792.589539,1677.917358 
C787.680908,1663.935181 782.952026,1650.465088 778.002930,1636.367798 
C777.403870,1637.397461 777.296265,1637.529053 777.243958,1637.679688 
C773.654358,1648.019775 770.019714,1658.344482 766.515320,1668.713379 
C765.525208,1671.643311 764.917114,1674.702271 764.996094,1677.917358 
z'
    />
    <path
      fill='#494949'
      opacity='1.000000'
      stroke='none'
      d='
M295.004456,174.002167 
C290.729523,174.314285 286.764618,174.314285 282.180237,174.314285 
C282.180237,159.567627 282.180237,144.878891 282.180237,129.978882 
C273.479279,129.978882 265.397949,129.978882 256.833832,129.978882 
C256.833832,140.211182 256.736786,150.297043 256.890869,160.379059 
C256.939301,163.549637 259.270172,164.485992 262.155426,164.215607 
C268.726471,163.599792 268.726227,163.597244 271.965759,170.080704 
C267.007446,175.009872 257.624573,176.858704 251.242020,174.054062 
C244.595108,171.133286 243.075073,165.383301 243.076401,158.850632 
C243.078308,149.375397 243.076904,139.900162 243.076904,130.578415 
C240.373322,129.719681 237.441940,129.535721 235.746078,127.993294 
C234.570541,126.924118 235.097275,123.983353 234.834518,121.618675 
C236.643585,121.266762 238.065247,121.003380 239.480911,120.710953 
C240.779709,120.442665 242.072037,120.143082 243.718018,119.779884 
C244.274307,116.858986 244.822998,113.786476 245.448639,110.729721 
C247.152267,102.406059 247.165161,102.408699 256.345093,103.185417 
C256.345093,108.517723 256.345093,113.914482 256.345093,119.855484 
C269.555420,119.855484 282.281982,119.855484 295.314453,119.855484 
C295.314453,138.160797 295.314453,155.925415 295.004456,174.002167 
z'
    />
    <path
      fill='#494949'
      opacity='1.000000'
      stroke='none'
      d='
M360.139893,95.017181 
C363.587433,95.016571 366.554169,95.016571 369.847626,95.016571 
C369.847626,104.956223 369.847626,114.556549 369.847626,123.674545 
C375.073578,122.034248 380.028046,119.550003 385.172455,119.059959 
C395.537872,118.072594 403.085297,123.698822 403.860931,134.068527 
C404.848541,147.271896 404.100159,160.605133 404.100159,174.237671 
C400.218536,174.237671 395.988495,174.237671 391.179962,174.237671 
C391.179962,167.262894 391.181122,160.489777 391.179535,153.716675 
C391.178467,149.218689 391.180237,144.720688 391.168335,140.222717 
C391.156281,135.679367 390.449036,131.503891 385.344574,129.822800 
C380.722046,128.300415 373.490204,130.444061 370.976440,134.393478 
C370.178253,135.647507 370.136139,137.522079 370.124908,139.115326 
C370.044922,150.442749 370.065308,161.770828 370.035553,173.098679 
C370.034729,173.407150 369.829193,173.715118 369.618317,174.305664 
C365.632233,174.305664 361.546631,174.305664 357.185913,174.305664 
C357.074890,173.060959 356.889709,171.947906 356.888947,170.834732 
C356.872284,147.012024 356.860016,123.189278 356.907501,99.366653 
C356.911285,97.476974 355.840240,94.617271 360.139893,95.017181 
z'
    />
    <path
      fill='#2A2A2A'
      opacity='1.000000'
      stroke='none'
      d='
M1191.994995,1708.989746 
C1183.498047,1708.989380 1175.498657,1708.904297 1167.502075,1709.024780 
C1163.540771,1709.084351 1161.671265,1707.490234 1161.678711,1703.439575 
C1161.723633,1679.111572 1161.726074,1654.783447 1161.667847,1630.455688 
C1161.658447,1626.520630 1163.160889,1624.685669 1167.286377,1624.729614 
C1179.282349,1624.857544 1191.282104,1624.880005 1203.276978,1624.709595 
C1206.789917,1624.659790 1208.055908,1625.994995 1208.037354,1629.344727 
C1208.019287,1632.584961 1207.008789,1634.156128 1203.375610,1634.082397 
C1193.411255,1633.879883 1183.440063,1634.012451 1173.197266,1634.012451 
C1173.197266,1642.869873 1173.197266,1651.422241 1173.197266,1660.376587 
C1181.690063,1660.376587 1189.983032,1660.505981 1198.268799,1660.317261 
C1201.956421,1660.233398 1203.281372,1661.595459 1203.284424,1665.252441 
C1203.287598,1669.000244 1201.410522,1669.620361 1198.261841,1669.573730 
C1189.973145,1669.450562 1181.681274,1669.532104 1173.157959,1669.532104 
C1173.157959,1679.699951 1173.157959,1689.464966 1173.157959,1699.696411 
C1183.094727,1699.696411 1192.876465,1699.768555 1202.656006,1699.656250 
C1205.959961,1699.618408 1208.540039,1699.723022 1208.571655,1704.148560 
C1208.604004,1708.688354 1206.163086,1709.279053 1202.488403,1709.036377 
C1199.170166,1708.817383 1195.826294,1708.989868 1191.994995,1708.989746 
z'
    />
    <path
      fill='#2A2A2A'
      opacity='1.000000'
      stroke='none'
      d='
M1124.608154,1709.930908 
C1116.563110,1710.453735 1109.207031,1709.623535 1102.287354,1706.190186 
C1096.589600,1703.363159 1095.578491,1700.642578 1098.096191,1693.470581 
C1100.020874,1694.319702 1101.958130,1695.053345 1103.784180,1696.001343 
C1110.273682,1699.370361 1116.998657,1701.415405 1124.420288,1700.161133 
C1131.150635,1699.023560 1135.320068,1695.323486 1136.545532,1689.302368 
C1137.709351,1683.583862 1135.392578,1678.566772 1129.445190,1675.202026 
C1123.522339,1671.850952 1117.258301,1669.102539 1111.338623,1665.746338 
C1100.449951,1659.572754 1096.233398,1648.755005 1100.128418,1637.763794 
C1103.223755,1629.029175 1111.972168,1623.448975 1123.775146,1623.650879 
C1128.646240,1623.734131 1133.660156,1624.960205 1138.302124,1626.558472 
C1144.318237,1628.630005 1145.272827,1632.058472 1142.406128,1638.854126 
C1139.292847,1637.456665 1136.289917,1635.644165 1133.034790,1634.769165 
C1129.250244,1633.752197 1125.216919,1632.971191 1121.342407,1633.155396 
C1116.695557,1633.376221 1112.643433,1635.554932 1111.034180,1640.471069 
C1109.371460,1645.550781 1110.377686,1650.194092 1114.574097,1653.539795 
C1117.531494,1655.897705 1120.976196,1657.683594 1124.324951,1659.500610 
C1128.119141,1661.559448 1132.137695,1663.210083 1135.903198,1665.316040 
C1145.774658,1670.837036 1149.624390,1678.728760 1148.083496,1689.813232 
C1146.797119,1699.068115 1139.455322,1706.628662 1129.452637,1708.979736 
C1127.996948,1709.321899 1126.526245,1709.599487 1124.608154,1709.930908 
z'
    />
    <path
      fill='#272727'
      opacity='1.000000'
      stroke='none'
      d='
M1156.317261,1834.158081 
C1151.441284,1834.500366 1150.019409,1832.165771 1150.029907,1828.084473 
C1150.091675,1804.091675 1150.104248,1780.098511 1150.022583,1756.105713 
C1150.007324,1751.618652 1151.868286,1749.863403 1156.348999,1749.932861 
C1167.343140,1750.103027 1178.341675,1749.986572 1189.338501,1749.987427 
C1196.882324,1749.988037 1197.531982,1750.884155 1195.416626,1759.113525 
C1184.326538,1759.113525 1173.078003,1759.113525 1161.538818,1759.113525 
C1161.538818,1768.092651 1161.538818,1776.521362 1161.538818,1785.800049 
C1166.341675,1785.800049 1171.256592,1785.800171 1176.171387,1785.800171 
C1178.504028,1785.800171 1180.873413,1785.539429 1183.160645,1785.861572 
C1186.531738,1786.336426 1191.928711,1783.377441 1191.840210,1790.436157 
C1191.756836,1797.082642 1186.656372,1794.646118 1183.375732,1794.775024 
C1176.231689,1795.055542 1169.069092,1794.861450 1161.576416,1794.861450 
C1161.576416,1804.847778 1161.576416,1814.578491 1161.576416,1824.953369 
C1171.671021,1824.953369 1181.768311,1825.076782 1191.859863,1824.886597 
C1195.418335,1824.819580 1197.103760,1825.834595 1197.050415,1829.599731 
C1197.002686,1832.967651 1195.764648,1834.270996 1192.269531,1834.221436 
C1180.442017,1834.053955 1168.610596,1834.158081 1156.317261,1834.158081 
z'
    />
    <path
      fill='#272727'
      opacity='1.000000'
      stroke='none'
      d='
M1020.487305,1824.963379 
C1024.676514,1825.940430 1024.227783,1829.087158 1023.407166,1831.350830 
C1022.924561,1832.682373 1020.338806,1834.002075 1018.674072,1834.034180 
C1006.846497,1834.262329 995.009888,1834.013794 983.181641,1834.225586 
C978.305664,1834.312866 976.828613,1832.265503 976.855042,1827.641968 
C976.990356,1803.978638 976.904846,1780.314331 976.927551,1756.650269 
C976.933228,1750.725464 977.661133,1750.011108 983.563354,1749.997681 
C995.228638,1749.971191 1006.896057,1750.112183 1018.558228,1749.918945 
C1022.213196,1749.858398 1023.125916,1751.409546 1023.174133,1754.659180 
C1023.225037,1758.090576 1021.944336,1759.334595 1018.449646,1759.270264 
C1008.493103,1759.086914 998.530945,1759.205933 988.306458,1759.205933 
C988.306458,1768.195557 988.306458,1776.756714 988.306458,1785.802368 
C996.786865,1785.802368 1005.078674,1785.974731 1013.357483,1785.722534 
C1016.984802,1785.612183 1018.550171,1786.754395 1018.565369,1790.410034 
C1018.581543,1794.307373 1016.513977,1794.994019 1013.129089,1794.918335 
C1004.979858,1794.736084 996.823730,1794.859253 988.354126,1794.859253 
C988.354126,1804.805420 988.354126,1814.552246 988.354126,1824.955933 
C998.852051,1824.955933 1009.445251,1824.955933 1020.487305,1824.963379 
z'
    />
    <path
      fill='#2A2A2A'
      opacity='1.000000'
      stroke='none'
      d='
M1267.358032,1707.465576 
C1253.106323,1711.628296 1239.957275,1711.166260 1228.743896,1700.721680 
C1222.800781,1695.186279 1219.833130,1687.949829 1218.591797,1680.075195 
C1216.227173,1665.075806 1217.043579,1650.548096 1226.116699,1637.561401 
C1236.316406,1622.962402 1260.473267,1619.163086 1274.858154,1629.660889 
C1279.413208,1632.985229 1278.152344,1636.911743 1277.320190,1641.931396 
C1274.905762,1640.685669 1273.134399,1639.933838 1271.529541,1638.918823 
C1252.864868,1627.111938 1234.463501,1634.485352 1230.609619,1656.156372 
C1229.192749,1664.123169 1229.559204,1672.852539 1231.168945,1680.818604 
C1234.436035,1696.985962 1249.720215,1704.339111 1265.040894,1698.034180 
C1269.142944,1696.345825 1273.012939,1694.093262 1276.989136,1692.099976 
C1279.872314,1698.081299 1278.912231,1701.641479 1273.594360,1704.625122 
C1271.723267,1705.674927 1269.682495,1706.422119 1267.358032,1707.465576 
z'
    />
    <path
      fill='#494949'
      opacity='1.000000'
      stroke='none'
      d='
M280.513428,252.398285 
C295.356995,245.370651 310.222290,249.547348 315.946442,262.099060 
C316.561310,263.447388 316.987640,264.895813 317.373840,266.332123 
C320.471741,277.853119 319.081421,279.686829 307.312225,279.686829 
C298.681610,279.686859 290.051025,279.686829 281.432892,279.686829 
C281.255402,292.373871 290.567505,298.779114 302.757416,294.780334 
C303.700684,294.470917 304.605530,294.035339 305.510437,293.619629 
C313.062256,290.150055 313.061005,290.147308 317.705963,297.592438 
C308.445526,306.477783 297.512146,308.531036 285.533936,304.943115 
C274.565857,301.657715 269.361145,293.315796 267.847839,282.434814 
C266.136505,270.129913 269.076416,259.644714 280.513428,252.398285 
M304.748871,265.079803 
C301.266693,259.387207 296.961853,257.672974 290.380798,259.358429 
C285.218994,260.680389 282.318970,264.640839 282.002747,270.906860 
C289.937347,270.906860 297.864471,270.906860 306.251923,270.906860 
C305.803406,268.990631 305.432159,267.404663 304.748871,265.079803 
z'
    />
    <path
      fill='#494949'
      opacity='1.000000'
      stroke='none'
      d='
M532.018066,249.770538 
C550.705566,246.557312 562.944031,256.410675 563.106018,274.041168 
C563.147400,278.536774 561.371033,279.813385 557.199707,279.743225 
C546.922241,279.570343 536.639893,279.686584 526.422852,279.686584 
C525.061707,289.948975 533.498474,299.221344 547.393372,294.798187 
C548.336609,294.497925 549.244629,294.075134 550.147705,293.662445 
C557.711792,290.205322 557.710266,290.201996 562.138733,297.215668 
C556.751709,305.570770 540.455566,308.937439 528.864929,304.671539 
C517.802917,300.600220 511.449188,289.067871 512.089661,274.632721 
C512.629517,262.464508 519.745239,253.454269 532.018066,249.770538 
M528.088440,271.140198 
C535.533142,271.140198 542.977844,271.140198 550.440247,271.140198 
C549.976990,263.805878 547.318237,260.084839 542.037415,259.038727 
C535.815308,257.806152 529.945557,260.480316 527.574707,265.982483 
C526.936707,267.463257 527.312744,269.381042 528.088440,271.140198 
z'
    />
    <path
      fill='#494949'
      opacity='1.000000'
      stroke='none'
      d='
M573.963196,276.000000 
C573.963196,267.188995 573.963196,258.877991 573.963196,250.624268 
C582.521362,248.598450 584.657715,249.419037 586.742432,255.734558 
C587.724243,255.104904 588.664124,254.584778 589.513367,253.944565 
C596.428894,248.731186 604.034668,247.250595 612.036316,250.667770 
C619.942749,254.044266 622.435669,261.207916 622.652893,269.031616 
C622.985291,281.007263 622.740173,292.998962 622.740173,305.424622 
C618.260376,305.424622 613.909424,305.424622 609.037842,305.424622 
C609.037842,298.267395 609.038025,291.153198 609.037842,284.039001 
C609.037781,279.874939 609.051575,275.710785 609.033142,271.546814 
C609.012451,266.877441 608.476440,262.068909 603.434021,260.336426 
C598.195557,258.536621 593.139160,260.113373 589.236450,264.065582 
C588.154785,265.160980 587.711853,267.295654 587.690308,268.962738 
C587.555115,279.454468 587.621521,289.948792 587.621277,300.442261 
C587.621216,302.067780 587.621277,303.693268 587.621277,305.590179 
C582.994507,305.590179 578.893677,305.590179 573.963196,305.590179 
C573.963196,295.976044 573.963196,286.238007 573.963196,276.000000 
z'
    />
    <path
      fill='#494949'
      opacity='1.000000'
      stroke='none'
      d='
M423.200195,409.962585 
C423.200195,399.865021 423.200195,390.261597 423.200195,380.405029 
C427.994659,380.405029 432.224792,380.405029 436.709442,380.405029 
C436.709442,399.009277 436.709442,417.382812 436.709442,435.724945 
C426.971100,436.918732 426.557343,436.743225 424.108490,430.839050 
C419.846527,432.806671 415.760773,435.605164 411.276917,436.588806 
C398.760803,439.334503 389.370758,431.613068 388.208160,418.313385 
C388.063538,416.659302 388.088623,414.987732 388.087128,413.324219 
C388.077423,402.519775 388.082153,391.715332 388.082153,380.527710 
C392.568512,380.527710 396.803375,380.527710 401.886841,380.527710 
C401.886841,382.108002 401.884399,383.848633 401.887207,385.589294 
C401.903809,395.907196 401.868317,406.225616 401.963562,416.542816 
C402.005280,421.058197 403.624512,424.753296 408.459564,425.949005 
C413.331482,427.153778 421.471558,424.540497 422.621979,420.804169 
C423.608704,417.599487 423.066345,413.924011 423.200195,409.962585 
z'
    />
    <path
      fill='#494949'
      opacity='1.000000'
      stroke='none'
      d='
M171.270538,428.549805 
C170.131027,425.061157 168.455307,421.912384 168.375870,418.723846 
C168.061371,406.100586 168.246658,393.464874 168.246658,380.489136 
C172.682480,380.489136 176.919708,380.489136 181.899017,380.489136 
C181.899017,383.361237 181.896240,386.286713 181.899536,389.212189 
C181.909668,398.205688 181.794006,407.201752 181.974442,416.191864 
C182.117432,423.314758 185.453751,426.419739 192.121887,426.167877 
C199.114441,425.903778 203.213837,422.065277 203.215546,415.768768 
C203.218704,404.136414 203.216461,392.504089 203.216461,380.508667 
C207.813553,380.508667 212.041565,380.508667 216.626801,380.508667 
C216.626801,398.821411 216.626801,417.198486 216.621323,435.576660 
C207.656754,437.165833 206.359329,436.643982 203.939560,429.953278 
C197.801819,435.554596 190.579468,438.733978 182.646225,436.451874 
C178.533539,435.268829 175.169891,431.481964 171.270538,428.549805 
z'
    />
    <path
      fill='#494949'
      opacity='1.000000'
      stroke='none'
      d='
M349.019562,379.927460 
C363.006561,377.878662 371.919708,382.274078 375.292816,392.736511 
C375.950226,394.775452 376.481995,396.959564 376.501923,399.082092 
C376.615753,411.204956 376.557190,423.329468 376.557190,435.414185 
C368.453033,437.296387 367.053894,436.672241 364.443085,429.756592 
C358.749878,434.532715 352.483521,437.496185 344.886719,437.034882 
C337.422668,436.581696 332.195251,432.873077 330.437714,426.257904 
C328.630463,419.455658 331.317596,413.020111 338.091339,409.569580 
C341.889099,407.635010 346.086578,406.292389 350.253418,405.330444 
C354.259949,404.405487 358.459137,404.315002 362.558197,403.859589 
C364.512024,393.187653 359.178223,388.135132 348.911926,390.938385 
C347.487488,391.327301 346.124115,392.003693 344.796936,392.674561 
C337.753021,396.234863 336.744354,395.903839 332.793579,388.340973 
C337.023315,383.686188 342.531189,381.330475 349.019562,379.927460 
M351.444977,427.498138 
C361.906799,426.026917 364.968048,421.953308 362.200592,412.370697 
C358.057861,413.090179 353.817902,413.681549 349.647980,414.593323 
C345.809296,415.432648 342.701233,417.342468 343.089478,421.930054 
C343.468658,426.410858 346.850067,427.321564 351.444977,427.498138 
z'
    />
    <path
      fill='#494949'
      opacity='1.000000'
      stroke='none'
      d='
M287.216400,419.498291 
C292.943970,426.905701 300.079193,428.309937 309.220917,424.141510 
C316.731201,420.716949 316.731232,420.717010 321.589111,428.059021 
C313.911072,436.061371 304.215424,438.084534 293.788452,436.620636 
C283.568085,435.185699 276.498169,429.135742 273.107666,419.312012 
C267.921631,404.285919 272.825897,389.044373 284.874573,382.662842 
C299.575745,374.876434 322.380920,380.381104 322.228943,404.903656 
C322.204926,408.777405 320.854218,410.148254 316.928253,410.066803 
C306.450317,409.849579 295.964966,409.992889 284.450958,409.992889 
C285.407318,413.364441 286.228271,416.258667 287.216400,419.498291 
M286.096588,397.795197 
C285.862030,399.062286 285.627502,400.329346 285.416229,401.470703 
C293.666443,401.470703 301.704254,401.470703 309.765717,401.470703 
C308.765503,392.292175 304.238556,388.538696 296.520386,389.453766 
C291.429688,390.057281 288.396240,392.750732 286.096588,397.795197 
z'
    />
    <path
      fill='#080808'
      opacity='1.000000'
      stroke='none'
      d='
M1321.517090,1245.039429 
C1322.768921,1235.455566 1327.645996,1230.174683 1336.822510,1229.015747 
C1341.044556,1228.482544 1345.477539,1228.529907 1349.678589,1229.186768 
C1355.374878,1230.077515 1359.977051,1233.153320 1361.885742,1238.938354 
C1363.932495,1245.142090 1362.438721,1250.790894 1357.975586,1255.460938 
C1355.733154,1257.807251 1353.008545,1259.692383 1350.304321,1261.951294 
C1353.004272,1263.829346 1355.743286,1265.601318 1358.336548,1267.565918 
C1363.875000,1271.761597 1366.211060,1277.377930 1364.829956,1284.201172 
C1363.456665,1290.985596 1359.262939,1295.981689 1352.500244,1297.038452 
C1345.758667,1298.091919 1338.656738,1298.316406 1331.908447,1297.424805 
C1325.494751,1296.577515 1320.823242,1292.225342 1319.453247,1285.414429 
C1318.125244,1278.812500 1320.085449,1273.244995 1325.394287,1269.032227 
C1328.076904,1266.903564 1330.934204,1264.995361 1334.068970,1262.729858 
C1327.263062,1258.658325 1321.698608,1253.906982 1321.517090,1245.039429 
M1355.172241,1277.634888 
C1352.862793,1271.835693 1347.509155,1269.638550 1342.520630,1267.055176 
C1341.916504,1266.742432 1340.748901,1266.796753 1340.214600,1267.188477 
C1336.901123,1269.617920 1333.022461,1271.674072 1330.590210,1274.825684 
C1325.354126,1281.610352 1329.160034,1289.959839 1337.642822,1291.049683 
C1340.562744,1291.424805 1343.607544,1291.433838 1346.528809,1291.072266 
C1353.652710,1290.190186 1356.688110,1285.660034 1355.172241,1277.634888 
M1353.726929,1244.682739 
C1353.503906,1243.713013 1353.380737,1242.706665 1353.041504,1241.779419 
C1351.043213,1236.315796 1342.955933,1233.773315 1336.332397,1236.491211 
C1331.499756,1238.474243 1328.547241,1244.430664 1331.549194,1248.779785 
C1334.206543,1252.629517 1338.610229,1257.128052 1342.650146,1257.563477 
C1345.706665,1257.892822 1349.507446,1252.378052 1352.744507,1249.225464 
C1353.553223,1248.437866 1353.465332,1246.729858 1353.726929,1244.682739 
z'
    />
    <path
      fill='#080808'
      opacity='1.000000'
      stroke='none'
      d='
M1461.761719,1266.152100 
C1468.535156,1271.136353 1471.801147,1277.260376 1469.574829,1285.374390 
C1467.290527,1293.699341 1461.012817,1297.534180 1452.992798,1298.139526 
C1447.462769,1298.557129 1441.724487,1298.226807 1436.276367,1297.192749 
C1429.926147,1295.987305 1425.727539,1291.712158 1424.473877,1285.138794 
C1423.247681,1278.708862 1425.187866,1273.280029 1430.302002,1269.160034 
C1432.992798,1266.992432 1435.892456,1265.083984 1438.920654,1262.897461 
C1436.523560,1261.005981 1433.952637,1259.320679 1431.793091,1257.213623 
C1422.774048,1248.414307 1425.677002,1234.476685 1437.462891,1230.111938 
C1443.720703,1227.794189 1450.210938,1227.644531 1456.585205,1229.625732 
C1468.118896,1233.210571 1471.613403,1246.149536 1463.424438,1255.072388 
C1461.114624,1257.589111 1458.224121,1259.573120 1455.276123,1262.076660 
C1457.352539,1263.368042 1459.411377,1264.648315 1461.761719,1266.152100 
M1453.295044,1270.075317 
C1450.917969,1268.984741 1448.580811,1267.107422 1446.154541,1266.984009 
C1442.315918,1266.788574 1434.849854,1274.291138 1433.925293,1278.325562 
C1431.732422,1287.896606 1438.868896,1292.987427 1451.640991,1291.174805 
C1455.849976,1290.577515 1458.770996,1288.625366 1460.280884,1284.680420 
C1461.809326,1280.687012 1460.738892,1277.121216 1458.055298,1274.040894 
C1456.873535,1272.684326 1455.300171,1271.669067 1453.295044,1270.075317 
M1440.804443,1236.861694 
C1436.274780,1239.835083 1434.766479,1243.483765 1436.129150,1248.172119 
C1437.144165,1251.664307 1444.844238,1258.271118 1447.805542,1258.143311 
C1448.276733,1258.123047 1448.844238,1257.961304 1449.184692,1257.659302 
C1451.870361,1255.275757 1455.147461,1253.254639 1457.037598,1250.340454 
C1461.284790,1243.792603 1457.643677,1236.774048 1449.838623,1235.958618 
C1447.106934,1235.673096 1444.286133,1236.242188 1440.804443,1236.861694 
z'
    />
    <path
      fill='#252525'
      opacity='1.000000'
      stroke='none'
      d='
M427.999451,1664.000000 
C427.999603,1652.674927 428.108734,1641.848389 427.947052,1631.025635 
C427.880890,1626.597290 429.491974,1624.664917 434.071045,1624.734863 
C445.226532,1624.905273 456.388306,1624.905884 467.543427,1624.723511 
C471.112457,1624.665161 472.232147,1626.066040 472.212280,1629.404785 
C472.193207,1632.611206 471.386536,1634.284424 467.678497,1634.198975 
C458.382446,1633.984619 449.078186,1634.128174 439.118134,1634.128174 
C439.118134,1639.038452 439.118134,1643.634521 439.118134,1648.230591 
C439.118134,1652.879639 439.118134,1657.528809 439.118134,1662.915161 
C448.079651,1662.915161 456.835449,1663.123901 465.573914,1662.825073 
C469.802216,1662.680542 470.765472,1664.597412 470.560333,1668.167847 
C470.398254,1670.989014 469.221558,1672.221802 466.177673,1672.161987 
C457.378357,1671.989258 448.573456,1672.100830 439.118103,1672.100830 
C439.118103,1682.661987 438.834229,1692.931396 439.239136,1703.173584 
C439.438477,1708.215942 437.590240,1709.484009 432.965057,1709.310669 
C429.118927,1709.166504 427.829468,1707.946777 427.905151,1703.967896 
C428.155365,1690.816040 427.999481,1677.656616 427.999451,1664.000000 
z'
    />
    <path
      fill='#080808'
      opacity='1.000000'
      stroke='none'
      d='
M1505.061035,1287.181152 
C1510.444946,1281.184570 1512.096680,1276.690796 1512.164185,1268.208740 
C1507.895996,1269.192871 1503.704590,1270.712158 1499.419556,1271.052368 
C1479.842896,1272.606934 1474.706421,1260.148315 1477.382324,1245.026123 
C1479.260986,1234.409668 1487.786011,1228.412842 1499.646973,1228.292847 
C1510.052612,1228.187622 1517.443970,1233.997681 1519.934937,1244.670166 
C1522.549683,1255.873291 1522.459839,1267.149536 1519.451538,1278.265747 
C1515.024170,1294.625488 1499.436279,1302.668091 1483.039673,1297.537964 
C1478.423218,1296.093750 1478.227295,1293.211548 1479.244385,1288.898560 
C1487.870605,1290.869141 1496.695557,1293.824097 1505.061035,1287.181152 
M1500.202637,1235.843262 
C1489.205444,1234.522339 1485.238647,1244.618408 1486.088257,1252.843750 
C1486.974609,1261.425781 1491.690552,1264.915161 1501.409302,1263.983032 
C1510.953491,1263.067627 1513.025513,1260.626831 1511.896973,1251.152466 
C1511.587524,1248.553711 1510.881836,1245.952271 1509.993164,1243.483398 
C1508.493774,1239.317871 1505.684326,1236.471313 1500.202637,1235.843262 
z'
    />
    <path
      fill='#282828'
      opacity='1.000000'
      stroke='none'
      d='
M861.773254,1624.780029 
C865.979187,1624.222046 867.791992,1625.622192 867.789978,1629.605347 
C867.787781,1633.863770 865.420898,1634.297974 861.970398,1634.193604 
C855.503235,1633.997803 849.025940,1634.137207 841.859375,1634.137207 
C841.859375,1636.170044 841.859375,1637.924683 841.859375,1639.679321 
C841.859375,1661.003418 841.728333,1682.328979 841.963257,1703.650513 
C842.014038,1708.253174 840.233643,1709.279419 836.140198,1709.331909 
C831.847656,1709.386841 830.443726,1707.972290 830.491211,1703.539062 
C830.717773,1682.384033 830.592102,1661.225098 830.591736,1640.067627 
C830.591675,1638.265259 830.591736,1636.462769 830.591736,1634.137207 
C823.350586,1634.137207 816.550598,1633.955688 809.766785,1634.209717 
C806.099976,1634.346924 804.682739,1633.130005 804.682922,1629.436768 
C804.683044,1625.694946 806.222595,1624.675293 809.824280,1624.708740 
C826.982056,1624.868042 844.142151,1624.780151 861.773254,1624.780029 
z'
    />
    <path
      fill='#272727'
      opacity='1.000000'
      stroke='none'
      d='
M1340.736938,1759.494629 
C1334.461426,1759.494507 1328.654053,1759.494507 1322.379761,1759.494507 
C1322.379761,1784.368530 1322.379761,1808.794800 1322.379761,1833.674927 
C1320.279053,1834.049561 1318.561646,1834.530273 1316.822388,1834.630371 
C1312.941040,1834.854004 1310.896484,1833.697876 1310.953979,1828.997437 
C1311.215454,1807.673096 1311.068237,1786.343506 1311.067993,1765.015869 
C1311.067993,1763.374512 1311.067993,1761.733032 1311.067993,1759.493530 
C1303.984863,1759.493530 1297.223511,1759.346680 1290.473145,1759.554077 
C1286.971680,1759.661621 1285.122559,1758.651855 1285.135864,1754.890869 
C1285.149292,1751.083130 1286.731567,1749.847534 1290.623413,1749.896606 
C1307.449707,1750.108276 1324.280029,1749.970215 1341.108887,1750.001709 
C1344.420166,1750.007812 1348.237061,1748.785034 1348.265869,1754.666382 
C1348.294189,1760.458740 1344.610474,1759.456177 1340.736938,1759.494629 
z'
    />
    <path
      fill='#494949'
      opacity='1.000000'
      stroke='none'
      d='
M379.217224,277.822113 
C369.489349,269.117584 372.483002,254.926086 384.897736,250.617462 
C394.988586,247.115372 404.448059,248.650848 412.769684,255.668625 
C409.042053,263.183746 409.115601,262.908966 401.887085,260.571381 
C398.547180,259.491302 394.701752,259.208710 391.223724,259.651215 
C389.535889,259.865906 387.161194,262.457306 386.944031,264.202545 
C386.739319,265.847626 388.545105,268.558533 390.196167,269.451691 
C393.804688,271.403809 397.890381,272.463287 401.755768,273.953339 
C410.062439,277.155426 413.761536,281.564728 413.717529,288.120453 
C413.663513,296.163300 408.965332,302.604126 400.769745,305.120605 
C390.399841,308.304718 380.831360,306.466095 372.153564,299.986877 
C375.683258,291.811432 376.316711,291.903625 384.391876,294.940948 
C388.027161,296.308319 392.454956,296.353485 396.367889,295.832428 
C398.061157,295.606964 400.152588,292.591187 400.563904,290.541962 
C400.840240,289.165161 398.841278,286.610382 397.232422,285.729706 
C394.073212,284.000336 390.429688,283.181671 387.075226,281.774689 
C384.488708,280.689880 382.037750,279.281952 379.217224,277.822113 
z'
    />
    <path
      fill='#494949'
      opacity='1.000000'
      stroke='none'
      d='
M254.451447,301.508667 
C243.271042,308.992004 228.517288,308.107147 219.136292,299.644592 
C222.516708,291.896484 223.303497,291.995148 230.849991,294.778503 
C234.767227,296.223297 239.481415,296.006165 243.766052,295.665497 
C245.128937,295.557159 247.123657,292.698700 247.262054,290.972992 
C247.393661,289.331818 245.891647,286.753662 244.381317,285.945648 
C240.616577,283.931549 236.436096,282.696289 232.427017,281.136810 
C223.722427,277.750916 219.844437,272.800293 220.202560,265.546875 
C220.591873,257.661896 225.638657,251.956177 234.467422,249.845261 
C243.738907,247.628479 252.191177,249.287003 259.510468,255.618256 
C256.201904,263.094147 256.169769,262.821594 248.372482,260.443573 
C244.918427,259.390167 240.901199,259.486786 237.278641,260.014923 
C235.766281,260.235413 233.836044,262.811157 233.551712,264.553558 
C233.330872,265.907013 235.019150,268.308228 236.470535,269.055176 
C240.271255,271.011139 244.404266,272.322906 248.409409,273.879700 
C261.958893,279.146301 264.584900,290.524048 254.451447,301.508667 
z'
    />
    <path
      fill='#494949'
      opacity='1.000000'
      stroke='none'
      d='
M336.477234,305.747986 
C332.194031,303.949829 328.310089,302.257965 324.454498,300.578461 
C327.976379,291.967407 328.992706,291.815002 336.443542,294.820526 
C339.814606,296.180389 343.907135,296.748352 347.472717,296.249298 
C349.555054,295.957794 352.332855,293.067505 352.756958,290.939667 
C353.084198,289.297699 350.639954,286.350159 348.704437,285.186340 
C345.778076,283.426697 342.201782,282.768524 338.937683,281.546143 
C329.027008,277.834564 325.398163,272.999908 326.043549,264.478485 
C326.619110,256.878876 332.481659,250.869324 341.637665,249.395309 
C350.310181,247.999161 358.457550,249.431259 365.146973,255.716217 
C361.612915,263.163452 361.639923,262.867645 354.267334,260.560852 
C350.799744,259.475861 346.795746,259.457245 343.149353,259.899536 
C341.615997,260.085510 339.453430,262.613556 339.274109,264.261597 
C339.103424,265.830536 340.767609,268.224030 342.298279,269.210449 
C344.754913,270.793610 347.761871,271.527588 350.545166,272.597260 
C352.248993,273.252075 354.006287,273.779388 355.675629,274.510071 
C361.281036,276.963593 365.794830,280.309662 366.006073,287.208557 
C366.238007,294.781921 363.101440,300.436432 356.373871,303.878174 
C350.181122,307.046326 343.570923,307.111816 336.477234,305.747986 
z'
    />
    <path
      fill='#494949'
      opacity='1.000000'
      stroke='none'
      d='
M201.370926,260.515381 
C197.427322,260.058228 193.768631,259.250214 190.306931,259.765503 
C188.647797,260.012482 186.497925,262.612579 186.179474,264.429077 
C185.924713,265.882172 187.720200,268.483063 189.276688,269.306946 
C192.907257,271.228638 196.945831,272.376740 200.812210,273.856323 
C209.764954,277.282257 213.174484,281.498077 212.931290,288.815430 
C212.665787,296.803955 207.824203,302.996582 199.462143,305.334015 
C189.239258,308.191620 179.841995,306.321716 171.356277,299.930573 
C175.233444,291.757568 175.778992,291.843414 183.377731,294.833405 
C186.880219,296.211548 191.124588,296.568512 194.871613,296.100403 
C196.776474,295.862366 199.341431,292.954041 199.711197,290.909729 
C200.004944,289.285736 197.828354,286.415527 196.016785,285.384827 
C192.751724,283.527191 188.916550,282.690582 185.359253,281.324036 
C175.674255,277.603638 172.387192,273.103027 172.975815,264.508759 
C173.491806,256.975006 178.891663,251.253113 187.957260,249.532913 
C196.817291,247.851730 205.078232,249.381256 211.991608,255.656235 
C208.692825,262.983307 208.084717,263.271667 201.370926,260.515381 
z'
    />
    <path
      fill='#494949'
      opacity='1.000000'
      stroke='none'
      d='
M650.055847,240.025085 
C650.055847,243.490097 650.055847,246.466141 650.055847,250.060455 
C655.000427,250.060455 659.712891,250.060455 664.653870,250.060455 
C664.653870,253.590042 664.653870,256.502869 664.653870,259.805084 
C659.946411,259.805084 655.347473,259.805084 650.317261,259.805084 
C650.317261,270.585663 650.182068,280.993622 650.404114,291.393951 
C650.466309,294.305847 653.043884,296.372620 655.633667,295.196167 
C662.385620,292.129028 663.854736,296.989197 665.958252,301.245209 
C660.574463,306.540985 651.050476,308.258942 644.334778,305.118134 
C639.885803,303.037476 637.197449,299.441223 636.961792,294.640686 
C636.529785,285.839783 636.558716,277.015930 636.416870,268.201294 
C636.376770,265.710327 636.410767,263.218170 636.410767,260.352753 
C634.998596,260.223236 633.727722,259.957733 632.473389,260.020447 
C629.124695,260.187897 628.265015,258.317810 628.051575,255.385681 
C627.836304,252.428329 628.846252,250.948303 631.871887,251.060089 
C636.274109,251.222717 638.146179,248.977356 638.161926,244.715912 
C638.166748,243.415451 638.724121,242.124573 638.953247,240.816147 
C640.479309,232.100571 640.501465,232.078583 650.055847,233.230560 
C650.055847,235.289337 650.055847,237.412720 650.055847,240.025085 
z'
    />
    <path
      fill='#494949'
      opacity='1.000000'
      stroke='none'
      d='
M341.628418,122.360054 
C343.135590,123.469673 344.313934,124.372261 345.445282,125.238846 
C342.376709,132.550690 342.056122,132.496048 334.879547,130.124893 
C331.828339,129.116776 328.290161,128.663223 325.160095,129.152542 
C323.232544,129.453857 320.752014,131.759186 320.225739,133.641663 
C319.839325,135.023804 321.812561,137.884399 323.457886,138.839752 
C326.566803,140.644928 330.193237,141.562134 333.610596,142.832123 
C343.327057,146.442978 346.793610,150.701630 346.239960,158.366867 
C345.627411,166.847839 340.344940,172.595718 331.270172,174.655670 
C322.508789,176.644501 312.696594,174.338333 305.993683,168.714890 
C308.544678,161.113861 309.860291,160.937180 317.400818,163.741226 
C321.180389,165.146729 325.749115,165.067230 329.852081,164.632248 
C331.358246,164.472565 333.266022,161.487244 333.635376,159.534500 
C333.883240,158.224289 332.091156,155.791397 330.611542,155.035049 
C326.800262,153.086823 322.648529,151.808548 318.645020,150.231583 
C309.677246,146.699249 306.085266,141.427292 307.103668,133.336929 
C308.027252,125.999695 314.549713,120.019920 322.936951,119.079140 
C329.315033,118.363724 335.561462,118.846664 341.628418,122.360054 
z'
    />
    <path
      fill='#080808'
      opacity='1.000000'
      stroke='none'
      d='
M1411.636108,1297.908081 
C1400.670532,1297.908203 1390.169556,1298.017578 1379.674561,1297.813354 
C1377.642578,1297.773804 1374.006958,1296.662598 1373.923828,1295.780640 
C1373.685791,1293.254272 1374.183228,1290.048584 1375.678711,1288.095703 
C1378.797363,1284.023682 1382.912231,1280.732910 1386.308960,1276.851074 
C1390.900513,1271.603882 1395.313721,1266.188843 1399.562866,1260.660889 
C1400.939209,1258.870361 1401.774292,1256.567871 1402.481934,1254.378418 
C1404.194214,1249.081665 1404.579712,1243.721191 1400.178955,1239.508301 
C1395.765015,1235.282959 1390.350708,1236.053955 1385.166748,1237.834595 
C1381.931274,1238.945923 1378.903809,1240.662476 1375.757568,1242.119263 
C1373.700073,1235.982178 1374.054199,1234.050903 1379.404297,1232.034302 
C1384.277588,1230.197510 1389.648926,1228.428589 1394.726807,1228.617188 
C1411.344238,1229.234741 1418.510620,1245.055786 1409.440186,1260.451904 
C1407.089844,1264.441406 1404.299316,1268.236206 1401.285278,1271.755859 
C1396.124634,1277.782349 1390.628052,1283.521118 1384.675781,1290.033325 
C1394.105713,1290.033325 1402.841187,1290.060303 1411.576294,1290.015381 
C1413.913818,1290.003296 1415.953247,1290.078735 1416.084229,1293.208130 
C1416.204834,1296.087280 1415.716309,1298.273926 1411.636108,1297.908081 
z'
    />
    <path
      fill='#494949'
      opacity='1.000000'
      stroke='none'
      d='
M183.195007,136.431778 
C182.278412,139.236740 181.059387,141.706726 180.993240,144.207214 
C180.738251,153.846329 180.855118,163.495193 180.812073,173.140335 
C180.810776,173.433273 180.574326,173.725159 180.336197,174.274139 
C176.213211,174.274139 171.989532,174.274139 167.523712,174.274139 
C167.523712,156.058701 167.523712,138.156967 167.523712,120.274437 
C176.554703,117.750580 178.455048,118.874062 180.235825,128.226517 
C181.263550,127.086296 181.961273,126.066017 182.886459,125.332787 
C185.463623,123.290367 187.892502,120.375809 190.832901,119.655968 
C194.251236,118.819130 198.150528,119.946869 201.841095,120.221970 
C201.482910,123.624237 201.428391,127.107178 200.560501,130.374039 
C200.333618,131.228104 197.533615,131.933960 195.991379,131.804184 
C191.086105,131.391510 186.698380,131.990005 183.195007,136.431778 
z'
    />
    <path
      fill='#494949'
      opacity='1.000000'
      stroke='none'
      d='
M252.043442,393.394867 
C246.666000,396.278107 244.279480,400.254242 244.444916,406.137634 
C244.720413,415.935547 244.520004,425.746887 244.520004,435.852448 
C239.885513,435.852448 235.660217,435.852448 231.172668,435.852448 
C231.172668,417.368744 231.172668,398.979980 231.172668,380.627167 
C241.132935,379.302216 241.132935,379.302216 243.639908,387.505707 
C248.299316,384.868561 252.938416,381.579865 258.086456,379.646149 
C260.232544,378.839996 265.659943,380.651215 265.791748,381.734924 
C266.206329,385.143707 264.928680,388.802368 263.991272,392.279358 
C263.865204,392.747009 261.939484,392.849762 260.835602,392.909943 
C258.025970,393.063141 255.209763,393.096436 252.043442,393.394867 
z'
    />
    <path
      fill='#2B2B2B'
      opacity='1.000000'
      stroke='none'
      d='
M1442.495850,1680.999756 
C1442.496216,1663.529541 1442.660156,1646.556763 1442.388428,1629.590820 
C1442.315308,1625.024658 1444.513428,1624.231812 1448.087402,1624.237183 
C1451.574341,1624.242310 1453.958496,1624.825073 1453.920776,1629.455322 
C1453.717285,1654.409912 1453.708008,1679.368042 1453.925903,1704.322388 
C1453.968384,1709.180176 1451.368164,1709.275024 1447.962402,1709.269165 
C1444.674683,1709.263550 1442.196899,1708.978027 1442.401367,1704.455200 
C1442.746460,1696.817627 1442.495972,1689.152954 1442.495850,1680.999756 
z'
    />
    <path
      fill='#2A2A2A'
      opacity='1.000000'
      stroke='none'
      d='
M320.838196,1709.211548 
C315.390015,1709.903931 313.923767,1707.811157 313.978241,1702.759399 
C314.240234,1678.464233 314.228149,1654.163330 313.982605,1629.867798 
C313.934326,1625.092041 316.160126,1624.258789 319.942139,1624.229492 
C323.668610,1624.200684 325.487671,1625.294312 325.447784,1629.695435 
C325.223114,1654.490601 325.310211,1679.288940 325.378357,1704.085938 
C325.386627,1707.093994 325.160339,1709.496338 320.838196,1709.211548 
z'
    />
    <path
      fill='#252525'
      opacity='1.000000'
      stroke='none'
      d='
M876.958740,1660.000000 
C876.959106,1649.358154 877.172729,1639.209961 876.863281,1629.077515 
C876.724121,1624.520386 879.404236,1624.287842 882.496887,1624.284302 
C885.554077,1624.280762 888.200195,1624.402222 888.164062,1628.994873 
C887.965149,1654.264648 887.968079,1679.537720 888.157654,1704.807739 
C888.193909,1709.640137 885.277100,1709.183838 882.307495,1709.210327 
C879.398010,1709.236328 876.802734,1709.324951 876.871765,1704.889893 
C877.102112,1690.096313 876.958862,1675.297119 876.958740,1660.000000 
z'
    />
    <path
      fill='#494949'
      opacity='1.000000'
      stroke='none'
      d='
M225.180847,159.994507 
C225.180862,164.971222 225.180862,169.449036 225.180862,174.256454 
C220.783035,174.256454 216.713135,174.256454 212.297058,174.256454 
C212.297058,156.186752 212.297058,138.138916 212.297058,119.766281 
C216.303253,119.766281 220.378433,119.766281 225.180832,119.766281 
C225.180832,133.033279 225.180832,146.264450 225.180847,159.994507 
z'
    />
    <path
      fill='#494949'
      opacity='1.000000'
      stroke='none'
      d='
M224.571625,109.553261 
C221.062912,112.265907 217.278519,113.269928 214.250916,110.439987 
C212.223785,108.545204 210.198685,104.905922 210.669525,102.545235 
C211.195663,99.907272 214.216171,96.520050 216.757675,95.884521 
C219.255981,95.259789 223.212433,96.949532 225.277679,98.929131 
C228.420105,101.941284 227.569061,105.915787 224.571625,109.553261 
z'
    />
    <path
      fill='#494949'
      opacity='1.000000'
      stroke='none'
      d='
M283.909943,110.281982 
C279.894104,105.673279 279.386993,102.036003 282.303192,98.503761 
C285.049683,95.177124 288.583923,94.188713 292.552734,96.184006 
C296.477325,98.157043 297.760345,101.480232 296.991333,105.744598 
C296.233246,109.948524 289.483063,114.445297 283.909943,110.281982 
z'
    />
    <path
      fill='#FEFEFE'
      opacity='1.000000'
      stroke='none'
      d='
M1819.994141,665.017883 
C1820.054688,673.046631 1820.115234,681.075317 1819.625854,689.520630 
C1808.843018,689.937134 1798.610107,689.937134 1788.322632,689.937134 
C1788.322632,693.928467 1788.322632,697.463623 1788.322632,701.151733 
C1799.084106,701.151733 1809.523560,701.151733 1819.987793,701.393372 
C1820.012695,701.635010 1820.359253,701.975586 1820.359253,701.975586 
C1820.300293,709.688721 1820.241333,717.401917 1819.630493,725.534485 
C1808.841675,725.953918 1798.604736,725.953918 1788.326538,725.953918 
C1788.326538,729.954163 1788.326538,733.491638 1788.326538,737.047485 
C1799.096680,737.047485 1809.540405,737.047485 1819.984131,737.047485 
C1820.075073,744.391968 1820.166016,751.736389 1820.202637,759.854797 
C1820.095825,761.072144 1820.043457,761.515625 1819.522949,761.958130 
C1798.013428,761.957214 1776.972046,761.957214 1756.017334,761.957214 
C1756.017334,766.003113 1756.017334,769.421143 1756.017334,773.073853 
C1777.516602,773.073853 1798.745972,773.073853 1819.975220,773.073853 
C1820.062378,774.734375 1820.225830,776.394958 1820.226074,778.055481 
C1820.238159,901.033752 1820.237305,1024.011963 1820.237427,1146.990234 
C1820.237427,1148.471558 1820.237305,1149.952759 1820.237305,1151.727295 
C1554.478027,1151.727295 1288.952637,1151.727295 1022.889587,1151.727295 
C1022.889587,1028.103271 1022.889587,904.521423 1022.929871,780.063232 
C1023.007751,777.221436 1023.045410,775.255859 1023.545044,773.254883 
C1044.207153,773.219421 1064.407227,773.219421 1084.580200,773.219421 
C1084.580200,769.072021 1084.580200,765.668640 1084.580200,761.948303 
C1063.865234,761.948303 1043.441528,761.948303 1023.017761,761.948303 
C1023.004700,754.004639 1022.991638,746.060913 1023.039734,737.640808 
C1023.100830,737.164368 1023.111023,737.224426 1023.571045,737.205811 
C1034.263672,737.187256 1044.496216,737.187256 1054.742188,737.187256 
C1054.742188,733.142395 1054.742188,729.620850 1054.742188,725.865051 
C1043.945923,725.865051 1033.503418,725.865051 1023.055847,725.895813 
C1023.050720,725.926575 1023.097534,725.885071 1023.097534,725.885071 
C1023.055908,717.944214 1023.014221,710.003418 1023.477417,701.613464 
C1034.225220,701.164368 1044.468262,701.164368 1054.748779,701.164368 
C1054.748779,697.143555 1054.748779,693.619080 1054.748779,689.942261 
C1043.951050,689.942261 1033.501221,689.942261 1023.051392,689.942261 
C1023.023376,681.977234 1022.995422,674.012146 1023.472046,665.594177 
C1034.219849,665.141235 1044.463013,665.141235 1054.751221,665.141235 
C1054.751221,661.129578 1054.751221,657.604675 1054.751221,653.931274 
C1043.958008,653.931274 1033.509766,653.931274 1023.061401,653.931274 
C1023.029663,645.978149 1022.997925,638.024963 1023.020630,629.592773 
C1023.075073,629.113770 1023.086121,629.181396 1023.547852,629.154236 
C1034.245239,629.127075 1044.480835,629.127075 1054.749756,629.127075 
C1054.749756,625.105774 1054.749756,621.583130 1054.749756,617.825989 
C1043.962891,617.825989 1033.522339,617.825989 1023.076294,617.858643 
C1023.070923,617.891296 1023.115295,617.841064 1023.115295,617.841064 
C1023.040344,610.540527 1022.965393,603.240051 1022.937866,595.184631 
C1023.008057,594.019043 1023.030762,593.608276 1023.516968,593.155640 
C1045.081177,593.113708 1066.181763,593.113708 1087.192505,593.113708 
C1087.192505,589.070984 1087.192505,585.648010 1087.192505,581.880005 
C1065.620483,581.880005 1044.331543,581.880005 1023.042664,581.880005 
C1023.011719,573.922363 1022.980835,565.964722 1023.456116,557.545593 
C1034.211426,557.084106 1044.460449,557.084106 1054.752441,557.084106 
C1054.752441,553.079163 1054.752441,549.550354 1054.752441,545.865967 
C1043.954712,545.865967 1033.501221,545.865967 1023.047729,545.865967 
C1023.013428,537.909485 1022.979126,529.953064 1023.451721,521.532837 
C1034.209106,521.069092 1044.459595,521.069092 1054.754761,521.069092 
C1054.754761,517.065430 1054.754761,513.535339 1054.754761,509.852112 
C1043.959961,509.852112 1033.506470,509.852112 1023.053040,509.852112 
C1022.998535,503.547729 1022.944092,497.243347 1022.930115,490.080200 
C1022.992920,487.865021 1023.015137,486.508606 1023.501648,485.106934 
C1034.209961,485.061646 1044.453979,485.061646 1054.768066,485.061646 
C1054.768066,481.064148 1054.768066,477.534698 1054.768066,473.766693 
C1043.998779,473.766693 1033.557373,473.766693 1023.110718,473.792664 
C1023.105530,473.818634 1023.139954,473.768585 1023.139954,473.768585 
C1023.056519,468.491241 1022.973083,463.213928 1022.929993,457.045013 
C1022.992065,453.815033 1023.013794,451.476654 1023.499878,449.093018 
C1034.215698,449.047791 1044.467041,449.047791 1054.761719,449.047791 
C1054.761719,445.030457 1054.761719,441.495758 1054.761719,437.811859 
C1043.974121,437.811859 1033.521118,437.811859 1023.068115,437.811859 
C1023.023560,429.875549 1022.979065,421.939240 1022.988464,413.529236 
C1023.042419,413.055573 1023.048584,413.110107 1023.512512,413.071838 
C1045.066528,413.033569 1066.156616,413.033569 1087.218506,413.033569 
C1087.218506,409.054413 1087.218506,405.628418 1087.218506,402.168030 
C1086.520874,401.999420 1086.055664,401.789185 1085.590332,401.788635 
C1066.288208,401.765747 1046.985962,401.745300 1027.683960,401.801239 
C1026.661865,401.804199 1025.641602,402.473633 1024.617920,402.495361 
C1024.026489,401.784149 1023.437866,401.410431 1022.849182,401.036682 
C1022.867432,309.391266 1022.885742,217.745819 1022.903931,126.100395 
C1022.904297,124.144173 1022.903992,122.187943 1022.903992,120.017715 
C1288.726196,120.017715 1554.105347,120.017715 1820.248657,120.017715 
C1820.248657,213.360092 1820.248657,306.748413 1819.840942,400.831360 
C1799.080688,401.525970 1778.728271,401.525970 1758.428711,401.525970 
C1758.428711,405.868134 1758.428711,409.292511 1758.428711,413.015259 
C1779.126709,413.015259 1799.541382,413.015259 1819.955933,413.015259 
C1820.012451,421.011414 1820.068970,429.007599 1819.586426,437.398956 
C1808.816650,437.794159 1798.586182,437.794159 1788.339844,437.794159 
C1788.339844,441.827881 1788.339844,445.360779 1788.339844,448.942444 
C1799.125488,448.942444 1809.571533,448.942444 1820.017578,448.942444 
C1820.055542,456.968170 1820.093384,464.993927 1819.591309,473.420471 
C1808.823608,473.821259 1798.595703,473.821259 1788.334595,473.821259 
C1788.334595,477.835815 1788.334595,481.366364 1788.334595,485.049011 
C1799.108887,485.049011 1809.549072,485.049011 1820.027710,485.378235 
C1820.177002,486.130951 1820.288086,486.554382 1820.399170,486.977814 
C1820.311279,494.332947 1820.223389,501.688080 1819.589844,509.444153 
C1808.815552,509.845123 1798.586792,509.845123 1788.341431,509.845123 
C1788.341431,513.869690 1788.341431,517.400391 1788.341431,520.963379 
C1799.125610,520.963379 1809.568604,520.963379 1820.011475,520.963379 
C1820.093506,527.336121 1820.175781,533.708862 1820.209473,540.934692 
C1820.096069,543.145630 1820.031250,544.503479 1819.499878,545.856201 
C1808.807007,545.851135 1798.580688,545.851135 1788.342529,545.851135 
C1788.342529,549.889587 1788.342529,553.420166 1788.342529,556.973999 
C1799.126099,556.973999 1809.567017,556.973999 1820.008057,556.973999 
C1820.055908,565.005005 1820.103760,573.036072 1819.607422,581.474609 
C1798.025391,581.882202 1776.987671,581.882202 1756.020752,581.882202 
C1756.020752,585.936646 1756.020752,589.348206 1756.020752,592.988037 
C1777.530151,592.988037 1798.766846,592.988037 1820.003662,592.988037 
C1820.056152,601.018616 1820.108643,609.049194 1819.615356,617.490479 
C1808.835571,617.901245 1798.601440,617.901245 1788.334473,617.901245 
C1788.334473,621.908264 1788.334473,625.441528 1788.334473,629.003967 
C1799.112061,629.003967 1809.555420,629.003967 1819.998779,629.003967 
C1820.055176,637.032104 1820.111694,645.060303 1819.623047,653.503296 
C1808.841797,653.918152 1798.605591,653.918152 1788.331055,653.918152 
C1788.331055,657.922607 1788.331055,661.457397 1788.331055,665.017883 
C1799.105957,665.017883 1809.550049,665.017883 1819.994141,665.017883 
M1241.886841,484.366547 
C1237.878784,492.384491 1233.387451,500.200928 1229.947388,508.455566 
C1215.885620,542.196594 1211.219727,577.263550 1215.858521,613.569336 
C1221.878418,660.684448 1242.060547,700.960449 1275.564209,734.257446 
C1306.225342,764.729614 1343.104492,784.043396 1385.933105,791.304749 
C1433.546265,799.377319 1478.847168,792.215515 1521.165771,768.943726 
C1561.013062,747.030823 1590.669922,715.224426 1609.942261,673.894531 
C1627.471558,636.302979 1632.929932,596.864990 1626.590820,556.060181 
C1619.011353,507.270996 1596.489868,466.195587 1559.611816,433.323517 
C1523.582642,401.208221 1481.321655,383.615662 1433.048584,380.896118 
C1393.341675,378.659149 1355.949463,387.106812 1321.207520,406.421570 
C1287.887817,424.945587 1261.503174,450.753967 1241.886841,484.366547 
M1315.046631,293.230347 
C1311.391968,296.817047 1307.737427,300.403748 1303.542480,304.520660 
C1312.693726,327.442566 1322.321655,351.558929 1331.936157,375.641296 
C1392.027954,351.655853 1451.495239,351.710327 1511.262695,375.638306 
C1520.980469,351.254974 1530.586670,327.151581 1540.182617,303.073975 
C1537.607422,301.729126 1535.472412,300.792419 1533.522949,299.561707 
C1528.381836,296.316101 1526.567749,291.854950 1528.051025,285.920654 
C1528.609375,283.685974 1529.616455,281.559601 1530.464600,279.401703 
C1541.035522,252.504242 1528.403198,225.763962 1501.070435,217.493454 
C1490.045776,214.157516 1479.337524,215.980530 1468.912109,220.293381 
C1458.773071,224.487625 1448.316650,227.369858 1438.479858,228.343750 
C1435.380981,223.760101 1432.832397,219.990356 1430.241211,216.157639 
C1436.929321,212.476364 1440.985229,206.630920 1441.152588,198.344025 
C1441.284180,191.833603 1437.810669,187.036911 1433.770142,182.476776 
C1429.350586,177.488632 1425.955322,172.024918 1425.367310,163.702362 
C1431.201294,166.129532 1436.114014,168.173431 1440.819580,170.131104 
C1440.819580,164.010681 1440.819580,157.680206 1440.819580,151.786819 
C1435.712280,153.812943 1430.783569,155.768234 1425.854736,157.723526 
C1425.483398,157.248291 1425.112061,156.773056 1424.740723,156.297821 
C1426.792236,151.366882 1428.843628,146.435944 1430.922119,141.440063 
C1424.612549,141.440063 1418.407104,141.440063 1412.252808,141.440063 
C1414.381104,146.546646 1416.429321,151.460999 1418.477539,156.375336 
C1418.055664,156.856674 1417.633789,157.338013 1417.212036,157.819351 
C1412.167358,155.749435 1407.122803,153.679520 1402.244263,151.677719 
C1402.244263,157.811905 1402.244263,164.169724 1402.244263,170.074646 
C1407.336060,168.060837 1412.322876,166.088531 1418.115112,163.797668 
C1416.282837,173.487762 1415.541870,174.870499 1407.388672,184.894104 
C1401.074219,192.657104 1400.155762,201.082687 1405.030640,208.882294 
C1407.034912,212.088821 1409.479736,215.019928 1411.658691,217.987213 
C1410.152832,220.265747 1407.553223,224.199188 1404.142456,229.359879 
C1394.013306,226.240356 1382.939575,223.353439 1372.248047,219.426407 
C1351.113403,211.663712 1330.491699,216.839996 1317.482056,234.613495 
C1306.929565,249.030075 1306.604980,264.731293 1313.242432,281.037140 
C1314.664062,284.529541 1314.562866,288.641754 1315.046631,293.230347 
M1383.518799,829.694702 
C1382.352295,829.694702 1381.155884,829.865051 1380.024292,829.666443 
C1373.745972,828.564880 1369.737183,831.174377 1365.935547,836.264832 
C1356.373291,849.069336 1346.046143,861.299500 1336.222900,873.913635 
C1332.832764,878.266846 1328.377808,877.047485 1324.346558,876.433533 
C1323.386963,876.287354 1322.558594,871.990967 1322.526611,869.592102 
C1322.351440,856.456238 1322.443115,843.316833 1322.443115,830.037720 
C1312.614990,830.037720 1303.227173,830.037720 1293.804321,830.037720 
C1293.804321,867.591309 1293.804321,904.812256 1293.804321,942.171875 
C1303.413940,942.171875 1312.673950,942.171875 1322.444336,942.171875 
C1322.444336,940.322327 1322.444458,938.703918 1322.444336,937.085510 
C1322.444092,924.421143 1322.368164,911.755859 1322.534668,899.093689 
C1322.556641,897.422546 1323.389038,894.809875 1324.579956,894.278748 
C1328.712891,892.435730 1334.246948,894.446655 1337.283691,898.198303 
C1346.400513,909.461609 1356.112549,920.305908 1364.433960,932.128906 
C1370.260376,940.407227 1376.856812,943.697083 1386.816406,942.624817 
C1394.794556,941.765930 1402.938721,942.451233 1412.043335,942.451233 
C1409.631592,939.666138 1408.026123,937.787292 1406.394287,935.931458 
C1392.862061,920.542236 1379.314697,905.166199 1365.795166,889.765869 
C1361.486816,884.858215 1361.461914,883.611877 1365.445068,878.703430 
C1370.902710,871.977905 1376.397705,865.282593 1381.867310,858.566650 
C1389.493408,849.202820 1397.110840,839.831909 1405.357666,829.694641 
C1397.727173,829.694641 1391.120117,829.694641 1383.518799,829.694702 
M1526.243896,916.731628 
C1530.251465,916.082947 1532.257080,917.912170 1533.475586,921.714966 
C1535.399170,927.718567 1537.759155,933.588928 1540.125000,939.438660 
C1540.596680,940.605042 1541.905396,942.255310 1542.859863,942.276794 
C1552.292480,942.489258 1561.731567,942.405273 1571.572632,942.405273 
C1571.245361,941.154114 1571.157715,940.525452 1570.921631,939.958557 
C1556.036987,904.233276 1541.174805,868.498474 1526.119019,832.845337 
C1525.513916,831.412537 1523.084961,829.915588 1521.472046,829.877441 
C1510.481567,829.617798 1499.477051,829.926086 1488.488037,829.637939 
C1484.798340,829.541199 1483.335815,830.937500 1482.024536,834.139771 
C1471.700684,859.349731 1461.192017,884.484009 1450.732544,909.638428 
C1446.293457,920.313965 1441.835571,930.981689 1437.074097,942.401611 
C1446.935669,942.401611 1456.045044,942.489319 1465.147095,942.271057 
C1466.094604,942.248291 1467.379272,940.566772 1467.858887,939.390381 
C1470.304688,933.393860 1472.738525,927.376648 1474.765015,921.231079 
C1475.901489,917.784668 1477.761719,916.630371 1481.310669,916.667786 
C1495.971069,916.822693 1510.634277,916.730957 1526.243896,916.731628 
M1635.844849,861.317200 
C1636.289429,854.440979 1639.530151,850.888489 1647.885254,850.144775 
C1655.969849,849.425232 1664.204712,849.179688 1672.278564,849.857788 
C1682.781006,850.739807 1693.189575,852.739014 1703.677979,854.263184 
C1703.677979,847.528137 1703.677979,840.921753 1703.677979,834.235168 
C1688.477295,829.733459 1673.099731,828.343201 1657.582520,828.472595 
C1646.402954,828.565918 1635.293091,829.632385 1624.833496,834.100464 
C1613.741577,838.838623 1607.400635,847.076782 1606.621094,859.284180 
C1605.872437,871.008240 1608.523438,881.761475 1619.628418,887.363647 
C1627.645142,891.407837 1636.672363,893.674316 1645.459839,895.901978 
C1654.462891,898.184448 1663.823730,899.049377 1672.836670,901.300659 
C1679.640137,903.000122 1682.811401,909.044983 1679.629272,914.693604 
C1677.846924,917.857483 1673.706665,920.577637 1670.089966,921.609253 
C1665.086426,923.036438 1659.507812,923.428833 1654.294189,922.955750 
C1638.275024,921.502319 1622.312378,919.425598 1606.068237,917.561340 
C1606.068237,922.488892 1606.256470,928.465698 1605.989014,934.422058 
C1605.854858,937.411316 1606.971680,938.637939 1609.721313,939.033813 
C1619.919556,940.501892 1630.065186,942.561951 1640.312622,943.410034 
C1657.299438,944.815796 1674.262939,944.634216 1690.446655,938.008118 
C1701.494263,933.484985 1708.630371,925.536377 1709.779297,913.512878 
C1710.894165,901.845032 1709.558838,890.294983 1698.205200,883.667786 
C1692.164917,880.141968 1685.180176,877.814087 1678.326538,876.196899 
C1667.182129,873.567200 1655.774902,872.070068 1644.521729,869.873779 
C1640.289673,869.047791 1636.580688,867.161560 1635.844849,861.317200 
M1216.307983,939.930481 
C1233.626343,933.432495 1241.200928,919.843262 1241.843872,902.433289 
C1242.697632,879.314636 1242.437256,856.154724 1242.633789,833.012329 
C1242.641968,832.050171 1242.429077,831.086121 1242.298218,829.939209 
C1233.199707,829.939209 1224.292114,829.939209 1214.971313,829.939209 
C1214.971313,831.793091 1214.971313,833.421814 1214.971313,835.050598 
C1214.971191,854.203613 1215.040161,873.357117 1214.919800,892.509399 
C1214.891724,896.982605 1214.551758,901.511047 1213.764282,905.908203 
C1212.739624,911.630615 1210.232666,916.897339 1204.909790,919.756165 
C1194.733765,925.221313 1183.957886,925.340820 1173.642944,920.630249 
C1164.431030,916.423462 1162.741455,907.455566 1162.120239,898.363953 
C1161.972778,896.207092 1162.004272,894.036011 1162.003296,891.871460 
C1161.995239,872.885010 1161.998657,853.898499 1161.998657,834.912048 
C1161.998657,833.290649 1161.998657,831.669250 1161.998657,829.971680 
C1152.120605,829.971680 1142.733276,829.971680 1132.998657,829.971680 
C1132.998657,835.034241 1132.945068,839.836243 1133.007812,844.636841 
C1133.271240,864.778259 1133.073120,884.942139 1134.003906,905.053345 
C1134.827637,922.854004 1145.014893,935.835144 1161.357056,940.485718 
C1179.334351,945.601624 1197.512329,945.416992 1216.307983,939.930481 
M1162.977783,993.751465 
C1163.983765,1007.808411 1164.989746,1021.865356 1165.988159,1035.816406 
C1169.276001,1035.816406 1172.008057,1035.816406 1174.953979,1035.816406 
C1173.238037,1014.261902 1171.550171,993.060730 1169.826904,971.415283 
C1167.747192,971.415283 1165.905396,971.643921 1164.141357,971.370972 
C1159.435547,970.642822 1157.180908,972.550354 1155.505981,977.071716 
C1151.643066,987.499817 1147.079956,997.669250 1142.769165,1007.930359 
C1141.524536,1010.892822 1140.172485,1013.810181 1138.630249,1017.288269 
C1132.642456,1002.724487 1127.003662,988.879211 1121.205200,975.101135 
C1120.603516,973.671265 1119.186401,971.789917 1117.917114,971.591492 
C1114.702759,971.088806 1111.357422,971.424622 1107.579468,971.424622 
C1105.875732,993.177429 1104.206909,1014.483765 1102.523438,1035.976807 
C1105.759155,1035.976807 1108.380127,1035.976807 1111.438477,1035.976807 
C1112.762939,1018.802734 1114.077271,1001.760620 1115.391602,984.718567 
C1122.102905,997.779419 1127.696533,1010.896057 1133.186279,1024.056030 
C1134.219482,1026.532715 1135.204346,1028.110474 1138.476685,1028.081543 
C1141.818359,1028.051758 1142.994751,1026.633179 1144.129883,1023.882935 
C1149.009521,1012.059692 1154.102173,1000.324219 1159.138916,988.566101 
C1159.852295,986.901184 1160.684570,985.287170 1162.040771,982.429932 
C1162.426270,986.879028 1162.684326,989.857239 1162.977783,993.751465 
M1517.320557,1002.241028 
C1520.517578,1009.725586 1523.859619,1017.153137 1526.833862,1024.725098 
C1527.887207,1027.406494 1529.359253,1027.993408 1532.016602,1028.025635 
C1534.744263,1028.058594 1536.091309,1027.265625 1537.158569,1024.668945 
C1542.020996,1012.839478 1547.123657,1001.108704 1552.161865,989.351868 
C1552.894775,987.641541 1553.745728,985.981689 1554.541992,984.298523 
C1554.900757,984.375244 1555.259399,984.452026 1555.618042,984.528748 
C1556.864868,1001.663452 1558.111694,1018.798096 1559.346680,1035.771973 
C1562.599854,1035.771973 1565.323730,1035.771973 1568.296143,1035.771973 
C1566.578979,1014.160217 1564.893677,992.949219 1563.182617,971.415283 
C1560.889771,971.415283 1559.038086,971.667236 1557.281372,971.366211 
C1552.716919,970.583923 1550.562866,972.531982 1548.944092,976.786865 
C1544.929810,987.338562 1540.372192,997.683899 1536.016357,1008.105286 
C1534.857178,1010.878540 1533.638550,1013.627136 1532.018921,1017.379395 
C1526.720825,1004.465881 1521.869751,992.678040 1517.047974,980.878235 
C1513.047607,971.088806 1513.062744,971.077881 1502.581543,971.463745 
C1502.123291,971.480652 1501.673706,971.730957 1500.905029,971.970886 
C1499.226562,993.254883 1497.545288,1014.574829 1495.872681,1035.784546 
C1499.308594,1035.784546 1502.045166,1035.784546 1504.814331,1035.784546 
C1506.144897,1018.423462 1507.447510,1001.424988 1508.750244,984.426453 
C1509.069092,984.380981 1509.387939,984.335449 1509.706909,984.289978 
C1512.153687,990.036255 1514.600464,995.782532 1517.320557,1002.241028 
M1521.950562,1082.505615 
C1518.601685,1074.375854 1515.252930,1066.246216 1511.952026,1058.232910 
C1507.771240,1058.232910 1503.842163,1058.232910 1499.565674,1058.232910 
C1497.891235,1079.768555 1496.234741,1101.072632 1494.562744,1122.575317 
C1497.895996,1122.575317 1500.478027,1122.575317 1503.469971,1122.575317 
C1504.787354,1105.408203 1506.089233,1088.444092 1507.390991,1071.479858 
C1509.209351,1073.041260 1510.114380,1074.715210 1510.855713,1076.458862 
C1515.727783,1087.915894 1520.629395,1099.361328 1525.361206,1110.876221 
C1526.380127,1113.355957 1527.583008,1114.379517 1530.439697,1114.413086 
C1533.665771,1114.450806 1535.003052,1113.246094 1536.183472,1110.390747 
C1541.741455,1096.946045 1547.557251,1083.608032 1553.281128,1070.231934 
C1553.599609,1070.273682 1553.917969,1070.315308 1554.236450,1070.357056 
C1555.516113,1087.777222 1556.795898,1105.197510 1558.074097,1122.598145 
C1561.279785,1122.598145 1563.881836,1122.598145 1566.992310,1122.598145 
C1565.285156,1101.029175 1563.598389,1079.719604 1561.895386,1058.203003 
C1557.860352,1058.203003 1554.079102,1058.203003 1549.930908,1058.203003 
C1543.679932,1073.108643 1537.359985,1088.178833 1530.750244,1103.940063 
C1527.636841,1096.426392 1524.905029,1089.833862 1521.950562,1082.505615 
M1676.332153,1007.488342 
C1676.332153,1011.883545 1676.332153,1016.278748 1676.332153,1020.673950 
C1674.582764,1019.545898 1673.798828,1018.189026 1673.059937,1016.808167 
C1665.617798,1002.899109 1658.233398,988.958740 1650.674316,975.113586 
C1649.849976,973.603516 1648.187622,971.914917 1646.638062,971.578125 
C1643.970703,970.998413 1641.086304,971.417664 1638.133667,971.417664 
C1638.133667,993.244446 1638.133667,1014.594177 1638.133667,1035.921021 
C1641.076538,1035.921021 1643.680420,1035.921021 1646.932617,1035.921021 
C1646.932617,1019.275879 1646.932617,1002.849976 1646.932617,986.424072 
C1655.581055,1000.577393 1663.348145,1014.834839 1671.121948,1029.088501 
C1675.507080,1037.128784 1675.685303,1037.207764 1685.077393,1035.622437 
C1685.077393,1014.388062 1685.077393,993.140686 1685.077393,971.769897 
C1682.114868,971.769897 1679.401245,971.769897 1676.332153,971.769897 
C1676.332153,983.578003 1676.332153,995.035217 1676.332153,1007.488342 
M1300.164917,1018.499146 
C1300.164917,1002.925415 1300.164917,987.351685 1300.164917,971.831787 
C1296.790771,971.831787 1294.080688,971.831787 1290.936768,971.831787 
C1290.936768,988.412781 1290.936768,1004.580811 1290.936768,1020.748901 
C1282.569702,1006.795166 1274.995728,992.663025 1267.422607,978.530334 
C1263.037354,970.346436 1262.943237,970.302368 1252.858398,971.984558 
C1252.858398,993.185303 1252.858398,1014.427795 1252.858398,1035.885376 
C1255.710327,1035.885376 1258.442261,1035.885376 1261.907349,1035.885376 
C1261.907349,1019.247070 1261.907349,1002.864685 1261.907349,986.482300 
C1270.606445,1000.882202 1278.465698,1015.309082 1286.334961,1029.730469 
C1290.374146,1037.132568 1291.361572,1037.537720 1300.164917,1035.392700 
C1300.164917,1030.126099 1300.164917,1024.812500 1300.164917,1018.499146 
M1394.437256,980.568665 
C1404.527466,979.852722 1414.617798,979.136780 1424.806885,978.413818 
C1424.806885,977.223816 1424.806885,975.103760 1424.806885,971.601624 
C1415.406860,971.545593 1406.038330,970.441528 1396.991943,971.683777 
C1383.727051,973.505249 1378.421509,980.463440 1378.072876,993.796631 
C1377.872803,1001.449158 1377.911743,1009.122009 1378.225464,1016.770081 
C1378.560791,1024.944336 1382.374878,1031.181519 1390.205444,1034.140259 
C1402.540283,1038.800903 1414.698730,1037.736084 1426.438232,1031.926025 
C1427.524048,1031.388550 1428.808228,1029.880127 1428.835205,1028.793701 
C1429.036865,1020.681213 1428.944824,1012.561462 1428.944824,1004.304993 
C1421.482544,1004.304993 1414.437134,1004.304993 1407.439941,1004.304993 
C1407.439941,1006.889954 1407.439941,1009.140564 1407.439941,1011.845337 
C1411.963867,1011.845337 1416.218750,1011.845337 1420.389526,1011.845337 
C1422.312256,1026.295288 1420.640503,1028.364990 1406.821411,1029.019653 
C1404.832764,1029.113892 1402.815796,1029.096680 1400.839478,1028.880371 
C1391.551880,1027.863647 1387.211792,1023.192139 1387.047119,1013.830750 
C1386.921143,1006.672974 1386.965088,999.508911 1387.103760,992.350952 
C1387.199829,987.392639 1389.018188,983.278198 1394.437256,980.568665 
M1313.021851,1030.430542 
C1312.462769,1032.216187 1311.903687,1034.001831 1311.316895,1035.875732 
C1320.316284,1036.515747 1320.300781,1036.510376 1323.079468,1028.451294 
C1324.515869,1024.285400 1326.018799,1020.142517 1327.412720,1016.211670 
C1336.155518,1016.211670 1344.302124,1016.211670 1352.655273,1016.211670 
C1354.152222,1020.481262 1355.627563,1024.689331 1357.103149,1028.897461 
C1359.744141,1036.428223 1359.744385,1036.432007 1367.785522,1036.074341 
C1368.076172,1036.061401 1368.356812,1035.823120 1368.897949,1035.570312 
C1361.217407,1014.212646 1353.530884,992.838623 1345.879028,971.560791 
C1341.797119,971.560791 1338.151245,971.560791 1334.243774,971.560791 
C1327.235474,990.964478 1320.243042,1010.324402 1313.021851,1030.430542 
M1185.851318,1030.302124 
C1185.196289,1032.092407 1184.541382,1033.882812 1183.839478,1035.801514 
C1192.988892,1036.622559 1192.985596,1036.621460 1195.633423,1029.005127 
C1197.140259,1024.670410 1198.660278,1020.340332 1200.153687,1016.067627 
C1207.847534,1016.067627 1215.014404,1016.218628 1222.169312,1015.992249 
C1224.965942,1015.903687 1225.864990,1017.192444 1226.618042,1019.477173 
C1228.467651,1025.088379 1230.512207,1030.635254 1232.337402,1035.808350 
C1235.740845,1035.808350 1238.460571,1035.808350 1241.466431,1035.808350 
C1241.009888,1034.311035 1240.721191,1033.198120 1240.334351,1032.120483 
C1233.654053,1013.511353 1226.627930,995.015747 1220.483276,976.231750 
C1218.734253,970.885193 1215.630859,971.771301 1211.900879,971.296509 
C1207.487549,970.734619 1206.252686,972.998657 1205.023804,976.503235 
C1198.811890,994.219116 1192.393066,1011.862549 1185.851318,1030.302124 
M1443.262573,976.743896 
C1443.262573,996.471008 1443.262573,1016.198120 1443.262573,1035.868042 
C1457.302124,1035.868042 1470.549316,1035.868042 1483.766235,1035.868042 
C1483.766235,1033.301392 1483.766235,1031.048584 1483.766235,1028.302979 
C1473.260010,1028.302979 1463.000732,1028.302979 1452.523682,1028.302979 
C1452.523682,1021.369629 1452.523682,1014.933655 1452.523682,1007.907715 
C1461.665771,1007.907715 1470.735474,1007.907715 1479.561768,1007.907715 
C1479.561768,1005.064148 1479.561768,1002.813782 1479.561768,1000.046753 
C1470.317749,1000.046753 1461.407349,1000.046753 1452.529785,1000.046753 
C1452.529785,992.890991 1452.529785,986.266479 1452.529785,979.084351 
C1462.825684,979.084351 1472.897949,979.084351 1482.823486,979.084351 
C1482.823486,976.256470 1482.823486,974.006042 1482.823486,971.676147 
C1469.599854,971.676147 1456.685059,971.676147 1443.505493,971.676147 
C1443.414429,973.227051 1443.338501,974.519287 1443.262573,976.743896 
M1592.159424,1015.582886 
C1592.159424,1013.157532 1592.159424,1010.732178 1592.159424,1007.854858 
C1601.736328,1007.854858 1610.642456,1007.854858 1619.485596,1007.854858 
C1619.485596,1005.133240 1619.485596,1002.890381 1619.485596,1000.121155 
C1610.299316,1000.121155 1601.408325,1000.121155 1592.522949,1000.121155 
C1592.522949,992.868042 1592.522949,986.157288 1592.522949,979.093994 
C1602.803833,979.093994 1612.726074,979.093994 1622.677002,979.093994 
C1622.677002,976.357910 1622.677002,974.006348 1622.677002,971.686401 
C1609.389648,971.686401 1596.476196,971.686401 1583.361084,971.686401 
C1583.361084,993.203552 1583.361084,1014.422546 1583.361084,1035.862915 
C1596.948608,1035.862915 1610.309814,1035.862915 1623.677368,1035.862915 
C1623.677368,1033.309204 1623.677368,1031.067627 1623.677368,1028.366943 
C1613.158691,1028.366943 1602.906372,1028.366943 1592.159424,1028.366943 
C1592.159424,1024.126099 1592.159424,1020.338745 1592.159424,1015.582886 
M1442.017944,1061.666748 
C1442.017944,1081.924438 1442.017944,1102.182007 1442.017944,1122.534790 
C1455.843994,1122.534790 1469.078979,1122.534790 1482.400391,1122.534790 
C1482.400391,1119.874634 1482.400391,1117.509521 1482.400391,1114.767456 
C1471.768677,1114.767456 1461.511230,1114.767456 1451.230713,1114.767456 
C1451.230713,1107.944702 1451.230713,1101.510010 1451.230713,1094.538208 
C1460.319336,1094.538208 1469.204102,1094.538208 1478.216064,1094.538208 
C1478.216064,1091.744019 1478.216064,1089.491333 1478.216064,1086.748779 
C1469.055176,1086.748779 1460.151001,1086.748779 1451.320557,1086.748779 
C1451.320557,1079.504639 1451.320557,1072.756714 1451.320557,1065.675781 
C1461.565063,1065.675781 1471.505493,1065.675781 1481.607666,1065.675781 
C1481.607666,1062.959473 1481.607666,1060.594849 1481.607666,1057.975586 
C1469.147339,1057.975586 1457.005737,1057.914185 1444.867554,1058.093506 
C1443.905273,1058.107788 1442.967651,1059.791626 1442.017944,1061.666748 
M1258.490601,1066.707031 
C1259.440308,1064.427490 1260.390137,1062.147949 1261.419189,1059.678101 
C1251.078979,1056.675049 1241.815674,1056.569336 1232.560303,1058.183228 
C1225.226074,1059.462036 1221.520020,1064.220581 1220.987671,1071.711792 
C1220.435425,1079.482910 1223.294556,1085.328125 1230.204956,1089.051758 
C1236.198364,1092.281372 1242.204956,1095.487305 1248.237061,1098.643799 
C1252.459839,1100.853394 1254.141724,1104.380005 1253.516724,1108.951172 
C1252.898438,1113.474243 1249.345459,1114.701172 1245.553467,1115.104248 
C1242.105469,1115.470581 1238.578369,1115.690308 1235.137573,1115.388306 
C1230.060669,1114.942993 1225.029297,1113.978027 1219.846313,1113.214722 
C1219.846313,1115.848511 1219.846313,1118.289551 1219.846313,1122.188965 
C1229.731201,1122.406494 1239.512695,1123.385620 1249.157104,1122.624756 
C1259.356812,1121.820435 1263.504028,1115.086182 1262.354370,1104.770386 
C1261.704468,1098.940063 1258.921021,1094.791260 1253.989136,1092.025391 
C1247.907471,1088.614868 1241.700928,1085.427734 1235.567749,1082.108276 
C1231.327393,1079.813354 1229.058716,1076.408081 1230.159668,1071.451294 
C1231.238647,1066.593628 1235.362061,1065.340088 1239.331177,1065.273682 
C1245.446045,1065.171143 1251.576050,1065.984863 1258.490601,1066.707031 
M1340.550781,1087.987915 
C1347.426758,1091.689819 1354.342896,1095.319702 1361.162842,1099.122192 
C1364.931885,1101.223755 1366.297729,1104.753662 1365.715698,1108.888794 
C1365.127319,1113.067383 1361.956787,1114.624634 1358.247803,1115.008423 
C1354.629639,1115.383057 1350.939819,1115.688110 1347.332520,1115.394531 
C1342.274292,1114.983276 1337.263428,1113.990234 1332.012451,1113.213501 
C1332.012451,1115.862305 1332.012451,1118.297241 1332.012451,1122.188599 
C1341.903076,1122.403198 1351.640991,1123.046875 1361.337158,1122.655273 
C1366.750854,1122.436523 1371.640625,1119.839722 1373.767334,1114.076294 
C1376.872681,1105.660156 1373.815308,1096.547729 1366.061035,1092.006714 
C1360.617065,1088.818481 1354.895386,1086.108398 1349.379395,1083.037964 
C1343.004639,1079.489502 1341.013794,1076.069092 1342.281372,1071.362671 
C1343.413086,1067.160889 1346.937866,1065.019653 1354.054932,1065.106201 
C1360.143921,1065.180420 1366.224731,1065.908203 1372.487183,1066.359619 
C1372.487183,1064.169434 1372.487183,1061.740601 1372.487183,1058.005249 
C1363.330811,1058.005249 1354.384399,1057.511963 1345.520264,1058.154663 
C1337.829956,1058.712158 1333.708008,1063.716309 1333.137573,1071.401489 
C1332.654053,1077.917969 1334.218628,1083.638794 1340.550781,1087.987915 
M1600.791382,1065.037842 
C1606.997803,1065.472168 1613.204224,1065.906372 1619.554932,1066.350708 
C1619.554932,1064.115967 1619.554932,1061.830322 1619.554932,1059.426636 
C1610.144653,1056.604126 1600.728271,1056.545898 1591.332764,1058.274048 
C1584.582642,1059.515869 1580.986694,1063.770874 1580.195557,1070.597412 
C1579.291382,1078.399048 1581.744507,1084.701172 1588.770874,1088.776855 
C1591.356323,1090.276489 1593.999878,1091.677734 1596.641968,1093.076660 
C1600.457642,1095.096924 1604.346191,1096.984985 1608.110962,1099.094849 
C1611.880859,1101.207642 1613.273315,1104.691895 1612.725464,1108.824707 
C1612.171753,1113.001587 1609.033691,1114.603760 1605.317749,1114.996948 
C1601.702271,1115.379761 1598.013916,1115.696289 1594.408936,1115.405273 
C1589.339600,1114.996216 1584.317749,1113.999634 1579.036865,1113.219116 
C1579.036865,1115.789307 1579.036865,1118.220581 1579.036865,1120.805542 
C1588.868408,1123.548950 1598.789185,1124.143311 1608.716431,1122.665405 
C1617.433594,1121.367432 1621.704712,1116.441650 1621.801025,1108.310303 
C1621.885254,1101.201050 1619.449463,1095.338013 1612.764771,1091.785400 
C1606.169434,1088.280151 1599.607544,1084.704468 1593.133179,1080.981934 
C1589.749268,1079.036377 1588.506592,1075.804077 1589.174561,1071.999023 
C1589.832275,1068.251221 1592.329346,1066.310425 1595.994873,1065.729492 
C1597.299683,1065.522705 1598.600464,1065.290283 1600.791382,1065.037842 
M1324.293457,1061.698242 
C1324.829224,1060.565186 1325.365112,1059.432129 1325.835327,1058.437744 
C1318.369385,1056.220337 1314.520752,1059.184082 1311.635986,1065.965576 
C1307.693237,1075.234375 1302.516357,1083.978149 1297.602173,1093.460815 
C1292.395142,1083.497803 1287.493530,1074.110962 1282.583984,1064.728394 
C1278.509888,1056.941895 1278.505737,1056.944092 1268.950806,1058.595459 
C1276.417725,1072.192261 1283.891724,1085.666016 1291.185791,1099.236572 
C1292.227539,1101.174927 1292.798462,1103.564941 1292.892456,1105.775391 
C1293.129883,1111.357788 1292.971191,1116.956909 1292.971191,1122.436279 
C1296.352539,1122.436279 1299.067261,1122.436279 1301.966553,1122.436279 
C1301.966553,1118.398560 1302.218262,1114.722412 1301.909912,1111.093750 
C1301.397217,1105.061523 1303.017334,1099.829102 1306.074829,1094.618286 
C1312.291870,1084.022461 1318.030273,1073.145752 1324.293457,1061.698242 
M1731.649658,979.153259 
C1736.055664,979.153259 1740.461548,979.153259 1744.734863,979.153259 
C1744.734863,976.201782 1744.734863,974.072998 1744.734863,971.717651 
C1728.665649,971.717651 1712.793945,971.717651 1696.711792,971.717651 
C1696.711792,974.262329 1696.711792,976.501709 1696.711792,979.199097 
C1703.207153,979.199097 1709.450928,979.199097 1716.161621,979.199097 
C1716.161621,998.361694 1716.161621,1017.071777 1716.161621,1035.856689 
C1719.374390,1035.856689 1722.094971,1035.856689 1725.292969,1035.856689 
C1725.292969,1016.865479 1725.292969,998.165833 1725.292969,979.153259 
C1727.415283,979.153259 1729.053101,979.153259 1731.649658,979.153259 
M1402.171509,1083.500732 
C1402.171509,1096.436768 1402.171509,1109.372681 1402.171509,1122.511597 
C1405.404419,1122.511597 1408.115479,1122.511597 1411.333008,1122.511597 
C1411.333008,1103.491577 1411.333008,1084.774048 1411.333008,1065.660156 
C1418.105957,1065.660156 1424.372437,1065.660156 1430.803467,1065.660156 
C1430.803467,1062.988281 1430.803467,1060.724976 1430.803467,1058.217651 
C1414.761353,1058.217651 1398.882812,1058.217651 1382.945312,1058.217651 
C1382.945312,1060.837891 1382.945312,1063.229736 1382.945312,1066.086060 
C1389.540161,1066.086060 1395.780273,1066.086060 1402.171509,1066.086060 
C1402.171509,1071.869751 1402.171509,1077.185425 1402.171509,1083.500732 
M1550.802734,265.734100 
C1546.001099,262.365234 1540.715210,262.837738 1539.396606,267.384430 
C1538.680908,269.852203 1539.524780,273.614655 1541.105469,275.702484 
C1543.305542,278.607849 1547.015381,278.402435 1549.932495,275.992310 
C1553.214600,273.280609 1553.515503,269.909851 1550.802734,265.734100 
M1303.820190,274.129822 
C1305.457764,270.982483 1305.349609,267.738983 1302.587158,265.610138 
C1300.865967,264.283783 1297.736816,263.203186 1295.986328,263.896759 
C1293.802002,264.762238 1291.250610,267.411804 1290.956299,269.576324 
C1290.659546,271.759033 1292.345581,275.042145 1294.211914,276.501465 
C1297.340210,278.947357 1300.762085,277.721741 1303.820190,274.129822 
M1551.620605,247.020142 
C1547.357666,242.680695 1542.229492,242.524460 1539.517944,246.749924 
C1537.602905,249.734055 1537.780518,252.801392 1540.175537,255.407654 
C1542.523682,257.962891 1545.483276,258.761566 1548.681152,256.964111 
C1552.421509,254.861877 1553.360840,251.662201 1551.620605,247.020142 
M1470.822510,214.221527 
C1476.819580,211.486053 1478.483887,205.196640 1473.651978,202.117004 
C1471.609009,200.814758 1467.595703,200.479797 1465.700806,201.663254 
C1463.783691,202.860550 1462.336548,206.570053 1462.550903,209.015503 
C1462.887451,212.858719 1466.056641,214.716995 1470.822510,214.221527 
M1534.681030,294.787567 
C1540.246216,297.510376 1544.635498,296.313324 1546.041748,291.578735 
C1547.045044,288.200714 1546.172729,285.236237 1543.145386,283.329651 
C1539.946411,281.314972 1536.678223,281.677277 1534.112915,284.450195 
C1531.208374,287.590149 1531.340576,291.001801 1534.681030,294.787567 
M1302.995605,255.443115 
C1305.992920,250.070251 1304.585938,245.099243 1299.646240,243.907883 
C1296.209717,243.079086 1292.763306,243.903870 1291.730713,247.284286 
C1290.985474,249.724670 1291.355225,253.398529 1292.787720,255.412567 
C1295.243286,258.864838 1299.046509,258.613708 1302.995605,255.443115 
M1368.366211,211.853500 
C1371.546021,215.026337 1375.094971,215.560623 1378.595947,212.672394 
C1381.336670,210.411392 1381.929810,207.247330 1380.148926,204.112274 
C1378.187500,200.659470 1375.139526,199.297897 1371.260986,200.842621 
C1367.085938,202.505402 1366.047119,205.898926 1368.366211,211.853500 
M1506.168457,200.372421 
C1502.694946,201.840744 1500.437866,204.613464 1501.518799,208.155746 
C1502.216919,210.443680 1504.678223,213.091446 1506.893188,213.750687 
C1508.867188,214.338257 1512.415771,213.077423 1513.748413,211.413864 
C1515.088379,209.740997 1515.675903,205.713638 1514.568359,204.250305 
C1512.981201,202.153336 1509.556519,201.447235 1506.168457,200.372421 
M1335.335815,200.023987 
C1329.583130,200.910400 1327.140503,203.640335 1327.859619,208.379349 
C1328.473145,212.422531 1332.387329,215.447906 1336.212646,213.844940 
C1338.548828,212.865997 1341.091064,210.135849 1341.677368,207.736847 
C1342.614746,203.901169 1339.925415,201.257370 1335.335815,200.023987 
M1304.318359,282.175537 
C1298.547241,283.153625 1295.899780,286.351044 1296.966553,291.054443 
C1297.885132,295.103851 1302.403564,297.833893 1306.176636,295.831818 
C1308.286377,294.712280 1310.364990,291.983368 1310.826904,289.655975 
C1311.609619,285.712830 1308.875244,283.284576 1304.318359,282.175537 
M1310.252075,216.601227 
C1310.690674,218.014236 1310.699951,220.083740 1311.654419,220.707886 
C1313.853149,222.145706 1316.875122,224.145950 1318.886841,223.567337 
C1321.171997,222.910065 1323.861084,219.878906 1324.246826,217.530182 
C1324.587646,215.455475 1322.557861,212.122391 1320.593262,210.722321 
C1316.731445,207.970490 1312.631226,210.325378 1310.252075,216.601227 
M1398.978394,217.332214 
C1400.654053,213.896286 1400.357300,210.327866 1396.983643,208.720886 
C1394.583862,207.577774 1390.575439,207.332535 1388.544434,208.641205 
C1386.770020,209.784592 1385.692749,213.869095 1386.174072,216.281937 
C1387.308350,221.968292 1393.627686,222.656876 1398.978394,217.332214 
M1545.582153,233.125137 
C1545.937622,229.309906 1544.304077,226.149811 1540.740356,225.482666 
C1538.387085,225.042099 1534.885010,226.017288 1533.285400,227.687805 
C1531.871338,229.164474 1531.421875,232.915100 1532.306763,234.861359 
C1533.185913,236.795029 1536.112671,238.478271 1538.406006,238.930649 
C1541.954590,239.630615 1544.245972,237.217926 1545.582153,233.125137 
M1360.806519,200.668320 
C1357.118408,196.241013 1352.588867,195.440262 1349.389526,198.778625 
C1346.933105,201.341827 1346.383789,204.365601 1348.316162,207.447021 
C1350.195435,210.443649 1353.043701,211.767426 1356.471558,210.544754 
C1360.774902,209.009827 1362.136475,205.742737 1360.806519,200.668320 
M1525.537354,209.853546 
C1523.331421,211.540298 1520.254395,212.783905 1519.119263,215.015366 
C1517.311035,218.570465 1520.169067,222.926224 1523.995483,223.868652 
C1527.563965,224.747574 1531.511230,222.417053 1532.610229,218.782333 
C1533.813599,214.802917 1531.414795,211.409027 1525.537354,209.853546 
M1311.530518,230.144775 
C1310.205444,226.625732 1307.596924,224.224411 1303.959351,225.208527 
C1301.655640,225.831833 1298.909058,228.094040 1298.166748,230.244553 
C1297.495850,232.188080 1298.579834,235.773132 1300.173462,237.171005 
C1301.764282,238.566483 1305.121094,238.881836 1307.394409,238.349884 
C1310.892456,237.531372 1311.995361,234.380463 1311.530518,230.144775 
M1444.161011,210.750305 
C1442.620117,216.357376 1444.531494,220.386765 1449.186523,221.009842 
C1452.851440,221.500366 1456.345459,220.216888 1456.902222,216.537445 
C1457.291016,213.967407 1456.217773,210.170258 1454.370483,208.491196 
C1451.181152,205.592224 1447.331055,206.360260 1444.161011,210.750305 
M1495.891113,202.772400 
C1494.827393,198.694351 1492.177002,195.941330 1488.036865,197.057846 
C1485.675781,197.694550 1483.008667,200.235748 1482.106445,202.552917 
C1480.638550,206.323227 1483.780762,210.236786 1487.769287,210.880463 
C1491.844971,211.538208 1494.852783,208.853348 1495.891113,202.772400 
z'
    />
    <path
      fill='#494949'
      opacity='1.000000'
      stroke='none'
      d='
M1820.283203,412.760986 
C1799.541382,413.015259 1779.126709,413.015259 1758.428711,413.015259 
C1758.428711,409.292511 1758.428711,405.868134 1758.428711,401.525970 
C1778.728271,401.525970 1799.080688,401.525970 1819.880615,401.303345 
C1820.421997,404.889404 1820.516235,408.698029 1820.283203,412.760986 
z'
    />
    <path
      fill='#252525'
      opacity='1.000000'
      stroke='none'
      d='
M1819.975708,772.852173 
C1798.745972,773.073853 1777.516602,773.073853 1756.017334,773.073853 
C1756.017334,769.421143 1756.017334,766.003113 1756.017334,761.957214 
C1776.972046,761.957214 1798.013428,761.957214 1819.515137,762.416931 
C1819.974976,765.980103 1819.974731,769.083618 1819.974487,772.187073 
C1819.974487,772.187073 1819.976196,772.630493 1819.975708,772.852173 
z'
    />
    <path
      fill='#252525'
      opacity='1.000000'
      stroke='none'
      d='
M1819.995605,592.787903 
C1798.766846,592.988037 1777.530151,592.988037 1756.020752,592.988037 
C1756.020752,589.348206 1756.020752,585.936646 1756.020752,581.882202 
C1776.987671,581.882202 1798.025391,581.882202 1819.528564,581.937256 
C1819.994141,581.992371 1820.002563,582.025574 1819.995361,582.491333 
C1819.983521,586.033875 1819.979004,589.110596 1819.974365,592.187378 
C1819.974365,592.187378 1819.987671,592.587769 1819.995605,592.787903 
z'
    />
    <path
      fill='#252525'
      opacity='1.000000'
      stroke='none'
      d='
M1023.033325,582.149292 
C1044.331543,581.880005 1065.620483,581.880005 1087.192505,581.880005 
C1087.192505,585.648010 1087.192505,589.070984 1087.192505,593.113708 
C1066.181763,593.113708 1045.081177,593.113708 1023.494934,592.688599 
C1023.009644,589.161377 1023.009949,586.059387 1023.010315,582.957336 
C1023.014893,582.777771 1023.019409,582.598206 1023.033325,582.149292 
z'
    />
    <path
      fill='#252525'
      opacity='1.000000'
      stroke='none'
      d='
M1023.015503,762.201599 
C1043.441528,761.948303 1063.865234,761.948303 1084.580200,761.948303 
C1084.580200,765.668640 1084.580200,769.072021 1084.580200,773.219421 
C1064.407227,773.219421 1044.207153,773.219421 1023.514648,772.782043 
C1023.017883,769.216919 1023.013611,766.089233 1023.009277,762.961487 
C1023.010559,762.792603 1023.011902,762.623779 1023.015503,762.201599 
z'
    />
    <path
      fill='#252525'
      opacity='1.000000'
      stroke='none'
      d='
M1023.044189,653.960388 
C1033.509766,653.931274 1043.958008,653.931274 1054.751221,653.931274 
C1054.751221,657.604675 1054.751221,661.129578 1054.751221,665.141235 
C1044.463013,665.141235 1034.219849,665.141235 1023.510986,665.134888 
C1023.038574,664.947693 1023.031860,664.766907 1023.008057,663.856812 
C1022.988220,660.098572 1022.985474,657.069763 1022.982727,654.040894 
C1022.982727,654.040894 1023.026855,653.989502 1023.044189,653.960388 
z'
    />
    <path
      fill='#252525'
      opacity='1.000000'
      stroke='none'
      d='
M1820.005371,448.753845 
C1809.571533,448.942444 1799.125488,448.942444 1788.339844,448.942444 
C1788.339844,445.360779 1788.339844,441.827881 1788.339844,437.794159 
C1798.586182,437.794159 1808.816650,437.794159 1819.510498,437.857666 
C1819.973633,437.921173 1819.975464,438.365112 1819.973389,439.061981 
C1819.972412,442.568481 1819.973389,445.378143 1819.974365,448.187775 
C1819.974365,448.187775 1819.993164,448.565277 1820.005371,448.753845 
z'
    />
    <path
      fill='#252525'
      opacity='1.000000'
      stroke='none'
      d='
M1023.036987,546.138550 
C1033.501221,545.865967 1043.954712,545.865967 1054.752441,545.865967 
C1054.752441,549.550354 1054.752441,553.079163 1054.752441,557.084106 
C1044.460449,557.084106 1034.211426,557.084106 1023.495483,557.083496 
C1023.025208,556.909363 1023.021667,556.735779 1023.004272,555.846375 
C1022.997192,552.405884 1023.003845,549.681213 1023.010498,546.956482 
C1023.015747,546.774658 1023.020996,546.592896 1023.036987,546.138550 
z'
    />
    <path
      fill='#252525'
      opacity='1.000000'
      stroke='none'
      d='
M1819.998779,556.777100 
C1809.567017,556.973999 1799.126099,556.973999 1788.342529,556.973999 
C1788.342529,553.420166 1788.342529,549.889587 1788.342529,545.851135 
C1798.580688,545.851135 1808.807007,545.851135 1819.499634,546.321533 
C1819.968750,549.923462 1819.971680,553.054871 1819.974609,556.186340 
C1819.974609,556.186340 1819.989624,556.580261 1819.998779,556.777100 
z'
    />
    <path
      fill='#252525'
      opacity='1.000000'
      stroke='none'
      d='
M1819.992188,628.799683 
C1809.555420,629.003967 1799.112061,629.003967 1788.334473,629.003967 
C1788.334473,625.441528 1788.334473,621.908264 1788.334473,617.901245 
C1798.601440,617.901245 1808.835571,617.901245 1819.535889,617.953979 
C1820.002075,618.006653 1819.987183,618.409607 1819.979492,619.085571 
C1819.972778,622.570068 1819.973633,625.378540 1819.974365,628.187012 
C1819.974365,628.187012 1819.985718,628.595459 1819.992188,628.799683 
z'
    />
    <path
      fill='#252525'
      opacity='1.000000'
      stroke='none'
      d='
M1820.001221,520.769409 
C1809.568604,520.963379 1799.125610,520.963379 1788.341431,520.963379 
C1788.341431,517.400391 1788.341431,513.869690 1788.341431,509.845123 
C1798.586792,509.845123 1808.815552,509.845123 1819.507812,509.904602 
C1819.971191,509.964081 1819.990601,510.010162 1819.989014,510.482239 
C1819.983032,514.031982 1819.978638,517.109680 1819.974365,520.187378 
C1819.974365,520.187378 1819.990967,520.575500 1820.001221,520.769409 
z'
    />
    <path
      fill='#252525'
      opacity='1.000000'
      stroke='none'
      d='
M1023.051392,438.097900 
C1033.521118,437.811859 1043.974121,437.811859 1054.761719,437.811859 
C1054.761719,441.495758 1054.761719,445.030457 1054.761719,449.047791 
C1044.467041,449.047791 1034.215698,449.047791 1023.483032,448.629669 
C1023.004700,445.126556 1023.007568,442.041595 1023.010437,438.956604 
C1023.018555,438.765717 1023.026611,438.574860 1023.051392,438.097900 
z'
    />
    <path
      fill='#252525'
      opacity='1.000000'
      stroke='none'
      d='
M1819.988892,664.810303 
C1809.550049,665.017883 1799.105957,665.017883 1788.331055,665.017883 
C1788.331055,661.457397 1788.331055,657.922607 1788.331055,653.918152 
C1798.605591,653.918152 1808.841797,653.918152 1819.545288,653.967651 
C1820.012573,654.017090 1820.008667,654.039490 1819.998291,654.499634 
C1819.983521,658.035645 1819.979004,661.111511 1819.974365,664.187378 
C1819.974365,664.187378 1819.983643,664.602661 1819.988892,664.810303 
z'
    />
    <path
      fill='#252525'
      opacity='1.000000'
      stroke='none'
      d='
M1023.036499,689.968994 
C1033.501221,689.942261 1043.951050,689.942261 1054.748779,689.942261 
C1054.748779,693.619080 1054.748779,697.143555 1054.748779,701.164368 
C1044.468262,701.164368 1034.225220,701.164368 1023.517090,701.155334 
C1023.043823,700.962158 1023.035767,700.778076 1023.009094,699.859924 
C1022.987610,696.098083 1022.984802,693.070251 1022.981995,690.042480 
C1022.981995,690.042480 1023.021606,689.995789 1023.036499,689.968994 
z'
    />
    <path
      fill='#252525'
      opacity='1.000000'
      stroke='none'
      d='
M1819.963013,701.151733 
C1809.523560,701.151733 1799.084106,701.151733 1788.322632,701.151733 
C1788.322632,697.463623 1788.322632,693.928467 1788.322632,689.937134 
C1798.610107,689.937134 1808.843018,689.937134 1819.543213,689.985229 
C1820.010376,690.033325 1819.990479,690.423035 1819.981201,691.097412 
C1819.969116,694.898438 1819.966064,698.025085 1819.963013,701.151733 
z'
    />
    <path
      fill='#252525'
      opacity='1.000000'
      stroke='none'
      d='
M1023.040649,510.128723 
C1033.506470,509.852112 1043.959961,509.852112 1054.754761,509.852112 
C1054.754761,513.535339 1054.754761,517.065430 1054.754761,521.069092 
C1044.459595,521.069092 1034.209106,521.069092 1023.491577,521.070068 
C1023.021729,520.899414 1023.019043,520.727783 1023.003479,519.843506 
C1022.997070,516.406738 1023.003540,513.682800 1023.010010,510.958801 
C1023.016052,510.774323 1023.022156,510.589813 1023.040649,510.128723 
z'
    />
    <path
      fill='#252525'
      opacity='1.000000'
      stroke='none'
      d='
M1819.981934,736.832458 
C1809.540405,737.047485 1799.096680,737.047485 1788.326538,737.047485 
C1788.326538,733.491638 1788.326538,729.954163 1788.326538,725.953918 
C1798.604736,725.953918 1808.841675,725.953918 1819.546265,725.999573 
C1820.013916,726.045227 1819.991821,726.428833 1819.981934,727.095215 
C1819.972778,730.570190 1819.973633,733.378784 1819.974365,736.187378 
C1819.974365,736.187378 1819.979736,736.617432 1819.981934,736.832458 
z'
    />
    <path
      fill='#252525'
      opacity='1.000000'
      stroke='none'
      d='
M1819.989380,485.049011 
C1809.549072,485.049011 1799.108887,485.049011 1788.334595,485.049011 
C1788.334595,481.366364 1788.334595,477.835815 1788.334595,473.821259 
C1798.595703,473.821259 1808.823608,473.821259 1819.515625,473.880310 
C1819.979858,473.939392 1819.978149,474.376190 1819.975098,475.071411 
C1819.977783,478.860748 1819.983643,481.954865 1819.989380,485.049011 
z'
    />
    <path
      fill='#494949'
      opacity='1.000000'
      stroke='none'
      d='
M1022.710205,439.252655 
C1023.007568,442.041595 1023.004700,445.126556 1023.018677,448.674896 
C1023.013794,451.476654 1022.992065,453.815033 1022.870300,456.582031 
C1022.650085,451.189972 1022.529968,445.369324 1022.710205,439.252655 
z'
    />
    <path
      fill='#494949'
      opacity='1.000000'
      stroke='none'
      d='
M1022.580444,401.339600 
C1023.437866,401.410431 1024.026489,401.784149 1024.408203,402.675537 
C1023.817017,406.498810 1023.432800,409.804443 1023.048584,413.110107 
C1023.048584,413.110107 1023.042419,413.055573 1023.064758,413.071594 
C1022.828613,409.272552 1022.570129,405.457520 1022.580444,401.339600 
z'
    />
    <path
      fill='#494949'
      opacity='1.000000'
      stroke='none'
      d='
M1022.709534,763.256714 
C1023.013611,766.089233 1023.017883,769.216919 1023.052612,772.817505 
C1023.045410,775.255859 1023.007751,777.221436 1022.870178,779.598755 
C1022.650085,774.524414 1022.529907,769.038147 1022.709534,763.256714 
z'
    />
    <path
      fill='#494949'
      opacity='1.000000'
      stroke='none'
      d='
M1023.037354,485.152191 
C1023.015137,486.508606 1022.992920,487.865021 1022.870422,489.616028 
C1022.682922,484.797363 1022.595703,479.584137 1022.824219,474.069763 
C1023.139954,473.768585 1023.105530,473.818634 1023.067871,474.270721 
C1023.032654,478.199280 1023.034973,481.675720 1023.037354,485.152191 
z'
    />
    <path
      fill='#494949'
      opacity='1.000000'
      stroke='none'
      d='
M1820.284180,555.879822 
C1819.971680,553.054871 1819.968750,549.923462 1819.966187,546.326660 
C1820.031250,544.503479 1820.096069,543.145630 1820.282227,541.398193 
C1820.466797,545.863525 1820.530151,550.718445 1820.284180,555.879822 
z'
    />
    <path
      fill='#494949'
      opacity='1.000000'
      stroke='none'
      d='
M1820.027710,485.378235 
C1819.983643,481.954865 1819.977783,478.860748 1819.973389,475.289795 
C1820.270508,478.647522 1820.566528,482.482025 1820.630859,486.647186 
C1820.288086,486.554382 1820.177002,486.130951 1820.027710,485.378235 
z'
    />
    <path
      fill='#494949'
      opacity='1.000000'
      stroke='none'
      d='
M1820.281006,771.886841 
C1819.974731,769.083618 1819.974976,765.980103 1819.983154,762.417847 
C1820.043457,761.515625 1820.095825,761.072144 1820.274658,760.318604 
C1820.463257,763.867859 1820.525391,767.727234 1820.281006,771.886841 
z'
    />
    <path
      fill='#494949'
      opacity='1.000000'
      stroke='none'
      d='
M1022.713806,583.245605 
C1023.009949,586.059387 1023.009644,589.161377 1023.031372,592.730469 
C1023.030762,593.608276 1023.008057,594.019043 1022.878540,594.720093 
C1022.653503,591.184937 1022.535400,587.359375 1022.713806,583.245605 
z'
    />
    <path
      fill='#494949'
      opacity='1.000000'
      stroke='none'
      d='
M1023.119202,737.191895 
C1022.916687,733.628845 1022.695740,730.038391 1022.786133,726.166504 
C1023.097534,725.885071 1023.050720,725.926575 1023.030334,726.366577 
C1023.043640,730.279175 1023.077332,733.751770 1023.111023,737.224426 
C1023.111023,737.224426 1023.100830,737.164368 1023.119202,737.191895 
z'
    />
    <path
      fill='#494949'
      opacity='1.000000'
      stroke='none'
      d='
M1819.987793,701.393372 
C1819.966064,698.025085 1819.969116,694.898438 1819.973267,691.292297 
C1820.259766,694.318420 1820.545166,697.824097 1820.594971,701.652649 
C1820.359253,701.975586 1820.012695,701.635010 1819.987793,701.393372 
z'
    />
    <path
      fill='#494949'
      opacity='1.000000'
      stroke='none'
      d='
M1023.097656,629.140137 
C1022.910706,625.581787 1022.701172,621.997009 1022.803467,618.126648 
C1023.115295,617.841064 1023.070923,617.891296 1023.044312,618.331909 
C1023.040527,622.242126 1023.063354,625.711731 1023.086121,629.181396 
C1023.086121,629.181396 1023.075073,629.113770 1023.097656,629.140137 
z'
    />
    <path
      fill='#494949'
      opacity='1.000000'
      stroke='none'
      d='
M1820.278320,591.893311 
C1819.979004,589.110596 1819.983521,586.033875 1820.005615,582.504944 
C1820.209595,585.234924 1820.395996,588.417114 1820.278320,591.893311 
z'
    />
    <path
      fill='#494949'
      opacity='1.000000'
      stroke='none'
      d='
M1820.278320,519.893188 
C1819.978638,517.109680 1819.983032,514.031982 1820.004395,510.501892 
C1820.208374,513.232666 1820.395264,516.415771 1820.278320,519.893188 
z'
    />
    <path
      fill='#494949'
      opacity='1.000000'
      stroke='none'
      d='
M1022.687805,654.310669 
C1022.985474,657.069763 1022.988220,660.098572 1023.000671,663.585449 
C1022.804565,660.889160 1022.598694,657.734802 1022.687805,654.310669 
z'
    />
    <path
      fill='#494949'
      opacity='1.000000'
      stroke='none'
      d='
M1820.278320,663.893250 
C1819.979004,661.111511 1819.983521,658.035645 1820.006348,654.507812 
C1820.210571,657.237000 1820.396484,660.418030 1820.278320,663.893250 
z'
    />
    <path
      fill='#494949'
      opacity='1.000000'
      stroke='none'
      d='
M1022.687134,690.312073 
C1022.984802,693.070251 1022.987610,696.098083 1023.000305,699.583618 
C1022.804199,696.888123 1022.598206,693.734924 1022.687134,690.312073 
z'
    />
    <path
      fill='#494949'
      opacity='1.000000'
      stroke='none'
      d='
M1820.276611,627.897583 
C1819.973633,625.378540 1819.972778,622.570068 1819.973145,619.287109 
C1820.175903,621.744446 1820.377441,624.676270 1820.276611,627.897583 
z'
    />
    <path
      fill='#494949'
      opacity='1.000000'
      stroke='none'
      d='
M1820.276367,735.897705 
C1819.973633,733.378784 1819.972778,730.570190 1819.973145,727.287109 
C1820.175781,729.744385 1820.377197,732.676208 1820.276367,735.897705 
z'
    />
    <path
      fill='#494949'
      opacity='1.000000'
      stroke='none'
      d='
M1022.719238,547.232544 
C1023.003845,549.681213 1022.997192,552.405884 1023.000366,555.585938 
C1022.816162,553.197083 1022.622131,550.352844 1022.719238,547.232544 
z'
    />
    <path
      fill='#494949'
      opacity='1.000000'
      stroke='none'
      d='
M1022.718994,511.234680 
C1023.003540,513.682800 1022.997070,516.406738 1023.000366,519.586060 
C1022.816040,517.197754 1022.622009,514.354187 1022.718994,511.234680 
z'
    />
    <path
      fill='#494949'
      opacity='1.000000'
      stroke='none'
      d='
M1820.276367,447.897949 
C1819.973389,445.378143 1819.972412,442.568481 1819.972900,439.283966 
C1820.175781,441.742096 1820.377075,444.675140 1820.276367,447.897949 
z'
    />
    <path
      fill='#FEFEFE'
      opacity='1.000000'
      stroke='none'
      d='
M655.247925,1528.490601 
C651.708496,1508.872437 650.953247,1489.740479 656.836609,1470.797363 
C664.073486,1447.496460 683.648315,1435.092407 707.967468,1438.429810 
C729.593445,1441.397583 742.140442,1453.122803 746.707825,1476.013306 
C750.428284,1494.659424 750.413635,1513.399048 744.854736,1531.846191 
C738.326599,1553.509644 721.308411,1565.304932 698.716431,1564.562134 
C679.784790,1563.939697 661.993774,1556.752441 655.247925,1528.490601 
z'
    />
    <path
      fill='#FEFEFE'
      opacity='1.000000'
      stroke='none'
      d='
M1229.500854,1547.400391 
C1222.453735,1527.476807 1222.372559,1507.165039 1223.743042,1486.900879 
C1224.419312,1476.901001 1226.406860,1466.809814 1229.232178,1457.179810 
C1232.990112,1444.372070 1243.130005,1437.579834 1256.104980,1437.349609 
C1269.367432,1437.114380 1278.221924,1442.968994 1283.140991,1455.972290 
C1285.120728,1461.205811 1286.647095,1466.774658 1287.299683,1472.317993 
C1289.894409,1494.354248 1290.919800,1516.452515 1285.826538,1538.296875 
C1283.477539,1548.371826 1279.292603,1557.730591 1269.221558,1562.521973 
C1257.409790,1568.141479 1236.269409,1567.328369 1229.500854,1547.400391 
z'
    />
    <path
      fill='#FEFEFE'
      opacity='1.000000'
      stroke='none'
      d='
M1165.043945,1466.118408 
C1168.935913,1491.231567 1170.189209,1515.932861 1163.969482,1540.419189 
C1161.255615,1551.103882 1156.111084,1560.821655 1144.517334,1563.818237 
C1123.709717,1569.196289 1111.102051,1561.112061 1105.914307,1540.402710 
C1101.328003,1522.094238 1101.134521,1503.409546 1102.624634,1484.778564 
C1103.346558,1475.750488 1105.123901,1466.643555 1107.736084,1457.967529 
C1111.826904,1444.381104 1121.808228,1437.420410 1135.100220,1437.351074 
C1148.982300,1437.278687 1158.107300,1444.026611 1162.887573,1458.008667 
C1163.745605,1460.518433 1164.299072,1463.132446 1165.043945,1466.118408 
z'
    />
    <path
      fill='#FCFCFC'
      opacity='1.000000'
      stroke='none'
      d='
M132.504669,402.091614 
C140.931885,403.795349 143.449402,406.637604 143.136398,413.638885 
C142.845871,420.137299 139.362579,423.690735 131.773056,424.267975 
C126.202980,424.691620 120.574760,424.350983 114.667313,424.350983 
C114.667313,416.924744 114.667313,409.698792 114.667313,402.047516 
C120.544182,402.047516 126.303055,402.047516 132.504669,402.091614 
z'
    />
    <path
      fill='#FCFCFC'
      opacity='1.000000'
      stroke='none'
      d='
M129.590210,391.062561 
C124.371529,391.083435 119.606209,391.083435 114.629311,391.083435 
C114.525467,389.464783 114.376030,388.165710 114.370140,386.865967 
C114.343910,381.079529 114.358749,375.292877 114.358749,369.131439 
C119.716537,369.131439 124.666313,368.830627 129.565582,369.199921 
C137.490097,369.797119 140.835953,373.047791 141.026489,379.580658 
C141.226456,386.436981 138.168701,389.627869 129.590210,391.062561 
z'
    />
    <path
      fill='#FCFCFC'
      opacity='1.000000'
      stroke='none'
      d='
M113.123047,143.237976 
C114.033318,142.102554 114.927635,140.896942 115.843773,140.880127 
C121.150566,140.782700 126.482704,140.707321 131.767395,141.121063 
C137.862228,141.598267 140.936295,144.862228 141.373947,150.494965 
C141.863464,156.794922 139.362000,161.099518 133.173523,162.143295 
C126.861649,163.207901 120.339417,163.025345 113.117165,163.433594 
C113.117165,156.502151 113.117165,150.109512 113.123047,143.237976 
z'
    />
    <path
      fill='#FCFCFC'
      opacity='1.000000'
      stroke='none'
      d='
M113.115791,112.338753 
C112.766487,109.340805 113.749733,108.216530 116.413269,108.385048 
C120.716858,108.657333 125.043930,108.594292 129.340485,108.933609 
C135.959625,109.456367 138.744354,112.301498 139.113754,118.529099 
C139.495331,124.962311 136.827576,129.035843 130.512115,129.791519 
C124.984146,130.452957 119.314407,129.929550 113.115570,129.929550 
C113.115570,124.302505 113.115570,118.553345 113.115791,112.338753 
z'
    />
    <path
      fill='#FFFFFF'
      opacity='1.000000'
      stroke='none'
      d='
M1224.044922,1764.941895 
C1223.848267,1764.903687 1223.625488,1764.915649 1223.415649,1764.868896 
C1223.374390,1764.859741 1223.383789,1764.623657 1223.369873,1764.492188 
C1223.556885,1764.490845 1223.743774,1764.489502 1223.953369,1764.757812 
C1223.975830,1765.027466 1224.023315,1764.971436 1224.044922,1764.941895 
z'
    />
    <path
      fill='#FCFCFC'
      opacity='1.000000'
      stroke='none'
      d='
M503.037933,1637.925171 
C518.705566,1627.262207 537.455872,1634.117310 542.146423,1652.057983 
C544.669800,1661.709961 544.650940,1671.485718 542.046082,1681.134399 
C538.532104,1694.150635 530.004272,1700.641479 517.201172,1700.346313 
C503.937042,1700.040527 496.399658,1693.771851 493.566528,1679.988647 
C491.571167,1670.281128 491.185547,1660.339844 494.647675,1650.936768 
C496.354370,1646.301514 499.971771,1642.369873 503.037933,1637.925171 
z'
    />
    <path
      fill='#FEFEFE'
      opacity='1.000000'
      stroke='none'
      d='
M966.024902,1661.263916 
C965.316040,1668.971069 965.441650,1676.423828 963.677307,1683.398315 
C960.841064,1694.610229 951.539734,1700.600952 939.677246,1700.334839 
C927.245483,1700.056152 919.976013,1694.649902 916.798035,1682.867798 
C913.974243,1672.398926 913.821899,1661.807861 916.859924,1651.351562 
C920.405151,1639.149902 929.346619,1632.670654 941.559753,1633.083130 
C953.947815,1633.501709 961.809509,1639.986572 964.769470,1652.415771 
C965.421082,1655.152222 965.609436,1657.998901 966.024902,1661.263916 
z'
    />
    <path
      fill='#FCFCFC'
      opacity='1.000000'
      stroke='none'
      d='
M141.067352,271.186554 
C141.557007,272.823273 141.940369,274.057281 142.441711,275.671021 
C134.231339,275.671021 126.406120,275.671021 118.382225,275.671021 
C118.561646,274.947784 118.661240,274.306244 118.878265,273.707275 
C122.650909,263.295105 126.437965,252.888153 130.415405,241.947769 
C134.038162,251.853821 137.499619,261.318817 141.067352,271.186554 
z'
    />
    <path
      fill='#FEFEFE'
      opacity='1.000000'
      stroke='none'
      d='
M609.253174,1644.074707 
C611.001831,1654.695557 605.824402,1661.399292 595.532593,1662.026367 
C591.224304,1662.288940 586.886536,1662.069946 582.188660,1662.069946 
C582.188660,1652.883545 582.188660,1643.677368 582.188660,1633.756836 
C587.798767,1634.050049 593.431702,1634.000000 598.960327,1634.734375 
C604.077759,1635.414185 607.821655,1638.356079 609.253174,1644.074707 
z'
    />
    <path
      fill='#FCFCFC'
      opacity='1.000000'
      stroke='none'
      d='
M1404.216187,1635.449341 
C1410.775146,1638.735474 1413.115479,1643.462158 1412.056152,1650.789429 
C1411.195190,1656.743408 1406.545532,1661.243042 1399.708984,1661.877319 
C1394.780151,1662.334595 1389.774658,1661.966309 1384.164307,1661.966309 
C1384.164307,1657.376343 1384.164307,1652.776733 1384.164307,1648.177246 
C1384.164307,1643.701904 1384.164307,1639.226562 1384.164307,1633.506714 
C1390.899292,1634.102173 1397.385620,1634.675537 1404.216187,1635.449341 
z'
    />
    <path
      fill='#FCFCFC'
      opacity='1.000000'
      stroke='none'
      d='
M704.051758,1795.995972 
C704.859131,1798.390381 705.567688,1800.394165 706.422546,1802.811279 
C696.701965,1802.811279 687.489441,1802.811279 677.494873,1802.811279 
C682.151917,1789.246948 686.741943,1775.877808 691.791199,1761.171265 
C696.102112,1773.376831 700.027527,1784.490967 704.051758,1795.995972 
z'
    />
    <path
      fill='#FCFCFC'
      opacity='1.000000'
      stroke='none'
      d='
M862.150146,1798.143677 
C862.699158,1799.939331 863.123596,1801.325806 863.616577,1802.936035 
C853.863037,1802.936035 844.573059,1802.936035 834.767578,1802.936035 
C839.511902,1789.217896 844.150269,1775.805908 849.217346,1761.154541 
C853.779541,1774.183838 857.902588,1785.959106 862.150146,1798.143677 
z'
    />
    <path
      fill='#FCFCFC'
      opacity='1.000000'
      stroke='none'
      d='
M764.564941,1677.809814 
C764.917114,1674.702271 765.525208,1671.643311 766.515320,1668.713379 
C770.019714,1658.344482 773.654358,1648.019775 777.243958,1637.679688 
C777.296265,1637.529053 777.403870,1637.397461 778.002930,1636.367798 
C782.952026,1650.465088 787.680908,1663.935181 792.589539,1677.917358 
C782.902710,1677.917358 773.949402,1677.917358 764.564941,1677.809814 
z'
    />
    <path
      fill='#FCFCFC'
      opacity='1.000000'
      stroke='none'
      d='
M304.904907,265.449249 
C305.432159,267.404663 305.803406,268.990631 306.251923,270.906860 
C297.864471,270.906860 289.937347,270.906860 282.002747,270.906860 
C282.318970,264.640839 285.218994,260.680389 290.380798,259.358429 
C296.961853,257.672974 301.266693,259.387207 304.904907,265.449249 
z'
    />
    <path
      fill='#FCFCFC'
      opacity='1.000000'
      stroke='none'
      d='
M527.655884,271.119202 
C527.312744,269.381042 526.936707,267.463257 527.574707,265.982483 
C529.945557,260.480316 535.815308,257.806152 542.037415,259.038727 
C547.318237,260.084839 549.976990,263.805878 550.440247,271.140198 
C542.977844,271.140198 535.533142,271.140198 527.655884,271.119202 
z'
    />
    <path
      fill='#FCFCFC'
      opacity='1.000000'
      stroke='none'
      d='
M351.008362,427.547394 
C346.850067,427.321564 343.468658,426.410858 343.089478,421.930054 
C342.701233,417.342468 345.809296,415.432648 349.647980,414.593323 
C353.817902,413.681549 358.057861,413.090179 362.200592,412.370697 
C364.968048,421.953308 361.906799,426.026917 351.008362,427.547394 
z'
    />
    <path
      fill='#FCFCFC'
      opacity='1.000000'
      stroke='none'
      d='
M286.218384,397.435486 
C288.396240,392.750732 291.429688,390.057281 296.520386,389.453766 
C304.238556,388.538696 308.765503,392.292175 309.765717,401.470703 
C301.704254,401.470703 293.666443,401.470703 285.416229,401.470703 
C285.627502,400.329346 285.862030,399.062286 286.218384,397.435486 
z'
    />
    <path
      fill='#FCFCFC'
      opacity='1.000000'
      stroke='none'
      d='
M1355.267456,1278.015137 
C1356.688110,1285.660034 1353.652710,1290.190186 1346.528809,1291.072266 
C1343.607544,1291.433838 1340.562744,1291.424805 1337.642822,1291.049683 
C1329.160034,1289.959839 1325.354126,1281.610352 1330.590210,1274.825684 
C1333.022461,1271.674072 1336.901123,1269.617920 1340.214600,1267.188477 
C1340.748901,1266.796753 1341.916504,1266.742432 1342.520630,1267.055176 
C1347.509155,1269.638550 1352.862793,1271.835693 1355.267456,1278.015137 
z'
    />
    <path
      fill='#FCFCFC'
      opacity='1.000000'
      stroke='none'
      d='
M1353.758301,1245.063843 
C1353.465332,1246.729858 1353.553223,1248.437866 1352.744507,1249.225464 
C1349.507446,1252.378052 1345.706665,1257.892822 1342.650146,1257.563477 
C1338.610229,1257.128052 1334.206543,1252.629517 1331.549194,1248.779785 
C1328.547241,1244.430664 1331.499756,1238.474243 1336.332397,1236.491211 
C1342.955933,1233.773315 1351.043213,1236.315796 1353.041504,1241.779419 
C1353.380737,1242.706665 1353.503906,1243.713013 1353.758301,1245.063843 
z'
    />
    <path
      fill='#FCFCFC'
      opacity='1.000000'
      stroke='none'
      d='
M1453.599854,1270.287109 
C1455.300171,1271.669067 1456.873535,1272.684326 1458.055298,1274.040894 
C1460.738892,1277.121216 1461.809326,1280.687012 1460.280884,1284.680420 
C1458.770996,1288.625366 1455.849976,1290.577515 1451.640991,1291.174805 
C1438.868896,1292.987427 1431.732422,1287.896606 1433.925293,1278.325562 
C1434.849854,1274.291138 1442.315918,1266.788574 1446.154541,1266.984009 
C1448.580811,1267.107422 1450.917969,1268.984741 1453.599854,1270.287109 
z'
    />
    <path
      fill='#FCFCFC'
      opacity='1.000000'
      stroke='none'
      d='
M1441.155273,1236.641357 
C1444.286133,1236.242188 1447.106934,1235.673096 1449.838623,1235.958618 
C1457.643677,1236.774048 1461.284790,1243.792603 1457.037598,1250.340454 
C1455.147461,1253.254639 1451.870361,1255.275757 1449.184692,1257.659302 
C1448.844238,1257.961304 1448.276733,1258.123047 1447.805542,1258.143311 
C1444.844238,1258.271118 1437.144165,1251.664307 1436.129150,1248.172119 
C1434.766479,1243.483765 1436.274780,1239.835083 1441.155273,1236.641357 
z'
    />
    <path
      fill='#FCFCFC'
      opacity='1.000000'
      stroke='none'
      d='
M1500.621094,1235.878418 
C1505.684326,1236.471313 1508.493774,1239.317871 1509.993164,1243.483398 
C1510.881836,1245.952271 1511.587524,1248.553711 1511.896973,1251.152466 
C1513.025513,1260.626831 1510.953491,1263.067627 1501.409302,1263.983032 
C1491.690552,1264.915161 1486.974609,1261.425781 1486.088257,1252.843750 
C1485.238647,1244.618408 1489.205444,1234.522339 1500.621094,1235.878418 
z'
    />
    <path
      fill='#272727'
      opacity='1.000000'
      stroke='none'
      d='
M1242.051270,484.041748 
C1261.503174,450.753967 1287.887817,424.945587 1321.207520,406.421570 
C1355.949463,387.106812 1393.341675,378.659149 1433.048584,380.896118 
C1481.321655,383.615662 1523.582642,401.208221 1559.611816,433.323517 
C1596.489868,466.195587 1619.011353,507.270996 1626.590820,556.060181 
C1632.929932,596.864990 1627.471558,636.302979 1609.942261,673.894531 
C1590.669922,715.224426 1561.013062,747.030823 1521.165771,768.943726 
C1478.847168,792.215515 1433.546265,799.377319 1385.933105,791.304749 
C1343.104492,784.043396 1306.225342,764.729614 1275.564209,734.257446 
C1242.060547,700.960449 1221.878418,660.684448 1215.858521,613.569336 
C1211.219727,577.263550 1215.885620,542.196594 1229.947388,508.455566 
C1233.387451,500.200928 1237.878784,492.384491 1242.051270,484.041748 
M1473.036865,409.318359 
C1459.282349,407.048248 1445.604980,403.864685 1431.757446,402.697784 
C1402.708740,400.249969 1374.658203,405.663605 1348.038086,417.275818 
C1310.777466,433.529724 1281.542358,459.225677 1261.047119,494.459564 
C1237.366089,535.169739 1230.078979,578.978210 1239.718018,624.872192 
C1250.848999,677.869873 1280.055542,719.065613 1326.795044,746.575134 
C1380.331299,778.084839 1437.010986,782.239258 1493.939209,757.873657 
C1554.935059,731.767090 1591.951050,684.636414 1604.451416,619.213440 
C1610.404785,588.055664 1607.549561,557.273499 1597.174805,527.210693 
C1585.928711,494.623322 1566.906982,467.379608 1540.624390,445.277466 
C1520.921997,428.708801 1498.578125,416.807312 1473.036865,409.318359 
z'
    />
    <path
      fill='#282828'
      opacity='1.000000'
      stroke='none'
      d='
M1315.104980,292.849396 
C1314.562866,288.641754 1314.664062,284.529541 1313.242432,281.037140 
C1306.604980,264.731293 1306.929565,249.030075 1317.482056,234.613495 
C1330.491699,216.839996 1351.113403,211.663712 1372.248047,219.426407 
C1382.939575,223.353439 1394.013306,226.240356 1404.142456,229.359879 
C1407.553223,224.199188 1410.152832,220.265747 1411.658691,217.987213 
C1409.479736,215.019928 1407.034912,212.088821 1405.030640,208.882294 
C1400.155762,201.082687 1401.074219,192.657104 1407.388672,184.894104 
C1415.541870,174.870499 1416.282837,173.487762 1418.115112,163.797668 
C1412.322876,166.088531 1407.336060,168.060837 1402.244263,170.074646 
C1402.244263,164.169724 1402.244263,157.811905 1402.244263,151.677719 
C1407.122803,153.679520 1412.167358,155.749435 1417.212036,157.819351 
C1417.633789,157.338013 1418.055664,156.856674 1418.477539,156.375336 
C1416.429321,151.460999 1414.381104,146.546646 1412.252808,141.440063 
C1418.407104,141.440063 1424.612549,141.440063 1430.922119,141.440063 
C1428.843628,146.435944 1426.792236,151.366882 1424.740723,156.297821 
C1425.112061,156.773056 1425.483398,157.248291 1425.854736,157.723526 
C1430.783569,155.768234 1435.712280,153.812943 1440.819580,151.786819 
C1440.819580,157.680206 1440.819580,164.010681 1440.819580,170.131104 
C1436.114014,168.173431 1431.201294,166.129532 1425.367310,163.702362 
C1425.955322,172.024918 1429.350586,177.488632 1433.770142,182.476776 
C1437.810669,187.036911 1441.284180,191.833603 1441.152588,198.344025 
C1440.985229,206.630920 1436.929321,212.476364 1430.241211,216.157639 
C1432.832397,219.990356 1435.380981,223.760101 1438.479858,228.343750 
C1448.316650,227.369858 1458.773071,224.487625 1468.912109,220.293381 
C1479.337524,215.980530 1490.045776,214.157516 1501.070435,217.493454 
C1528.403198,225.763962 1541.035522,252.504242 1530.464600,279.401703 
C1529.616455,281.559601 1528.609375,283.685974 1528.051025,285.920654 
C1526.567749,291.854950 1528.381836,296.316101 1533.522949,299.561707 
C1535.472412,300.792419 1537.607422,301.729126 1540.182617,303.073975 
C1530.586670,327.151581 1520.980469,351.254974 1511.262695,375.638306 
C1451.495239,351.710327 1392.027954,351.655853 1331.936157,375.641296 
C1322.321655,351.558929 1312.693726,327.442566 1303.542480,304.520660 
C1307.737427,300.403748 1311.391968,296.817047 1315.104980,292.849396 
M1348.636230,300.693878 
C1349.013672,300.788361 1349.391235,300.882812 1349.768677,300.977295 
C1349.515381,300.649078 1349.261963,300.320862 1349.039795,299.217804 
C1348.109253,293.195770 1346.669922,287.187714 1346.503662,281.144653 
C1346.438843,278.791351 1349.243286,276.359100 1350.740723,273.962860 
C1353.067993,275.585938 1356.472290,276.705048 1357.513428,278.929962 
C1360.249023,284.775574 1361.955933,291.102570 1363.945435,296.869385 
C1368.064941,292.186615 1372.090454,290.747375 1376.740112,292.896576 
C1380.960938,294.847565 1383.166748,298.349762 1382.682373,302.895172 
C1382.240234,307.044250 1380.111816,310.303894 1375.381348,311.263336 
C1375.381348,310.492615 1375.339233,310.024292 1375.388062,309.565613 
C1375.793335,305.754120 1374.141235,303.195831 1370.313110,303.143219 
C1366.475098,303.090424 1364.735474,305.651245 1364.984375,309.442017 
C1365.070801,310.758026 1365.196289,312.098969 1365.535400,313.366577 
C1368.505249,324.468781 1379.435547,331.344879 1392.240356,330.219696 
C1404.417114,329.149658 1414.447021,319.983154 1415.497070,308.964813 
C1406.904297,309.714630 1403.555786,311.639008 1390.315430,323.506317 
C1390.315430,310.174622 1390.315430,297.038513 1390.315430,283.090485 
C1397.173950,291.737701 1405.218140,297.051788 1416.185425,298.107513 
C1414.069946,293.531830 1411.323608,289.386597 1408.840210,285.089325 
C1407.613281,282.966217 1406.091431,280.579773 1406.040894,278.282990 
C1405.766968,265.833344 1405.911011,253.374512 1405.911011,242.130676 
C1391.435059,237.639954 1377.756836,233.197327 1363.956665,229.173294 
C1350.861084,225.354721 1338.996460,228.190887 1329.713257,238.186569 
C1319.844238,248.813019 1317.855103,261.539185 1323.746216,274.755737 
C1329.460449,287.574982 1329.212158,298.875793 1317.865112,308.589142 
C1322.674438,320.558228 1327.412964,332.351013 1332.402954,344.769928 
C1336.516724,342.806732 1340.316284,341.472229 1343.595459,339.338074 
C1353.100342,333.152161 1357.162109,320.720612 1352.846313,311.892242 
C1351.359741,308.851196 1349.023560,307.075989 1345.593384,308.670837 
C1342.330566,310.187866 1341.549561,312.871613 1343.109741,316.149933 
C1343.447510,316.859619 1343.876709,317.525818 1344.327515,318.325195 
C1336.842896,318.996857 1332.105469,314.384430 1332.876099,307.507812 
C1333.678955,300.343597 1339.974243,297.422668 1348.636230,300.693878 
M1452.220459,283.885834 
C1452.500732,285.216553 1453.015503,286.545807 1453.024048,287.878296 
C1453.091431,298.375488 1453.072266,308.873352 1453.049194,319.370911 
C1453.046265,320.721375 1452.866699,322.071442 1452.723999,324.045013 
C1445.767334,315.493103 1438.020020,309.934357 1427.260376,308.797089 
C1431.007080,325.071381 1446.047119,333.780609 1461.480103,329.200317 
C1471.564575,326.207367 1478.574951,317.583557 1478.204590,308.715332 
C1478.064697,305.365417 1476.442505,303.238922 1473.110718,303.119263 
C1469.761841,302.998962 1467.934814,305.014069 1467.696777,308.366394 
C1467.633545,309.256409 1467.687256,310.154724 1467.687256,311.357452 
C1462.684204,309.889862 1460.529541,306.457825 1460.458740,302.040710 
C1460.390259,297.758362 1462.577026,294.374481 1466.782837,292.764404 
C1472.357544,290.630371 1476.379028,293.128723 1479.291138,297.038361 
C1481.049683,291.571564 1482.560669,285.855347 1484.759521,280.417175 
C1486.100098,277.101898 1488.582397,272.730103 1492.536133,274.414856 
C1494.877686,275.412689 1496.701416,280.267456 1496.751953,283.420074 
C1496.842163,289.055237 1495.415649,294.714691 1494.609375,300.462433 
C1499.395874,298.109100 1504.145874,297.929688 1508.026367,302.309540 
C1510.955444,305.615631 1511.346313,309.579926 1509.272949,313.435394 
C1507.147461,317.387909 1503.720337,319.206696 1500.353027,318.699951 
C1500.032227,315.352509 1500.231079,312.500610 1499.309814,310.073914 
C1498.902954,309.002228 1495.382690,307.811371 1494.730225,308.370819 
C1492.512695,310.272308 1489.958862,312.683441 1489.293335,315.340759 
C1486.014526,328.432556 1497.322021,342.807404 1511.292603,343.597351 
C1515.629639,332.719177 1520.047852,321.791626 1524.272949,310.789978 
C1524.674805,309.743652 1524.325684,307.767487 1523.553345,307.009491 
C1514.291870,297.920166 1513.715698,287.659607 1518.906494,276.390411 
C1522.336304,268.944244 1523.641235,261.136902 1521.559204,253.079544 
C1516.278198,232.641891 1496.100342,222.986115 1475.549194,230.191833 
C1464.162964,234.184128 1452.332153,236.956528 1440.605591,239.895493 
C1437.823364,240.592773 1437.190796,241.610565 1437.213135,244.170578 
C1437.312134,255.500473 1437.410156,266.835571 1437.127930,278.159363 
C1437.070068,280.477509 1435.831421,283.119415 1434.343750,284.976532 
C1431.057373,289.079346 1427.925903,293.093506 1427.477051,298.728088 
C1437.684570,296.957184 1445.590820,292.145813 1452.220459,283.885834 
M1493.463501,301.654755 
C1493.556885,301.574127 1493.712891,301.502319 1493.725830,301.410309 
C1493.738892,301.318390 1493.608887,301.206177 1493.541382,301.102844 
C1493.447998,301.183441 1493.354492,301.264038 1493.463501,301.654755 
z'
    />
    <path
      fill='#272727'
      opacity='1.000000'
      stroke='none'
      d='
M1384.015869,829.694702 
C1391.120117,829.694641 1397.727173,829.694641 1405.357666,829.694641 
C1397.110840,839.831909 1389.493408,849.202820 1381.867310,858.566650 
C1376.397705,865.282593 1370.902710,871.977905 1365.445068,878.703430 
C1361.461914,883.611877 1361.486816,884.858215 1365.795166,889.765869 
C1379.314697,905.166199 1392.862061,920.542236 1406.394287,935.931458 
C1408.026123,937.787292 1409.631592,939.666138 1412.043335,942.451233 
C1402.938721,942.451233 1394.794556,941.765930 1386.816406,942.624817 
C1376.856812,943.697083 1370.260376,940.407227 1364.433960,932.128906 
C1356.112549,920.305908 1346.400513,909.461609 1337.283691,898.198303 
C1334.246948,894.446655 1328.712891,892.435730 1324.579956,894.278748 
C1323.389038,894.809875 1322.556641,897.422546 1322.534668,899.093689 
C1322.368164,911.755859 1322.444092,924.421143 1322.444336,937.085510 
C1322.444458,938.703918 1322.444336,940.322327 1322.444336,942.171875 
C1312.673950,942.171875 1303.413940,942.171875 1293.804321,942.171875 
C1293.804321,904.812256 1293.804321,867.591309 1293.804321,830.037720 
C1303.227173,830.037720 1312.614990,830.037720 1322.443115,830.037720 
C1322.443115,843.316833 1322.351440,856.456238 1322.526611,869.592102 
C1322.558594,871.990967 1323.386963,876.287354 1324.346558,876.433533 
C1328.377808,877.047485 1332.832764,878.266846 1336.222900,873.913635 
C1346.046143,861.299500 1356.373291,849.069336 1365.935547,836.264832 
C1369.737183,831.174377 1373.745972,828.564880 1380.024292,829.666443 
C1381.155884,829.865051 1382.352295,829.694702 1384.015869,829.694702 
z'
    />
    <path
      fill='#272727'
      opacity='1.000000'
      stroke='none'
      d='
M1525.770142,916.730713 
C1510.634277,916.730957 1495.971069,916.822693 1481.310669,916.667786 
C1477.761719,916.630371 1475.901489,917.784668 1474.765015,921.231079 
C1472.738525,927.376648 1470.304688,933.393860 1467.858887,939.390381 
C1467.379272,940.566772 1466.094604,942.248291 1465.147095,942.271057 
C1456.045044,942.489319 1446.935669,942.401611 1437.074097,942.401611 
C1441.835571,930.981689 1446.293457,920.313965 1450.732544,909.638428 
C1461.192017,884.484009 1471.700684,859.349731 1482.024536,834.139771 
C1483.335815,830.937500 1484.798340,829.541199 1488.488037,829.637939 
C1499.477051,829.926086 1510.481567,829.617798 1521.472046,829.877441 
C1523.084961,829.915588 1525.513916,831.412537 1526.119019,832.845337 
C1541.174805,868.498474 1556.036987,904.233276 1570.921631,939.958557 
C1571.157715,940.525452 1571.245361,941.154114 1571.572632,942.405273 
C1561.731567,942.405273 1552.292480,942.489258 1542.859863,942.276794 
C1541.905396,942.255310 1540.596680,940.605042 1540.125000,939.438660 
C1537.759155,933.588928 1535.399170,927.718567 1533.475586,921.714966 
C1532.257080,917.912170 1530.251465,916.082947 1525.770142,916.730713 
M1517.975952,880.507690 
C1514.634644,871.847046 1511.387085,863.147888 1507.867432,854.560303 
C1507.215820,852.970581 1505.465820,851.831055 1504.222778,850.483826 
C1502.828857,851.856445 1500.808716,852.977905 1500.141235,854.641846 
C1495.267334,866.795166 1490.654541,879.053406 1485.991455,891.290833 
C1485.488647,892.610291 1485.190186,894.007629 1484.729736,895.601685 
C1497.852295,895.601685 1510.369263,895.601685 1523.762573,895.601685 
C1521.753540,890.417725 1519.977417,885.834229 1517.975952,880.507690 
z'
    />
    <path
      fill='#272727'
      opacity='1.000000'
      stroke='none'
      d='
M1635.882812,861.726013 
C1636.580688,867.161560 1640.289673,869.047791 1644.521729,869.873779 
C1655.774902,872.070068 1667.182129,873.567200 1678.326538,876.196899 
C1685.180176,877.814087 1692.164917,880.141968 1698.205200,883.667786 
C1709.558838,890.294983 1710.894165,901.845032 1709.779297,913.512878 
C1708.630371,925.536377 1701.494263,933.484985 1690.446655,938.008118 
C1674.262939,944.634216 1657.299438,944.815796 1640.312622,943.410034 
C1630.065186,942.561951 1619.919556,940.501892 1609.721313,939.033813 
C1606.971680,938.637939 1605.854858,937.411316 1605.989014,934.422058 
C1606.256470,928.465698 1606.068237,922.488892 1606.068237,917.561340 
C1622.312378,919.425598 1638.275024,921.502319 1654.294189,922.955750 
C1659.507812,923.428833 1665.086426,923.036438 1670.089966,921.609253 
C1673.706665,920.577637 1677.846924,917.857483 1679.629272,914.693604 
C1682.811401,909.044983 1679.640137,903.000122 1672.836670,901.300659 
C1663.823730,899.049377 1654.462891,898.184448 1645.459839,895.901978 
C1636.672363,893.674316 1627.645142,891.407837 1619.628418,887.363647 
C1608.523438,881.761475 1605.872437,871.008240 1606.621094,859.284180 
C1607.400635,847.076782 1613.741577,838.838623 1624.833496,834.100464 
C1635.293091,829.632385 1646.402954,828.565918 1657.582520,828.472595 
C1673.099731,828.343201 1688.477295,829.733459 1703.677979,834.235168 
C1703.677979,840.921753 1703.677979,847.528137 1703.677979,854.263184 
C1693.189575,852.739014 1682.781006,850.739807 1672.278564,849.857788 
C1664.204712,849.179688 1655.969849,849.425232 1647.885254,850.144775 
C1639.530151,850.888489 1636.289429,854.440979 1635.882812,861.726013 
z'
    />
    <path
      fill='#272727'
      opacity='1.000000'
      stroke='none'
      d='
M1215.921875,940.017334 
C1197.512329,945.416992 1179.334351,945.601624 1161.357056,940.485718 
C1145.014893,935.835144 1134.827637,922.854004 1134.003906,905.053345 
C1133.073120,884.942139 1133.271240,864.778259 1133.007812,844.636841 
C1132.945068,839.836243 1132.998657,835.034241 1132.998657,829.971680 
C1142.733276,829.971680 1152.120605,829.971680 1161.998657,829.971680 
C1161.998657,831.669250 1161.998657,833.290649 1161.998657,834.912048 
C1161.998657,853.898499 1161.995239,872.885010 1162.003296,891.871460 
C1162.004272,894.036011 1161.972778,896.207092 1162.120239,898.363953 
C1162.741455,907.455566 1164.431030,916.423462 1173.642944,920.630249 
C1183.957886,925.340820 1194.733765,925.221313 1204.909790,919.756165 
C1210.232666,916.897339 1212.739624,911.630615 1213.764282,905.908203 
C1214.551758,901.511047 1214.891724,896.982605 1214.919800,892.509399 
C1215.040161,873.357117 1214.971191,854.203613 1214.971313,835.050598 
C1214.971313,833.421814 1214.971313,831.793091 1214.971313,829.939209 
C1224.292114,829.939209 1233.199707,829.939209 1242.298218,829.939209 
C1242.429077,831.086121 1242.641968,832.050171 1242.633789,833.012329 
C1242.437256,856.154724 1242.697632,879.314636 1241.843872,902.433289 
C1241.200928,919.843262 1233.626343,933.432495 1215.921875,940.017334 
z'
    />
    <path
      fill='#2B2B2B'
      opacity='1.000000'
      stroke='none'
      d='
M1162.960083,993.293457 
C1162.684326,989.857239 1162.426270,986.879028 1162.040771,982.429932 
C1160.684570,985.287170 1159.852295,986.901184 1159.138916,988.566101 
C1154.102173,1000.324219 1149.009521,1012.059692 1144.129883,1023.882935 
C1142.994751,1026.633179 1141.818359,1028.051758 1138.476685,1028.081543 
C1135.204346,1028.110474 1134.219482,1026.532715 1133.186279,1024.056030 
C1127.696533,1010.896057 1122.102905,997.779419 1115.391602,984.718567 
C1114.077271,1001.760620 1112.762939,1018.802734 1111.438477,1035.976807 
C1108.380127,1035.976807 1105.759155,1035.976807 1102.523438,1035.976807 
C1104.206909,1014.483765 1105.875732,993.177429 1107.579468,971.424622 
C1111.357422,971.424622 1114.702759,971.088806 1117.917114,971.591492 
C1119.186401,971.789917 1120.603516,973.671265 1121.205200,975.101135 
C1127.003662,988.879211 1132.642456,1002.724487 1138.630249,1017.288269 
C1140.172485,1013.810181 1141.524536,1010.892822 1142.769165,1007.930359 
C1147.079956,997.669250 1151.643066,987.499817 1155.505981,977.071716 
C1157.180908,972.550354 1159.435547,970.642822 1164.141357,971.370972 
C1165.905396,971.643921 1167.747192,971.415283 1169.826904,971.415283 
C1171.550171,993.060730 1173.238037,1014.261902 1174.953979,1035.816406 
C1172.008057,1035.816406 1169.276001,1035.816406 1165.988159,1035.816406 
C1164.989746,1021.865356 1163.983765,1007.808411 1162.960083,993.293457 
z'
    />
    <path
      fill='#2B2B2B'
      opacity='1.000000'
      stroke='none'
      d='
M1517.183838,1001.884888 
C1514.600464,995.782532 1512.153687,990.036255 1509.706909,984.289978 
C1509.387939,984.335449 1509.069092,984.380981 1508.750244,984.426453 
C1507.447510,1001.424988 1506.144897,1018.423462 1504.814331,1035.784546 
C1502.045166,1035.784546 1499.308594,1035.784546 1495.872681,1035.784546 
C1497.545288,1014.574829 1499.226562,993.254883 1500.905029,971.970886 
C1501.673706,971.730957 1502.123291,971.480652 1502.581543,971.463745 
C1513.062744,971.077881 1513.047607,971.088806 1517.047974,980.878235 
C1521.869751,992.678040 1526.720825,1004.465881 1532.018921,1017.379395 
C1533.638550,1013.627136 1534.857178,1010.878540 1536.016357,1008.105286 
C1540.372192,997.683899 1544.929810,987.338562 1548.944092,976.786865 
C1550.562866,972.531982 1552.716919,970.583923 1557.281372,971.366211 
C1559.038086,971.667236 1560.889771,971.415283 1563.182617,971.415283 
C1564.893677,992.949219 1566.578979,1014.160217 1568.296143,1035.771973 
C1565.323730,1035.771973 1562.599854,1035.771973 1559.346680,1035.771973 
C1558.111694,1018.798096 1556.864868,1001.663452 1555.618042,984.528748 
C1555.259399,984.452026 1554.900757,984.375244 1554.541992,984.298523 
C1553.745728,985.981689 1552.894775,987.641541 1552.161865,989.351868 
C1547.123657,1001.108704 1542.020996,1012.839478 1537.158569,1024.668945 
C1536.091309,1027.265625 1534.744263,1028.058594 1532.016602,1028.025635 
C1529.359253,1027.993408 1527.887207,1027.406494 1526.833862,1024.725098 
C1523.859619,1017.153137 1520.517578,1009.725586 1517.183838,1001.884888 
z'
    />
    <path
      fill='#2B2B2B'
      opacity='1.000000'
      stroke='none'
      d='
M1522.062012,1082.873413 
C1524.905029,1089.833862 1527.636841,1096.426392 1530.750244,1103.940063 
C1537.359985,1088.178833 1543.679932,1073.108643 1549.930908,1058.203003 
C1554.079102,1058.203003 1557.860352,1058.203003 1561.895386,1058.203003 
C1563.598389,1079.719604 1565.285156,1101.029175 1566.992310,1122.598145 
C1563.881836,1122.598145 1561.279785,1122.598145 1558.074097,1122.598145 
C1556.795898,1105.197510 1555.516113,1087.777222 1554.236450,1070.357056 
C1553.917969,1070.315308 1553.599609,1070.273682 1553.281128,1070.231934 
C1547.557251,1083.608032 1541.741455,1096.946045 1536.183472,1110.390747 
C1535.003052,1113.246094 1533.665771,1114.450806 1530.439697,1114.413086 
C1527.583008,1114.379517 1526.380127,1113.355957 1525.361206,1110.876221 
C1520.629395,1099.361328 1515.727783,1087.915894 1510.855713,1076.458862 
C1510.114380,1074.715210 1509.209351,1073.041260 1507.390991,1071.479858 
C1506.089233,1088.444092 1504.787354,1105.408203 1503.469971,1122.575317 
C1500.478027,1122.575317 1497.895996,1122.575317 1494.562744,1122.575317 
C1496.234741,1101.072632 1497.891235,1079.768555 1499.565674,1058.232910 
C1503.842163,1058.232910 1507.771240,1058.232910 1511.952026,1058.232910 
C1515.252930,1066.246216 1518.601685,1074.375854 1522.062012,1082.873413 
z'
    />
    <path
      fill='#2B2B2B'
      opacity='1.000000'
      stroke='none'
      d='
M1676.332153,1006.990356 
C1676.332153,995.035217 1676.332153,983.578003 1676.332153,971.769897 
C1679.401245,971.769897 1682.114868,971.769897 1685.077393,971.769897 
C1685.077393,993.140686 1685.077393,1014.388062 1685.077393,1035.622437 
C1675.685303,1037.207764 1675.507080,1037.128784 1671.121948,1029.088501 
C1663.348145,1014.834839 1655.581055,1000.577393 1646.932617,986.424072 
C1646.932617,1002.849976 1646.932617,1019.275879 1646.932617,1035.921021 
C1643.680420,1035.921021 1641.076538,1035.921021 1638.133667,1035.921021 
C1638.133667,1014.594177 1638.133667,993.244446 1638.133667,971.417664 
C1641.086304,971.417664 1643.970703,970.998413 1646.638062,971.578125 
C1648.187622,971.914917 1649.849976,973.603516 1650.674316,975.113586 
C1658.233398,988.958740 1665.617798,1002.899109 1673.059937,1016.808167 
C1673.798828,1018.189026 1674.582764,1019.545898 1676.332153,1020.673950 
C1676.332153,1016.278748 1676.332153,1011.883545 1676.332153,1006.990356 
z'
    />
    <path
      fill='#2B2B2B'
      opacity='1.000000'
      stroke='none'
      d='
M1300.164917,1018.998962 
C1300.164917,1024.812500 1300.164917,1030.126099 1300.164917,1035.392700 
C1291.361572,1037.537720 1290.374146,1037.132568 1286.334961,1029.730469 
C1278.465698,1015.309082 1270.606445,1000.882202 1261.907349,986.482300 
C1261.907349,1002.864685 1261.907349,1019.247070 1261.907349,1035.885376 
C1258.442261,1035.885376 1255.710327,1035.885376 1252.858398,1035.885376 
C1252.858398,1014.427795 1252.858398,993.185303 1252.858398,971.984558 
C1262.943237,970.302368 1263.037354,970.346436 1267.422607,978.530334 
C1274.995728,992.663025 1282.569702,1006.795166 1290.936768,1020.748901 
C1290.936768,1004.580811 1290.936768,988.412781 1290.936768,971.831787 
C1294.080688,971.831787 1296.790771,971.831787 1300.164917,971.831787 
C1300.164917,987.351685 1300.164917,1002.925415 1300.164917,1018.998962 
z'
    />
    <path
      fill='#2B2B2B'
      opacity='1.000000'
      stroke='none'
      d='
M1394.093262,980.755127 
C1389.018188,983.278198 1387.199829,987.392639 1387.103760,992.350952 
C1386.965088,999.508911 1386.921143,1006.672974 1387.047119,1013.830750 
C1387.211792,1023.192139 1391.551880,1027.863647 1400.839478,1028.880371 
C1402.815796,1029.096680 1404.832764,1029.113892 1406.821411,1029.019653 
C1420.640503,1028.364990 1422.312256,1026.295288 1420.389526,1011.845337 
C1416.218750,1011.845337 1411.963867,1011.845337 1407.439941,1011.845337 
C1407.439941,1009.140564 1407.439941,1006.889954 1407.439941,1004.304993 
C1414.437134,1004.304993 1421.482544,1004.304993 1428.944824,1004.304993 
C1428.944824,1012.561462 1429.036865,1020.681213 1428.835205,1028.793701 
C1428.808228,1029.880127 1427.524048,1031.388550 1426.438232,1031.926025 
C1414.698730,1037.736084 1402.540283,1038.800903 1390.205444,1034.140259 
C1382.374878,1031.181519 1378.560791,1024.944336 1378.225464,1016.770081 
C1377.911743,1009.122009 1377.872803,1001.449158 1378.072876,993.796631 
C1378.421509,980.463440 1383.727051,973.505249 1396.991943,971.683777 
C1406.038330,970.441528 1415.406860,971.545593 1424.806885,971.601624 
C1424.806885,975.103760 1424.806885,977.223816 1424.806885,978.413818 
C1414.617798,979.136780 1404.527466,979.852722 1394.093262,980.755127 
z'
    />
    <path
      fill='#2B2B2B'
      opacity='1.000000'
      stroke='none'
      d='
M1313.136230,1030.057373 
C1320.243042,1010.324402 1327.235474,990.964478 1334.243774,971.560791 
C1338.151245,971.560791 1341.797119,971.560791 1345.879028,971.560791 
C1353.530884,992.838623 1361.217407,1014.212646 1368.897949,1035.570312 
C1368.356812,1035.823120 1368.076172,1036.061401 1367.785522,1036.074341 
C1359.744385,1036.432007 1359.744141,1036.428223 1357.103149,1028.897461 
C1355.627563,1024.689331 1354.152222,1020.481262 1352.655273,1016.211670 
C1344.302124,1016.211670 1336.155518,1016.211670 1327.412720,1016.211670 
C1326.018799,1020.142517 1324.515869,1024.285400 1323.079468,1028.451294 
C1320.300781,1036.510376 1320.316284,1036.515747 1311.316895,1035.875732 
C1311.903687,1034.001831 1312.462769,1032.216187 1313.136230,1030.057373 
M1337.704834,986.156616 
C1335.244751,993.326172 1332.784790,1000.495667 1330.226685,1007.950867 
C1336.974365,1007.950867 1343.071045,1007.950867 1349.789307,1007.950867 
C1346.597290,998.636292 1343.536377,989.704834 1340.051758,979.536621 
C1339.022339,982.397522 1338.480835,983.902649 1337.704834,986.156616 
z'
    />
    <path
      fill='#2B2B2B'
      opacity='1.000000'
      stroke='none'
      d='
M1185.948975,1029.916748 
C1192.393066,1011.862549 1198.811890,994.219116 1205.023804,976.503235 
C1206.252686,972.998657 1207.487549,970.734619 1211.900879,971.296509 
C1215.630859,971.771301 1218.734253,970.885193 1220.483276,976.231750 
C1226.627930,995.015747 1233.654053,1013.511353 1240.334351,1032.120483 
C1240.721191,1033.198120 1241.009888,1034.311035 1241.466431,1035.808350 
C1238.460571,1035.808350 1235.740845,1035.808350 1232.337402,1035.808350 
C1230.512207,1030.635254 1228.467651,1025.088379 1226.618042,1019.477173 
C1225.864990,1017.192444 1224.965942,1015.903687 1222.169312,1015.992249 
C1215.014404,1016.218628 1207.847534,1016.067627 1200.153687,1016.067627 
C1198.660278,1020.340332 1197.140259,1024.670410 1195.633423,1029.005127 
C1192.985596,1036.621460 1192.988892,1036.622559 1183.839478,1035.801514 
C1184.541382,1033.882812 1185.196289,1032.092407 1185.948975,1029.916748 
M1204.585083,1003.081238 
C1204.083252,1004.630371 1203.581299,1006.179504 1203.038452,1007.854797 
C1209.550659,1007.854797 1215.751831,1007.854797 1222.495239,1007.854797 
C1219.248047,998.402466 1216.154053,989.395874 1212.696045,979.329529 
C1209.829590,987.753784 1207.349854,995.041321 1204.585083,1003.081238 
z'
    />
    <path
      fill='#313131'
      opacity='1.000000'
      stroke='none'
      d='
M1443.262573,976.277710 
C1443.338501,974.519287 1443.414429,973.227051 1443.505493,971.676147 
C1456.685059,971.676147 1469.599854,971.676147 1482.823486,971.676147 
C1482.823486,974.006042 1482.823486,976.256470 1482.823486,979.084351 
C1472.897949,979.084351 1462.825684,979.084351 1452.529785,979.084351 
C1452.529785,986.266479 1452.529785,992.890991 1452.529785,1000.046753 
C1461.407349,1000.046753 1470.317749,1000.046753 1479.561768,1000.046753 
C1479.561768,1002.813782 1479.561768,1005.064148 1479.561768,1007.907715 
C1470.735474,1007.907715 1461.665771,1007.907715 1452.523682,1007.907715 
C1452.523682,1014.933655 1452.523682,1021.369629 1452.523682,1028.302979 
C1463.000732,1028.302979 1473.260010,1028.302979 1483.766235,1028.302979 
C1483.766235,1031.048584 1483.766235,1033.301392 1483.766235,1035.868042 
C1470.549316,1035.868042 1457.302124,1035.868042 1443.262573,1035.868042 
C1443.262573,1016.198120 1443.262573,996.471008 1443.262573,976.277710 
z'
    />
    <path
      fill='#313131'
      opacity='1.000000'
      stroke='none'
      d='
M1592.159424,1016.067139 
C1592.159424,1020.338745 1592.159424,1024.126099 1592.159424,1028.366943 
C1602.906372,1028.366943 1613.158691,1028.366943 1623.677368,1028.366943 
C1623.677368,1031.067627 1623.677368,1033.309204 1623.677368,1035.862915 
C1610.309814,1035.862915 1596.948608,1035.862915 1583.361084,1035.862915 
C1583.361084,1014.422546 1583.361084,993.203552 1583.361084,971.686401 
C1596.476196,971.686401 1609.389648,971.686401 1622.677002,971.686401 
C1622.677002,974.006348 1622.677002,976.357910 1622.677002,979.093994 
C1612.726074,979.093994 1602.803833,979.093994 1592.522949,979.093994 
C1592.522949,986.157288 1592.522949,992.868042 1592.522949,1000.121155 
C1601.408325,1000.121155 1610.299316,1000.121155 1619.485596,1000.121155 
C1619.485596,1002.890381 1619.485596,1005.133240 1619.485596,1007.854858 
C1610.642456,1007.854858 1601.736328,1007.854858 1592.159424,1007.854858 
C1592.159424,1010.732178 1592.159424,1013.157532 1592.159424,1016.067139 
z'
    />
    <path
      fill='#2B2B2B'
      opacity='1.000000'
      stroke='none'
      d='
M1442.018311,1061.183228 
C1442.967651,1059.791626 1443.905273,1058.107788 1444.867554,1058.093506 
C1457.005737,1057.914185 1469.147339,1057.975586 1481.607666,1057.975586 
C1481.607666,1060.594849 1481.607666,1062.959473 1481.607666,1065.675781 
C1471.505493,1065.675781 1461.565063,1065.675781 1451.320557,1065.675781 
C1451.320557,1072.756714 1451.320557,1079.504639 1451.320557,1086.748779 
C1460.151001,1086.748779 1469.055176,1086.748779 1478.216064,1086.748779 
C1478.216064,1089.491333 1478.216064,1091.744019 1478.216064,1094.538208 
C1469.204102,1094.538208 1460.319336,1094.538208 1451.230713,1094.538208 
C1451.230713,1101.510010 1451.230713,1107.944702 1451.230713,1114.767456 
C1461.511230,1114.767456 1471.768677,1114.767456 1482.400391,1114.767456 
C1482.400391,1117.509521 1482.400391,1119.874634 1482.400391,1122.534790 
C1469.078979,1122.534790 1455.843994,1122.534790 1442.017944,1122.534790 
C1442.017944,1102.182007 1442.017944,1081.924438 1442.018311,1061.183228 
z'
    />
    <path
      fill='#2B2B2B'
      opacity='1.000000'
      stroke='none'
      d='
M1258.095215,1066.558472 
C1251.576050,1065.984863 1245.446045,1065.171143 1239.331177,1065.273682 
C1235.362061,1065.340088 1231.238647,1066.593628 1230.159668,1071.451294 
C1229.058716,1076.408081 1231.327393,1079.813354 1235.567749,1082.108276 
C1241.700928,1085.427734 1247.907471,1088.614868 1253.989136,1092.025391 
C1258.921021,1094.791260 1261.704468,1098.940063 1262.354370,1104.770386 
C1263.504028,1115.086182 1259.356812,1121.820435 1249.157104,1122.624756 
C1239.512695,1123.385620 1229.731201,1122.406494 1219.846313,1122.188965 
C1219.846313,1118.289551 1219.846313,1115.848511 1219.846313,1113.214722 
C1225.029297,1113.978027 1230.060669,1114.942993 1235.137573,1115.388306 
C1238.578369,1115.690308 1242.105469,1115.470581 1245.553467,1115.104248 
C1249.345459,1114.701172 1252.898438,1113.474243 1253.516724,1108.951172 
C1254.141724,1104.380005 1252.459839,1100.853394 1248.237061,1098.643799 
C1242.204956,1095.487305 1236.198364,1092.281372 1230.204956,1089.051758 
C1223.294556,1085.328125 1220.435425,1079.482910 1220.987671,1071.711792 
C1221.520020,1064.220581 1225.226074,1059.462036 1232.560303,1058.183228 
C1241.815674,1056.569336 1251.078979,1056.675049 1261.419189,1059.678101 
C1260.390137,1062.147949 1259.440308,1064.427490 1258.095215,1066.558472 
z'
    />
    <path
      fill='#2B2B2B'
      opacity='1.000000'
      stroke='none'
      d='
M1340.269165,1087.762207 
C1334.218628,1083.638794 1332.654053,1077.917969 1333.137573,1071.401489 
C1333.708008,1063.716309 1337.829956,1058.712158 1345.520264,1058.154663 
C1354.384399,1057.511963 1363.330811,1058.005249 1372.487183,1058.005249 
C1372.487183,1061.740601 1372.487183,1064.169434 1372.487183,1066.359619 
C1366.224731,1065.908203 1360.143921,1065.180420 1354.054932,1065.106201 
C1346.937866,1065.019653 1343.413086,1067.160889 1342.281372,1071.362671 
C1341.013794,1076.069092 1343.004639,1079.489502 1349.379395,1083.037964 
C1354.895386,1086.108398 1360.617065,1088.818481 1366.061035,1092.006714 
C1373.815308,1096.547729 1376.872681,1105.660156 1373.767334,1114.076294 
C1371.640625,1119.839722 1366.750854,1122.436523 1361.337158,1122.655273 
C1351.640991,1123.046875 1341.903076,1122.403198 1332.012451,1122.188599 
C1332.012451,1118.297241 1332.012451,1115.862305 1332.012451,1113.213501 
C1337.263428,1113.990234 1342.274292,1114.983276 1347.332520,1115.394531 
C1350.939819,1115.688110 1354.629639,1115.383057 1358.247803,1115.008423 
C1361.956787,1114.624634 1365.127319,1113.067383 1365.715698,1108.888794 
C1366.297729,1104.753662 1364.931885,1101.223755 1361.162842,1099.122192 
C1354.342896,1095.319702 1347.426758,1091.689819 1340.269165,1087.762207 
z'
    />
    <path
      fill='#2B2B2B'
      opacity='1.000000'
      stroke='none'
      d='
M1600.347168,1065.053711 
C1598.600464,1065.290283 1597.299683,1065.522705 1595.994873,1065.729492 
C1592.329346,1066.310425 1589.832275,1068.251221 1589.174561,1071.999023 
C1588.506592,1075.804077 1589.749268,1079.036377 1593.133179,1080.981934 
C1599.607544,1084.704468 1606.169434,1088.280151 1612.764771,1091.785400 
C1619.449463,1095.338013 1621.885254,1101.201050 1621.801025,1108.310303 
C1621.704712,1116.441650 1617.433594,1121.367432 1608.716431,1122.665405 
C1598.789185,1124.143311 1588.868408,1123.548950 1579.036865,1120.805542 
C1579.036865,1118.220581 1579.036865,1115.789307 1579.036865,1113.219116 
C1584.317749,1113.999634 1589.339600,1114.996216 1594.408936,1115.405273 
C1598.013916,1115.696289 1601.702271,1115.379761 1605.317749,1114.996948 
C1609.033691,1114.603760 1612.171753,1113.001587 1612.725464,1108.824707 
C1613.273315,1104.691895 1611.880859,1101.207642 1608.110962,1099.094849 
C1604.346191,1096.984985 1600.457642,1095.096924 1596.641968,1093.076660 
C1593.999878,1091.677734 1591.356323,1090.276489 1588.770874,1088.776855 
C1581.744507,1084.701172 1579.291382,1078.399048 1580.195557,1070.597412 
C1580.986694,1063.770874 1584.582642,1059.515869 1591.332764,1058.274048 
C1600.728271,1056.545898 1610.144653,1056.604126 1619.554932,1059.426636 
C1619.554932,1061.830322 1619.554932,1064.115967 1619.554932,1066.350708 
C1613.204224,1065.906372 1606.997803,1065.472168 1600.347168,1065.053711 
z'
    />
    <path
      fill='#2B2B2B'
      opacity='1.000000'
      stroke='none'
      d='
M1324.129639,1062.041504 
C1318.030273,1073.145752 1312.291870,1084.022461 1306.074829,1094.618286 
C1303.017334,1099.829102 1301.397217,1105.061523 1301.909912,1111.093750 
C1302.218262,1114.722412 1301.966553,1118.398560 1301.966553,1122.436279 
C1299.067261,1122.436279 1296.352539,1122.436279 1292.971191,1122.436279 
C1292.971191,1116.956909 1293.129883,1111.357788 1292.892456,1105.775391 
C1292.798462,1103.564941 1292.227539,1101.174927 1291.185791,1099.236572 
C1283.891724,1085.666016 1276.417725,1072.192261 1268.950806,1058.595459 
C1278.505737,1056.944092 1278.509888,1056.941895 1282.583984,1064.728394 
C1287.493530,1074.110962 1292.395142,1083.497803 1297.602173,1093.460815 
C1302.516357,1083.978149 1307.693237,1075.234375 1311.635986,1065.965576 
C1314.520752,1059.184082 1318.369385,1056.220337 1325.835327,1058.437744 
C1325.365112,1059.432129 1324.829224,1060.565186 1324.129639,1062.041504 
z'
    />
    <path
      fill='#2B2B2B'
      opacity='1.000000'
      stroke='none'
      d='
M1731.170288,979.153259 
C1729.053101,979.153259 1727.415283,979.153259 1725.292969,979.153259 
C1725.292969,998.165833 1725.292969,1016.865479 1725.292969,1035.856689 
C1722.094971,1035.856689 1719.374390,1035.856689 1716.161621,1035.856689 
C1716.161621,1017.071777 1716.161621,998.361694 1716.161621,979.199097 
C1709.450928,979.199097 1703.207153,979.199097 1696.711792,979.199097 
C1696.711792,976.501709 1696.711792,974.262329 1696.711792,971.717651 
C1712.793945,971.717651 1728.665649,971.717651 1744.734863,971.717651 
C1744.734863,974.072998 1744.734863,976.201782 1744.734863,979.153259 
C1740.461548,979.153259 1736.055664,979.153259 1731.170288,979.153259 
z'
    />
    <path
      fill='#2B2B2B'
      opacity='1.000000'
      stroke='none'
      d='
M1402.171509,1083.000977 
C1402.171509,1077.185425 1402.171509,1071.869751 1402.171509,1066.086060 
C1395.780273,1066.086060 1389.540161,1066.086060 1382.945312,1066.086060 
C1382.945312,1063.229736 1382.945312,1060.837891 1382.945312,1058.217651 
C1398.882812,1058.217651 1414.761353,1058.217651 1430.803467,1058.217651 
C1430.803467,1060.724976 1430.803467,1062.988281 1430.803467,1065.660156 
C1424.372437,1065.660156 1418.105957,1065.660156 1411.333008,1065.660156 
C1411.333008,1084.774048 1411.333008,1103.491577 1411.333008,1122.511597 
C1408.115479,1122.511597 1405.404419,1122.511597 1402.171509,1122.511597 
C1402.171509,1109.372681 1402.171509,1096.436768 1402.171509,1083.000977 
z'
    />
    <path
      fill='#252525'
      opacity='1.000000'
      stroke='none'
      d='
M1023.512512,413.071838 
C1023.432800,409.804443 1023.817017,406.498810 1024.410889,403.012970 
C1025.641602,402.473633 1026.661865,401.804199 1027.683960,401.801239 
C1046.985962,401.745300 1066.288208,401.765747 1085.590332,401.788635 
C1086.055664,401.789185 1086.520874,401.999420 1087.218506,402.168030 
C1087.218506,405.628418 1087.218506,409.054413 1087.218506,413.033569 
C1066.156616,413.033569 1045.066528,413.033569 1023.512512,413.071838 
z'
    />
    <path
      fill='#252525'
      opacity='1.000000'
      stroke='none'
      d='
M1023.547852,629.154236 
C1023.063354,625.711731 1023.040527,622.242126 1023.049744,618.299194 
C1033.522339,617.825989 1043.962891,617.825989 1054.749756,617.825989 
C1054.749756,621.583130 1054.749756,625.105774 1054.749756,629.127075 
C1044.480835,629.127075 1034.245239,629.127075 1023.547852,629.154236 
z'
    />
    <path
      fill='#252525'
      opacity='1.000000'
      stroke='none'
      d='
M1023.571045,737.205811 
C1023.077332,733.751770 1023.043640,730.279175 1023.035461,726.335815 
C1033.503418,725.865051 1043.945923,725.865051 1054.742188,725.865051 
C1054.742188,729.620850 1054.742188,733.142395 1054.742188,737.187256 
C1044.496216,737.187256 1034.263672,737.187256 1023.571045,737.205811 
z'
    />
    <path
      fill='#252525'
      opacity='1.000000'
      stroke='none'
      d='
M1023.501648,485.106934 
C1023.034973,481.675720 1023.032654,478.199280 1023.073120,474.244751 
C1033.557373,473.766693 1043.998779,473.766693 1054.768066,473.766693 
C1054.768066,477.534698 1054.768066,481.064148 1054.768066,485.061646 
C1044.453979,485.061646 1034.209961,485.061646 1023.501648,485.106934 
z'
    />
    <path
      fill='#2B2B2B'
      opacity='1.000000'
      stroke='none'
      d='
M1551.045654,266.019287 
C1553.515503,269.909851 1553.214600,273.280609 1549.932495,275.992310 
C1547.015381,278.402435 1543.305542,278.607849 1541.105469,275.702484 
C1539.524780,273.614655 1538.680908,269.852203 1539.396606,267.384430 
C1540.715210,262.837738 1546.001099,262.365234 1551.045654,266.019287 
z'
    />
    <path
      fill='#313131'
      opacity='1.000000'
      stroke='none'
      d='
M1303.599854,274.438629 
C1300.762085,277.721741 1297.340210,278.947357 1294.211914,276.501465 
C1292.345581,275.042145 1290.659546,271.759033 1290.956299,269.576324 
C1291.250610,267.411804 1293.802002,264.762238 1295.986328,263.896759 
C1297.736816,263.203186 1300.865967,264.283783 1302.587158,265.610138 
C1305.349609,267.738983 1305.457764,270.982483 1303.599854,274.438629 
z'
    />
    <path
      fill='#313131'
      opacity='1.000000'
      stroke='none'
      d='
M1551.781006,247.354675 
C1553.360840,251.662201 1552.421509,254.861877 1548.681152,256.964111 
C1545.483276,258.761566 1542.523682,257.962891 1540.175537,255.407654 
C1537.780518,252.801392 1537.602905,249.734055 1539.517944,246.749924 
C1542.229492,242.524460 1547.357666,242.680695 1551.781006,247.354675 
z'
    />
    <path
      fill='#2B2B2B'
      opacity='1.000000'
      stroke='none'
      d='
M1470.464844,214.300842 
C1466.056641,214.716995 1462.887451,212.858719 1462.550903,209.015503 
C1462.336548,206.570053 1463.783691,202.860550 1465.700806,201.663254 
C1467.595703,200.479797 1471.609009,200.814758 1473.651978,202.117004 
C1478.483887,205.196640 1476.819580,211.486053 1470.464844,214.300842 
z'
    />
    <path
      fill='#2B2B2B'
      opacity='1.000000'
      stroke='none'
      d='
M1534.404907,294.530090 
C1531.340576,291.001801 1531.208374,287.590149 1534.112915,284.450195 
C1536.678223,281.677277 1539.946411,281.314972 1543.145386,283.329651 
C1546.172729,285.236237 1547.045044,288.200714 1546.041748,291.578735 
C1544.635498,296.313324 1540.246216,297.510376 1534.404907,294.530090 
z'
    />
    <path
      fill='#2B2B2B'
      opacity='1.000000'
      stroke='none'
      d='
M1302.727905,255.719193 
C1299.046509,258.613708 1295.243286,258.864838 1292.787720,255.412567 
C1291.355225,253.398529 1290.985474,249.724670 1291.730713,247.284286 
C1292.763306,243.903870 1296.209717,243.079086 1299.646240,243.907883 
C1304.585938,245.099243 1305.992920,250.070251 1302.727905,255.719193 
z'
    />
    <path
      fill='#2B2B2B'
      opacity='1.000000'
      stroke='none'
      d='
M1368.158447,211.524414 
C1366.047119,205.898926 1367.085938,202.505402 1371.260986,200.842621 
C1375.139526,199.297897 1378.187500,200.659470 1380.148926,204.112274 
C1381.929810,207.247330 1381.336670,210.411392 1378.595947,212.672394 
C1375.094971,215.560623 1371.546021,215.026337 1368.158447,211.524414 
z'
    />
    <path
      fill='#2B2B2B'
      opacity='1.000000'
      stroke='none'
      d='
M1506.542358,200.259872 
C1509.556519,201.447235 1512.981201,202.153336 1514.568359,204.250305 
C1515.675903,205.713638 1515.088379,209.740997 1513.748413,211.413864 
C1512.415771,213.077423 1508.867188,214.338257 1506.893188,213.750687 
C1504.678223,213.091446 1502.216919,210.443680 1501.518799,208.155746 
C1500.437866,204.613464 1502.694946,201.840744 1506.542358,200.259872 
z'
    />
    <path
      fill='#2B2B2B'
      opacity='1.000000'
      stroke='none'
      d='
M1335.724121,200.071259 
C1339.925415,201.257370 1342.614746,203.901169 1341.677368,207.736847 
C1341.091064,210.135849 1338.548828,212.865997 1336.212646,213.844940 
C1332.387329,215.447906 1328.473145,212.422531 1327.859619,208.379349 
C1327.140503,203.640335 1329.583130,200.910400 1335.724121,200.071259 
z'
    />
    <path
      fill='#2A2A2A'
      opacity='1.000000'
      stroke='none'
      d='
M1304.705078,282.203186 
C1308.875244,283.284576 1311.609619,285.712830 1310.826904,289.655975 
C1310.364990,291.983368 1308.286377,294.712280 1306.176636,295.831818 
C1302.403564,297.833893 1297.885132,295.103851 1296.966553,291.054443 
C1295.899780,286.351044 1298.547241,283.153625 1304.705078,282.203186 
z'
    />
    <path
      fill='#2B2B2B'
      opacity='1.000000'
      stroke='none'
      d='
M1310.314331,216.230499 
C1312.631226,210.325378 1316.731445,207.970490 1320.593262,210.722321 
C1322.557861,212.122391 1324.587646,215.455475 1324.246826,217.530182 
C1323.861084,219.878906 1321.171997,222.910065 1318.886841,223.567337 
C1316.875122,224.145950 1313.853149,222.145706 1311.654419,220.707886 
C1310.699951,220.083740 1310.690674,218.014236 1310.314331,216.230499 
z'
    />
    <path
      fill='#2B2B2B'
      opacity='1.000000'
      stroke='none'
      d='
M1398.779053,217.665070 
C1393.627686,222.656876 1387.308350,221.968292 1386.174072,216.281937 
C1385.692749,213.869095 1386.770020,209.784592 1388.544434,208.641205 
C1390.575439,207.332535 1394.583862,207.577774 1396.983643,208.720886 
C1400.357300,210.327866 1400.654053,213.896286 1398.779053,217.665070 
z'
    />
    <path
      fill='#2B2B2B'
      opacity='1.000000'
      stroke='none'
      d='
M1545.472534,233.488617 
C1544.245972,237.217926 1541.954590,239.630615 1538.406006,238.930649 
C1536.112671,238.478271 1533.185913,236.795029 1532.306763,234.861359 
C1531.421875,232.915100 1531.871338,229.164474 1533.285400,227.687805 
C1534.885010,226.017288 1538.387085,225.042099 1540.740356,225.482666 
C1544.304077,226.149811 1545.937622,229.309906 1545.472534,233.488617 
z'
    />
    <path
      fill='#2B2B2B'
      opacity='1.000000'
      stroke='none'
      d='
M1360.924072,201.024658 
C1362.136475,205.742737 1360.774902,209.009827 1356.471558,210.544754 
C1353.043701,211.767426 1350.195435,210.443649 1348.316162,207.447021 
C1346.383789,204.365601 1346.933105,201.341827 1349.389526,198.778625 
C1352.588867,195.440262 1357.118408,196.241013 1360.924072,201.024658 
z'
    />
    <path
      fill='#2B2B2B'
      opacity='1.000000'
      stroke='none'
      d='
M1525.935303,209.877838 
C1531.414795,211.409027 1533.813599,214.802917 1532.610229,218.782333 
C1531.511230,222.417053 1527.563965,224.747574 1523.995483,223.868652 
C1520.169067,222.926224 1517.311035,218.570465 1519.119263,215.015366 
C1520.254395,212.783905 1523.331421,211.540298 1525.935303,209.877838 
z'
    />
    <path
      fill='#2B2B2B'
      opacity='1.000000'
      stroke='none'
      d='
M1311.640503,230.513977 
C1311.995361,234.380463 1310.892456,237.531372 1307.394409,238.349884 
C1305.121094,238.881836 1301.764282,238.566483 1300.173462,237.171005 
C1298.579834,235.773132 1297.495850,232.188080 1298.166748,230.244553 
C1298.909058,228.094040 1301.655640,225.831833 1303.959351,225.208527 
C1307.596924,224.224411 1310.205444,226.625732 1311.640503,230.513977 
z'
    />
    <path
      fill='#2B2B2B'
      opacity='1.000000'
      stroke='none'
      d='
M1444.375366,210.436157 
C1447.331055,206.360260 1451.181152,205.592224 1454.370483,208.491196 
C1456.217773,210.170258 1457.291016,213.967407 1456.902222,216.537445 
C1456.345459,220.216888 1452.851440,221.500366 1449.186523,221.009842 
C1444.531494,220.386765 1442.620117,216.357376 1444.375366,210.436157 
z'
    />
    <path
      fill='#2B2B2B'
      opacity='1.000000'
      stroke='none'
      d='
M1495.932373,203.164627 
C1494.852783,208.853348 1491.844971,211.538208 1487.769287,210.880463 
C1483.780762,210.236786 1480.638550,206.323227 1482.106445,202.552917 
C1483.008667,200.235748 1485.675781,197.694550 1488.036865,197.057846 
C1492.177002,195.941330 1494.827393,198.694351 1495.932373,203.164627 
z'
    />
    <path
      fill='#FEFEFE'
      opacity='1.000000'
      stroke='none'
      d='
M1473.416992,409.465942 
C1498.578125,416.807312 1520.921997,428.708801 1540.624390,445.277466 
C1566.906982,467.379608 1585.928711,494.623322 1597.174805,527.210693 
C1607.549561,557.273499 1610.404785,588.055664 1604.451416,619.213440 
C1591.951050,684.636414 1554.935059,731.767090 1493.939209,757.873657 
C1437.010986,782.239258 1380.331299,778.084839 1326.795044,746.575134 
C1280.055542,719.065613 1250.848999,677.869873 1239.718018,624.872192 
C1230.078979,578.978210 1237.366089,535.169739 1261.047119,494.459564 
C1281.542358,459.225677 1310.777466,433.529724 1348.038086,417.275818 
C1374.658203,405.663605 1402.708740,400.249969 1431.757446,402.697784 
C1445.604980,403.864685 1459.282349,407.048248 1473.416992,409.465942 
M1443.606934,553.106018 
C1417.027710,575.416992 1392.808594,600.083313 1370.466919,626.985718 
C1347.124878,608.653076 1322.482300,593.141602 1295.177490,580.694946 
C1295.177490,598.785034 1295.288818,616.213440 1295.085815,633.638184 
C1295.043945,637.227905 1296.191284,639.299866 1299.097290,641.341736 
C1324.445557,659.153503 1346.958252,680.062988 1366.657349,703.981628 
C1370.710205,708.902649 1374.632690,713.931030 1378.854736,719.209167 
C1380.053711,717.184692 1381.013550,715.650757 1381.890137,714.070618 
C1397.919556,685.179626 1416.616211,658.116028 1437.713501,632.706238 
C1466.797485,597.677368 1499.734741,566.756531 1536.767334,540.250793 
C1539.520874,538.279968 1540.531494,536.200562 1540.482422,532.854126 
C1540.294556,520.030945 1540.416260,507.203278 1540.393188,494.377380 
C1540.390503,492.822357 1540.209595,491.267700 1540.076416,489.162323 
C1505.198364,506.750000 1473.614258,528.091370 1443.606934,553.106018 
z'
    />
    <path
      fill='#FCFCFC'
      opacity='1.000000'
      stroke='none'
      d='
M1451.970947,284.131500 
C1445.590820,292.145813 1437.684570,296.957184 1427.477051,298.728088 
C1427.925903,293.093506 1431.057373,289.079346 1434.343750,284.976532 
C1435.831421,283.119415 1437.070068,280.477509 1437.127930,278.159363 
C1437.410156,266.835571 1437.312134,255.500473 1437.213135,244.170578 
C1437.190796,241.610565 1437.823364,240.592773 1440.605591,239.895493 
C1452.332153,236.956528 1464.162964,234.184128 1475.549194,230.191833 
C1496.100342,222.986115 1516.278198,232.641891 1521.559204,253.079544 
C1523.641235,261.136902 1522.336304,268.944244 1518.906494,276.390411 
C1513.715698,287.659607 1514.291870,297.920166 1523.553345,307.009491 
C1524.325684,307.767487 1524.674805,309.743652 1524.272949,310.789978 
C1520.047852,321.791626 1515.629639,332.719177 1511.292603,343.597351 
C1497.322021,342.807404 1486.014526,328.432556 1489.293335,315.340759 
C1489.958862,312.683441 1492.512695,310.272308 1494.730225,308.370819 
C1495.382690,307.811371 1498.902954,309.002228 1499.309814,310.073914 
C1500.231079,312.500610 1500.032227,315.352509 1500.353027,318.699951 
C1503.720337,319.206696 1507.147461,317.387909 1509.272949,313.435394 
C1511.346313,309.579926 1510.955444,305.615631 1508.026367,302.309540 
C1504.145874,297.929688 1499.395874,298.109100 1494.609375,300.462433 
C1495.415649,294.714691 1496.842163,289.055237 1496.751953,283.420074 
C1496.701416,280.267456 1494.877686,275.412689 1492.536133,274.414856 
C1488.582397,272.730103 1486.100098,277.101898 1484.759521,280.417175 
C1482.560669,285.855347 1481.049683,291.571564 1479.291138,297.038361 
C1476.379028,293.128723 1472.357544,290.630371 1466.782837,292.764404 
C1462.577026,294.374481 1460.390259,297.758362 1460.458740,302.040710 
C1460.529541,306.457825 1462.684204,309.889862 1467.687256,311.357452 
C1467.687256,310.154724 1467.633545,309.256409 1467.696777,308.366394 
C1467.934814,305.014069 1469.761841,302.998962 1473.110718,303.119263 
C1476.442505,303.238922 1478.064697,305.365417 1478.204590,308.715332 
C1478.574951,317.583557 1471.564575,326.207367 1461.480103,329.200317 
C1446.047119,333.780609 1431.007080,325.071381 1427.260376,308.797089 
C1438.020020,309.934357 1445.767334,315.493103 1452.723999,324.045013 
C1452.866699,322.071442 1453.046265,320.721375 1453.049194,319.370911 
C1453.072266,308.873352 1453.091431,298.375488 1453.024048,287.878296 
C1453.015503,286.545807 1452.500732,285.216553 1451.970947,284.131500 
z'
    />
    <path
      fill='#FCFCFC'
      opacity='1.000000'
      stroke='none'
      d='
M1348.534058,300.242798 
C1339.974243,297.422668 1333.678955,300.343597 1332.876099,307.507812 
C1332.105469,314.384430 1336.842896,318.996857 1344.327515,318.325195 
C1343.876709,317.525818 1343.447510,316.859619 1343.109741,316.149933 
C1341.549561,312.871613 1342.330566,310.187866 1345.593384,308.670837 
C1349.023560,307.075989 1351.359741,308.851196 1352.846313,311.892242 
C1357.162109,320.720612 1353.100342,333.152161 1343.595459,339.338074 
C1340.316284,341.472229 1336.516724,342.806732 1332.402954,344.769928 
C1327.412964,332.351013 1322.674438,320.558228 1317.865112,308.589142 
C1329.212158,298.875793 1329.460449,287.574982 1323.746216,274.755737 
C1317.855103,261.539185 1319.844238,248.813019 1329.713257,238.186569 
C1338.996460,228.190887 1350.861084,225.354721 1363.956665,229.173294 
C1377.756836,233.197327 1391.435059,237.639954 1405.911011,242.130676 
C1405.911011,253.374512 1405.766968,265.833344 1406.040894,278.282990 
C1406.091431,280.579773 1407.613281,282.966217 1408.840210,285.089325 
C1411.323608,289.386597 1414.069946,293.531830 1416.185425,298.107513 
C1405.218140,297.051788 1397.173950,291.737701 1390.315430,283.090485 
C1390.315430,297.038513 1390.315430,310.174622 1390.315430,323.506317 
C1403.555786,311.639008 1406.904297,309.714630 1415.497070,308.964813 
C1414.447021,319.983154 1404.417114,329.149658 1392.240356,330.219696 
C1379.435547,331.344879 1368.505249,324.468781 1365.535400,313.366577 
C1365.196289,312.098969 1365.070801,310.758026 1364.984375,309.442017 
C1364.735474,305.651245 1366.475098,303.090424 1370.313110,303.143219 
C1374.141235,303.195831 1375.793335,305.754120 1375.388062,309.565613 
C1375.339233,310.024292 1375.381348,310.492615 1375.381348,311.263336 
C1380.111816,310.303894 1382.240234,307.044250 1382.682373,302.895172 
C1383.166748,298.349762 1380.960938,294.847565 1376.740112,292.896576 
C1372.090454,290.747375 1368.064941,292.186615 1363.945435,296.869385 
C1361.955933,291.102570 1360.249023,284.775574 1357.513428,278.929962 
C1356.472290,276.705048 1353.067993,275.585938 1350.740723,273.962830 
C1349.243286,276.359100 1346.438843,278.791351 1346.503662,281.144653 
C1346.669922,287.187714 1348.109253,293.195770 1348.908447,299.673065 
C1348.776978,300.128326 1348.534058,300.242798 1348.534058,300.242798 
z'
    />
    <path
      fill='#FCFCFC'
      opacity='1.000000'
      stroke='none'
      d='
M1348.892822,300.060486 
C1349.261963,300.320862 1349.515381,300.649078 1349.768677,300.977295 
C1349.391235,300.882812 1349.013672,300.788361 1348.585205,300.468323 
C1348.534058,300.242798 1348.776978,300.128326 1348.892822,300.060486 
z'
    />
    <path
      fill='#FCFCFC'
      opacity='1.000000'
      stroke='none'
      d='
M1493.362305,301.499695 
C1493.354492,301.264038 1493.447998,301.183441 1493.541382,301.102844 
C1493.608887,301.206177 1493.738892,301.318390 1493.725830,301.410309 
C1493.712891,301.502319 1493.556885,301.574127 1493.362305,301.499695 
z'
    />
    <path
      fill='#FCFCFC'
      opacity='1.000000'
      stroke='none'
      d='
M1518.088623,880.879211 
C1519.977417,885.834229 1521.753540,890.417725 1523.762573,895.601685 
C1510.369263,895.601685 1497.852295,895.601685 1484.729736,895.601685 
C1485.190186,894.007629 1485.488647,892.610291 1485.991455,891.290833 
C1490.654541,879.053406 1495.267334,866.795166 1500.141235,854.641846 
C1500.808716,852.977905 1502.828857,851.856445 1504.222778,850.483765 
C1505.465820,851.831055 1507.215820,852.970581 1507.867432,854.560303 
C1511.387085,863.147888 1514.634644,871.847046 1518.088623,880.879211 
z'
    />
    <path
      fill='#FCFCFC'
      opacity='1.000000'
      stroke='none'
      d='
M1337.822021,985.782166 
C1338.480835,983.902649 1339.022339,982.397522 1340.051758,979.536621 
C1343.536377,989.704834 1346.597290,998.636292 1349.789307,1007.950867 
C1343.071045,1007.950867 1336.974365,1007.950867 1330.226685,1007.950867 
C1332.784790,1000.495667 1335.244751,993.326172 1337.822021,985.782166 
z'
    />
    <path
      fill='#FCFCFC'
      opacity='1.000000'
      stroke='none'
      d='
M1204.727539,1002.705078 
C1207.349854,995.041321 1209.829590,987.753784 1212.696045,979.329529 
C1216.154053,989.395874 1219.248047,998.402466 1222.495239,1007.854797 
C1215.751831,1007.854797 1209.550659,1007.854797 1203.038452,1007.854797 
C1203.581299,1006.179504 1204.083252,1004.630371 1204.727539,1002.705078 
z'
    />
    <path
      fill='#272727'
      opacity='1.000000'
      stroke='none'
      d='
M1443.879517,552.880188 
C1473.614258,528.091370 1505.198364,506.750000 1540.076416,489.162323 
C1540.209595,491.267700 1540.390503,492.822357 1540.393188,494.377380 
C1540.416260,507.203278 1540.294556,520.030945 1540.482422,532.854126 
C1540.531494,536.200562 1539.520874,538.279968 1536.767334,540.250793 
C1499.734741,566.756531 1466.797485,597.677368 1437.713501,632.706238 
C1416.616211,658.116028 1397.919556,685.179626 1381.890137,714.070618 
C1381.013550,715.650757 1380.053711,717.184692 1378.854736,719.209167 
C1374.632690,713.931030 1370.710205,708.902649 1366.657349,703.981628 
C1346.958252,680.062988 1324.445557,659.153503 1299.097290,641.341736 
C1296.191284,639.299866 1295.043945,637.227905 1295.085815,633.638184 
C1295.288818,616.213440 1295.177490,598.785034 1295.177490,580.694946 
C1322.482300,593.141602 1347.124878,608.653076 1370.466919,626.985718 
C1392.808594,600.083313 1417.027710,575.416992 1443.879517,552.880188 
z'
    />
  </svg>
)
